import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client/react';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  FilterDate: { input: any; output: any; }
  JSON: { input: any; output: any; }
  SafeInt: { input: number; output: number; }
};

export type AdfAudienceIntegrationConfiguration = {
  emails: Array<Scalars['String']['output']>;
};

export type AdfAudienceIntegrationConfigurationInput = {
  emails: Array<Scalars['String']['input']>;
};

export type AiUsageEventInput = {
  assistantTurnDuration: Scalars['Int']['input'];
  cacheReadTokens: Scalars['Int']['input'];
  cacheWriteTokens: Scalars['Int']['input'];
  conversationId: Scalars['String']['input'];
  llmCallsCount: Scalars['Int']['input'];
  modelIdUsed: Scalars['String']['input'];
  outputTokens: Scalars['Int']['input'];
  provider: Scalars['String']['input'];
  timestamp: Scalars['Date']['input'];
  turnId: Scalars['String']['input'];
  uncachedInputTokens: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};

export type AiUsageEventProcessingResult = {
  error?: Maybe<Scalars['String']['output']>;
  status: AiUsageEventProcessingStatus;
  turnId: Scalars['String']['output'];
};

export enum AiUsageEventProcessingStatus {
  Duplicate = 'Duplicate',
  Failed = 'Failed',
  Processed = 'Processed'
}

export enum ActionType {
  AccessRequest = 'AccessRequest',
  AudienceExported = 'AudienceExported',
  Created = 'Created',
  Deleted = 'Deleted',
  InviteAccepted = 'InviteAccepted',
  InviteRejected = 'InviteRejected',
  Updated = 'Updated'
}

export type ActivationAudienceIntegrationConfiguration = {
  /** Which destination this integration activates to, e.g. 'generic-webhook'. A spec type, not an instance id. */
  activationType: Scalars['ID']['output'];
  bypassHiddenPeopleFields?: Maybe<Scalars['Boolean']['output']>;
  /** Encrypted secret blob. Hidden (null) for normal users via getCleanConfig; only the internal worker scope reads it. */
  credentials?: Maybe<Scalars['String']['output']>;
  historicalDataSync: Scalars['Boolean']['output'];
  parameters: Array<ActivationParameter>;
  /** Customer-chosen export columns on configurableColumns specs (S3-style); empty/null means the spec default. */
  peopleColumns?: Maybe<Array<Scalars['String']['output']>>;
  status: ActivationConnectionStatus;
};

export type ActivationAudienceIntegrationConfigurationInput = {
  /** Which destination to activate to, e.g. 'generic-webhook'. A spec type, not an instance id. Immutable after create. */
  activationType: Scalars['ID']['input'];
  /** Write-only secret params. Stored encrypted (single field) and never returned. */
  credentials?: InputMaybe<Array<ActivationParameterInput>>;
  historicalDataSync?: InputMaybe<Scalars['Boolean']['input']>;
  parameters?: InputMaybe<Array<ActivationParameterInput>>;
  /** Only on configurableColumns specs; immutable after create (mirrors S3). */
  peopleColumns?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ActivationConnectionStatus {
  Connected = 'Connected',
  Disconnected = 'Disconnected'
}

export type ActivationParameter = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ActivationParameterInput = {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * What a destination receives on the wire, so the setup form can show the customer the exact shape of their data.
 * Rendered by the engine from synthetic rows through the real batch->body mapping, so it cannot drift from delivery.
 */
export type ActivationPayloadPreview = {
  /** People columns exported for this destination (the CSV header / the source of every mapped value). */
  columns: Array<Scalars['String']['output']>;
  /** Request Content-Type sent to the destination. */
  contentType: Scalars['String']['output'];
  /** Wire format label, e.g. CSV | JSON | Form-encoded | TXT. */
  format: Scalars['String']['output'];
  /** Records per request, when the spec caps them. */
  maxRecordsPerBatch?: Maybe<Scalars['Int']['output']>;
  /** A rendered sample body built from clearly-synthetic people. */
  sampleBody: Scalars['String']['output'];
};

/** Public metadata for one activation destination in the in-repo spec registry — drives the web catalog + generic form. */
export type ActivationSpec = {
  /** Stable type key identifying this destination in the spec registry, e.g. 'generic-webhook'. */
  activationType: Scalars['ID']['output'];
  /** Audience conditions this destination supports; null means all are allowed. */
  allowedAudienceConditions?: Maybe<Array<AudienceCondition>>;
  /** Newly generated destinations carry a Beta badge in the catalog until they've had real-world validation. */
  beta: Scalars['Boolean']['output'];
  catalogId: Scalars['String']['output'];
  category: Scalars['String']['output'];
  /** The customer may choose the exported people columns (stored per integration, S3-style, immutable after create). */
  configurableColumns: Scalars['Boolean']['output'];
  /**
   * The spec's default export columns — the column picker's initial selection. Deliberately independent of
   * payloadPreview, which is null for destinations outside PAYLOAD_PREVIEW_ACTIVATION_TYPES.
   */
  defaultPeopleColumns: Array<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  fieldDefs: Array<ActivationSpecField>;
  /** Set only for destinations posting to a customer-owned endpoint (webhook-style); null for vendor APIs. */
  payloadPreview?: Maybe<ActivationPayloadPreview>;
  specVersion: Scalars['Int']['output'];
};

/** Public form-field metadata from a spec's fieldDefs. Secret fields expose their SHAPE only, never stored values. */
export type ActivationSpecField = {
  defaultValue?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  /** One of: string | number | boolean | select */
  kind: Scalars['String']['output'];
  /** i18n key (preferred) or literal label for the web form. */
  label: Scalars['String']['output'];
  options?: Maybe<Array<Scalars['String']['output']>>;
  /** Regex (RegExp source) a present value must match. */
  pattern?: Maybe<Scalars['String']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  secret: Scalars['Boolean']['output'];
};

export enum ActivityLevel {
  Audience = 'Audience',
  Organization = 'Organization'
}

export type ActivitySummaryConnection = {
  /** A list of nodes. */
  nodes: Array<EntityLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type AddOnCompletedInput = {
  addOnType: AudienceAddOn;
  additionId?: InputMaybe<Scalars['ID']['input']>;
  audienceId: Scalars['ID']['input'];
};

export type AddPeopleAudienceCustomerListInput = {
  audienceId: Scalars['ID']['input'];
  delimiter?: InputMaybe<Scalars['String']['input']>;
  s3FileUri: Scalars['String']['input'];
  selectedColumns: AudienceCustomerListColumnMappingsInput;
};

export type AddPeopleAudienceGlobalInput = {
  additionalRequestedCount: Scalars['Int']['input'];
  audienceId: Scalars['ID']['input'];
};

export type AdditionalInfo = {
  all?: Maybe<Array<KeyValue>>;
  known?: Maybe<KnownAdditionalInfo>;
};

export type AdditionalInfoAggregates = {
  all?: Maybe<Array<KeyAggregate>>;
  known?: Maybe<KnownAdditionalInfoAggregates>;
};

export type AdminAudiencePixelSettingsUpdateInput = {
  id: Scalars['ID']['input'];
  pixelMatchingCadence?: InputMaybe<PixelMatchingCadence>;
};

export type AdminUpdateOrganizationInput = {
  adfProviderInfo?: InputMaybe<Scalars['String']['input']>;
  businessDataEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  customerListEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Please use defaultS3OutputObjectKeyTemplate instead of this field. */
  defaultS3OutputFilenameStrategy?: InputMaybe<OutputFilenameStrategy>;
  defaultS3OutputObjectKeyTemplate?: InputMaybe<Scalars['String']['input']>;
  disableEmailValidation?: InputMaybe<Scalars['Boolean']['input']>;
  globalSearchEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  globalSearchLimit?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  lookalikeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lookalikeSearchLimit?: InputMaybe<Scalars['Int']['input']>;
  madhiveEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  madhiveRootPath?: InputMaybe<Scalars['String']['input']>;
  matchbackEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Please use paymentStatus instead of this field. */
  paidSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  pixelDomain?: InputMaybe<Scalars['String']['input']>;
  pixelMatchingCadence?: InputMaybe<PixelMatchingCadence>;
  pulseEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  subscriptionOverride?: InputMaybe<Scalars['Boolean']['input']>;
  whiteLabelImageUrl?: InputMaybe<Scalars['String']['input']>;
};

export enum AgentElasticsearchIndexType {
  Journey = 'Journey',
  People = 'People'
}

/**
 * Public half of the KMS key used by the AI agent's confirmation card to
 * envelope-encrypt sensitive tool inputs (JWE RSA-OAEP-256 + A256GCM).
 */
export type AgentSecureInputKey = {
  kid: Scalars['String']['output'];
  publicKeyPem: Scalars['String']['output'];
};

export type AiCreditsUsage = {
  enabled: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  percentage: Scalars['Int']['output'];
  periodEnd?: Maybe<Scalars['Date']['output']>;
  periodStart?: Maybe<Scalars['Date']['output']>;
  usage: Scalars['Int']['output'];
};

export type AllowedField = {
  fields: Array<Scalars['String']['output']>;
  operators?: Maybe<Array<AllowedQueryType>>;
  values?: Maybe<Array<Scalars['String']['output']>>;
  valuesDescription?: Maybe<Scalars['String']['output']>;
};

export enum AllowedQueryType {
  Bool = 'bool',
  Exists = 'exists',
  Range = 'range',
  Term = 'term',
  Terms = 'terms'
}

export type AppConfiguration = {
  agentSecureInputKey?: Maybe<AgentSecureInputKey>;
  pulseDateRange: DateRange;
  pulseSubscriptionAmount: Scalars['Int']['output'];
  pulseTopicVersion: Scalars['Int']['output'];
};

export type AppConfigurationInput = {
  pulseDateRange?: InputMaybe<DateRangeInput>;
  pulseSubscriptionAmount?: InputMaybe<Scalars['Int']['input']>;
  pulseTopicVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type AttributionSource = {
  count: Scalars['Int']['output'];
  source: Scalars['String']['output'];
};

export type AttributionSources = {
  attributions: Array<AttributionSource>;
};

export type Audience = BaseAudience & {
  /**
   * Get the most X attribution sources grouped by utmGroup (where X is specified by the count parameter) and the unique
   * people count for each attribution source.
   */
  attributionSourceCounts: AttributionSources;
  audienceOnlyAccess: Scalars['Boolean']['output'];
  baseAudience?: Maybe<BaseAudience>;
  categories?: Maybe<Array<AudienceCategory>>;
  condition: AudienceCondition;
  createdAt: Scalars['Date']['output'];
  createdByUserId: Scalars['ID']['output'];
  creator: BaseUser;
  customFields: Array<CustomField>;
  deepLink?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  filters?: Maybe<Array<PersonFilter>>;
  graph?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  info?: Maybe<AudienceInfo>;
  /**
   * Gets a page of integrations for the given arguments.
   * Also, audience integrations can be filtered by name.
   */
  integrationsPage: AudienceIntegrationConnection;
  /**
   * Get the most visited X paths for the provided filters (where X is specified by the count parameter). In order to
   * get the root ones, don't pass a pathPrefix filter. This query will return the top X paths of level Y + 1, where Y
   * is the level of the prefix passed, if any. No pathPrefix filter will return "/a", "/b", etc, and passing "/a" will
   * return "/a/a", "/a/b", etc.
   *
   * The result object will have the total number of unique users, including the number of visits to the pathPrefix, and
   * each path object will have the total number of unique users for that path. The same user can appear in more than a
   * path entry.
   */
  journeyTopPaths: JourneyPaths;
  /** Get the most visited X URLs for the provided filters (where X is specified by the count parameter). */
  journeyTopUrls: Array<Scalars['String']['output']>;
  /** Gets paginated journeys for a pixel audience. */
  journeys?: Maybe<PageViewConnection>;
  lookalikesCount: Scalars['Int']['output'];
  /** Gets a page of lookalikes for the given arguments. */
  lookalikesPage: AudienceConnection;
  /**
   * Gets how this Matchback's people divide across the distinct combinations of comparisons they matched
   * through, keeping the maxCombinations largest and merging the rest into other.
   * The total is this audience's own peopleCount, which callers select alongside this field: the combination
   * counts plus other always add up to it, so no caller has to discover something was left out.
   * Counts come from an Elasticsearch terms aggregation and carry its accuracy. other.combinationCount is the
   * one figure that may be approximate.
   * A non-Matchback fails with an invalid-operation-for-condition error. An unfinished Matchback returns null.
   */
  matchbackAttribution?: Maybe<AudienceMatchbackAttribution>;
  /**
   * Gets a page of the Matchbacks built from this audience as their base.
   * Matchbacks can be filtered by text, which matches their name.
   */
  matchbacksAsBasePage: AudienceConnection;
  /**
   * Gets a page of the Matchbacks that selected this audience as one of their comparisons.
   * Matchbacks can be filtered by text, which matches their name. The search does not widen what the viewer
   * may see: a Matchback left out for a viewer with audience-only access stays out however it is searched for.
   */
  matchbacksAsComparisonPage: BaseAudienceConnection;
  name: Scalars['String']['output'];
  organization: BaseOrganization;
  organizationId: Scalars['ID']['output'];
  parentAudience?: Maybe<BaseAudience>;
  /**
   * The id of the audience this one derives from, for Segments; null otherwise. Exposed as a scalar so a
   * caller filtering a page of candidates does not have to resolve a related audience for every Segment.
   */
  parentAudienceId?: Maybe<Scalars['ID']['output']>;
  pendingInvites?: Maybe<Array<Invite>>;
  /** Scans full audience people. */
  people?: Maybe<PersonConnection>;
  /**
   * Batched demographic breakdowns. Returns one result per requested field.
   * Category fields return BucketElement buckets; numeric fields return histogram buckets.
   * Partial success: disallowed fields are returned with an error entry; allowed
   * fields still return their buckets.
   */
  peopleBreakdowns: PeopleBreakdowns;
  peopleCount?: Maybe<Scalars['Int']['output']>;
  /** Gets counts of people for the given field. Fields compatible with this query are "category-like" fields. */
  peopleCounts?: Maybe<Array<Maybe<BucketElement>>>;
  /** Gets counts of people for the provided date field. Counts are returned in buckets defined by the provided date interval. */
  peopleDateHistogram?: Maybe<Array<Maybe<BucketElement>>>;
  /**
   * Gets counts of people for the provided number field. Counts are returned in buckets defined by the provided interval.
   * minCountPerBucket (0 by default): returns only buckets with at least minCountPerBucket documents.
   * bucketKeyFormat ("{from} - {to}" by default): format for the bucket key.
   */
  peopleNumberHistogram?: Maybe<Array<Maybe<BucketElement>>>;
  /** Gets a page of people for the given arguments. NOTE: For a cursor-based pagination, use the people query instead. */
  peoplePage?: Maybe<PersonConnection>;
  /** Gets a paginated journey of a given person for a pixel audience. */
  personJourney?: Maybe<PageViewConnection>;
  /**
   * Gets paged counts of journeys for a person grouped by a field.
   * This query will always return "totalCount" with a value.
   */
  personJourneyGroups?: Maybe<BucketConnection>;
  pixelSettings?: Maybe<AudiencePixelSettings>;
  processingResult?: Maybe<Scalars['String']['output']>;
  processingResultInfo?: Maybe<ProcessingResultInfo>;
  processingStatus?: Maybe<AudienceProcessingStatus>;
  quotaInfo?: Maybe<AudienceQuotaInfo>;
  /**
   * Returns the S3 Path for a new S3 integration.
   * For existing integrations, please use destinationS3Bucket and outputObjectKeyTemplates[0] from the configuration
   */
  s3IntegrationTestPath: Scalars['String']['output'];
  /** @deprecated Please use the segmentsPage query instead of this. */
  segments: Array<Audience>;
  segmentsCount: Scalars['Int']['output'];
  /** Gets a page of segments for the given arguments. */
  segmentsPage: AudienceConnection;
  systemQueryInfo?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['Date']['output'];
  userRoles?: Maybe<Array<AudienceUserRole>>;
  verifyEmails?: Maybe<Scalars['Boolean']['output']>;
};


export type AudienceAttributionSourceCountsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<PersonFilterInput>>;
  utmGroup: UtmGroup;
};


export type AudienceIntegrationsPageArgs = {
  pageItemsCount: Scalars['Int']['input'];
  pageNumber: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type AudienceJourneyTopPathsArgs = {
  count: Scalars['Int']['input'];
  filters?: InputMaybe<Array<PersonFilterInput>>;
};


export type AudienceJourneyTopUrlsArgs = {
  count: Scalars['Int']['input'];
  filters?: InputMaybe<Array<PersonFilterInput>>;
};


export type AudienceJourneysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<JourneyFilterInput>>;
  first: Scalars['Int']['input'];
};


export type AudienceLookalikesPageArgs = {
  pageItemsCount: Scalars['Int']['input'];
  pageNumber: Scalars['Int']['input'];
};


export type AudienceMatchbackAttributionArgs = {
  maxCombinations: Scalars['Int']['input'];
};


export type AudienceMatchbacksAsBasePageArgs = {
  pageItemsCount: Scalars['Int']['input'];
  pageNumber: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type AudienceMatchbacksAsComparisonPageArgs = {
  pageItemsCount: Scalars['Int']['input'];
  pageNumber: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type AudiencePeopleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<PersonFilterInput>>;
  first: Scalars['Int']['input'];
  matchbackComparisons?: InputMaybe<MatchbackComparisonsFilterInput>;
  sort?: InputMaybe<Array<SortFieldInput>>;
};


export type AudiencePeopleBreakdownsArgs = {
  filters?: InputMaybe<Array<PersonFilterInput>>;
  matchbackComparisons?: InputMaybe<MatchbackComparisonsFilterInput>;
  numberFields?: InputMaybe<Array<PeopleNumberFieldBreakdownInput>>;
  stringFields?: InputMaybe<Array<PeopleStringFieldBreakdownInput>>;
};


export type AudiencePeopleCountsArgs = {
  customField?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<FilterStringField>;
  filters?: InputMaybe<Array<InputMaybe<PersonFilterInput>>>;
  matchbackComparisons?: InputMaybe<MatchbackComparisonsFilterInput>;
  takeIntoAccountSameFieldFilters?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AudiencePeopleDateHistogramArgs = {
  field: FilterDateField;
  filters?: InputMaybe<Array<InputMaybe<PersonFilterInput>>>;
  interval: DateIntervalInput;
  max?: InputMaybe<Scalars['Date']['input']>;
  min?: InputMaybe<Scalars['Date']['input']>;
};


export type AudiencePeopleNumberHistogramArgs = {
  bucketKeyFormat?: InputMaybe<Scalars['String']['input']>;
  field: FilterNumberField;
  filters?: InputMaybe<Array<InputMaybe<PersonFilterInput>>>;
  interval?: InputMaybe<Scalars['Int']['input']>;
  matchbackComparisons?: InputMaybe<MatchbackComparisonsFilterInput>;
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
  minCountPerBucket?: InputMaybe<Scalars['Int']['input']>;
  takeIntoAccountSameFieldFilters?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AudiencePeoplePageArgs = {
  filters?: InputMaybe<Array<InputMaybe<PersonFilterInput>>>;
  matchbackComparisons?: InputMaybe<MatchbackComparisonsFilterInput>;
  pageItemsCount: Scalars['Int']['input'];
  pageNumber: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortFieldInput>>>;
};


export type AudiencePersonJourneyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<JourneyFilterInput>>;
  first: Scalars['Int']['input'];
  personId: Scalars['ID']['input'];
};


export type AudiencePersonJourneyGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  groupBy: JourneyGroupByInput;
  personId: Scalars['ID']['input'];
};


export type AudienceSegmentsPageArgs = {
  pageItemsCount: Scalars['Int']['input'];
  pageNumber: Scalars['Int']['input'];
};


export type AudienceSystemQueryInfoArgs = {
  options?: InputMaybe<SystemAudienceQueryInfoOptions>;
};

export enum AudienceAddOn {
  EmailValidation = 'EmailValidation'
}

export type AudienceBilling = {
  dayOfMonth: Scalars['Int']['output'];
};

export type AudienceBillingInput = {
  dayOfMonth: Scalars['Int']['input'];
};

export type AudienceCategory = {
  categoryCode: Scalars['Int']['output'];
  categoryName: Scalars['String']['output'];
  categoryPath: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  relevance?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type AudienceCategoryInput = {
  code: Scalars['Int']['input'];
  relevance?: InputMaybe<Scalars['Int']['input']>;
};

export enum AudienceCondition {
  CustomerList = 'CustomerList',
  Global = 'Global',
  Lookalike = 'Lookalike',
  Matchback = 'Matchback',
  Pixel = 'Pixel',
  Pulse = 'Pulse',
  Segment = 'Segment'
}

export type AudienceConnection = {
  edges: Array<AudienceEdge>;
  nodes: Array<Audience>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AudienceCustomerListColumnMappings = {
  customFields?: Maybe<Array<AudienceCustomerListCustomFieldColumnMapping>>;
  email?: Maybe<Scalars['Int']['output']>;
  emailField?: Maybe<Scalars['String']['output']>;
  emailMd5?: Maybe<Scalars['Int']['output']>;
  emailMd5Field?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['Int']['output']>;
  phoneField?: Maybe<Scalars['String']['output']>;
};

export type AudienceCustomerListColumnMappingsInput = {
  customFields?: InputMaybe<Array<AudienceCustomerListCustomFieldColumnMappingInput>>;
  email?: InputMaybe<Scalars['Int']['input']>;
  emailField?: InputMaybe<Scalars['String']['input']>;
  emailMd5?: InputMaybe<Scalars['Int']['input']>;
  emailMd5Field?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['Int']['input']>;
  phoneField?: InputMaybe<Scalars['String']['input']>;
};

export type AudienceCustomerListCustomField = {
  field: Scalars['String']['output'];
  fieldType: CustomFieldType;
  pending?: Maybe<Scalars['Boolean']['output']>;
};

export type AudienceCustomerListCustomFieldColumnMapping = {
  /** The column number in the CSV file provided by the user */
  column: Scalars['Int']['output'];
  /** The name of the custom field in the audience provided by the user */
  field: Scalars['String']['output'];
  /** The type of the custom field */
  fieldType: CustomFieldType;
  /** The original column name in the CSV file provided by the user */
  originalField?: Maybe<Scalars['String']['output']>;
};

export type AudienceCustomerListCustomFieldColumnMappingInput = {
  /** The column number in the CSV file provided by the user */
  column: Scalars['Int']['input'];
  /** The name of the custom field in the audience provided by the user */
  field: Scalars['String']['input'];
  /** The type of the custom field */
  fieldType: CustomFieldType;
  /** The original column name in the CSV file provided by the user */
  originalField?: InputMaybe<Scalars['String']['input']>;
};

export type AudienceCustomerListInfo = BaseAdditionsInfo & {
  additions?: Maybe<Array<CustomerListAdditionsArrayInfo>>;
  customFields?: Maybe<Array<AudienceCustomerListCustomField>>;
  /** @deprecated Moved to additions info */
  delimiter?: Maybe<Scalars['String']['output']>;
  failedAdditions?: Maybe<Array<CustomerListFailedAdditionsArrayInfo>>;
  isProcessingAddOns?: Maybe<Scalars['Boolean']['output']>;
  lastProcessedAt?: Maybe<Scalars['Date']['output']>;
  lastSuccessfullyProcessedAt?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Moved to additions info */
  mapping: AudienceCustomerListColumnMappings;
  /** @deprecated Moved to additions info */
  matchedCount?: Maybe<Scalars['Int']['output']>;
  processingAdditionInfo?: Maybe<CustomerListProcessingAdditionInfo>;
  s3FileUri: Scalars['String']['output'];
  /** @deprecated Moved to additions info */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AudienceCustomerListInput = {
  delimiter?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  s3FileUri: Scalars['String']['input'];
  selectedColumns: AudienceCustomerListColumnMappingsInput;
  verifyEmails?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AudienceDateFilterInput = {
  field: AudienceFilterDateField;
  operator: DateOperatorsInput;
};

export type AudienceEdge = {
  cursor: Scalars['String']['output'];
  node?: Maybe<Audience>;
};

export enum AudienceFilterDateField {
  CreatedAt = 'CreatedAt',
  LastNewMatchDate = 'LastNewMatchDate'
}

export type AudienceFilterInput = {
  dateFilter?: InputMaybe<AudienceDateFilterInput>;
  numberFilter?: InputMaybe<AudienceNumberFilterInput>;
};

export enum AudienceFilterNumberField {
  QuotaUsagePercentage = 'QuotaUsagePercentage'
}

export type AudienceGlobalInfo = BaseAdditionsInfo & {
  additions?: Maybe<Array<GlobalAdditionsArrayInfo>>;
  isProcessingAddOns?: Maybe<Scalars['Boolean']['output']>;
  lastProcessedAt?: Maybe<Scalars['Date']['output']>;
  lastSuccessfullyProcessedAt?: Maybe<Scalars['Date']['output']>;
  processingAdditionInfo?: Maybe<GlobalProcessingAdditionInfo>;
};

export type AudienceGlobalInput = {
  filters: Array<PersonFilterInput>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  requestedCount?: InputMaybe<Scalars['Int']['input']>;
  verifyEmails?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AudienceInfo = AudienceCustomerListInfo | AudienceGlobalInfo | AudienceLookalikeInfo | AudienceMatchbackInfo | AudiencePixelInfo | AudiencePulseInfo;

export type AudienceIntegration = {
  audience: Audience;
  configuration: AudienceIntegrationConfiguration;
  createdAt: Scalars['Date']['output'];
  createdByUserId?: Maybe<Scalars['ID']['output']>;
  creator?: Maybe<User>;
  id: Scalars['ID']['output'];
  integrationType: AudienceIntegrationType;
  lastRunAt?: Maybe<Scalars['Date']['output']>;
  lastRunHasWarnings?: Maybe<Scalars['Boolean']['output']>;
  lastRunResult?: Maybe<Scalars['String']['output']>;
  lastRunSucceeded?: Maybe<Scalars['Boolean']['output']>;
  lastSuccessfulRunAt?: Maybe<Scalars['Date']['output']>;
  lastSyncedAt?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  /** Whether this activation can be saved as an activation template. */
  supportsTemplate: Scalars['Boolean']['output'];
};

export type AudienceIntegrationConfiguration = AdfAudienceIntegrationConfiguration | ActivationAudienceIntegrationConfiguration | BeeswaxAudienceIntegrationConfiguration | DisplayVideo360CustomerMatchAudienceIntegrationConfiguration | FacebookCustomAudienceAudienceIntegrationConfiguration | GoogleCustomerMatchAudienceIntegrationConfiguration | HighLevelAudienceIntegrationConfiguration | MadhiveAudienceIntegrationConfiguration | MailchimpAudienceIntegrationConfiguration | S3AudienceIntegrationConfiguration | TealiumAudienceIntegrationConfiguration | ZapierAudienceIntegrationConfiguration;

export type AudienceIntegrationConfigurationInput = {
  activation?: InputMaybe<ActivationAudienceIntegrationConfigurationInput>;
  adf?: InputMaybe<AdfAudienceIntegrationConfigurationInput>;
  beeswax?: InputMaybe<BeeswaxAudienceIntegrationConfigurationInput>;
  displayVideo360?: InputMaybe<DisplayVideo360CustomerMatchAudienceIntegrationConfigurationInput>;
  facebookCustomAudience?: InputMaybe<FacebookCustomAudienceAudienceIntegrationConfigurationInput>;
  googleCustomerMatch?: InputMaybe<GoogleCustomerMatchAudienceIntegrationConfigurationInput>;
  highLevel?: InputMaybe<HighLevelAudienceIntegrationConfigurationInput>;
  madhive?: InputMaybe<MadhiveAudienceIntegrationConfigurationInput>;
  mailchimp?: InputMaybe<MailchimpAudienceIntegrationConfigurationInput>;
  s3?: InputMaybe<S3AudienceIntegrationConfigurationInput>;
  tealium?: InputMaybe<TealiumAudienceIntegrationConfigurationInput>;
  zapier?: InputMaybe<ZapierAudienceIntegrationConfigurationInput>;
};

export type AudienceIntegrationConnection = {
  edges: Array<AudienceIntegrationEdge>;
  nodes: Array<AudienceIntegration>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AudienceIntegrationEdge = {
  cursor: Scalars['String']['output'];
  node?: Maybe<AudienceIntegration>;
};

export type AudienceIntegrationInput = {
  audienceId: Scalars['ID']['input'];
  configuration: AudienceIntegrationConfigurationInput;
  integrationType: AudienceIntegrationType;
  name: Scalars['String']['input'];
  /**
   * Inherits this activation template's stored configuration, including its sensitive values. Every value present in
   * "configuration" overrides the inherited one.
   */
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

export type AudienceIntegrationLastRunInfoInput = {
  hasWarnings?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  lastSyncedAt?: InputMaybe<Scalars['Date']['input']>;
  result?: InputMaybe<Scalars['String']['input']>;
  succeeded: Scalars['Boolean']['input'];
};

export type AudienceIntegrationMetadata = {
  description: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  integrationType: AudienceIntegrationType;
  /** Whether activations of this type can be saved as, or created from, an activation template. */
  supportsTemplates: Scalars['Boolean']['output'];
};

export type AudienceIntegrationTemplate = {
  /** Whether this template creates its activation on its own when an audience or an eligible segment is created. */
  automaticallyCreateActivations: Scalars['Boolean']['output'];
  /** Whether the organizations below this template's one can use it too. Only meaningful above a Customer organization. */
  cascadeToChildOrgs: Scalars['Boolean']['output'];
  /**
   * The template configuration with every value hidden to users returned as null, which is enough to prefill the
   * activation form. The hidden values stay on the server and are inherited when an activation is created from it.
   */
  configuration: AudienceIntegrationConfiguration;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  /** Whether segments of an audience get an activation from this template as well. */
  includeSegments: Scalars['Boolean']['output'];
  /**
   * The ancestor organization this template is inherited from, relative to the organization it was read through. Null
   * when that organization owns the template, and always null on audienceIntegrationTemplatesPage, which reads templates
   * through an audience rather than an organization.
   */
  inheritedFromOrganization?: Maybe<BaseOrganization>;
  integrationType: AudienceIntegrationType;
  name: Scalars['String']['output'];
  organization: BaseOrganization;
};

export type AudienceIntegrationTemplateConnection = {
  edges: Array<AudienceIntegrationTemplateEdge>;
  nodes: Array<AudienceIntegrationTemplate>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AudienceIntegrationTemplateEdge = {
  cursor: Scalars['String']['output'];
  node?: Maybe<AudienceIntegrationTemplate>;
};

export type AudienceIntegrationTemplateInput = {
  /** Checks the source template against this audience. Requires templateId; checked against the template's own organization otherwise. */
  audienceId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The activation to copy the stored configuration from, secret values included. Provide it, templateId, or
   * integrationType and configuration to build the template from scratch, but only one of the three.
   */
  audienceIntegrationId?: InputMaybe<Scalars['ID']['input']>;
  /** Defaults to true, which is how every template created before this setting existed behaves. */
  automaticallyCreateActivations?: InputMaybe<Scalars['Boolean']['input']>;
  cascadeToChildOrgs?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The whole configuration when the template is built from scratch. On a templateId source it is an overlay on the
   * copied configuration instead: a field left out keeps the source template's value, which is how a secret is
   * inherited without ever being sent back. Cannot be sent with audienceIntegrationId.
   */
  configuration?: InputMaybe<AudienceIntegrationConfigurationInput>;
  includeSegments?: InputMaybe<Scalars['Boolean']['input']>;
  integrationType?: InputMaybe<AudienceIntegrationType>;
  name: Scalars['String']['input'];
  /**
   * Defaults to whichever organization the chosen source was checked against: the source activation's for
   * audienceIntegrationId, the given audience's for templateId with audienceId, or the source template's own for
   * templateId alone. Must be that organization or one of its ancestors. Required only when the template is built from
   * a raw integrationType and configuration, which has no source organization to default to.
   */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The Activation Template to copy the integrationType and configuration from instead. Cannot be sent with
   * audienceIntegrationId, and an integrationType sent with it has to match the source template's.
   */
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

export type AudienceIntegrationTemplateUpdateInput = {
  automaticallyCreateActivations?: InputMaybe<Scalars['Boolean']['input']>;
  cascadeToChildOrgs?: InputMaybe<Scalars['Boolean']['input']>;
  configuration?: InputMaybe<AudienceIntegrationConfigurationInput>;
  id: Scalars['ID']['input'];
  includeSegments?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AudienceIntegrationTestInput = {
  audienceId: Scalars['ID']['input'];
  configuration: AudienceIntegrationConfigurationInput;
  integrationId?: InputMaybe<Scalars['ID']['input']>;
  integrationType: AudienceIntegrationType;
  name: Scalars['String']['input'];
  /** Inherits this activation template's stored configuration, the same way the creation does. */
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

export type AudienceIntegrationTestResult = {
  /** @deprecated Please use the 'message' property instead. */
  failureReason?: Maybe<Scalars['String']['output']>;
  hasWarnings?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum AudienceIntegrationType {
  Adf = 'ADF',
  Activation = 'Activation',
  Beeswax = 'Beeswax',
  DisplayVideo360CustomerMatch = 'DisplayVideo360CustomerMatch',
  FacebookCustomAudience = 'FacebookCustomAudience',
  GoogleCustomerMatch = 'GoogleCustomerMatch',
  HighLevel = 'HighLevel',
  Madhive = 'Madhive',
  Mailchimp = 'Mailchimp',
  S3 = 'S3',
  Tealium = 'Tealium',
  Zapier = 'Zapier'
}

export type AudienceIntegrationUpdateInput = {
  configuration?: InputMaybe<AudienceIntegrationConfigurationInput>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AudienceLookalikeCountInput = {
  baseAudienceId: Scalars['ID']['input'];
  dateRange?: InputMaybe<DateRangeInput>;
  similarityPercentage: Scalars['Int']['input'];
};

export type AudienceLookalikeInfo = {
  dateRange?: Maybe<DateRange>;
  isProcessingAddOns?: Maybe<Scalars['Boolean']['output']>;
  matchedCount?: Maybe<Scalars['Int']['output']>;
  requestedCount: Scalars['Int']['output'];
  similarityPercentage: Scalars['Int']['output'];
};

export type AudienceLookalikeInput = {
  baseAudienceId: Scalars['ID']['input'];
  dateRange?: InputMaybe<DateRangeInput>;
  name: Scalars['String']['input'];
  requestedCount: Scalars['Int']['input'];
  similarityPercentage: Scalars['Int']['input'];
  verifyEmails?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AudienceMatchCount = {
  audience: BaseAudience;
  count: Scalars['Int']['output'];
};

export type AudienceMatchbackAttribution = {
  /** The largest combinations, ordered by count, largest first. */
  combinations: Array<AudienceMatchbackCombination>;
  /** Everything past the requested maximum, merged into one entry. Absent when nothing was merged. */
  other?: Maybe<AudienceMatchbackOtherCombination>;
};

export type AudienceMatchbackCombination = {
  /**
   * The comparisons every person in this combination matched through, and only those. Someone who matched two
   * comparisons belongs here, and to neither single-comparison combination.
   */
  comparisons: Array<AudienceMatchbackComparison>;
  /** The people this combination holds. Follows Elasticsearch terms accuracy, so it can read slightly low. */
  count: Scalars['Int']['output'];
};

export type AudienceMatchbackComparison = {
  /**
   * The audience this comparison was built from. Restricted when the viewer reaches the Matchback through a
   * share that does not extend to it, and still returned once it has been deleted, with deletedAt set, so a
   * Matchback can always name what it was built against.
   */
  audience: BaseAudience;
  /**
   * The ranges the caller selected for this comparison. Read them against the audience's condition: on a
   * Pixel they are the filter itself, closed at creation; on a Lookalike there are none; on every other
   * condition they are the window the selection was resolved from.
   */
  dateRanges?: Maybe<Array<DateRange>>;
  id: Scalars['ID']['output'];
};

export type AudienceMatchbackComparisonInput = {
  audienceId: Scalars['ID']['input'];
  dateRanges?: InputMaybe<Array<DateRangeInput>>;
};

export type AudienceMatchbackInfo = {
  /** The ranges the base Customer List was narrowed to at creation. Absent when the whole base was taken. */
  baseDateRanges?: Maybe<Array<DateRange>>;
  comparisons?: Maybe<Array<AudienceMatchbackComparison>>;
  /** The base Customer List's custom fields as they stood when the Matchback was created. */
  customFields?: Maybe<Array<AudienceCustomerListCustomField>>;
};

export type AudienceMatchbackInput = {
  baseAudienceId: Scalars['ID']['input'];
  baseDateRanges?: InputMaybe<Array<DateRangeInput>>;
  comparisons: Array<AudienceMatchbackComparisonInput>;
  name: Scalars['String']['input'];
};

export type AudienceMatchbackOtherCombination = {
  /** How many combinations were merged into this one. May be approximate, and is never below one. */
  combinationCount: Scalars['Int']['output'];
  /**
   * The people those merged combinations hold, as the Matchback's peopleCount minus every count reported
   * alongside it.
   */
  count: Scalars['Int']['output'];
};

export type AudienceNumberFilterInput = {
  field: AudienceFilterNumberField;
  operator: NumberOperatorsInput;
};

export type AudiencePixelCodeSnippets = {
  body: Scalars['String']['output'];
  head: Scalars['String']['output'];
};

export type AudiencePixelEditInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pixelEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AudiencePixelInfo = {
  categoriesProcessed: Scalars['Boolean']['output'];
};

export type AudiencePixelInput = {
  billing: AudienceBillingInput;
  /** @deprecated Please use hostAndPath instead of this. */
  host?: InputMaybe<Scalars['String']['input']>;
  hostAndPath?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LocationInput>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  pixelMatchingCadence?: InputMaybe<PixelMatchingCadence>;
  quota?: InputMaybe<AudienceQuotaInput>;
  quotaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AudiencePixelSettings = {
  billing: AudienceBilling;
  codeSnippets?: Maybe<AudiencePixelCodeSnippets>;
  host: Scalars['String']['output'];
  hostAndPath: Scalars['String']['output'];
  lastNewMatchDate?: Maybe<Scalars['Date']['output']>;
  location?: Maybe<Location>;
  pixelDisabledAt?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Please use pixelStatus instead of this. */
  pixelEnabled: Scalars['Boolean']['output'];
  pixelId: Scalars['String']['output'];
  pixelMatchingCadence: PixelMatchingCadence;
  pixelReachedQuotaAt?: Maybe<Scalars['Date']['output']>;
  pixelSetupStatus?: Maybe<PixelSetupStatus>;
  pixelStatus: AudiencePixelStatus;
  quota: AudienceQuota;
  quotaEnabled: Scalars['Boolean']['output'];
  sendsPixelStatsEmail?: Maybe<Scalars['Boolean']['output']>;
};


export type AudiencePixelSettingsSendsPixelStatsEmailArgs = {
  retrieveFinalValue?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AudiencePixelSettingsUpdateInput = {
  hostAndPath?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  pixelEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  quota?: InputMaybe<AudienceQuotaInput>;
  quotaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AudiencePixelStatus {
  Disabled = 'Disabled',
  Enabled = 'Enabled',
  QuotaReached = 'QuotaReached'
}

export enum AudienceProcessingStatus {
  Completed = 'Completed',
  Error = 'Error',
  Pending = 'Pending',
  Processing = 'Processing'
}

export type AudiencePulseInfo = BaseAdditionsInfo & {
  additions?: Maybe<Array<PulseAdditionsArrayInfo>>;
  isProcessingAddOns?: Maybe<Scalars['Boolean']['output']>;
  items: Array<PulseItem>;
  lastProcessedAt?: Maybe<Scalars['Date']['output']>;
  lastProcessedDateRange?: Maybe<DateRange>;
  lastSuccessfullyProcessedAt?: Maybe<Scalars['Date']['output']>;
  processingAdditionInfo?: Maybe<PulseProcessingAdditionInfo>;
  subscriptionAmount: Scalars['Int']['output'];
  subscriptionCount: Scalars['Int']['output'];
  /** @deprecated topicIds is deprecated. Use items instead. */
  topicIds: Array<Scalars['String']['output']>;
};

export type AudiencePulseInput = {
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  filters?: InputMaybe<Array<PersonFilterInput>>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  subCategoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  subscriptionCount: Scalars['Int']['input'];
  topicIds: Array<Scalars['String']['input']>;
  verifyEmails?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AudienceQuota = {
  /** @deprecated Please use the quotaEnabled instead of this. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  period?: Maybe<AudienceQuotaPeriod>;
};

export type AudienceQuotaInfo = {
  currentCount?: Maybe<Scalars['Int']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  period?: Maybe<AudienceQuotaPeriod>;
  pixelStatus: AudiencePixelStatus;
};

export type AudienceQuotaInput = {
  /** @deprecated Please use the quotaEnabled instead of this. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<AudienceQuotaPeriod>;
};

export enum AudienceQuotaPeriod {
  Monthly = 'Monthly',
  Weekly = 'Weekly'
}

export type AudienceScopedField = {
  audienceIds: Array<Scalars['Int']['output']>;
  customFieldName?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
};

export type AudienceSegmentInput = {
  filters: Array<PersonFilterInput>;
  name: Scalars['String']['input'];
  parentAudienceId: Scalars['ID']['input'];
};

export type AudienceUpdateInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AudienceUserRole = {
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
  user: User;
};

export type AudiencesCount = {
  customerList: Scalars['Int']['output'];
  global: Scalars['Int']['output'];
  lookalike: Scalars['Int']['output'];
  pixel: Scalars['Int']['output'];
  pulse: Scalars['Int']['output'];
};

export type AutoCustomerListCreationConfiguration = {
  mapping: AudienceCustomerListColumnMappings;
  verifyEmails: Scalars['Boolean']['output'];
};

export enum AwsRegion {
  AfSouth1 = 'AfSouth1',
  ApEast1 = 'ApEast1',
  ApNortheast1 = 'ApNortheast1',
  ApNortheast2 = 'ApNortheast2',
  ApNortheast3 = 'ApNortheast3',
  ApSouth1 = 'ApSouth1',
  ApSouth2 = 'ApSouth2',
  ApSoutheast1 = 'ApSoutheast1',
  ApSoutheast2 = 'ApSoutheast2',
  ApSoutheast3 = 'ApSoutheast3',
  ApSoutheast4 = 'ApSoutheast4',
  CaCentral1 = 'CaCentral1',
  EuCentral1 = 'EuCentral1',
  EuCentral2 = 'EuCentral2',
  EuNorth1 = 'EuNorth1',
  EuSouth1 = 'EuSouth1',
  EuSouth2 = 'EuSouth2',
  EuWest1 = 'EuWest1',
  EuWest2 = 'EuWest2',
  EuWest3 = 'EuWest3',
  IlCentral1 = 'IlCentral1',
  MeCentral1 = 'MeCentral1',
  MeSouth1 = 'MeSouth1',
  SaEast1 = 'SaEast1',
  UsEast1 = 'UsEast1',
  UsEast2 = 'UsEast2',
  UsGovEast1 = 'UsGovEast1',
  UsGovWest1 = 'UsGovWest1',
  UsWest1 = 'UsWest1',
  UsWest2 = 'UsWest2'
}

export type BaseAdditionsArrayInfo = {
  date: Scalars['Date']['output'];
  matchedCount: Scalars['Int']['output'];
  requestedCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type BaseAdditionsInfo = {
  additions?: Maybe<Array<BaseAdditionsArrayInfo>>;
  isProcessingAddOns?: Maybe<Scalars['Boolean']['output']>;
  lastProcessedAt?: Maybe<Scalars['Date']['output']>;
  lastSuccessfullyProcessedAt?: Maybe<Scalars['Date']['output']>;
  processingAdditionInfo?: Maybe<BaseProcessingAdditionInfo>;
};

export type BaseAudience = {
  baseAudience?: Maybe<BaseAudience>;
  categories?: Maybe<Array<AudienceCategory>>;
  condition?: Maybe<AudienceCondition>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  filters?: Maybe<Array<PersonFilter>>;
  id: Scalars['ID']['output'];
  info?: Maybe<AudienceInfo>;
  name?: Maybe<Scalars['String']['output']>;
  parentAudience?: Maybe<BaseAudience>;
};

export type BaseAudienceConnection = {
  edges: Array<BaseAudienceEdge>;
  nodes: Array<BaseAudience>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAudienceEdge = {
  cursor: Scalars['String']['output'];
  node?: Maybe<BaseAudience>;
};

export type BaseOrganization = {
  businessDataEnabled?: Maybe<Scalars['Boolean']['output']>;
  disableEmailValidation?: Maybe<Scalars['Boolean']['output']>;
  hiddenPeopleFields?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  madhiveEnabled?: Maybe<Scalars['Boolean']['output']>;
  matchbackEnabled?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationType?: Maybe<OrganizationType>;
};


export type BaseOrganizationDisableEmailValidationArgs = {
  retrieveFinalValue?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BaseProcessingAdditionInfo = {
  date: Scalars['Date']['output'];
  requestedCount: Scalars['Int']['output'];
};

export type BaseRole = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organization?: Maybe<RestrictedAccessOrganization>;
  organizationId?: Maybe<Scalars['ID']['output']>;
};

export type BaseUser = {
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type BeeswaxAudienceIntegrationConfiguration = {
  buzzKey: Scalars['String']['output'];
  email: Scalars['String']['output'];
  hemSalt?: Maybe<Scalars['String']['output']>;
  lastUploadIds?: Maybe<Array<Scalars['String']['output']>>;
  password?: Maybe<Scalars['String']['output']>;
  /** Null on a template configuration that leaves the segment for the activation creation to create. */
  segmentKey?: Maybe<Scalars['String']['output']>;
};

export type BeeswaxAudienceIntegrationConfigurationInput = {
  buzzKey?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  hemSalt?: InputMaybe<Scalars['String']['input']>;
  lastUploadIds?: InputMaybe<Array<Scalars['String']['input']>>;
  password?: InputMaybe<Scalars['String']['input']>;
  segmentKey?: InputMaybe<Scalars['String']['input']>;
};

export type BeeswaxCreateSegmentInput = {
  advertiserId?: InputMaybe<Scalars['Int']['input']>;
  aggregateExcludes?: InputMaybe<Scalars['Boolean']['input']>;
  alternativeId?: InputMaybe<Scalars['String']['input']>;
  /** Checks the template against this audience. Requires templateId; checked against the template's own organization otherwise. */
  audienceId?: InputMaybe<Scalars['ID']['input']>;
  audienceIntegrationId?: InputMaybe<Scalars['ID']['input']>;
  buzzKey?: InputMaybe<Scalars['String']['input']>;
  cpmCost?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  /** Reads the Beeswax credentials from this Activation Template instead. Cannot be sent with buzzKey/email/password or audienceIntegrationId. */
  templateId?: InputMaybe<Scalars['ID']['input']>;
  ttlDays?: InputMaybe<Scalars['Int']['input']>;
};

export type BeeswaxGetSegmentInput = {
  /** Checks the template against this audience. Requires templateId; checked against the template's own organization otherwise. */
  audienceId?: InputMaybe<Scalars['ID']['input']>;
  audienceIntegrationId?: InputMaybe<Scalars['ID']['input']>;
  buzzKey?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  segmentKey: Scalars['String']['input'];
  /** Reads the Beeswax credentials from this Activation Template instead. Cannot be sent with buzzKey/email/password or audienceIntegrationId. */
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

export type BeeswaxListSegmentsInput = {
  /** Checks the template against this audience. Requires templateId; checked against the template's own organization otherwise. */
  audienceId?: InputMaybe<Scalars['ID']['input']>;
  audienceIntegrationId?: InputMaybe<Scalars['ID']['input']>;
  buzzKey?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  nextCursor?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  /** Reads the Beeswax credentials from this Activation Template instead. Cannot be sent with buzzKey/email/password or audienceIntegrationId. */
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

export type BeeswaxListSegmentsResult = {
  hasNextPage: Scalars['Boolean']['output'];
  items: Array<BeeswaxSegment>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type BeeswaxSegment = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type BooleanFilter = {
  customField?: Maybe<Scalars['String']['output']>;
  field?: Maybe<FilterBooleanField>;
  operator: BooleanOperators;
};

export type BooleanFilterInput = {
  customField?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<FilterBooleanField>;
  operator: BooleanOperatorsInput;
};

export type BooleanOperators = {
  eq?: Maybe<Scalars['Boolean']['output']>;
  exists?: Maybe<Scalars['Boolean']['output']>;
};

export type BooleanOperatorsInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Browser = {
  name?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type BucketConnection = {
  /** A list of nodes. */
  nodes: Array<BucketElement>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type BucketElement = {
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
};

/** An action the calling user can be allowed to perform in an organization. */
export enum Capability {
  CreatePixelAudience = 'CreatePixelAudience'
}

/** Why a capability can't be used in an organization. */
export enum CapabilityUnavailableReason {
  /** The user has no role granting the permission the action needs. */
  NoPermission = 'NoPermission',
  /** The organization's payment is paused. */
  PaymentPaused = 'PaymentPaused',
  /** The organization's plan allows no more audiences of this kind. */
  PlanLimitReached = 'PlanLimitReached'
}

export type CompleteAudienceCustomerListInput = {
  audienceId: Scalars['ID']['input'];
  processingResultInfo?: InputMaybe<CompleteAudienceCustomerListProcessingResultInfoInput>;
  requestedCount?: InputMaybe<Scalars['Int']['input']>;
  result?: InputMaybe<Scalars['String']['input']>;
  succeeded: Scalars['Boolean']['input'];
};

export type CompleteAudienceCustomerListProcessingResultInfoInput = {
  invalidEntries?: InputMaybe<Array<CustomerListInvalidEntryInput>>;
};

export type CompleteAudienceGlobalInput = {
  audienceId: Scalars['ID']['input'];
  result?: InputMaybe<Scalars['String']['input']>;
  succeeded: Scalars['Boolean']['input'];
};

export type CompleteAudienceLookalikeInput = {
  audienceId: Scalars['ID']['input'];
  result?: InputMaybe<Scalars['String']['input']>;
  succeeded: Scalars['Boolean']['input'];
};

export type CompleteAudienceMatchbackInput = {
  audienceId: Scalars['ID']['input'];
  result?: InputMaybe<Scalars['String']['input']>;
  succeeded: Scalars['Boolean']['input'];
};

export type CompleteAudiencePulseInput = {
  audienceId: Scalars['ID']['input'];
  result?: InputMaybe<Scalars['String']['input']>;
  succeeded: Scalars['Boolean']['input'];
};

export enum ComponentKind {
  MeteredComponent = 'MeteredComponent',
  OnOffComponent = 'OnOffComponent',
  PrepaidUsageComponent = 'PrepaidUsageComponent',
  QuantityBasedComponent = 'QuantityBasedComponent'
}

export type Configuration = {
  clientApplicationId: Scalars['String']['output'];
  domain: Scalars['String']['output'];
  identityPoolId: Scalars['String']['output'];
  region: Scalars['String']['output'];
  userPoolId: Scalars['String']['output'];
};

export type ConfirmPendingAudiencePulseInput = {
  id: Scalars['ID']['input'];
  subscriptionCount: Scalars['Int']['input'];
};

export type Conversation = {
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  lastUserMessageAt?: Maybe<Scalars['Date']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type ConversationConnection = {
  edges: Array<ConversationEdge>;
  nodes: Array<Conversation>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ConversationEdge = {
  cursor: Scalars['String']['output'];
  node: Conversation;
};

export type ConversationMessage = {
  a2ui?: Maybe<Scalars['JSON']['output']>;
  a2uiSubmission?: Maybe<Scalars['JSON']['output']>;
  block?: Maybe<Scalars['JSON']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  citations?: Maybe<Array<MessageCitation>>;
  id: Scalars['String']['output'];
  mutationConfirmation?: Maybe<Scalars['JSON']['output']>;
  pdfReports?: Maybe<Array<ConversationPdfReport>>;
  role: ConversationRole;
  sources?: Maybe<Array<MessageSource>>;
};

export type ConversationMessageConnection = {
  agentSessionId: Scalars['String']['output'];
  nodes: Array<ConversationMessage>;
  pageInfo: PageInfo;
  title: Scalars['String']['output'];
};

export type ConversationPdfReport = {
  relativePath: Scalars['String']['output'];
};

export type ConversationReference = {
  audienceCondition?: Maybe<AudienceCondition>;
  deepLink: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: ConversationReferenceType;
};

export type ConversationReferenceConnection = {
  edges: Array<ConversationReferenceEdge>;
  nodes: Array<ConversationReference>;
  pageInfo: PageInfo;
};

export type ConversationReferenceEdge = {
  cursor: Scalars['String']['output'];
  node: ConversationReference;
};

export type ConversationReferenceFilterInput = {
  audienceCondition?: InputMaybe<AudienceCondition>;
  entityType: ConversationReferenceType;
};

export enum ConversationReferenceType {
  Audience = 'Audience',
  Organization = 'Organization'
}

export enum ConversationRole {
  Assistant = 'Assistant',
  Other = 'Other',
  Tool = 'Tool',
  User = 'User'
}

export enum ConversationSection {
  PixelAudienceOverviewAmountOfVisits = 'PixelAudienceOverviewAmountOfVisits',
  PixelAudienceOverviewAttributionSources = 'PixelAudienceOverviewAttributionSources',
  PixelAudienceOverviewBusinessInsight = 'PixelAudienceOverviewBusinessInsight',
  PixelAudienceOverviewPixelCounts = 'PixelAudienceOverviewPixelCounts',
  PixelAudienceOverviewSegments = 'PixelAudienceOverviewSegments',
  PixelAudienceOverviewUserJourney = 'PixelAudienceOverviewUserJourney'
}

export type Coordinates = {
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type CoordinatesInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type CreateOrganizationInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentOrganizationId: Scalars['ID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  pixelDomain?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
};

export type CustomField = {
  fieldType: CustomFieldType;
  name: Scalars['String']['output'];
};

export enum CustomFieldType {
  Boolean = 'Boolean',
  Date = 'Date',
  Integer = 'Integer',
  String = 'String'
}

export type CustomerListAdditionsArrayInfo = BaseAdditionsArrayInfo & {
  date: Scalars['Date']['output'];
  delimiter?: Maybe<Scalars['String']['output']>;
  mapping: AudienceCustomerListColumnMappings;
  matchedCount: Scalars['Int']['output'];
  requestedCount: Scalars['Int']['output'];
  s3FileUri: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export type CustomerListFailedAdditionsArrayInfo = {
  date: Scalars['Date']['output'];
  delimiter?: Maybe<Scalars['String']['output']>;
  error: Scalars['String']['output'];
  mapping: AudienceCustomerListColumnMappings;
  s3FileUri: Scalars['String']['output'];
};

export type CustomerListInvalidEntry = {
  columnName: Scalars['String']['output'];
  fieldType: CustomFieldType;
  rowNumber: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type CustomerListInvalidEntryInput = {
  columnName: Scalars['String']['input'];
  fieldType: CustomFieldType;
  rowNumber: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CustomerListInvalidImportData = {
  invalidEntries: Array<CustomerListInvalidEntry>;
};

export type CustomerListProcessingAdditionInfo = BaseProcessingAdditionInfo & {
  date: Scalars['Date']['output'];
  delimiter?: Maybe<Scalars['String']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  mapping: AudienceCustomerListColumnMappings;
  requestedCount: Scalars['Int']['output'];
  s3FileUri: Scalars['String']['output'];
};

export type DateFilter = {
  customField?: Maybe<Scalars['String']['output']>;
  field?: Maybe<FilterDateField>;
  operator: DateOperators;
};

export type DateFilterInput = {
  customField?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<FilterDateField>;
  operator: DateOperatorsInput;
};

export type DateIntervalInput = {
  unit: DateIntervalUnit;
  value: Scalars['Int']['input'];
};

export enum DateIntervalUnit {
  Day = 'Day',
  Hour = 'Hour',
  /** Only single calendar units are supported (that is, 1 month) */
  Month = 'Month',
  /** Only single calendar units are supported (that is, 1 quarter) */
  Quarter = 'Quarter',
  /** Only single calendar units are supported (that is, 1 week) */
  Week = 'Week',
  /** Only single calendar units are supported (that is, 1 year) */
  Year = 'Year'
}

export type DateOperators = {
  between?: Maybe<DateRange>;
  exists?: Maybe<Scalars['Boolean']['output']>;
  gt?: Maybe<Scalars['FilterDate']['output']>;
  gte?: Maybe<Scalars['FilterDate']['output']>;
  lt?: Maybe<Scalars['FilterDate']['output']>;
  lte?: Maybe<Scalars['FilterDate']['output']>;
};

export type DateOperatorsInput = {
  between?: InputMaybe<DateRangeInput>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['FilterDate']['input']>;
  gte?: InputMaybe<Scalars['FilterDate']['input']>;
  lt?: InputMaybe<Scalars['FilterDate']['input']>;
  lte?: InputMaybe<Scalars['FilterDate']['input']>;
};

export type DateRange = {
  from: Scalars['FilterDate']['output'];
  to: Scalars['FilterDate']['output'];
};

export type DateRangeInput = {
  from: Scalars['FilterDate']['input'];
  to: Scalars['FilterDate']['input'];
};

export enum DisplayVideo360AudienceOwnerType {
  Advertiser = 'Advertiser',
  Partner = 'Partner'
}

export type DisplayVideo360CustomerMatchAudienceIntegrationConfiguration = {
  advertiserId?: Maybe<Scalars['String']['output']>;
  audienceOwnerType?: Maybe<DisplayVideo360AudienceOwnerType>;
  customerMatchAudienceId?: Maybe<Scalars['String']['output']>;
  daysToKeep: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  googleUserAccountId?: Maybe<Scalars['String']['output']>;
  historicalDataSync: Scalars['Boolean']['output'];
  lastIngestionCheckedAt?: Maybe<Scalars['Date']['output']>;
  lastIngestionDiagnosticsSummary?: Maybe<Scalars['String']['output']>;
  lastIngestionRequestIds?: Maybe<Array<Scalars['String']['output']>>;
  lastIngestionStatus?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  partnerId?: Maybe<Scalars['String']['output']>;
  status: DisplayVideo360CustomerMatchConnectionStatus;
  userId?: Maybe<Scalars['String']['output']>;
};

export type DisplayVideo360CustomerMatchAudienceIntegrationConfigurationInput = {
  advertiserId?: InputMaybe<Scalars['String']['input']>;
  audienceOwnerType?: InputMaybe<DisplayVideo360AudienceOwnerType>;
  daysToKeep?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  googleUserAccountId?: InputMaybe<Scalars['String']['input']>;
  historicalDataSync?: InputMaybe<Scalars['Boolean']['input']>;
  lastIngestionCheckedAt?: InputMaybe<Scalars['Date']['input']>;
  lastIngestionDiagnosticsSummary?: InputMaybe<Scalars['String']['input']>;
  lastIngestionRequestIds?: InputMaybe<Array<Scalars['String']['input']>>;
  lastIngestionStatus?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
};

export enum DisplayVideo360CustomerMatchConnectionStatus {
  Connected = 'Connected',
  Disconnected = 'Disconnected'
}

export enum DistanceUnit {
  Kilometers = 'Kilometers',
  Miles = 'Miles'
}

export type DomainConfiguration = {
  domain: Scalars['String']['output'];
  emailSender: Scalars['String']['output'];
  emailTemplateData: Scalars['JSON']['output'];
};

export type EntitiesCount = {
  audiences: Scalars['Int']['output'];
  organizations: Scalars['Int']['output'];
  users: Scalars['Int']['output'];
};

export type EntityLog = {
  actedByUserType?: Maybe<UserType>;
  actionType: ActionType;
  actor?: Maybe<User>;
  audience?: Maybe<Audience>;
  createdAt: Scalars['Date']['output'];
  entityId: Scalars['ID']['output'];
  entityType: EntityType;
  field?: Maybe<Scalars['String']['output']>;
  newValue?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  user?: Maybe<User>;
};

export enum EntityType {
  Audience = 'Audience',
  AudienceIntegration = 'AudienceIntegration',
  AudienceIntegrationTemplate = 'AudienceIntegrationTemplate',
  Invite = 'Invite',
  Ketch = 'Ketch',
  Organization = 'Organization',
  User = 'User',
  UserAudience = 'UserAudience',
  UserOrganization = 'UserOrganization'
}

export enum ExportType {
  DigitalActivations = 'DigitalActivations',
  Emails = 'Emails',
  Journeys = 'Journeys',
  Maids = 'Maids',
  People = 'People'
}

export type ExtendedStringFilter = {
  field: FilterExtendedStringField;
  negate?: Maybe<Scalars['Boolean']['output']>;
  operator: ExtendedStringOperators;
};

export type ExtendedStringFilterInput = {
  field: FilterExtendedStringField;
  negate?: InputMaybe<Scalars['Boolean']['input']>;
  operator: ExtendedStringOperatorsInput;
};

export type ExtendedStringOperators = {
  contains?: Maybe<Scalars['String']['output']>;
  eq?: Maybe<Scalars['String']['output']>;
  in?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  regex?: Maybe<Scalars['String']['output']>;
  startsWith?: Maybe<Scalars['String']['output']>;
};

export type ExtendedStringOperatorsInput = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type FacebookCustomAudienceAudienceIntegrationConfiguration = {
  accessToken?: Maybe<Scalars['String']['output']>;
  adAccountId: Scalars['String']['output'];
  /** Null on a template configuration, since the custom audience is created when the activation is. */
  customAudienceId?: Maybe<Scalars['String']['output']>;
  daysToKeep: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  historicalDataSync: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type FacebookCustomAudienceAudienceIntegrationConfigurationInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  adAccountId: Scalars['String']['input'];
  daysToKeep: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  historicalDataSync?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type FieldAggregate = {
  first: HistoricalValue;
  last: HistoricalValue;
};

export type FieldBreakdownError = {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export enum FieldCategory {
  Business = 'Business',
  Geo = 'Geo',
  Person = 'Person'
}

export enum FieldType {
  Boolean = 'Boolean',
  Date = 'Date',
  Number = 'Number',
  String = 'String'
}

export enum FileFormat {
  Csv = 'Csv',
  JsonLines = 'JsonLines'
}

export enum FilterBooleanField {
  AmexCard = 'AmexCard',
  BankCard = 'BankCard',
  CreditCard = 'CreditCard',
  Multilingual = 'Multilingual',
  OwnsInvestment = 'OwnsInvestment',
  OwnsStocksAndBonds = 'OwnsStocksAndBonds',
  PoliticalContributor = 'PoliticalContributor',
  PremiumAmexCardOwner = 'PremiumAmexCardOwner',
  PremiumCard = 'PremiumCard',
  PrimaryResidence = 'PrimaryResidence',
  Voter = 'Voter'
}

export type FilterConfiguration = {
  fieldAudienceTypes?: Maybe<Array<AudienceCondition>>;
  numberFilterConfiguration?: Maybe<NumberFilterConfiguration>;
  stringFilterConfiguration?: Maybe<StringFilterConfiguration>;
};

export enum FilterDateField {
  AdditionDate = 'AdditionDate',
  PixelFirstHitDate = 'PixelFirstHitDate',
  PixelHitDate = 'PixelHitDate'
}

export enum FilterExtendedStringField {
  PixelHitUrl = 'PixelHitUrl'
}

/** All these fields are guaranteed to have a 1:1 match in any of the FilterXField enums. */
export enum FilterField {
  AdditionDate = 'AdditionDate',
  AdultsInHousehold = 'AdultsInHousehold',
  Age = 'Age',
  AmexCard = 'AmexCard',
  BankCard = 'BankCard',
  Bebacks = 'Bebacks',
  Behaviors = 'Behaviors',
  BusinessEmail = 'BusinessEmail',
  ChildrenAgeRanges = 'ChildrenAgeRanges',
  ChildrenInHousehold = 'ChildrenInHousehold',
  City = 'City',
  CompanyCity = 'CompanyCity',
  CompanyDomain = 'CompanyDomain',
  CompanyEmployeeCount = 'CompanyEmployeeCount',
  CompanyName = 'CompanyName',
  CompanyRevenue = 'CompanyRevenue',
  CompanySic = 'CompanySic',
  CompanyState = 'CompanyState',
  CreditCard = 'CreditCard',
  CreditRange = 'CreditRange',
  Department = 'Department',
  Dma = 'Dma',
  DwellingType = 'DwellingType',
  Education = 'Education',
  Email = 'Email',
  EthnicGroup = 'EthnicGroup',
  FirstName = 'FirstName',
  Gender = 'Gender',
  Generation = 'Generation',
  HomeHeatType = 'HomeHeatType',
  HomeOwner = 'HomeOwner',
  HomePrice = 'HomePrice',
  HomePurchasedYearsAgo = 'HomePurchasedYearsAgo',
  HomeValue = 'HomeValue',
  HostAndPath = 'HostAndPath',
  HouseholdIncome = 'HouseholdIncome',
  HouseholdNetWorth = 'HouseholdNetWorth',
  IncomeLevels = 'IncomeLevels',
  Interests = 'Interests',
  JobTitle = 'JobTitle',
  Language = 'Language',
  LastName = 'LastName',
  MaritalStatus = 'MaritalStatus',
  MortgageAge = 'MortgageAge',
  MortgageAmount = 'MortgageAmount',
  MortgageLoanType = 'MortgageLoanType',
  MortgageRefinanceAge = 'MortgageRefinanceAge',
  MortgageRefinanceAmount = 'MortgageRefinanceAmount',
  MortgageRefinanceType = 'MortgageRefinanceType',
  Multilingual = 'Multilingual',
  NetWorth = 'NetWorth',
  NewCreditOfferedHousehold = 'NewCreditOfferedHousehold',
  NumberOfVehiclesInHousehold = 'NumberOfVehiclesInHousehold',
  OccupationDetail = 'OccupationDetail',
  OwnsInvestment = 'OwnsInvestment',
  OwnsStocksAndBonds = 'OwnsStocksAndBonds',
  PathPrefix = 'PathPrefix',
  PeopleInHousehold = 'PeopleInHousehold',
  Personality = 'Personality',
  Phone = 'Phone',
  PixelFirstHitDate = 'PixelFirstHitDate',
  PixelHitDate = 'PixelHitDate',
  PixelHitUrl = 'PixelHitUrl',
  PixelLastHitDate = 'PixelLastHitDate',
  PoliticalContributor = 'PoliticalContributor',
  PoliticalParty = 'PoliticalParty',
  PostalCode = 'PostalCode',
  PremiumAmexCardOwner = 'PremiumAmexCardOwner',
  PremiumCard = 'PremiumCard',
  PremiumIncomeHousehold = 'PremiumIncomeHousehold',
  PrimaryIndustry = 'PrimaryIndustry',
  PrimaryResidence = 'PrimaryResidence',
  PulseTopic = 'PulseTopic',
  Religion = 'Religion',
  SeniorityLevel = 'SeniorityLevel',
  State = 'State',
  Urbanicity = 'Urbanicity',
  UtmCampaign = 'UtmCampaign',
  UtmMedium = 'UtmMedium',
  UtmSource = 'UtmSource',
  UtmSourceAndMedium = 'UtmSourceAndMedium',
  VeteransInHousehold = 'VeteransInHousehold',
  Voter = 'Voter'
}

export enum FilterNumberField {
  AdultsInHousehold = 'AdultsInHousehold',
  Age = 'Age',
  Bebacks = 'Bebacks',
  ChildrenInHousehold = 'ChildrenInHousehold',
  HomePrice = 'HomePrice',
  HomePurchasedYearsAgo = 'HomePurchasedYearsAgo',
  HomeValue = 'HomeValue',
  MortgageAge = 'MortgageAge',
  MortgageAmount = 'MortgageAmount',
  MortgageRefinanceAge = 'MortgageRefinanceAge',
  MortgageRefinanceAmount = 'MortgageRefinanceAmount',
  NumberOfVehiclesInHousehold = 'NumberOfVehiclesInHousehold',
  PeopleInHousehold = 'PeopleInHousehold',
  VeteransInHousehold = 'VeteransInHousehold'
}

export enum FilterStringField {
  Behaviors = 'Behaviors',
  BusinessEmail = 'BusinessEmail',
  ChildrenAgeRanges = 'ChildrenAgeRanges',
  City = 'City',
  CompanyCity = 'CompanyCity',
  CompanyDomain = 'CompanyDomain',
  CompanyEmployeeCount = 'CompanyEmployeeCount',
  CompanyName = 'CompanyName',
  CompanyRevenue = 'CompanyRevenue',
  CompanySic = 'CompanySic',
  CompanyState = 'CompanyState',
  CreditRange = 'CreditRange',
  Department = 'Department',
  Dma = 'Dma',
  DwellingType = 'DwellingType',
  Education = 'Education',
  Email = 'Email',
  EthnicGroup = 'EthnicGroup',
  FirstName = 'FirstName',
  Gender = 'Gender',
  Generation = 'Generation',
  HomeHeatType = 'HomeHeatType',
  HomeOwner = 'HomeOwner',
  HostAndPath = 'HostAndPath',
  HouseholdIncome = 'HouseholdIncome',
  HouseholdNetWorth = 'HouseholdNetWorth',
  IncomeLevels = 'IncomeLevels',
  Interests = 'Interests',
  JobTitle = 'JobTitle',
  Language = 'Language',
  LastName = 'LastName',
  MaritalStatus = 'MaritalStatus',
  MortgageLoanType = 'MortgageLoanType',
  MortgageRefinanceType = 'MortgageRefinanceType',
  NetWorth = 'NetWorth',
  NewCreditOfferedHousehold = 'NewCreditOfferedHousehold',
  OccupationDetail = 'OccupationDetail',
  PathPrefix = 'PathPrefix',
  Personality = 'Personality',
  Phone = 'Phone',
  PoliticalParty = 'PoliticalParty',
  PostalCode = 'PostalCode',
  PremiumIncomeHousehold = 'PremiumIncomeHousehold',
  PrimaryIndustry = 'PrimaryIndustry',
  PulseTopic = 'PulseTopic',
  Religion = 'Religion',
  SeniorityLevel = 'SeniorityLevel',
  State = 'State',
  Urbanicity = 'Urbanicity',
  UtmCampaign = 'UtmCampaign',
  UtmMedium = 'UtmMedium',
  UtmSource = 'UtmSource',
  UtmSourceAndMedium = 'UtmSourceAndMedium'
}

/** A quota the organization's plan imposes on new audiences. */
export type FixedQuota = {
  limit: Scalars['Int']['output'];
  period: AudienceQuotaPeriod;
};

export type GeoDistanceOperator = {
  distance: Scalars['Int']['output'];
  location: Coordinates;
  unit: DistanceUnit;
};

export type GeoDistanceOperatorInput = {
  distance: Scalars['Int']['input'];
  location: CoordinatesInput;
  unit: DistanceUnit;
};

export enum GeoField {
  Dma = 'Dma',
  Zip = 'Zip'
}

export type GeoFilter = {
  coordinatesMode?: Maybe<Scalars['Boolean']['output']>;
  excludedZipCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  negate?: Maybe<Scalars['Boolean']['output']>;
  operator: GeoOperators;
  place?: Maybe<GeoFilterPlace>;
};

export type GeoFilterInput = {
  coordinatesMode?: InputMaybe<Scalars['Boolean']['input']>;
  excludedZipCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  negate?: InputMaybe<Scalars['Boolean']['input']>;
  operator: GeoOperatorsInput;
  place?: InputMaybe<GeoFilterPlaceInput>;
};

export type GeoFilterPlace = {
  address: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
};

export type GeoFilterPlaceInput = {
  address: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

export type GeoInOperator = {
  field: GeoField;
  values: Array<Scalars['String']['output']>;
};

export type GeoInOperatorInput = {
  field: GeoField;
  values: Array<Scalars['String']['input']>;
};

export type GeoLocation = {
  city?: Maybe<Scalars['String']['output']>;
  continentCode?: Maybe<Scalars['String']['output']>;
  continentName?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<Coordinates>;
  countryCode?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  regionCode?: Maybe<Scalars['String']['output']>;
  regionName?: Maybe<Scalars['String']['output']>;
  regionType?: Maybe<Scalars['String']['output']>;
};

export type GeoOperators = {
  distance?: Maybe<GeoDistanceOperator>;
  in?: Maybe<GeoInOperator>;
  polygon?: Maybe<Array<Coordinates>>;
};

export type GeoOperatorsInput = {
  distance?: InputMaybe<GeoDistanceOperatorInput>;
  in?: InputMaybe<GeoInOperatorInput>;
  /**
   * This array needs to have a size between 4 and 100 pairs of point locations. The last point must match the
   * first one in order to indicate the user closed the polygon.
   */
  polygon?: InputMaybe<Array<CoordinatesInput>>;
};

export type GlobalAdditionsArrayInfo = BaseAdditionsArrayInfo & {
  date: Scalars['Date']['output'];
  matchedCount: Scalars['Int']['output'];
  requestedCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type GlobalProcessingAdditionInfo = BaseProcessingAdditionInfo & {
  date: Scalars['Date']['output'];
  requestedCount: Scalars['Int']['output'];
};

export type GoogleAccessTokenInput = {
  accountId: Scalars['String']['input'];
  neededScopes: Array<Scalars['String']['input']>;
};

export type GoogleAccessTokenResult = {
  accessToken: Scalars['String']['output'];
  expiryDate: Scalars['Date']['output'];
  scopes: Array<Scalars['String']['output']>;
};

export type GoogleAuthorizeInput = {
  authorizationCode: Scalars['String']['input'];
  neededScopes: Array<Scalars['String']['input']>;
};

export type GoogleAuthorizeResponse = {
  accessToken: Scalars['String']['output'];
  accountId: Scalars['ID']['output'];
  expiryDate: Scalars['Date']['output'];
  scopes: Array<Scalars['String']['output']>;
};

export type GoogleCustomerMatchAudienceIntegrationConfiguration = {
  customerId: Scalars['String']['output'];
  daysToKeep: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  googleUserAccountId?: Maybe<Scalars['String']['output']>;
  historicalDataSync: Scalars['Boolean']['output'];
  lastOperationId?: Maybe<Scalars['String']['output']>;
  managerCustomerId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: GoogleCustomerMatchConnectionStatus;
  userId?: Maybe<Scalars['String']['output']>;
  /** Null on a template configuration, since the user list is created when the activation is. */
  userListId?: Maybe<Scalars['String']['output']>;
};

export type GoogleCustomerMatchAudienceIntegrationConfigurationInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  daysToKeep?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  googleUserAccountId?: InputMaybe<Scalars['String']['input']>;
  historicalDataSync?: InputMaybe<Scalars['Boolean']['input']>;
  lastOperationId?: InputMaybe<Scalars['String']['input']>;
  managerCustomerId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum GoogleCustomerMatchConnectionStatus {
  Connected = 'Connected',
  Disconnected = 'Disconnected'
}

export type GoogleToken = {
  accessToken?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  tokenType?: Maybe<Scalars['String']['output']>;
};

export type GoogleTokenInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  grantType: GrantType;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};

export enum GrantType {
  AuthorizationCode = 'AuthorizationCode',
  RefreshToken = 'RefreshToken'
}

export type HighLevelAudienceIntegrationConfiguration = {
  bypassHiddenPeopleFields?: Maybe<Scalars['Boolean']['output']>;
  locationId: Scalars['String']['output'];
  privateIntegrationToken?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
};

export type HighLevelAudienceIntegrationConfigurationInput = {
  locationId?: InputMaybe<Scalars['String']['input']>;
  privateIntegrationToken?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type HistoricalValue = {
  date: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type Invite = {
  acceptedAt?: Maybe<Scalars['Date']['output']>;
  assignedRole: Role;
  audience?: Maybe<Audience>;
  audienceId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Date']['output'];
  createdByUserId: Scalars['ID']['output'];
  declinedAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inviter?: Maybe<User>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  roleId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
};

export type InviteInput = {
  audienceId?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** Role id referencing the assignedRole with custom permissions assigned to the user in the organization. */
  roleId?: InputMaybe<Scalars['ID']['input']>;
};

export type InvoiceAddress = {
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type InvoiceCustomer = {
  chargifyId?: Maybe<Scalars['ID']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
};

export type InvoicePayment = {
  appliedAmount?: Maybe<Scalars['String']['output']>;
  gatewayHandle?: Maybe<Scalars['String']['output']>;
  gatewayTransactionId?: Maybe<Scalars['ID']['output']>;
  gatewayUsed?: Maybe<Scalars['String']['output']>;
  memo?: Maybe<Scalars['String']['output']>;
  originalAmount?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<InvoicePaymentMethod>;
  prepayment?: Maybe<Scalars['Boolean']['output']>;
  transactionId?: Maybe<Scalars['ID']['output']>;
  transactionTime?: Maybe<Scalars['String']['output']>;
};

export type InvoicePaymentMethod = {
  cardBrand?: Maybe<Scalars['String']['output']>;
  cardExpiration?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  lastFour?: Maybe<Scalars['String']['output']>;
  maskedCardNumber?: Maybe<Scalars['String']['output']>;
  memo?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type InvoiceSeller = {
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export enum JourneyFilterDateField {
  Date = 'Date'
}

/** All these fields are guaranteed to have a 1:1 match in any of the JourneyFilterXField enums. */
export enum JourneyFilterField {
  Date = 'Date'
}

export type JourneyFilterInput = {
  dateFilter?: InputMaybe<DateFilterInput>;
  stringFilter?: InputMaybe<StringFilterInput>;
};

export enum JourneyGroupByField {
  HostAndPath = 'HostAndPath'
}

export type JourneyGroupByInput = {
  field: JourneyGroupByField;
};

export type JourneyPath = {
  count: Scalars['Int']['output'];
  pathPrefix: Scalars['String']['output'];
};

export type JourneyPaths = {
  count: Scalars['Int']['output'];
  paths: Array<JourneyPath>;
};

export type JourneySortFieldInput = {
  ascending: Scalars['Boolean']['input'];
  field: JourneyFilterField;
};

export type KetchCallbackInput = {
  error?: InputMaybe<Scalars['String']['input']>;
  success: Scalars['Boolean']['input'];
  url: Scalars['String']['input'];
};

export type KeyAggregate = {
  aggregate: FieldAggregate;
  key: Scalars['String']['output'];
};

export type KeyValue = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type KnownAdditionalInfo = {
  vin?: Maybe<Scalars['String']['output']>;
};

export type KnownAdditionalInfoAggregates = {
  vin?: Maybe<FieldAggregate>;
};

export type Location = {
  address?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  coordinates?: Maybe<Coordinates>;
  country: Scalars['String']['output'];
  state: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type LocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  coordinates?: InputMaybe<CoordinatesInput>;
  country: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export enum LogicalOperator {
  And = 'And',
  Or = 'Or'
}

export type MadhiveAudienceIntegrationConfiguration = {
  cpm: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  segmentName?: Maybe<Scalars['String']['output']>;
};

export type MadhiveAudienceIntegrationConfigurationInput = {
  cpm?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  segmentName?: InputMaybe<Scalars['String']['input']>;
};

export type Maid = {
  maid: Scalars['String']['output'];
  os: MaidOs;
};

/**
 * Selectable columns of a MAID export, i.e. the ones backed by real MAID data. These are the only
 * fields a MAID export configuration can pick via "maidFields". When "maidFields" is omitted, the
 * fixed default set is used (which also includes extra padding columns, see ExtraMaidExportField).
 */
export enum MaidExportField {
  DeviceId = 'DeviceId',
  DeviceType = 'DeviceType',
  LastSeenDate = 'LastSeenDate',
  Md5 = 'Md5',
  Os = 'Os',
  Sha1 = 'Sha1',
  Sha256 = 'Sha256'
}

export enum MaidOs {
  Android = 'Android',
  Ios = 'IOS'
}

export type MailchimpAudience = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type MailchimpAudienceIntegrationConfiguration = {
  apiKey?: Maybe<Scalars['String']['output']>;
  audienceId: Scalars['String']['output'];
  bypassHiddenPeopleFields: Scalars['Boolean']['output'];
  daysToKeep: Scalars['Int']['output'];
  historicalDataSync: Scalars['Boolean']['output'];
  lastAddBatchCheckedAt?: Maybe<Scalars['Date']['output']>;
  lastAddBatchDiagnosticsSummary?: Maybe<Scalars['String']['output']>;
  lastAddBatchIds?: Maybe<Array<Scalars['String']['output']>>;
  lastAddBatchStatus?: Maybe<Scalars['String']['output']>;
  lastRemoveBatchCheckedAt?: Maybe<Scalars['Date']['output']>;
  lastRemoveBatchDiagnosticsSummary?: Maybe<Scalars['String']['output']>;
  lastRemoveBatchIds?: Maybe<Array<Scalars['String']['output']>>;
  lastRemoveBatchStatus?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
};

export type MailchimpAudienceIntegrationConfigurationInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  audienceId?: InputMaybe<Scalars['String']['input']>;
  daysToKeep?: InputMaybe<Scalars['Int']['input']>;
  historicalDataSync?: InputMaybe<Scalars['Boolean']['input']>;
  lastAddBatchCheckedAt?: InputMaybe<Scalars['Date']['input']>;
  lastAddBatchDiagnosticsSummary?: InputMaybe<Scalars['String']['input']>;
  lastAddBatchIds?: InputMaybe<Array<Scalars['String']['input']>>;
  lastAddBatchStatus?: InputMaybe<Scalars['String']['input']>;
  lastRemoveBatchCheckedAt?: InputMaybe<Scalars['Date']['input']>;
  lastRemoveBatchDiagnosticsSummary?: InputMaybe<Scalars['String']['input']>;
  lastRemoveBatchIds?: InputMaybe<Array<Scalars['String']['input']>>;
  lastRemoveBatchStatus?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type MailchimpListAudiencesInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  /** Checks the template against this audience. Requires templateId; checked against the template's own organization otherwise. */
  audienceId?: InputMaybe<Scalars['ID']['input']>;
  audienceIntegrationId?: InputMaybe<Scalars['ID']['input']>;
  /** Reads the Mailchimp API key from this Activation Template instead. Cannot be sent with apiKey or audienceIntegrationId. */
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

export type MatchbackComparisonsFilterInput = {
  /** An empty list matches nobody. */
  comparisonIds: Array<Scalars['ID']['input']>;
  operator: LogicalOperator;
};

export type MessageCitation = {
  end?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type MessageSource = {
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Mutation = {
  _?: Maybe<Scalars['Boolean']['output']>;
  /** Accepts an invite with the passed id */
  acceptInvite?: Maybe<Invite>;
  /** Allows the user to upload IP data in bulk */
  addAudienceVisits: Scalars['Boolean']['output'];
  /** Adds people to a Customer List audience */
  addPeopleAudienceCustomerList?: Maybe<Audience>;
  /** Adds people to a Global audience */
  addPeopleAudienceGlobal?: Maybe<Audience>;
  /** Confirms a pending audience */
  adminConfirmPendingAudiencePulse?: Maybe<Audience>;
  /** Updates the organization with *id* for Admin users or users with Super Owner role, using the passed params */
  adminUpdateOrganization?: Maybe<Organization>;
  /** Updates a Pixel audience's settings with admin permissions */
  adminUpdatePixelAudienceSettings?: Maybe<Audience>;
  /** Creates a new Beeswax segment. */
  beeswaxCreateSegment: BeeswaxSegment;
  /** Creates a Customer List audience */
  createAudienceCustomerList?: Maybe<Audience>;
  /** Creates a Global audience */
  createAudienceGlobal?: Maybe<Audience>;
  /** Creates an audience integration */
  createAudienceIntegration?: Maybe<AudienceIntegration>;
  /**
   * Saves an activation configuration as a reusable activation template. The configuration is copied on the server, so
   * sensitive values never have to be sent back by the client.
   */
  createAudienceIntegrationTemplate: AudienceIntegrationTemplate;
  /** Creates a Lookalike audience */
  createAudienceLookalike?: Maybe<Audience>;
  /** Creates a Matchback audience, returning it before its people have been matched */
  createAudienceMatchback?: Maybe<Audience>;
  /** Creates a Pixel audience */
  createAudiencePixel?: Maybe<Audience>;
  /** Creates a Pulse audience */
  createAudiencePulse?: Maybe<Audience>;
  /** Creates a Segment audience */
  createAudienceSegment?: Maybe<Audience>;
  createConversation: Conversation;
  /** Creates an invite with the passed params and the authenticated user as the inviter */
  createInvite?: Maybe<Invite>;
  /** Creates an organization with the current user as the owner */
  createOrganization?: Maybe<Organization>;
  /**
   * Creates a subscription with the passed params and the authenticated user as the creator. In order to get the
   * created subscription information use the "subscriptionInfo" query.
   */
  createSubscription?: Maybe<Scalars['Boolean']['output']>;
  /** Creates an user with with the information sent from global */
  createUser?: Maybe<User>;
  /** Declines an invite with the id */
  declineInvite?: Maybe<Invite>;
  /** Deletes an audience */
  deleteAudience?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes an audience integration */
  deleteAudienceIntegration?: Maybe<Scalars['Boolean']['output']>;
  deleteAudienceIntegrationTemplate: Scalars['Boolean']['output'];
  deleteConversation: Scalars['Boolean']['output'];
  /** Deletes an invite with the id */
  deleteInvite?: Maybe<Invite>;
  /** Discards a failed Customer List audience load */
  discardFailedAudienceCustomerListLoad?: Maybe<Audience>;
  /**
   * Edits a Pixel audience
   * @deprecated Please use updateAudience to update the audience itself or updatePixelAudienceSettings to update audience's pixel settings.
   */
  editAudiencePixel?: Maybe<Audience>;
  generateReportDownloadUrl: Scalars['String']['output'];
  /** Authorize with Google OAuth and store encrypted refresh token */
  googleAuthorize: GoogleAuthorizeResponse;
  /** Generate access token from stored refresh token for specific Google account and scopes */
  googleGenerateAccessToken: GoogleAccessTokenResult;
  /**
   * Returns one or more Google tokens for the provided parameters. For more info check
   * https://cloud.google.com/apigee/docs/api-platform/security/oauth/access-tokens
   * @deprecated Use googleAuthorize and googleGenerateAccessToken instead
   */
  googleToken?: Maybe<GoogleToken>;
  /** Removes user from the audience */
  removeAudienceMember?: Maybe<Scalars['Boolean']['output']>;
  /** Removes the member with *userId* from the organization with *id* */
  removeMember?: Maybe<Scalars['Boolean']['output']>;
  /** Resends an invite with the passed id */
  resendInvite?: Maybe<Invite>;
  /** Send an email to the support team with the given arguments. */
  sendSupportEmail?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Adds people to a pixel audience count. Returns the new total count of the audience.
   * Only available for internal use.
   */
  systemAddAudiencePeopleCount?: Maybe<Scalars['Int']['output']>;
  systemAddOnCompleted: Scalars['Boolean']['output'];
  /**
   * Iterates over Pulse audiences.
   * For each audience, it creates a count record related to the new date range and calls the worker to add people to it.
   */
  systemAddPeopleAudiencesPulse: PageInfo;
  /** Completes a Customer List audience */
  systemCompleteCustomerListAudience?: Maybe<Audience>;
  /** Completes a Global audience */
  systemCompleteGlobalAudience?: Maybe<Audience>;
  /** Completes a Lookalike audience */
  systemCompleteLookalikeAudience?: Maybe<Audience>;
  /** Completes a Matchback audience, reading the people count from its refreshed snapshot */
  systemCompleteMatchbackAudience?: Maybe<Audience>;
  /** Completes a Pulse audience */
  systemCompletePulseAudience?: Maybe<Audience>;
  /** Creates an Organization with data from global */
  systemCreateOrganization?: Maybe<Organization>;
  /** Creates an User with User Admin permissions */
  systemCreateUser?: Maybe<User>;
  /** Deletes an Organization with Org Admin permissions */
  systemDeleteOrganization?: Maybe<Scalars['Boolean']['output']>;
  /**
   * For internal use only, clears an Activation integration's stored credentials after the destination permanently
   * revoked its endpoint (a status in the spec's disconnectOnStatusCodes, e.g. Zapier's 410 unsubscribe), so the
   * integration reads Disconnected and later runs no-op instead of re-firing at a dead endpoint. Idempotent.
   */
  systemDisconnectActivationIntegration?: Maybe<AudienceIntegration>;
  /**
   * Iterates over Audiences with quota enabled that end at the specified date.
   * Adds the pixels as active again.
   */
  systemResetAudiencesQuota: PageInfo;
  /** Restores a deleted Organization with Org Admin permissions */
  systemRestoreOrganization?: Maybe<Scalars['Boolean']['output']>;
  /**
   * For internal use only, replaces the stored refresh token of an Activation integration whose provider rotates it
   * on every use (the spec's auth.rotatesRefreshToken, e.g. Microsoft Advertising) — persisted after each delivery
   * mint so the stored token keeps sliding its expiry window.
   */
  systemRotateActivationRefreshToken?: Maybe<AudienceIntegration>;
  /**
   * For internal use only, stores the destination-side resource id captured from a fileUploadBind create response
   * (the spec's bindResponseCapturePath, e.g. TikTok's custom audience id) so later runs append into that resource
   * instead of creating another same-named one. First stored value wins; idempotent.
   */
  systemStoreActivationBoundResource?: Maybe<AudienceIntegration>;
  systemTrackAIUsage: SystemTrackAiUsageResult;
  systemUpdateAppConfiguration: Scalars['Boolean']['output'];
  /** Update the categories for an audience. Only available for internal use. */
  systemUpdateAudienceCategories: Scalars['Boolean']['output'];
  /** For internal use only, updates the last run info after an AudienceIntegration has executed */
  systemUpdateAudienceIntegrationLastRunInfo?: Maybe<AudienceIntegration>;
  /**
   * Records the outcome of an opt-out request and the result of its Ketch callbacks.
   * For internal use only.
   */
  systemUpdateOptOutCallbacksStatus: Scalars['Boolean']['output'];
  /** Updates an Organization with Org Admin permissions */
  systemUpdateOrganization?: Maybe<Organization>;
  /** Updates the pixel setup status of a Pixel audience */
  systemUpdatePixelSetupStatus: Scalars['Boolean']['output'];
  /** Updates an User with User Admin permissions */
  systemUpdateUser?: Maybe<User>;
  /** Tests an audience integration */
  testAudienceIntegration: AudienceIntegrationTestResult;
  touchConversationAfterUserMessage: Scalars['Boolean']['output'];
  /** Updates an audience */
  updateAudience?: Maybe<Audience>;
  /** Update the categories for an audience */
  updateAudienceCategories: Scalars['Boolean']['output'];
  /** Updates an audience integration */
  updateAudienceIntegration?: Maybe<AudienceIntegration>;
  updateAudienceIntegrationTemplate: AudienceIntegrationTemplate;
  /** Updates a Pulse audience's recurring configuration. The update applies to the next weekly cycle. */
  updateAudiencePulse?: Maybe<Audience>;
  updateConversation: Conversation;
  updateMe?: Maybe<User>;
  /** Updates the organization with *id* using the passed params */
  updateOrganization?: Maybe<Organization>;
  /** Updates a Pixel audience's settings */
  updatePixelAudienceSettings?: Maybe<Audience>;
  /** Updates the role of a user in an organization */
  updateUserRole: UserRole;
};


export type MutationAcceptInviteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAddAudienceVisitsArgs = {
  audienceId: Scalars['ID']['input'];
  visits: Array<VisitInput>;
};


export type MutationAddPeopleAudienceCustomerListArgs = {
  addPeopleAudienceCustomerListParams: AddPeopleAudienceCustomerListInput;
};


export type MutationAddPeopleAudienceGlobalArgs = {
  addPeopleAudienceGlobalParams: AddPeopleAudienceGlobalInput;
};


export type MutationAdminConfirmPendingAudiencePulseArgs = {
  confirmPendingAudiencePulseParams: ConfirmPendingAudiencePulseInput;
};


export type MutationAdminUpdateOrganizationArgs = {
  input?: InputMaybe<AdminUpdateOrganizationInput>;
};


export type MutationAdminUpdatePixelAudienceSettingsArgs = {
  audiencePixelSettingsParams: AdminAudiencePixelSettingsUpdateInput;
};


export type MutationBeeswaxCreateSegmentArgs = {
  input: BeeswaxCreateSegmentInput;
};


export type MutationCreateAudienceCustomerListArgs = {
  audienceCustomerListParams: AudienceCustomerListInput;
};


export type MutationCreateAudienceGlobalArgs = {
  audienceGlobalParams: AudienceGlobalInput;
};


export type MutationCreateAudienceIntegrationArgs = {
  integrationParams: AudienceIntegrationInput;
};


export type MutationCreateAudienceIntegrationTemplateArgs = {
  templateParams: AudienceIntegrationTemplateInput;
};


export type MutationCreateAudienceLookalikeArgs = {
  audienceLookalikeParams: AudienceLookalikeInput;
};


export type MutationCreateAudienceMatchbackArgs = {
  audienceMatchbackParams: AudienceMatchbackInput;
};


export type MutationCreateAudiencePixelArgs = {
  audiencePixelParams: AudiencePixelInput;
};


export type MutationCreateAudiencePulseArgs = {
  audiencePulseParams: AudiencePulseInput;
};


export type MutationCreateAudienceSegmentArgs = {
  audienceSegmentParams: AudienceSegmentInput;
};


export type MutationCreateConversationArgs = {
  title: Scalars['String']['input'];
};


export type MutationCreateInviteArgs = {
  inviteParams?: InputMaybe<InviteInput>;
};


export type MutationCreateOrganizationArgs = {
  input?: InputMaybe<CreateOrganizationInput>;
};


export type MutationCreateSubscriptionArgs = {
  subscriptionParams: SubscriptionInput;
};


export type MutationCreateUserArgs = {
  user?: InputMaybe<CreateUserInput>;
};


export type MutationDeclineInviteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAudienceArgs = {
  audienceId: Scalars['ID']['input'];
};


export type MutationDeleteAudienceIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAudienceIntegrationTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteConversationArgs = {
  conversationId: Scalars['ID']['input'];
};


export type MutationDeleteInviteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDiscardFailedAudienceCustomerListLoadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEditAudiencePixelArgs = {
  audiencePixelParams: AudiencePixelEditInput;
};


export type MutationGenerateReportDownloadUrlArgs = {
  relativePath: Scalars['String']['input'];
};


export type MutationGoogleAuthorizeArgs = {
  input: GoogleAuthorizeInput;
};


export type MutationGoogleGenerateAccessTokenArgs = {
  input: GoogleAccessTokenInput;
};


export type MutationGoogleTokenArgs = {
  input: GoogleTokenInput;
};


export type MutationRemoveAudienceMemberArgs = {
  audienceId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRemoveMemberArgs = {
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationResendInviteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSendSupportEmailArgs = {
  message: Scalars['String']['input'];
};


export type MutationSystemAddAudiencePeopleCountArgs = {
  peopleCount: Scalars['Int']['input'];
  pixelId: Scalars['String']['input'];
};


export type MutationSystemAddOnCompletedArgs = {
  addOnCompletedInput?: InputMaybe<AddOnCompletedInput>;
};


export type MutationSystemAddPeopleAudiencesPulseArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type MutationSystemCompleteCustomerListAudienceArgs = {
  completionParams: CompleteAudienceCustomerListInput;
};


export type MutationSystemCompleteGlobalAudienceArgs = {
  completionParams: CompleteAudienceGlobalInput;
};


export type MutationSystemCompleteLookalikeAudienceArgs = {
  completionParams: CompleteAudienceLookalikeInput;
};


export type MutationSystemCompleteMatchbackAudienceArgs = {
  completionParams: CompleteAudienceMatchbackInput;
};


export type MutationSystemCompletePulseAudienceArgs = {
  completionParams: CompleteAudiencePulseInput;
};


export type MutationSystemCreateOrganizationArgs = {
  input?: InputMaybe<SystemOrganizationInput>;
  userId: Scalars['ID']['input'];
};


export type MutationSystemCreateUserArgs = {
  input?: InputMaybe<CreateUserInput>;
};


export type MutationSystemDeleteOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationSystemDisconnectActivationIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSystemResetAudiencesQuotaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  first: Scalars['Int']['input'];
};


export type MutationSystemRestoreOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationSystemRotateActivationRefreshTokenArgs = {
  id: Scalars['ID']['input'];
  refreshToken: Scalars['String']['input'];
};


export type MutationSystemStoreActivationBoundResourceArgs = {
  id: Scalars['ID']['input'];
  resourceId: Scalars['String']['input'];
};


export type MutationSystemTrackAiUsageArgs = {
  input: SystemTrackAiUsageInput;
};


export type MutationSystemUpdateAppConfigurationArgs = {
  newConfigurationInput: AppConfigurationInput;
};


export type MutationSystemUpdateAudienceCategoriesArgs = {
  input: UpdateSystemAudienceCategoriesInput;
};


export type MutationSystemUpdateAudienceIntegrationLastRunInfoArgs = {
  lastRunInfo: AudienceIntegrationLastRunInfoInput;
};


export type MutationSystemUpdateOptOutCallbacksStatusArgs = {
  input: UpdateOptOutCallbacksStatusInput;
};


export type MutationSystemUpdateOrganizationArgs = {
  input?: InputMaybe<UpdateSystemOrganizationInput>;
};


export type MutationSystemUpdatePixelSetupStatusArgs = {
  audienceId: Scalars['ID']['input'];
  isValid: Scalars['Boolean']['input'];
  url: Scalars['String']['input'];
};


export type MutationSystemUpdateUserArgs = {
  input?: InputMaybe<UpdateSystemUserInput>;
};


export type MutationTestAudienceIntegrationArgs = {
  integrationParams: AudienceIntegrationTestInput;
};


export type MutationTouchConversationAfterUserMessageArgs = {
  conversationId: Scalars['ID']['input'];
};


export type MutationUpdateAudienceArgs = {
  audienceUpdateParams: AudienceUpdateInput;
};


export type MutationUpdateAudienceCategoriesArgs = {
  audienceId: Scalars['ID']['input'];
  categoryCodes: Array<Scalars['Int']['input']>;
};


export type MutationUpdateAudienceIntegrationArgs = {
  integrationParams: AudienceIntegrationUpdateInput;
};


export type MutationUpdateAudienceIntegrationTemplateArgs = {
  templateParams: AudienceIntegrationTemplateUpdateInput;
};


export type MutationUpdateAudiencePulseArgs = {
  audiencePulseParams: UpdateAudiencePulseInput;
};


export type MutationUpdateConversationArgs = {
  updateConversationInput: UpdateConversationInput;
};


export type MutationUpdateMeArgs = {
  user?: InputMaybe<UpdateUserInput>;
};


export type MutationUpdateOrganizationArgs = {
  input?: InputMaybe<UpdateOrganizationInput>;
};


export type MutationUpdatePixelAudienceSettingsArgs = {
  audiencePixelSettingsParams: AudiencePixelSettingsUpdateInput;
};


export type MutationUpdateUserRoleArgs = {
  input: UpdateUserRoleInput;
};

export type NumberFieldBreakdown = {
  buckets?: Maybe<Array<BucketElement>>;
  error?: Maybe<FieldBreakdownError>;
  field: FilterNumberField;
};

export type NumberFilter = {
  customField?: Maybe<Scalars['String']['output']>;
  field?: Maybe<FilterNumberField>;
  operator: NumberOperators;
};

export type NumberFilterConfiguration = {
  from?: Maybe<Scalars['Int']['output']>;
  to?: Maybe<Scalars['Int']['output']>;
};

export type NumberFilterInput = {
  customField?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<FilterNumberField>;
  operator: NumberOperatorsInput;
};

export type NumberOperators = {
  between?: Maybe<NumberRange>;
  eq?: Maybe<Scalars['Float']['output']>;
  exists?: Maybe<Scalars['Boolean']['output']>;
  gt?: Maybe<Scalars['Float']['output']>;
  gte?: Maybe<Scalars['Float']['output']>;
  in?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  lt?: Maybe<Scalars['Float']['output']>;
  lte?: Maybe<Scalars['Float']['output']>;
};

export type NumberOperatorsInput = {
  between?: InputMaybe<NumberRangeInput>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
};

export type NumberRange = {
  from?: Maybe<Scalars['Float']['output']>;
  to?: Maybe<Scalars['Float']['output']>;
};

export type NumberRangeInput = {
  from?: InputMaybe<Scalars['Float']['input']>;
  to?: InputMaybe<Scalars['Float']['input']>;
};

export type Os = {
  name?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type OptOutCallbackState = {
  status: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/**
 * What a request resolved to. DROP requires every request to end on one of these four; we only expect to
 * produce deleted and not_found. The value names are the stored ones, so the wire and the column agree.
 */
export enum OptOutOutcome {
  Deleted = 'deleted',
  Exempted = 'exempted',
  NotFound = 'not_found',
  OptedOut = 'opted_out'
}

/**
 * How far an opt-out request has got, so a redelivered message can tell a request it has already answered
 * from one it has not, instead of resolving it again and reporting a second, different outcome.
 */
export type OptOutProcessingState = {
  /**
   * Where an earlier delivery left each callback. A redelivered message carries the statuses it was
   * enqueued with, so one already delivered looks pending there.
   */
  callbacks?: Maybe<Array<OptOutCallbackState>>;
  id: Scalars['Int']['output'];
  matchedPersonIds?: Maybe<Array<Scalars['String']['output']>>;
  outcome?: Maybe<OptOutOutcome>;
  status: Scalars['String']['output'];
};

export type Organization = BaseOrganization & {
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  adfProviderInfo?: Maybe<Scalars['String']['output']>;
  audiencesCount?: Maybe<Scalars['Int']['output']>;
  autoCustomerListCreationConfiguration?: Maybe<AutoCustomerListCreationConfiguration>;
  businessDataEnabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   * What the calling user can do in this organization, computed by the same checks the actions themselves run.
   * Always resolved. Nullable so client code that casts other organization types to Organization keeps type-checking.
   */
  capabilities?: Maybe<OrganizationCapabilities>;
  city?: Maybe<Scalars['String']['output']>;
  clientS3Bucket?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdByUserId?: Maybe<Scalars['ID']['output']>;
  creator?: Maybe<User>;
  customerListEnabled?: Maybe<Scalars['Boolean']['output']>;
  deepLink?: Maybe<Scalars['String']['output']>;
  /** @deprecated Please use defaultS3OutputObjectKeyTemplate instead of this field. */
  defaultS3OutputFilenameStrategy?: Maybe<OutputFilenameStrategy>;
  defaultS3OutputObjectKeyTemplate?: Maybe<Scalars['String']['output']>;
  defaultUser?: Maybe<User>;
  disableEmailValidation?: Maybe<Scalars['Boolean']['output']>;
  globalSearchEnabled?: Maybe<Scalars['Boolean']['output']>;
  globalSearchLimit?: Maybe<Scalars['Int']['output']>;
  hiddenPeopleFields: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  internalInfo?: Maybe<Scalars['JSON']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  lookalikeEnabled?: Maybe<Scalars['Boolean']['output']>;
  lookalikeSearchLimit?: Maybe<Scalars['Int']['output']>;
  madhiveEnabled?: Maybe<Scalars['Boolean']['output']>;
  madhiveRootPath?: Maybe<Scalars['String']['output']>;
  matchbackEnabled?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationType: OrganizationType;
  /** @deprecated Please use paymentStatus instead of this field. */
  paidSubscription?: Maybe<Scalars['Boolean']['output']>;
  parentOrganization?: Maybe<BaseOrganization>;
  paymentStatus?: Maybe<PaymentStatus>;
  pendingInvites?: Maybe<Array<Maybe<Invite>>>;
  phone?: Maybe<Scalars['String']['output']>;
  pixelDomain?: Maybe<Scalars['String']['output']>;
  pixelMatchingCadence?: Maybe<PixelMatchingCadence>;
  pulseEnabled?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  subscriptionOverride?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userRoles?: Maybe<Array<Maybe<UserRole>>>;
  whiteLabelImageUrl?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};


export type OrganizationDisableEmailValidationArgs = {
  retrieveFinalValue?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganizationCapabilities = {
  createPixelAudience: PixelAudienceCapability;
};

export type OrganizationConnection = {
  edges: Array<OrganizationEdge>;
  nodes: Array<Organization>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationEdge = {
  cursor: Scalars['String']['output'];
  node?: Maybe<Organization>;
};

export enum OrganizationType {
  Agency = 'Agency',
  Customer = 'Customer',
  WhiteLabel = 'WhiteLabel'
}

export enum OutputFilenameStrategy {
  AudienceAndIntegration = 'AudienceAndIntegration',
  Legacy = 'Legacy'
}

export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items?. */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items?. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PageView = {
  additionalInfo?: Maybe<AdditionalInfo>;
  browser?: Maybe<Browser>;
  date: Scalars['Date']['output'];
  gaSessionId?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  hostAndPath?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ip: Scalars['String']['output'];
  ipLocation?: Maybe<GeoLocation>;
  os?: Maybe<Os>;
  person: Person;
  personId: Scalars['ID']['output'];
  tealiumVisitorId?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmMedium?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
};

export type PageViewConnection = {
  nodes: Array<PageView>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum PaymentStatus {
  Free = 'Free',
  Paid = 'Paid',
  PaidPaused = 'PaidPaused'
}

export type PeopleBreakdowns = {
  numberBreakdowns: Array<NumberFieldBreakdown>;
  stringBreakdowns: Array<StringFieldBreakdown>;
};

export type PeopleNumberFieldBreakdownInput = {
  bucketKeyFormat?: InputMaybe<Scalars['String']['input']>;
  field: FilterNumberField;
  interval?: InputMaybe<Scalars['Int']['input']>;
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
  minCountPerBucket?: InputMaybe<Scalars['Int']['input']>;
};

export type PeopleSnaphostGeoResult = {
  count: Scalars['Int']['output'];
  postalCodes: Array<Maybe<Scalars['String']['output']>>;
};

export type PeopleSnapshot = {
  geoResults?: Maybe<Array<Maybe<PeopleSnaphostGeoResult>>>;
  people: Array<Maybe<Person>>;
  postalCodeCounts?: Maybe<Array<Maybe<PostalCodeCount>>>;
  totalCount: Scalars['Int']['output'];
};

export type PeopleStringFieldBreakdownInput = {
  field: FilterStringField;
};

export type PeriodUsageInfo = {
  audienceIdCount: Scalars['Int']['output'];
  currentPeriodUsageInCents: Scalars['Int']['output'];
  resolveIdCount: Scalars['Int']['output'];
};

export enum Permission {
  BypassActivationHiddenPeopleFields = 'BypassActivationHiddenPeopleFields',
  ConfirmPendingAudience = 'ConfirmPendingAudience',
  CreateAudience = 'CreateAudience',
  CreateAudienceIntegration = 'CreateAudienceIntegration',
  CreateAudienceMatchback = 'CreateAudienceMatchback',
  CreateAudienceSegment = 'CreateAudienceSegment',
  CreateInvite = 'CreateInvite',
  CreateOrganization = 'CreateOrganization',
  DeleteAudience = 'DeleteAudience',
  DeleteAudienceIntegration = 'DeleteAudienceIntegration',
  DeleteInvite = 'DeleteInvite',
  DeleteMember = 'DeleteMember',
  DeleteOrganization = 'DeleteOrganization',
  ExportData = 'ExportData',
  ReadAudience = 'ReadAudience',
  ReadAudienceIntegration = 'ReadAudienceIntegration',
  ReadInvite = 'ReadInvite',
  ReadInvoices = 'ReadInvoices',
  ReadOrganization = 'ReadOrganization',
  ReadPerson = 'ReadPerson',
  ReadSubscriptionInfo = 'ReadSubscriptionInfo',
  ResendInvite = 'ResendInvite',
  SuperOwner = 'SuperOwner',
  UpdateAudience = 'UpdateAudience',
  UpdateAudienceAdminSettings = 'UpdateAudienceAdminSettings',
  UpdateAudienceIntegration = 'UpdateAudienceIntegration',
  UpdateOrganization = 'UpdateOrganization',
  UpdateOrganizationAdminSettings = 'UpdateOrganizationAdminSettings',
  UpdateUserRole = 'UpdateUserRole'
}

export type Person = {
  addrAbrev?: Maybe<Scalars['String']['output']>;
  addrPrimary?: Maybe<Scalars['String']['output']>;
  addrSecy?: Maybe<Scalars['String']['output']>;
  addrStreet?: Maybe<Scalars['String']['output']>;
  addrSuffix?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  addressType?: Maybe<Scalars['String']['output']>;
  adultsInHousehold?: Maybe<Scalars['Int']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  bebacks?: Maybe<Scalars['Int']['output']>;
  beeswaxIds?: Maybe<Array<Scalars['String']['output']>>;
  behaviors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  businessEmail?: Maybe<Scalars['String']['output']>;
  businessEmailLastSeen?: Maybe<Scalars['Date']['output']>;
  businessEmailValidationStatus?: Maybe<Scalars['String']['output']>;
  carrierRoute?: Maybe<Scalars['String']['output']>;
  childrenAgeRanges?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  childrenBetweenAges0_3?: Maybe<Scalars['Int']['output']>;
  childrenBetweenAges4_6?: Maybe<Scalars['Int']['output']>;
  childrenBetweenAges7_9?: Maybe<Scalars['Int']['output']>;
  childrenBetweenAges10_12?: Maybe<Scalars['Int']['output']>;
  childrenBetweenAges13_18?: Maybe<Scalars['Int']['output']>;
  childrenInHousehold?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyAddress?: Maybe<Scalars['String']['output']>;
  companyCity?: Maybe<Scalars['String']['output']>;
  companyDomain?: Maybe<Scalars['String']['output']>;
  companyEmployeeCount?: Maybe<Scalars['String']['output']>;
  companyLastUpdated?: Maybe<Scalars['Date']['output']>;
  companyLinkedInUrl?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyPhone?: Maybe<Scalars['String']['output']>;
  companyRevenue?: Maybe<Scalars['String']['output']>;
  companySic?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  companyState?: Maybe<Scalars['String']['output']>;
  companyZip?: Maybe<Scalars['String']['output']>;
  congressionalDistrict?: Maybe<Scalars['Int']['output']>;
  countyName?: Maybe<Scalars['String']['output']>;
  creditRange?: Maybe<Scalars['String']['output']>;
  customBooleanFields?: Maybe<Array<Maybe<Scalars['Boolean']['output']>>>;
  customDateFields?: Maybe<Array<Maybe<Scalars['Date']['output']>>>;
  customIntegerFields?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** @deprecated Use customIntegerFields instead */
  customNumberFields?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  customStringFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  department?: Maybe<Scalars['String']['output']>;
  dma?: Maybe<Scalars['Int']['output']>;
  dnc?: Maybe<Scalars['Boolean']['output']>;
  dpbc?: Maybe<Scalars['Int']['output']>;
  dpv?: Maybe<Scalars['Int']['output']>;
  dwellingType?: Maybe<Scalars['String']['output']>;
  education?: Maybe<Scalars['String']['output']>;
  educationHistory?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailVerificationDate?: Maybe<Scalars['Date']['output']>;
  ethnicGroup?: Maybe<Scalars['String']['output']>;
  fipsCountyCode?: Maybe<Scalars['Int']['output']>;
  fipsStateCode?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  generation?: Maybe<Scalars['String']['output']>;
  hemMd5?: Maybe<Scalars['String']['output']>;
  hemMd5Uppercase?: Maybe<Scalars['String']['output']>;
  hemSha1?: Maybe<Scalars['String']['output']>;
  hemSha1Uppercase?: Maybe<Scalars['String']['output']>;
  hemSha256?: Maybe<Scalars['String']['output']>;
  hemSha256Uppercase?: Maybe<Scalars['String']['output']>;
  hemsMd5?: Maybe<Array<Scalars['String']['output']>>;
  hemsMd5Uppercase?: Maybe<Array<Scalars['String']['output']>>;
  hemsSha1?: Maybe<Array<Scalars['String']['output']>>;
  hemsSha1Uppercase?: Maybe<Array<Scalars['String']['output']>>;
  hemsSha256?: Maybe<Array<Scalars['String']['output']>>;
  hemsSha256Uppercase?: Maybe<Array<Scalars['String']['output']>>;
  homeHeatType?: Maybe<Scalars['String']['output']>;
  homeOwner?: Maybe<Scalars['String']['output']>;
  homePrice?: Maybe<Scalars['Int']['output']>;
  homePurchasedYearsAgo?: Maybe<Scalars['Int']['output']>;
  homeValue?: Maybe<Scalars['Int']['output']>;
  householdIncome?: Maybe<Scalars['String']['output']>;
  householdNetWorth?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  incomeLevels?: Maybe<Scalars['String']['output']>;
  interests?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ipAddresses?: Maybe<Array<Scalars['String']['output']>>;
  isMultilingual?: Maybe<Scalars['Boolean']['output']>;
  isPoliticalContributor?: Maybe<Scalars['Boolean']['output']>;
  isPrimaryResidence?: Maybe<Scalars['Boolean']['output']>;
  isVoter?: Maybe<Scalars['Boolean']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  jobTitleLastUpdated?: Maybe<Scalars['Date']['output']>;
  /** Gets a paginated journey of the person for the pixel audience with "audienceId". */
  journey?: Maybe<PageViewConnection>;
  /**
   * Gets paged counts of journeys for a person grouped by a field.
   * This query returns a null "totalCount" value. To get the value about that,
   * please use "Audience.personJourneyGroups".
   */
  journeyGroups?: Maybe<BucketConnection>;
  language?: Maybe<Scalars['String']['output']>;
  lastBusinessUpdated?: Maybe<Scalars['Date']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  maid?: Maybe<Scalars['String']['output']>;
  maidOs?: Maybe<MaidOs>;
  maids?: Maybe<Array<Maid>>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  matchbackComparisons?: Maybe<Array<AudienceMatchbackComparison>>;
  matchbackComparisonsCount?: Maybe<Scalars['Int']['output']>;
  mortgageAge?: Maybe<Scalars['Int']['output']>;
  mortgageAmount?: Maybe<Scalars['Int']['output']>;
  mortgageLoanType?: Maybe<Scalars['String']['output']>;
  mortgageRefinanceAge?: Maybe<Scalars['Int']['output']>;
  mortgageRefinanceAmount?: Maybe<Scalars['Int']['output']>;
  mortgageRefinanceType?: Maybe<Scalars['String']['output']>;
  msa?: Maybe<Scalars['Int']['output']>;
  netWorth?: Maybe<Scalars['String']['output']>;
  newCreditOfferedHousehold?: Maybe<Scalars['String']['output']>;
  numberOfVehiclesInHousehold?: Maybe<Scalars['Int']['output']>;
  occupationDetail?: Maybe<Scalars['String']['output']>;
  optIn?: Maybe<Scalars['Boolean']['output']>;
  optInDate?: Maybe<Scalars['Date']['output']>;
  optInIp?: Maybe<Scalars['String']['output']>;
  optInUrl?: Maybe<Scalars['String']['output']>;
  ownsAmexCard?: Maybe<Scalars['Boolean']['output']>;
  ownsBankCard?: Maybe<Scalars['Boolean']['output']>;
  ownsCreditCard?: Maybe<Scalars['Boolean']['output']>;
  ownsInvestment?: Maybe<Scalars['Boolean']['output']>;
  ownsPremiumAmexCard?: Maybe<Scalars['Boolean']['output']>;
  ownsPremiumCard?: Maybe<Scalars['Boolean']['output']>;
  ownsStocksAndBonds?: Maybe<Scalars['Boolean']['output']>;
  peopleInHousehold?: Maybe<Scalars['Int']['output']>;
  personality?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneUpdateDate?: Maybe<Scalars['Date']['output']>;
  pixelAdditionalInfo?: Maybe<AdditionalInfoAggregates>;
  pixelFirstHitDate?: Maybe<Scalars['Date']['output']>;
  pixelId?: Maybe<Scalars['String']['output']>;
  pixelLastHitDate?: Maybe<Scalars['Date']['output']>;
  pixelLastIpLocation?: Maybe<GeoLocation>;
  politicalParty?: Maybe<Scalars['String']['output']>;
  premiumIncomeHousehold?: Maybe<Scalars['String']['output']>;
  primaryIndustry?: Maybe<Scalars['String']['output']>;
  professionalAddress?: Maybe<Scalars['String']['output']>;
  professionalAddress2?: Maybe<Scalars['String']['output']>;
  professionalCity?: Maybe<Scalars['String']['output']>;
  professionalState?: Maybe<Scalars['String']['output']>;
  professionalZip?: Maybe<Scalars['String']['output']>;
  professionalZip4?: Maybe<Scalars['String']['output']>;
  religion?: Maybe<Scalars['String']['output']>;
  scf?: Maybe<Scalars['Int']['output']>;
  seniorityLevel?: Maybe<Scalars['String']['output']>;
  social?: Maybe<Social>;
  state?: Maybe<Scalars['String']['output']>;
  urbanicity?: Maybe<Scalars['String']['output']>;
  veteransInHousehold?: Maybe<Scalars['Int']['output']>;
  workHistory?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
  zip4?: Maybe<Scalars['String']['output']>;
};


export type PersonCustomBooleanFieldsArgs = {
  fields: Array<Scalars['String']['input']>;
};


export type PersonCustomDateFieldsArgs = {
  fields: Array<Scalars['String']['input']>;
};


export type PersonCustomIntegerFieldsArgs = {
  fields: Array<Scalars['String']['input']>;
};


export type PersonCustomNumberFieldsArgs = {
  fields: Array<Scalars['String']['input']>;
};


export type PersonCustomStringFieldsArgs = {
  fields: Array<Scalars['String']['input']>;
};


export type PersonJourneyArgs = {
  first: Scalars['Int']['input'];
  sort?: InputMaybe<Array<JourneySortFieldInput>>;
};


export type PersonJourneyGroupsArgs = {
  first: Scalars['Int']['input'];
  groupBy: JourneyGroupByInput;
};

export type PersonCompoundFilter = {
  filters: Array<PersonFilter>;
  operator: LogicalOperator;
};

export type PersonCompoundFilterInput = {
  filters: Array<PersonFilterInput>;
  operator: LogicalOperator;
};

export type PersonConnection = {
  /** A list of nodes. */
  nodes: Array<Person>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type PersonField = {
  category: FieldCategory;
  configuration?: Maybe<FilterConfiguration>;
  filterField: FilterField;
  title: Scalars['String']['output'];
  type: FieldType;
};

export type PersonFilter = {
  booleanFilter?: Maybe<BooleanFilter>;
  compoundFilter?: Maybe<PersonCompoundFilter>;
  dateFilter?: Maybe<DateFilter>;
  extendedStringFilter?: Maybe<ExtendedStringFilter>;
  geoFilter?: Maybe<GeoFilter>;
  numberFilter?: Maybe<NumberFilter>;
  stringFilter?: Maybe<StringFilter>;
};

export type PersonFilterInput = {
  booleanFilter?: InputMaybe<BooleanFilterInput>;
  compoundFilter?: InputMaybe<PersonCompoundFilterInput>;
  dateFilter?: InputMaybe<DateFilterInput>;
  extendedStringFilter?: InputMaybe<ExtendedStringFilterInput>;
  geoFilter?: InputMaybe<GeoFilterInput>;
  numberFilter?: InputMaybe<NumberFilterInput>;
  stringFilter?: InputMaybe<StringFilterInput>;
};

/** Whether the calling user can create a pixel audience in the organization right now. */
export type PixelAudienceCapability = {
  allowed: Scalars['Boolean']['output'];
  /** Set only when the capability can be used and the plan fixes the quota. */
  fixedQuota?: Maybe<FixedQuota>;
  /** Set only when the capability can't be used. */
  reason?: Maybe<CapabilityUnavailableReason>;
};

export type PixelMatchCounts = {
  highestTraffic?: Maybe<AudienceMatchCount>;
  lowestTraffic?: Maybe<AudienceMatchCount>;
  matchCount: Scalars['Int']['output'];
};

export enum PixelMatchingCadence {
  FourHours = 'FourHours',
  TwentyFourHours = 'TwentyFourHours'
}

export type PixelSetupStatus = {
  checkDate?: Maybe<Scalars['Date']['output']>;
  firstSuccessfulCheckDate?: Maybe<Scalars['Date']['output']>;
  isValid?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type PixelStatusCount = {
  nearQuotaReached: Scalars['Int']['output'];
  quotaReached: Scalars['Int']['output'];
  withoutRecentMatches: Scalars['Int']['output'];
};

export type PostalCodeCount = {
  count: Scalars['Int']['output'];
  postalCode: Scalars['String']['output'];
};

export type PreviousBalanceData = {
  capturedAt?: Maybe<Scalars['Date']['output']>;
  invoices?: Maybe<Array<PreviousBalanceInvoice>>;
};

export type PreviousBalanceInvoice = {
  number?: Maybe<Scalars['String']['output']>;
  outstandingAmount?: Maybe<Scalars['String']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
};

export enum PricingScheme {
  PerUnit = 'PerUnit',
  Stairstep = 'Stairstep',
  Tiered = 'Tiered',
  Volume = 'Volume'
}

export type ProcessingResultInfo = CustomerListInvalidImportData;

export type ProductComponent = {
  allowFractionalQuantities?: Maybe<Scalars['Boolean']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  defaultPricePointId?: Maybe<Scalars['Int']['output']>;
  defaultPricePointName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  downgradeCharge?: Maybe<Scalars['String']['output']>;
  handle?: Maybe<Scalars['String']['output']>;
  hideDateRangeOnInvoice?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  kind?: Maybe<ComponentKind>;
  name?: Maybe<Scalars['String']['output']>;
  pricePointCount?: Maybe<Scalars['Int']['output']>;
  pricePointsUrl?: Maybe<Scalars['String']['output']>;
  prices?: Maybe<Array<ProductComponentPrices>>;
  pricingScheme?: Maybe<PricingScheme>;
  productFamilyId: Scalars['ID']['output'];
  productFamilyName?: Maybe<Scalars['String']['output']>;
  recurring?: Maybe<Scalars['Boolean']['output']>;
  taxCode?: Maybe<Scalars['String']['output']>;
  taxable?: Maybe<Scalars['Boolean']['output']>;
  unitName?: Maybe<Scalars['String']['output']>;
  unitPrice?: Maybe<Scalars['String']['output']>;
  upgradeCharge?: Maybe<Scalars['String']['output']>;
  useSiteExchangeRate?: Maybe<Scalars['Boolean']['output']>;
};

export type ProductComponentPrices = {
  componentId?: Maybe<Scalars['ID']['output']>;
  endingQuantity?: Maybe<Scalars['Int']['output']>;
  formattedUnitPrice?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  pricePointId?: Maybe<Scalars['Int']['output']>;
  startingQuantity?: Maybe<Scalars['Int']['output']>;
  unitPrice?: Maybe<Scalars['String']['output']>;
};

export enum ProductIntervalUnit {
  Day = 'Day',
  Month = 'Month'
}

export type PromptPersonFilterInput = {
  audienceDescription: Scalars['String']['input'];
  audienceId?: InputMaybe<Scalars['ID']['input']>;
  currentDateHint?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
};

export type PromptPersonFilterOutput = {
  filters: Array<PersonFilter>;
  sessionId?: Maybe<Scalars['String']['output']>;
};

export type PulseAdditionsArrayInfo = BaseAdditionsArrayInfo & {
  date: Scalars['Date']['output'];
  dateRange: DateRange;
  matchedCount: Scalars['Int']['output'];
  requestedCount: Scalars['Int']['output'];
  subscriptionAmount: Scalars['Int']['output'];
  subscriptionCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type PulseItem = {
  category: Scalars['String']['output'];
  id: Scalars['String']['output'];
  subCategory?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
};

export type PulseNode = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  paths: Array<Scalars['String']['output']>;
  signalCount: Scalars['SafeInt']['output'];
};

export type PulseNodeConnection = {
  nodes: Array<PulseNode>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PulseProcessingAdditionInfo = BaseProcessingAdditionInfo & {
  date: Scalars['Date']['output'];
  dateRange: DateRange;
  requestedCount: Scalars['Int']['output'];
  subscriptionAmount: Scalars['Int']['output'];
  subscriptionCount: Scalars['Int']['output'];
};

export type Query = {
  _?: Maybe<Scalars['Boolean']['output']>;
  activationSpecs: Array<ActivationSpec>;
  activitySummaryPage?: Maybe<ActivitySummaryConnection>;
  /** Gets paginated journeys for a pixel audience. Only available for admin users. */
  adminJourneys?: Maybe<PageViewConnection>;
  /** Scans full audience people. Only available for admin users. */
  adminPeople?: Maybe<PersonConnection>;
  /** Gets a paginated journey of a given person for a pixel audience. Only available for admin users. */
  adminPersonJourney?: Maybe<PageViewConnection>;
  aiCreditsUsage: AiCreditsUsage;
  appConfiguration: AppConfiguration;
  /** Gets an audience by id */
  audience?: Maybe<Audience>;
  audienceIntegration?: Maybe<AudienceIntegration>;
  /**
   * One activation template, read through the given organization: returned exactly when it is one of the templates
   * organizationAudienceIntegrationTemplatesPage lists for that organization. An unknown, deleted, or not visible id
   * fails with the same not-found error. Sensitive configuration values are never returned.
   */
  audienceIntegrationTemplate?: Maybe<AudienceIntegrationTemplate>;
  /**
   * A page of the activation templates the given audience can be activated from: the ones of its organization, plus the
   * cascading ones of its ancestor organizations. Segments only get templates that include them, and templates whose
   * integration type does not accept the audience are left out. Templates come ordered by name, searchQuery matches
   * their name, and sensitive configuration values are never returned.
   */
  audienceIntegrationTemplatesPage: AudienceIntegrationTemplateConnection;
  /**
   * Using the average vector of a base audience (Pixel or Customer List),
   * get the number of people with a similarity greater or equal than X
   */
  audienceLookalikeCount: Scalars['Int']['output'];
  /**
   * Gets a page of audiences given a pair of after/first or before/last values. Note than for the first page there's no
   * need to provide an after/before cursor.
   * Also, audiences can be filtered by:
   *   - organization
   *   - text
   *   - condition
   *   - filters
   *   - pixelStatus
   *   - creationDateRange
   */
  audiences: AudienceConnection;
  audiencesCount?: Maybe<AudiencesCount>;
  /**
   * Gets a page of audiences for the given arguments. NOTE: For a cursor-based pagination, use the audiences query instead.
   * Also, audiences can be filtered by:
   *   - organization
   *   - text
   *   - condition
   *   - filters
   *   - pixelStatus
   *   - creationDateRange
   */
  audiencesPage: AudienceConnection;
  /** Gets a single Beeswax segment by its key. */
  beeswaxGetSegment?: Maybe<BeeswaxSegment>;
  /** Lists Beeswax segments. */
  beeswaxListSegments: BeeswaxListSegmentsResult;
  /** Get the configuration for a specific tenant based on the domain */
  configuration?: Maybe<Configuration>;
  conversationMessages: ConversationMessageConnection;
  conversationReferenceAutocomplete: ConversationReferenceConnection;
  conversations: ConversationConnection;
  /** Get the domain configurations for a list of domains */
  domainConfigurations: Array<Maybe<DomainConfiguration>>;
  entitiesCount?: Maybe<EntitiesCount>;
  /** @deprecated Use conversationMessages instead */
  getConversationMessages: ConversationMessageConnection;
  integrations: Array<AudienceIntegrationMetadata>;
  /** Get invite information. */
  invite?: Maybe<Invite>;
  /** Get all the organization invoices */
  invoices?: Maybe<Array<SubscriptionInvoice>>;
  listOrganizationRoles: Array<RestrictedAccessRole>;
  /** Lists Mailchimp audiences. */
  mailchimpListAudiences: Array<MailchimpAudience>;
  /** Current authenticated user information and settings */
  me?: Maybe<User>;
  /** Get organization information. */
  organization?: Maybe<Organization>;
  /**
   * A page of the activation templates the given organization can see: the ones it owns, plus the cascading ones of its
   * ancestor organizations. No audience is involved, so segment and audience compatibility do not filter them.
   * Templates come ordered by name, searchQuery matches their name, and sensitive configuration values are never
   * returned. Page count comes from totalCount and pageItemsCount; pageInfo does not describe numbered pages.
   */
  organizationAudienceIntegrationTemplatesPage: AudienceIntegrationTemplateConnection;
  /** Retrieves accessible organizations with an optional search query string, organization type or by an ancestor organization id. */
  organizationsPage: OrganizationConnection;
  /** Gets counts of people for the given field. Fields compatible with this query are "category-like" fields. */
  peopleCounts?: Maybe<Array<Maybe<BucketElement>>>;
  /**
   * Gets paged counts for values of the given field. Fields compatible with this query are "category-like" fields.
   * This query will always return "totalCount" with a value.
   */
  peopleFieldCounts: BucketConnection;
  peopleFields?: Maybe<Array<Maybe<PersonField>>>;
  /**
   * Gets counts of people for the provided number field. Counts are returned in buckets defined by the provided interval.
   * minCountPerBucket (0 by default): returns only buckets with at least minCountPerBucket documents.
   * bucketKeyFormat ("{from} - {to}" by default): format for the bucket key.
   */
  peopleNumberHistogram?: Maybe<Array<Maybe<BucketElement>>>;
  /** Returns the total count of people for a set of filters and an optional parent audience id */
  peopleSnapshot?: Maybe<PeopleSnapshot>;
  /** Gets the person by id for a specific audience. */
  person?: Maybe<Person>;
  pixelMatchCounts?: Maybe<PixelMatchCounts>;
  pixelMatchDateHistogram?: Maybe<Array<BucketElement>>;
  pixelStatusCount?: Maybe<PixelStatusCount>;
  /** Get all subscription products */
  products?: Maybe<Array<SubscriptionProduct>>;
  promptPersonFilter?: Maybe<PromptPersonFilterOutput>;
  /**
   * Gets the nodes of the pulse tree. Based on the parent paths, it returns the child nodes.
   * If parentPaths is empty, we load categories. If it has a single value, we load the category's sub-categories. If it has two values, we load the sub-category's topics.
   */
  pulseNodes: PulseNodeConnection;
  /** Gets the pulse node signal count. */
  pulseNodesSignalCount: Scalars['SafeInt']['output'];
  /** Retrieves the accessible organizations where the calling user can use a capability right now. */
  selectableOrganizationsPage: OrganizationConnection;
  /** Get the organization subscription */
  subscriptionInfo?: Maybe<SubscriptionInfo>;
  /** Gets an audience by the pixel id */
  systemAudienceByPixel?: Maybe<Audience>;
  /** Gets an audience quota information by pixel id. Only available for internal use. */
  systemAudienceQuotaInfo?: Maybe<AudienceQuotaInfo>;
  /**
   * Gets audiences by ids. Returns null for non-existent IDs at the corresponding position.
   * Only available for internal use.
   */
  systemAudiences: Array<Maybe<Audience>>;
  systemElasticsearchIndexInfo: SystemElasticsearchIndexInfo;
  systemElasticsearchSanitizeQuery: SystemElasticsearchSanitizedQuery;
  /** Retrieves encrypted refresh token and scopes for a user's Google account (internal usage only) */
  systemGoogleAuth: SystemGoogleAuthResponse;
  /** Get invite information. Only available for internal use. */
  systemInvite?: Maybe<Invite>;
  /** Reads the processing state of an opt-out record. For internal use only. */
  systemOptOutProcessingState?: Maybe<OptOutProcessingState>;
  /** Get organization information. Only available for internal use. */
  systemOrganization?: Maybe<Organization>;
  /**
   * For internal use only. Returns a page of Mailchimp integrations whose main audience condition is Pulse and that
   * have pending Batch API work (a non-empty lastAddBatchIds or lastRemoveBatchIds). Used by the daily reconciliation
   * scheduler to resolve prior batch work before Mailchimp's 7-day retention window expires.
   */
  systemPendingReconciliationMailchimpIntegrations: AudienceIntegrationConnection;
  /** Returns the number of email of all new matches between the specified dates (inclusive). */
  systemPixelAudienceEmailsCount: Scalars['Int']['output'];
  /** Get user information. Only available for internal use. */
  systemUser?: Maybe<User>;
  /** Get UserOrganization information. Only available for internal use. */
  systemUserOrganization?: Maybe<UserOrganization>;
  /** List all the users in the system. Only available for internal use. */
  systemUsers?: Maybe<UserConnection>;
};


export type QueryActivitySummaryPageArgs = {
  activityLevel?: InputMaybe<ActivityLevel>;
  dateRange: DateOperatorsInput;
  includeOrgTree?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  pageItemsCount: Scalars['Int']['input'];
  pageNumber: Scalars['Int']['input'];
};


export type QueryAdminJourneysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  audienceId: Scalars['ID']['input'];
  filters?: InputMaybe<Array<JourneyFilterInput>>;
  first: Scalars['Int']['input'];
  includeTotal?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAdminPeopleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  audienceId: Scalars['ID']['input'];
  filters?: InputMaybe<Array<PersonFilterInput>>;
  first: Scalars['Int']['input'];
  matchbackComparisons?: InputMaybe<MatchbackComparisonsFilterInput>;
  sort?: InputMaybe<Array<SortFieldInput>>;
};


export type QueryAdminPersonJourneyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  audienceId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  personId: Scalars['ID']['input'];
};


export type QueryAudienceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAudienceIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAudienceIntegrationTemplateArgs = {
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type QueryAudienceIntegrationTemplatesPageArgs = {
  audienceId: Scalars['ID']['input'];
  integrationType?: InputMaybe<AudienceIntegrationType>;
  pageItemsCount: Scalars['Int']['input'];
  pageNumber: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAudienceLookalikeCountArgs = {
  audienceLookalikeCountParams: AudienceLookalikeCountInput;
};


export type QueryAudiencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  condition?: InputMaybe<AudienceCondition>;
  conditions?: InputMaybe<Array<AudienceCondition>>;
  creationDateRange?: InputMaybe<DateOperatorsInput>;
  filters?: InputMaybe<Array<AudienceFilterInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  pixelStatus?: InputMaybe<AudiencePixelStatus>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAudiencesCountArgs = {
  dateRange?: InputMaybe<DateOperatorsInput>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAudiencesPageArgs = {
  condition?: InputMaybe<AudienceCondition>;
  conditions?: InputMaybe<Array<AudienceCondition>>;
  creationDateRange?: InputMaybe<DateOperatorsInput>;
  filters?: InputMaybe<Array<AudienceFilterInput>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  pageItemsCount: Scalars['Int']['input'];
  pageNumber: Scalars['Int']['input'];
  pixelStatus?: InputMaybe<AudiencePixelStatus>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBeeswaxGetSegmentArgs = {
  input: BeeswaxGetSegmentInput;
};


export type QueryBeeswaxListSegmentsArgs = {
  input: BeeswaxListSegmentsInput;
};


export type QueryConfigurationArgs = {
  domain: Scalars['String']['input'];
};


export type QueryConversationMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  conversationId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
};


export type QueryConversationReferenceAutocompleteArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ConversationReferenceFilterInput>;
  first: Scalars['Int']['input'];
  searchQuery: Scalars['String']['input'];
};


export type QueryConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDomainConfigurationsArgs = {
  domains: Array<Scalars['String']['input']>;
};


export type QueryEntitiesCountArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetConversationMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  identifier: Scalars['String']['input'];
  section: ConversationSection;
};


export type QueryInviteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInvoicesArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryListOrganizationRolesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMailchimpListAudiencesArgs = {
  input: MailchimpListAudiencesInput;
};


export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationAudienceIntegrationTemplatesPageArgs = {
  integrationType?: InputMaybe<AudienceIntegrationType>;
  organizationId: Scalars['ID']['input'];
  pageItemsCount: Scalars['Int']['input'];
  pageNumber: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganizationsPageArgs = {
  ancestorOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  includeAncestor?: InputMaybe<Scalars['Boolean']['input']>;
  organizationType?: InputMaybe<OrganizationType>;
  pageItemsCount: Scalars['Int']['input'];
  pageNumber: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPeopleCountsArgs = {
  customField?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<FilterStringField>;
  filters?: InputMaybe<Array<InputMaybe<PersonFilterInput>>>;
  matchbackComparisons?: InputMaybe<MatchbackComparisonsFilterInput>;
  parentAudienceId?: InputMaybe<Scalars['ID']['input']>;
  takeIntoAccountSameFieldFilters?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPeopleFieldCountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  customField?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<FilterStringField>;
  filters?: InputMaybe<Array<InputMaybe<PersonFilterInput>>>;
  first: Scalars['Int']['input'];
  matchbackComparisons?: InputMaybe<MatchbackComparisonsFilterInput>;
  parentAudienceId?: InputMaybe<Scalars['ID']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  takeIntoAccountSameFieldFilters?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPeopleNumberHistogramArgs = {
  bucketKeyFormat?: InputMaybe<Scalars['String']['input']>;
  field: FilterNumberField;
  filters?: InputMaybe<Array<InputMaybe<PersonFilterInput>>>;
  interval?: InputMaybe<Scalars['Int']['input']>;
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
  minCountPerBucket?: InputMaybe<Scalars['Int']['input']>;
  takeIntoAccountSameFieldFilters?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPeopleSnapshotArgs = {
  addingToGlobalAudienceId?: InputMaybe<Scalars['ID']['input']>;
  filters: Array<InputMaybe<PersonFilterInput>>;
  parentAudienceId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPersonArgs = {
  audienceId: Scalars['ID']['input'];
  personId: Scalars['ID']['input'];
};


export type QueryPixelMatchCountsArgs = {
  dateRange?: InputMaybe<DateOperatorsInput>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPixelMatchDateHistogramArgs = {
  interval: DateIntervalInput;
  max: Scalars['Date']['input'];
  min: Scalars['Date']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPixelStatusCountArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPromptPersonFilterArgs = {
  promptPersonFilterParams: PromptPersonFilterInput;
};


export type QueryPulseNodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  parentPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySelectableOrganizationsPageArgs = {
  capability: Capability;
  pageItemsCount: Scalars['Int']['input'];
  pageNumber: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySubscriptionInfoArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QuerySystemAudienceByPixelArgs = {
  pixelClientId: Scalars['ID']['input'];
};


export type QuerySystemAudienceQuotaInfoArgs = {
  pixelClientId: Scalars['String']['input'];
};


export type QuerySystemAudiencesArgs = {
  systemAudiencesInput: SystemAudiencesInput;
};


export type QuerySystemElasticsearchIndexInfoArgs = {
  params: SystemElasticsearchIndexInfoInput;
};


export type QuerySystemElasticsearchSanitizeQueryArgs = {
  params: SystemElasticsearchSanitizeQueryInput;
};


export type QuerySystemGoogleAuthArgs = {
  input: SystemGoogleAuthInput;
};


export type QuerySystemInviteArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySystemOptOutProcessingStateArgs = {
  optOutId: Scalars['Int']['input'];
};


export type QuerySystemOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySystemPendingReconciliationMailchimpIntegrationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type QuerySystemPixelAudienceEmailsCountArgs = {
  audienceId: Scalars['ID']['input'];
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
};


export type QuerySystemUserArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySystemUserOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySystemUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type RestrictedAccessAudience = BaseAudience & {
  baseAudience?: Maybe<BaseAudience>;
  categories?: Maybe<Array<AudienceCategory>>;
  condition?: Maybe<AudienceCondition>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  filters?: Maybe<Array<PersonFilter>>;
  id: Scalars['ID']['output'];
  info?: Maybe<AudienceInfo>;
  name?: Maybe<Scalars['String']['output']>;
  parentAudience?: Maybe<BaseAudience>;
};

export type RestrictedAccessOrganization = BaseOrganization & {
  businessDataEnabled?: Maybe<Scalars['Boolean']['output']>;
  disableEmailValidation?: Maybe<Scalars['Boolean']['output']>;
  hiddenPeopleFields?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  madhiveEnabled?: Maybe<Scalars['Boolean']['output']>;
  matchbackEnabled?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationType?: Maybe<OrganizationType>;
};


export type RestrictedAccessOrganizationDisableEmailValidationArgs = {
  retrieveFinalValue?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RestrictedAccessRole = BaseRole & {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organization?: Maybe<RestrictedAccessOrganization>;
  organizationId?: Maybe<Scalars['ID']['output']>;
};

export type RestrictedAccessUser = BaseUser & {
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type Role = BaseRole & {
  childOrgExtraPermissions?: Maybe<Array<Permission>>;
  createdAt: Scalars['Date']['output'];
  hiddenPeopleFields?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organization?: Maybe<RestrictedAccessOrganization>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  permissions: Array<Permission>;
  updatedAt: Scalars['Date']['output'];
};

export enum S3AudienceIntegrationBucketOwnership {
  Platform = 'Platform',
  /** Only for internal use, to be used on auto-created integrations for platform-owned buckets. */
  PlatformBucket = 'PlatformBucket',
  UserProvided = 'UserProvided'
}

export type S3AudienceIntegrationConfiguration = {
  accessKeyId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use outputObjectKeyTemplates instead. */
  addIdSuffix?: Maybe<Scalars['Boolean']['output']>;
  bypassHiddenPeopleFields?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use outputObjectKeyTemplates instead. Accepted only when creating an activation, and never together with outputObjectKeyTemplates. */
  destinationKey?: Maybe<Scalars['String']['output']>;
  /** TODO: These fields will be mandatory after the UI changes. */
  destinationS3Bucket?: Maybe<Scalars['String']['output']>;
  /**
   * @deprecated(reason: "Use destinationS3Bucket and outputObjectKeyTemplates instead. Will be removed after UI changes.")
   * Derived, not stored intent: it is only present when the destination has exactly one output object key template
   * whose directory holds no {{variables}}. It is absent for a multi-path destination and for a path with a variable
   * in its directory. A system-managed activation does get one, because it stores its directory already resolved;
   * the activation template it came from does not, because that one keeps the variables.
   */
  destinationS3URI?: Maybe<Scalars['String']['output']>;
  exportType: ExportType;
  fileFormat: FileFormat;
  iamRoles?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Only for the "Maids" export type. Set through activation templates (not via the UI). When omitted,
   * the fixed set of MAID export fields is used.
   */
  maidFields?: Maybe<Array<MaidExportField>>;
  /** @deprecated Use outputObjectKeyTemplates instead. Accepted only when creating an activation, and never together with outputObjectKeyTemplates. */
  outputFilenameStrategy?: Maybe<OutputFilenameStrategy>;
  /**
   * One entry per delivered file: a complete object key relative to the bucket, directory and filename, in which
   * {{variable}} placeholders are resolved at delivery time, in UTC. The filename must end with the extension that
   * matches "fileFormat". An unknown variable is rejected when the configuration is saved, and one that cannot be
   * resolved at delivery fails the run rather than delivering a file with an empty segment. A "/" or "\\" inside a
   * resolved value becomes "_", so only a separator written in the template itself creates a folder.
   *
   * Nothing else is rewritten: the delivered key holds exactly what the template says and exactly what each variable
   * resolved to, with three exceptions, applied to literal template text and resolved values alike. Every character
   * AWS lists as one to avoid becomes "-": a backslash, "{", "}", "^", "%", a backtick, "]", a double quote, ">",
   * "[", "~", "<", "#" and "|". Every control character becomes "-", and so does "?", which would otherwise truncate
   * the key wherever something parses the value as a URL. A run of two or more spaces collapses to a single space. A
   * single space is preserved, as are accented, CJK and other non-ASCII printable characters. See
   * https://docs.aws.amazon.com/AmazonS3/latest/userguide/object-keys.html#object-key-guidelines
   *
   * Available variables: {{timestamp}}, {{yyyy}}, {{MM}}, {{dd}}, {{hh}}, {{mm}}, {{ss}}, {{sourceFilenameBase}},
   * {{audienceId}}, {{audienceName}}, {{audienceNameKebab}}, {{audienceType}}, {{activationId}}, {{activationName}},
   * {{activationNameKebab}}, {{exportType}}, {{organizationId}}, {{organizationName}}, {{organizationNameKebab}}.
   *
   * {{sourceFilenameBase}} is the name of the uploaded source file, so it is only valid for a Customer List whose
   * file lives in a VisitIQ organization bucket. It is rejected on any other audience, and an activation template
   * that uses it is skipped for audiences that cannot resolve it, rather than delivering a differently named file.
   */
  outputObjectKeyTemplates?: Maybe<Array<Scalars['String']['output']>>;
  ownership: S3AudienceIntegrationBucketOwnership;
  peopleColumns: Array<Scalars['String']['output']>;
  region?: Maybe<AwsRegion>;
  secretAccessKey?: Maybe<Scalars['String']['output']>;
};

export type S3AudienceIntegrationConfigurationInput = {
  /** These are only required for the "UserProvided" ownership type. */
  accessKeyId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use outputObjectKeyTemplates instead. Accepted only when creating an activation, and never together with outputObjectKeyTemplates. */
  destinationKey?: InputMaybe<Scalars['String']['input']>;
  /** TODO: These fields will be mandatory after the UI changes. */
  destinationS3Bucket?: InputMaybe<Scalars['String']['input']>;
  /**
   * @deprecated(reason: "Use destinationS3Bucket and outputObjectKeyTemplates instead.")
   * Accepted only for a customer-managed destination, and on an update it replaces the directory only: the stored
   * filename is re-appended, because a URI cannot express one. Sending it for a system-managed destination is
   * rejected as an override of an automatic value.
   */
  destinationS3URI?: InputMaybe<Scalars['String']['input']>;
  exportType?: InputMaybe<ExportType>;
  fileFormat?: InputMaybe<FileFormat>;
  /** This is only required for the "Platform" ownership type. */
  iamRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Use outputObjectKeyTemplates instead. Accepted only when creating an activation, and never together with outputObjectKeyTemplates. */
  outputFilenameStrategy?: InputMaybe<OutputFilenameStrategy>;
  /**
   * One entry per delivered file: a complete object key relative to the bucket, directory and filename, in which
   * {{variable}} placeholders are resolved at delivery time, in UTC. The filename must end with the extension that
   * matches "fileFormat". An unknown variable is rejected when the configuration is saved, and one that cannot be
   * resolved at delivery fails the run rather than delivering a file with an empty segment. A "/" or "\\" inside a
   * resolved value becomes "_", so only a separator written in the template itself creates a folder.
   *
   * Nothing else is rewritten: the delivered key holds exactly what the template says and exactly what each variable
   * resolved to, with three exceptions, applied to literal template text and resolved values alike. Every character
   * AWS lists as one to avoid becomes "-": a backslash, "{", "}", "^", "%", a backtick, "]", a double quote, ">",
   * "[", "~", "<", "#" and "|". Every control character becomes "-", and so does "?", which would otherwise truncate
   * the key wherever something parses the value as a URL. A run of two or more spaces collapses to a single space. A
   * single space is preserved, as are accented, CJK and other non-ASCII printable characters. See
   * https://docs.aws.amazon.com/AmazonS3/latest/userguide/object-keys.html#object-key-guidelines
   *
   * Available variables: {{timestamp}}, {{yyyy}}, {{MM}}, {{dd}}, {{hh}}, {{mm}}, {{ss}}, {{sourceFilenameBase}},
   * {{audienceId}}, {{audienceName}}, {{audienceNameKebab}}, {{audienceType}}, {{activationId}}, {{activationName}},
   * {{activationNameKebab}}, {{exportType}}, {{organizationId}}, {{organizationName}}, {{organizationNameKebab}}.
   *
   * {{sourceFilenameBase}} is the name of the uploaded source file, so it is only valid for a Customer List whose
   * file lives in a VisitIQ organization bucket. It is rejected on any other audience, and an activation template
   * that uses it is skipped for audiences that cannot resolve it, rather than delivering a differently named file.
   */
  outputObjectKeyTemplates?: InputMaybe<Array<Scalars['String']['input']>>;
  ownership: S3AudienceIntegrationBucketOwnership;
  peopleColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  region?: InputMaybe<AwsRegion>;
  secretAccessKey?: InputMaybe<Scalars['String']['input']>;
};

export enum Scope {
  AudiencesAdmin = 'AudiencesAdmin',
  OrgsAdmin = 'OrgsAdmin',
  UserAdmin = 'UserAdmin'
}

export type Social = {
  facebook?: Maybe<Scalars['String']['output']>;
  linkedIn?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
};

export type SortFieldInput = {
  ascending: Scalars['Boolean']['input'];
  field: FilterField;
};

export type StringFieldBreakdown = {
  buckets?: Maybe<Array<BucketElement>>;
  /** Non-null when this field was rejected (e.g. permission, validation). Buckets will be null in that case. */
  error?: Maybe<FieldBreakdownError>;
  field: FilterStringField;
};

export type StringFilter = {
  customField?: Maybe<Scalars['String']['output']>;
  field?: Maybe<FilterStringField>;
  negate?: Maybe<Scalars['Boolean']['output']>;
  operator: StringOperators;
};

export type StringFilterConfiguration = {
  condition?: Maybe<LogicalOperator>;
  isExtendedStringFilter?: Maybe<Scalars['Boolean']['output']>;
  onlyExistence?: Maybe<Scalars['Boolean']['output']>;
};

export type StringFilterInput = {
  customField?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<FilterStringField>;
  negate?: InputMaybe<Scalars['Boolean']['input']>;
  operator: StringOperatorsInput;
};

export type StringOperators = {
  eq?: Maybe<Scalars['String']['output']>;
  exists?: Maybe<Scalars['Boolean']['output']>;
  in?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type StringOperatorsInput = {
  eq?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Subscription = {
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type SubscriptionCreditCard = {
  billingAddress?: Maybe<Scalars['String']['output']>;
  billingAddress_2?: Maybe<Scalars['String']['output']>;
  billingCity?: Maybe<Scalars['String']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  billingState?: Maybe<Scalars['String']['output']>;
  billingZip?: Maybe<Scalars['String']['output']>;
  cardType?: Maybe<Scalars['String']['output']>;
  currentVault?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['ID']['output']>;
  customerVaultToken?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  expirationMonth?: Maybe<Scalars['Int']['output']>;
  expirationYear?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gatewayHandle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  maskedCardNumber?: Maybe<Scalars['String']['output']>;
  paymentType?: Maybe<Scalars['String']['output']>;
  siteGatewaySettingId?: Maybe<Scalars['ID']['output']>;
  vaultToken?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionCustomer = {
  address?: Maybe<Scalars['String']['output']>;
  address_2?: Maybe<Scalars['String']['output']>;
  ccEmails?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['ID']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  portalCustomerCreatedAt?: Maybe<Scalars['Date']['output']>;
  portalInviteLastAcceptedAt?: Maybe<Scalars['Date']['output']>;
  portalInviteLastSentAt?: Maybe<Scalars['Date']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateName?: Maybe<Scalars['String']['output']>;
  taxExempt?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionGroup = {
  primary?: Maybe<Scalars['String']['output']>;
  primarySubscriptionId?: Maybe<Scalars['ID']['output']>;
  scheme?: Maybe<Scalars['String']['output']>;
  uid: Scalars['ID']['output'];
};

export type SubscriptionInfo = {
  activatedAt?: Maybe<Scalars['Date']['output']>;
  automaticallyResumeAt?: Maybe<Scalars['Date']['output']>;
  balanceInCents?: Maybe<Scalars['Int']['output']>;
  cancelAtEndOfPeriod?: Maybe<Scalars['String']['output']>;
  canceledAt?: Maybe<Scalars['Date']['output']>;
  cancellationMessage?: Maybe<Scalars['String']['output']>;
  cancellationMethod?: Maybe<Scalars['String']['output']>;
  couponCode?: Maybe<Scalars['String']['output']>;
  couponCodes?: Maybe<Array<Scalars['String']['output']>>;
  couponUseCount?: Maybe<Scalars['Int']['output']>;
  couponUsesAllowed?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  creditBalanceInCents?: Maybe<Scalars['Int']['output']>;
  creditCard?: Maybe<SubscriptionCreditCard>;
  currency?: Maybe<Scalars['String']['output']>;
  currentPeriodEndsAt?: Maybe<Scalars['Date']['output']>;
  currentPeriodStartedAt?: Maybe<Scalars['Date']['output']>;
  currentPeriodUsageInfo: PeriodUsageInfo;
  customer?: Maybe<SubscriptionCustomer>;
  delayedCancelAt?: Maybe<Scalars['Date']['output']>;
  expiresAt?: Maybe<Scalars['Date']['output']>;
  group?: Maybe<SubscriptionGroup>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  netTerms?: Maybe<Scalars['Int']['output']>;
  nextAssessmentAt?: Maybe<Scalars['Date']['output']>;
  nextProductHandle?: Maybe<Scalars['String']['output']>;
  nextProductId?: Maybe<Scalars['ID']['output']>;
  nextProductPricePointId?: Maybe<Scalars['ID']['output']>;
  offerId?: Maybe<Scalars['ID']['output']>;
  onHoldAt?: Maybe<Scalars['Date']['output']>;
  payerId?: Maybe<Scalars['ID']['output']>;
  paymentCollectionMethod?: Maybe<Scalars['String']['output']>;
  paymentType?: Maybe<Scalars['String']['output']>;
  prepaymentBalanceInCents?: Maybe<Scalars['Int']['output']>;
  previousState?: Maybe<SubscriptionState>;
  product?: Maybe<SubscriptionProduct>;
  productPriceInCents?: Maybe<Scalars['Int']['output']>;
  productPricePointId?: Maybe<Scalars['ID']['output']>;
  productPricePointType?: Maybe<Scalars['String']['output']>;
  productVersionNumber?: Maybe<Scalars['Int']['output']>;
  reasonCode?: Maybe<Scalars['String']['output']>;
  receivesInvoiceEmails?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
  scheduledCancellationAt?: Maybe<Scalars['Date']['output']>;
  signupPaymentId?: Maybe<Scalars['ID']['output']>;
  signupRevenue?: Maybe<Scalars['String']['output']>;
  snapDay?: Maybe<Scalars['String']['output']>;
  state?: Maybe<SubscriptionState>;
  storedCredentialTransactionId?: Maybe<Scalars['ID']['output']>;
  totalRevenueInCents?: Maybe<Scalars['Int']['output']>;
  trialEndedAt?: Maybe<Scalars['Date']['output']>;
  trialStartedAt?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type SubscriptionInput = {
  externalSubscriptionId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type SubscriptionInvoice = {
  billingAddress?: Maybe<InvoiceAddress>;
  collectionMethod?: Maybe<Scalars['String']['output']>;
  consolidationLevel?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  creditAmount?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<InvoiceCustomer>;
  customerId: Scalars['ID']['output'];
  discountAmount?: Maybe<Scalars['String']['output']>;
  dueAmount?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  groupPrimarySubscriptionId?: Maybe<Scalars['ID']['output']>;
  issueDate?: Maybe<Scalars['Date']['output']>;
  memo?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  paidAmount?: Maybe<Scalars['String']['output']>;
  paidDate?: Maybe<Scalars['Date']['output']>;
  parentInvoiceNumber?: Maybe<Scalars['Int']['output']>;
  parentInvoiceUid?: Maybe<Scalars['String']['output']>;
  paymentInstructions?: Maybe<Scalars['String']['output']>;
  payments?: Maybe<Array<Maybe<InvoicePayment>>>;
  previousBalanceData?: Maybe<PreviousBalanceData>;
  productFamilyName?: Maybe<Scalars['String']['output']>;
  productInterval?: Maybe<Scalars['Int']['output']>;
  productIntervalUnit?: Maybe<ProductIntervalUnit>;
  productName?: Maybe<Scalars['String']['output']>;
  publicUrl?: Maybe<Scalars['String']['output']>;
  refundAmount?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  seller?: Maybe<InvoiceSeller>;
  sequenceNumber?: Maybe<Scalars['Int']['output']>;
  shippingAddress?: Maybe<InvoiceAddress>;
  siteId: Scalars['ID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  subscriptionId: Scalars['ID']['output'];
  subtotalAmount?: Maybe<Scalars['String']['output']>;
  taxAmount?: Maybe<Scalars['String']['output']>;
  totalAmount?: Maybe<Scalars['String']['output']>;
  uid: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type SubscriptionProduct = {
  accountingCode?: Maybe<Scalars['String']['output']>;
  archivedAt?: Maybe<Scalars['Date']['output']>;
  budgetPerPeriod?: Maybe<Scalars['Int']['output']>;
  components?: Maybe<Array<Maybe<ProductComponent>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  defaultProductPricePointId?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expirationInterval?: Maybe<Scalars['Int']['output']>;
  expirationIntervalUnit?: Maybe<Scalars['String']['output']>;
  handle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initialChargeAfterTrial?: Maybe<Scalars['Boolean']['output']>;
  initialChargeInCents?: Maybe<Scalars['Int']['output']>;
  interval?: Maybe<Scalars['Int']['output']>;
  intervalUnit?: Maybe<ProductIntervalUnit>;
  name?: Maybe<Scalars['String']['output']>;
  priceInCents?: Maybe<Scalars['Int']['output']>;
  productFamily?: Maybe<SubscriptionProductFamily>;
  productPricePointHandle?: Maybe<Scalars['String']['output']>;
  productPricePointId?: Maybe<Scalars['ID']['output']>;
  productPricePointName?: Maybe<Scalars['String']['output']>;
  publicSignupPages?: Maybe<Array<SubscriptionPublicSignupPage>>;
  requestBillingAddress?: Maybe<Scalars['Boolean']['output']>;
  requestCreditCard?: Maybe<Scalars['Boolean']['output']>;
  requireBillingAddress?: Maybe<Scalars['Boolean']['output']>;
  requireCreditCard?: Maybe<Scalars['Boolean']['output']>;
  requireShippingAddress?: Maybe<Scalars['Boolean']['output']>;
  returnParams?: Maybe<Scalars['String']['output']>;
  taxCode?: Maybe<Scalars['String']['output']>;
  taxable?: Maybe<Scalars['Boolean']['output']>;
  trialInterval?: Maybe<Scalars['Int']['output']>;
  trialIntervalUnit?: Maybe<Scalars['String']['output']>;
  trialPriceInCents?: Maybe<Scalars['Int']['output']>;
  updateReturnParams?: Maybe<Scalars['String']['output']>;
  updateReturnUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  useSiteExchangeRate?: Maybe<Scalars['Boolean']['output']>;
  versionNumber?: Maybe<Scalars['Int']['output']>;
};

export type SubscriptionProductFamily = {
  accountingCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  handle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type SubscriptionPublicSignupPage = {
  currency?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  returnParams?: Maybe<Scalars['String']['output']>;
  returnUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum SubscriptionState {
  Active = 'Active',
  Assessing = 'Assessing',
  AwaitingSignup = 'AwaitingSignup',
  Canceled = 'Canceled',
  Expired = 'Expired',
  FailedToCreate = 'FailedToCreate',
  OnHold = 'OnHold',
  PastDue = 'PastDue',
  Paused = 'Paused',
  Pending = 'Pending',
  SoftFailure = 'SoftFailure',
  Suspended = 'Suspended',
  TrialEnded = 'TrialEnded',
  Trialing = 'Trialing',
  Unpaid = 'Unpaid'
}

export type SystemAudienceQueryInfoOptions = {
  additionId?: InputMaybe<Scalars['ID']['input']>;
  getAdditionsFromDaysAgo?: InputMaybe<Scalars['Int']['input']>;
};

export type SystemAudiencesInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  pixelIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SystemElasticsearchIndexInfo = {
  audienceScopedFields?: Maybe<Array<AudienceScopedField>>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  excludedFields?: Maybe<Array<Scalars['String']['output']>>;
  excludedFieldsReasons?: Maybe<Array<Scalars['String']['output']>>;
  indexNames?: Maybe<Array<Scalars['String']['output']>>;
  queryAllowedFields?: Maybe<Array<AllowedField>>;
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

export type SystemElasticsearchIndexInfoInput = {
  actorUserId: Scalars['String']['input'];
  audienceIds: Array<Scalars['ID']['input']>;
  indexType: AgentElasticsearchIndexType;
};

export type SystemElasticsearchSanitizeQueryInput = {
  actorUserId: Scalars['String']['input'];
  aggregations?: InputMaybe<Scalars['JSON']['input']>;
  audienceIds: Array<Scalars['ID']['input']>;
  dateRange?: InputMaybe<DateRangeInput>;
  indexType: AgentElasticsearchIndexType;
  query?: InputMaybe<Scalars['JSON']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
  source?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SystemElasticsearchSanitizedQuery = {
  body?: Maybe<Scalars['JSON']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  indexNames?: Maybe<Array<Scalars['String']['output']>>;
};

export type SystemGoogleAuthInput = {
  googleAccountId: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type SystemGoogleAuthResponse = {
  refreshToken: Scalars['String']['output'];
  scopes: Array<Scalars['String']['output']>;
};

export type SystemOrganizationInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentOrganizationId: Scalars['ID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  pixelDomain?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type SystemTrackAiUsageInput = {
  usageEvents: Array<AiUsageEventInput>;
};

export type SystemTrackAiUsageResult = {
  usageEvents: Array<AiUsageEventProcessingResult>;
};

export type TealiumAudienceIntegrationConfiguration = {
  bypassHiddenPeopleFields: Scalars['Boolean']['output'];
  checkIfExistingCustomer: Scalars['Boolean']['output'];
  customEntries: Scalars['JSON']['output'];
  emailAttributeName?: Maybe<Scalars['String']['output']>;
  endpoint: Scalars['String']['output'];
  events: TealiumEventsConfiguration;
  parameterNames: TealiumParameterNames;
  redshiftDatabase?: Maybe<Scalars['String']['output']>;
  redshiftHost?: Maybe<Scalars['String']['output']>;
  redshiftPassword?: Maybe<Scalars['String']['output']>;
  redshiftPort?: Maybe<Scalars['Int']['output']>;
  redshiftUser?: Maybe<Scalars['String']['output']>;
};

export type TealiumAudienceIntegrationConfigurationInput = {
  checkIfExistingCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  customEntries: Scalars['JSON']['input'];
  emailAttributeName?: InputMaybe<Scalars['String']['input']>;
  endpoint: Scalars['String']['input'];
  events?: InputMaybe<TealiumEventsConfigurationInput>;
  parameterNames: TealiumParameterNamesInput;
  redshiftDatabase?: InputMaybe<Scalars['String']['input']>;
  redshiftHost?: InputMaybe<Scalars['String']['input']>;
  redshiftPassword?: InputMaybe<Scalars['String']['input']>;
  redshiftPort?: InputMaybe<Scalars['Int']['input']>;
  redshiftUser?: InputMaybe<Scalars['String']['input']>;
};

export type TealiumEventsConfiguration = {
  existingCustomer?: Maybe<Scalars['String']['output']>;
  nonExistingCustomer?: Maybe<Scalars['String']['output']>;
  static?: Maybe<Scalars['String']['output']>;
};

export type TealiumEventsConfigurationInput = {
  existingCustomer?: InputMaybe<Scalars['String']['input']>;
  nonExistingCustomer?: InputMaybe<Scalars['String']['input']>;
  static?: InputMaybe<Scalars['String']['input']>;
};

export type TealiumParameterNames = {
  email: Scalars['String']['output'];
  hashedEmail: Scalars['String']['output'];
  hashedPhone: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type TealiumParameterNamesInput = {
  email: Scalars['String']['input'];
  hashedEmail: Scalars['String']['input'];
  hashedPhone: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export enum UtmGroup {
  Campaign = 'Campaign',
  Medium = 'Medium',
  Source = 'Source',
  SourceAndMedium = 'SourceAndMedium'
}

export type UpdateAudiencePulseInput = {
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  filters?: InputMaybe<Array<PersonFilterInput>>;
  id: Scalars['ID']['input'];
  subCategoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  subscriptionCount?: InputMaybe<Scalars['Int']['input']>;
  topicIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateConversationInput = {
  conversationId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type UpdateOptOutCallbacksStatusInput = {
  /** The result of each callback attempt. Absent leaves the callbacks and the request status untouched. */
  callbacks?: InputMaybe<Array<KetchCallbackInput>>;
  email?: InputMaybe<Scalars['String']['input']>;
  /**
   * The people the request matched, as the audit evidence of who it removed. An empty list means it
   * matched nobody, which is a different statement from not having been resolved yet.
   *
   * Sent on its own before the deletes, as the checkpoint of who the request is about to remove: a run
   * that stops between deleting and answering would otherwise re-resolve against indexes it emptied and
   * report "not found" about people it deleted.
   */
  matchedPersonIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * The opt-out record the outcome belongs to. The only handle a DROP request has, since it carries no
   * plain email. When absent, the record is looked up by email and requestType, as it always was.
   */
  optOutId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * What the request resolved to, and the request's answer: it dates requestProcessedAt and is only
   * sent once Ketch has been told. Absent leaves the stored outcome alone.
   */
  outcome?: InputMaybe<OptOutOutcome>;
  requestType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  adfProviderInfo?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pixelDomain?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSystemAudienceCategoriesInput = {
  audienceId: Scalars['ID']['input'];
  categories: Array<AudienceCategoryInput>;
  deleteMissing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSystemOrganizationInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  adfProviderInfo?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  pixelDomain?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSystemUserInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Array<Scope>>;
};

export type UpdateUserInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserRoleInput = {
  organizationId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type User = BaseUser & {
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  invites?: Maybe<Array<Invite>>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizations?: Maybe<Array<Organization>>;
  phone?: Maybe<Scalars['String']['output']>;
  scopes?: Maybe<Array<Scope>>;
  userRoles?: Maybe<Array<UserRole>>;
  whiteLabelImageUrl?: Maybe<Scalars['String']['output']>;
};

export type UserConnection = {
  edges: Array<UserEdge>;
  nodes: Array<User>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserEdge = {
  cursor: Scalars['String']['output'];
  node: User;
};

export type UserOrganization = {
  assignedRole: Role;
  id: Scalars['ID']['output'];
  invite?: Maybe<Invite>;
  organization?: Maybe<Organization>;
  user?: Maybe<User>;
};

export type UserRole = {
  assignedRole: Role;
  createdAt?: Maybe<Scalars['String']['output']>;
  hiddenPeopleFields?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export enum UserType {
  Admin = 'Admin',
  Internal = 'Internal',
  Ketch = 'Ketch',
  Salesforce = 'Salesforce',
  Standard = 'Standard',
  Unauthenticated = 'Unauthenticated'
}

export type VisitInput = {
  additionalParams?: InputMaybe<Scalars['JSON']['input']>;
  ip: Scalars['String']['input'];
  timestamp?: InputMaybe<Scalars['Date']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

export type ZapierAudienceIntegrationConfiguration = {
  bypassHiddenPeopleFields?: Maybe<Scalars['Boolean']['output']>;
  connectionTimestamp?: Maybe<Scalars['Date']['output']>;
  historicalDataSync: Scalars['Boolean']['output'];
  hookURL?: Maybe<Scalars['String']['output']>;
  status: ZapierConnectionStatus;
  zapID?: Maybe<Scalars['ID']['output']>;
};

export type ZapierAudienceIntegrationConfigurationInput = {
  historicalDataSync?: InputMaybe<Scalars['Boolean']['input']>;
  hookURL?: InputMaybe<Scalars['String']['input']>;
  zapID?: InputMaybe<Scalars['ID']['input']>;
};

export enum ZapierConnectionStatus {
  Connected = 'Connected',
  Disconnected = 'Disconnected'
}

export type ConversationReferenceAutocompleteQueryVariables = Exact<{
  searchQuery: Scalars['String']['input'];
  first: Scalars['Int']['input'];
  filter?: InputMaybe<ConversationReferenceFilterInput>;
}>;


export type ConversationReferenceAutocompleteQuery = { conversationReferenceAutocomplete: { nodes: Array<{ name: string, deepLink: string, type: ConversationReferenceType, audienceCondition?: AudienceCondition | null }> } };

export type CreateAudienceCustomerListMutationVariables = Exact<{
  audienceCustomerListParams: AudienceCustomerListInput;
}>;


export type CreateAudienceCustomerListMutation = { createAudienceCustomerList?: { id: string, name: string } | null };

export type ActivationSpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActivationSpecsQuery = { activationSpecs: Array<{ activationType: string, specVersion: number, displayName: string, category: string, beta: boolean, catalogId: string, allowedAudienceConditions?: Array<AudienceCondition> | null, configurableColumns: boolean, defaultPeopleColumns: Array<string>, fieldDefs: Array<{ key: string, label: string, kind: string, secret: boolean, required: boolean, options?: Array<string> | null, pattern?: string | null, placeholder?: string | null, defaultValue?: string | null }> }> };

export type ActivitySummaryPageQueryVariables = Exact<{
  pageNumber: Scalars['Int']['input'];
  pageItemsCount: Scalars['Int']['input'];
  dateRange: DateOperatorsInput;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  activityLevel?: InputMaybe<ActivityLevel>;
}>;


export type ActivitySummaryPageQuery = { activitySummaryPage?: { totalCount: number, nodes: Array<{ actedByUserType?: UserType | null, actionType: ActionType, createdAt: any, entityId: string, entityType: EntityType, field?: string | null, newValue?: string | null, oldValue?: string | null, actor?: { id: string, imageUrl?: string | null, firstName?: string | null, lastName?: string | null } | null, audience?: { id: string, name: string } | null, organization?: { id: string, name?: string | null, imageUrl?: string | null } | null, user?: { id: string, firstName?: string | null, lastName?: string | null, imageUrl?: string | null } | null }> } | null };

export type AddPeopleAudienceCustomerListMutationVariables = Exact<{
  addPeopleAudienceCustomerListParams: AddPeopleAudienceCustomerListInput;
}>;


export type AddPeopleAudienceCustomerListMutation = { addPeopleAudienceCustomerList?: { id: string, name: string } | null };

export type AddAudienceVisitsMutationVariables = Exact<{
  addPeopleAudienceGlobalParams: AddPeopleAudienceGlobalInput;
}>;


export type AddAudienceVisitsMutation = { addPeopleAudienceGlobal?: { id: string } | null };

export type AgentSecureInputKeyQueryVariables = Exact<{ [key: string]: never; }>;


export type AgentSecureInputKeyQuery = { appConfiguration: { agentSecureInputKey?: { kid: string, publicKeyPem: string } | null } };

export type AiCreditsUsageQueryVariables = Exact<{ [key: string]: never; }>;


export type AiCreditsUsageQuery = { aiCreditsUsage: { enabled: boolean, usage: number, limit: number, percentage: number, periodStart?: any | null, periodEnd?: any | null } };

export type AppConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type AppConfigurationQuery = { appConfiguration: { pulseSubscriptionAmount: number, pulseDateRange: { from: any, to: any } } };

export type AttributionSourceCountsQueryQueryVariables = Exact<{
  audienceId: Scalars['ID']['input'];
  utmGroup: UtmGroup;
  filters?: InputMaybe<Array<PersonFilterInput> | PersonFilterInput>;
  count?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AttributionSourceCountsQueryQuery = { audience?: { attributionSourceCounts: { attributions: Array<{ count: number, source: string }> } } | null };

export type AudienceIntegrationQueryVariables = Exact<{
  audienceIntegrationId: Scalars['ID']['input'];
}>;


export type AudienceIntegrationQuery = { audienceIntegration?: { id: string, integrationType: AudienceIntegrationType, name: string, lastSuccessfulRunAt?: any | null, lastRunSucceeded?: boolean | null, lastRunAt?: any | null, lastRunHasWarnings?: boolean | null, lastRunResult?: string | null, supportsTemplate: boolean, configuration:
      | { emails: Array<string> }
      | { activationType: string, historicalDataSync: boolean, activationPeopleColumns?: Array<string> | null, activationStatus: ActivationConnectionStatus, parameters: Array<{ key: string, value?: string | null }> }
      | { buzzKey: string, email: string, segmentKey?: string | null, hemSalt?: string | null }
      | { name: string, description?: string | null, advertiserId?: string | null, partnerId?: string | null, audienceOwnerType?: DisplayVideo360AudienceOwnerType | null, historicalDataSync: boolean, daysToKeep: number, googleUserAccountId?: string | null, dv360Status: DisplayVideo360CustomerMatchConnectionStatus }
      | { name: string, description?: string | null, adAccountId: string, accessToken?: string | null, customAudienceId?: string | null, historicalDataSync: boolean, daysToKeep: number }
      | { name: string, description?: string | null, customerId: string, managerCustomerId?: string | null, userListId?: string | null, lastOperationId?: string | null, historicalDataSync: boolean, daysToKeep: number, googleUserAccountId?: string | null, googleAdsStatus: GoogleCustomerMatchConnectionStatus }
      | { privateIntegrationToken?: string | null, locationId: string, tags: Array<string> }
      | { segmentName?: string | null, cpm: number, description?: string | null }
      | { apiKey?: string | null, audienceId: string, tag?: string | null, daysToKeep: number, historicalDataSync: boolean }
      | { secretAccessKey?: string | null, region?: AwsRegion | null, ownership: S3AudienceIntegrationBucketOwnership, iamRoles?: Array<string> | null, destinationS3Bucket?: string | null, outputObjectKeyTemplates?: Array<string> | null, accessKeyId?: string | null, exportType: ExportType, fileFormat: FileFormat, peopleColumns: Array<string> }
      | { checkIfExistingCustomer: boolean, redshiftHost?: string | null, redshiftPort?: number | null, redshiftUser?: string | null, redshiftPassword?: string | null, redshiftDatabase?: string | null, emailAttributeName?: string | null, customEntries: any, endpoint: string, events: { existingCustomer?: string | null, nonExistingCustomer?: string | null, static?: string | null }, parameterNames: { phone: string, email: string, hashedPhone: string, hashedEmail: string } }
      | { connectionTimestamp?: any | null, historicalDataSync: boolean, status: ZapierConnectionStatus }
    , creator?: { firstName?: string | null, lastName?: string | null } | null } | null };

export type ActivationAudienceIntegrationConfigurationFragment = { activationType: string, historicalDataSync: boolean, activationPeopleColumns?: Array<string> | null, activationStatus: ActivationConnectionStatus, parameters: Array<{ key: string, value?: string | null }> };

export type AdfAudienceIntegrationConfigurationFragment = { emails: Array<string> };

export type S3AudienceIntegrationConfigurationFragment = { secretAccessKey?: string | null, region?: AwsRegion | null, ownership: S3AudienceIntegrationBucketOwnership, iamRoles?: Array<string> | null, destinationS3Bucket?: string | null, outputObjectKeyTemplates?: Array<string> | null, accessKeyId?: string | null, exportType: ExportType, fileFormat: FileFormat, peopleColumns: Array<string> };

export type ZapierAudienceIntegrationConfigurationFragment = { connectionTimestamp?: any | null, historicalDataSync: boolean, status: ZapierConnectionStatus };

export type FacebookAudienceIntegrationConfigurationFragment = { name: string, description?: string | null, adAccountId: string, accessToken?: string | null, customAudienceId?: string | null, historicalDataSync: boolean, daysToKeep: number };

export type GoogleAdsAudienceIntegrationConfigurationFragment = { name: string, description?: string | null, customerId: string, managerCustomerId?: string | null, userListId?: string | null, lastOperationId?: string | null, historicalDataSync: boolean, daysToKeep: number, googleUserAccountId?: string | null, googleAdsStatus: GoogleCustomerMatchConnectionStatus };

export type HighLevelIntegrationConfigurationFragment = { privateIntegrationToken?: string | null, locationId: string, tags: Array<string> };

export type TealiumIntegrationConfigurationFragment = { checkIfExistingCustomer: boolean, redshiftHost?: string | null, redshiftPort?: number | null, redshiftUser?: string | null, redshiftPassword?: string | null, redshiftDatabase?: string | null, emailAttributeName?: string | null, customEntries: any, endpoint: string, events: { existingCustomer?: string | null, nonExistingCustomer?: string | null, static?: string | null }, parameterNames: { phone: string, email: string, hashedPhone: string, hashedEmail: string } };

export type MailchimpAudienceIntegrationConfigurationFragment = { apiKey?: string | null, audienceId: string, tag?: string | null, daysToKeep: number, historicalDataSync: boolean };

export type BeeswaxAudienceIntegrationConfigurationFragment = { buzzKey: string, email: string, segmentKey?: string | null, hemSalt?: string | null };

export type MadhiveAudienceIntegrationConfigurationFragment = { segmentName?: string | null, cpm: number, description?: string | null };

export type DisplayVideo360AudienceIntegrationConfigurationFragment = { name: string, description?: string | null, advertiserId?: string | null, partnerId?: string | null, audienceOwnerType?: DisplayVideo360AudienceOwnerType | null, historicalDataSync: boolean, daysToKeep: number, googleUserAccountId?: string | null, dv360Status: DisplayVideo360CustomerMatchConnectionStatus };

export type AudienceIntegrationTemplatesPageQueryVariables = Exact<{
  audienceId: Scalars['ID']['input'];
  integrationType?: InputMaybe<AudienceIntegrationType>;
  pageNumber: Scalars['Int']['input'];
  pageItemsCount: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}>;


export type AudienceIntegrationTemplatesPageQuery = { audienceIntegrationTemplatesPage: { totalCount: number, nodes: Array<{ id: string, name: string, integrationType: AudienceIntegrationType, cascadeToChildOrgs: boolean, includeSegments: boolean, automaticallyCreateActivations: boolean, configuration:
        | { emails: Array<string> }
        | { activationType: string, historicalDataSync: boolean, activationPeopleColumns?: Array<string> | null, activationStatus: ActivationConnectionStatus, parameters: Array<{ key: string, value?: string | null }> }
        | { buzzKey: string, email: string, segmentKey?: string | null, hemSalt?: string | null }
        | { name: string, description?: string | null, advertiserId?: string | null, partnerId?: string | null, audienceOwnerType?: DisplayVideo360AudienceOwnerType | null, historicalDataSync: boolean, daysToKeep: number, googleUserAccountId?: string | null, dv360Status: DisplayVideo360CustomerMatchConnectionStatus }
        | { name: string, description?: string | null, adAccountId: string, accessToken?: string | null, customAudienceId?: string | null, historicalDataSync: boolean, daysToKeep: number }
        | { name: string, description?: string | null, customerId: string, managerCustomerId?: string | null, userListId?: string | null, lastOperationId?: string | null, historicalDataSync: boolean, daysToKeep: number, googleUserAccountId?: string | null, googleAdsStatus: GoogleCustomerMatchConnectionStatus }
        | { privateIntegrationToken?: string | null, locationId: string, tags: Array<string> }
        | { segmentName?: string | null, cpm: number, description?: string | null }
        | { apiKey?: string | null, audienceId: string, tag?: string | null, daysToKeep: number, historicalDataSync: boolean }
        | { secretAccessKey?: string | null, region?: AwsRegion | null, ownership: S3AudienceIntegrationBucketOwnership, iamRoles?: Array<string> | null, destinationS3Bucket?: string | null, outputObjectKeyTemplates?: Array<string> | null, accessKeyId?: string | null, exportType: ExportType, fileFormat: FileFormat, peopleColumns: Array<string> }
        | { checkIfExistingCustomer: boolean, redshiftHost?: string | null, redshiftPort?: number | null, redshiftUser?: string | null, redshiftPassword?: string | null, redshiftDatabase?: string | null, emailAttributeName?: string | null, customEntries: any, endpoint: string, events: { existingCustomer?: string | null, nonExistingCustomer?: string | null, static?: string | null }, parameterNames: { phone: string, email: string, hashedPhone: string, hashedEmail: string } }
        | { connectionTimestamp?: any | null, historicalDataSync: boolean, status: ZapierConnectionStatus }
       }> } };

export type CreateAudienceIntegrationTemplateMutationVariables = Exact<{
  templateParams: AudienceIntegrationTemplateInput;
}>;


export type CreateAudienceIntegrationTemplateMutation = { createAudienceIntegrationTemplate: { id: string, name: string, integrationType: AudienceIntegrationType, cascadeToChildOrgs: boolean, includeSegments: boolean, automaticallyCreateActivations: boolean } };

export type OrganizationAudienceIntegrationTemplatesPageQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  integrationType?: InputMaybe<AudienceIntegrationType>;
  pageNumber: Scalars['Int']['input'];
  pageItemsCount: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganizationAudienceIntegrationTemplatesPageQuery = { organizationAudienceIntegrationTemplatesPage: { totalCount: number, nodes: Array<{ id: string, name: string, integrationType: AudienceIntegrationType, cascadeToChildOrgs: boolean, includeSegments: boolean, automaticallyCreateActivations: boolean, createdAt: any, organization:
        | { id: string, name?: string | null }
        | { id: string, name?: string | null }
      , inheritedFromOrganization?:
        | { id: string, name?: string | null }
        | { id: string, name?: string | null }
       | null }> } };

export type OrganizationAudienceIntegrationTemplateQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type OrganizationAudienceIntegrationTemplateQuery = { audienceIntegrationTemplate?: { id: string, name: string, integrationType: AudienceIntegrationType, cascadeToChildOrgs: boolean, includeSegments: boolean, automaticallyCreateActivations: boolean, createdAt: any, organization:
      | { id: string, name?: string | null }
      | { id: string, name?: string | null }
    , inheritedFromOrganization?:
      | { id: string, name?: string | null }
      | { id: string, name?: string | null }
     | null, configuration:
      | { emails: Array<string> }
      | { activationType: string, historicalDataSync: boolean, activationPeopleColumns?: Array<string> | null, activationStatus: ActivationConnectionStatus, parameters: Array<{ key: string, value?: string | null }> }
      | { buzzKey: string, email: string, segmentKey?: string | null, hemSalt?: string | null }
      | { name: string, description?: string | null, advertiserId?: string | null, partnerId?: string | null, audienceOwnerType?: DisplayVideo360AudienceOwnerType | null, historicalDataSync: boolean, daysToKeep: number, googleUserAccountId?: string | null, dv360Status: DisplayVideo360CustomerMatchConnectionStatus }
      | { name: string, description?: string | null, adAccountId: string, accessToken?: string | null, customAudienceId?: string | null, historicalDataSync: boolean, daysToKeep: number }
      | { name: string, description?: string | null, customerId: string, managerCustomerId?: string | null, userListId?: string | null, lastOperationId?: string | null, historicalDataSync: boolean, daysToKeep: number, googleUserAccountId?: string | null, googleAdsStatus: GoogleCustomerMatchConnectionStatus }
      | { privateIntegrationToken?: string | null, locationId: string, tags: Array<string> }
      | { segmentName?: string | null, cpm: number, description?: string | null }
      | { apiKey?: string | null, audienceId: string, tag?: string | null, daysToKeep: number, historicalDataSync: boolean }
      | { secretAccessKey?: string | null, region?: AwsRegion | null, ownership: S3AudienceIntegrationBucketOwnership, iamRoles?: Array<string> | null, destinationS3Bucket?: string | null, outputObjectKeyTemplates?: Array<string> | null, accessKeyId?: string | null, exportType: ExportType, fileFormat: FileFormat, peopleColumns: Array<string> }
      | { checkIfExistingCustomer: boolean, redshiftHost?: string | null, redshiftPort?: number | null, redshiftUser?: string | null, redshiftPassword?: string | null, redshiftDatabase?: string | null, emailAttributeName?: string | null, customEntries: any, endpoint: string, events: { existingCustomer?: string | null, nonExistingCustomer?: string | null, static?: string | null }, parameterNames: { phone: string, email: string, hashedPhone: string, hashedEmail: string } }
      | { connectionTimestamp?: any | null, historicalDataSync: boolean, status: ZapierConnectionStatus }
     } | null };

export type DeleteAudienceIntegrationTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAudienceIntegrationTemplateMutation = { deleteAudienceIntegrationTemplate: boolean };

export type UpdateAudienceIntegrationTemplateMutationVariables = Exact<{
  templateParams: AudienceIntegrationTemplateUpdateInput;
}>;


export type UpdateAudienceIntegrationTemplateMutation = { updateAudienceIntegrationTemplate: { id: string, name: string, integrationType: AudienceIntegrationType, cascadeToChildOrgs: boolean, includeSegments: boolean, automaticallyCreateActivations: boolean } };

export type TestAudienceIntegrationMutationVariables = Exact<{
  integrationParams: AudienceIntegrationTestInput;
}>;


export type TestAudienceIntegrationMutation = { testAudienceIntegration: { success: boolean, message?: string | null, hasWarnings?: boolean | null } };

export type AudienceIntegrationsQueryVariables = Exact<{
  audienceId: Scalars['ID']['input'];
  pageNumber: Scalars['Int']['input'];
  pageItemsCount: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}>;


export type AudienceIntegrationsQuery = { audience?: { integrationsPage: { totalCount: number, nodes: Array<{ id: string, name: string, integrationType: AudienceIntegrationType, lastSuccessfulRunAt?: any | null, lastRunSucceeded?: boolean | null, lastRunAt?: any | null, configuration:
          | { activationType: string }
          | Record<PropertyKey, never>
         }> } } | null };

export type InvitesAudienceQueryVariables = Exact<{
  audienceId: Scalars['ID']['input'];
}>;


export type InvitesAudienceQuery = { audience?: { id: string, pendingInvites?: Array<{ id: string, email: string, user?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null } | null }> | null } | null };

export type JourneyTopPathsQueryVariables = Exact<{
  audienceId: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
  filters?: InputMaybe<Array<PersonFilterInput> | PersonFilterInput>;
}>;


export type JourneyTopPathsQuery = { audience?: { journeyTopPaths: { count: number, paths: Array<{ count: number, pathPrefix: string }> } } | null };

export type AudienceJourneyTopUrlsQueryVariables = Exact<{
  audienceId: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
  filters?: InputMaybe<Array<PersonFilterInput> | PersonFilterInput>;
}>;


export type AudienceJourneyTopUrlsQuery = { audience?: { journeyTopUrls: Array<string> } | null };

export type AudienceLookalikeCountQueryVariables = Exact<{
  audienceLookalikeCountParams: AudienceLookalikeCountInput;
}>;


export type AudienceLookalikeCountQuery = { audienceLookalikeCount: number };

export type BasicFilterFieldsFragment = { stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { negate?: boolean | null, excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null, in?: { field: GeoField, values: Array<string> } | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null };

type FilterFields_Audience_Fragment = { filters?: Array<{ compoundFilter?: { operator: LogicalOperator, filters: Array<{ compoundFilter?: { operator: LogicalOperator, filters: Array<{ stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { negate?: boolean | null, excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null, in?: { field: GeoField, values: Array<string> } | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> } | null, stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { negate?: boolean | null, excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null, in?: { field: GeoField, values: Array<string> } | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> } | null, stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { negate?: boolean | null, excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null, in?: { field: GeoField, values: Array<string> } | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> | null };

type FilterFields_RestrictedAccessAudience_Fragment = { filters?: Array<{ compoundFilter?: { operator: LogicalOperator, filters: Array<{ compoundFilter?: { operator: LogicalOperator, filters: Array<{ stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { negate?: boolean | null, excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null, in?: { field: GeoField, values: Array<string> } | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> } | null, stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { negate?: boolean | null, excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null, in?: { field: GeoField, values: Array<string> } | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> } | null, stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { negate?: boolean | null, excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null, in?: { field: GeoField, values: Array<string> } | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> | null };

export type FilterFieldsFragment =
  | FilterFields_Audience_Fragment
  | FilterFields_RestrictedAccessAudience_Fragment
;

type Categories_Audience_Fragment = { categories?: Array<{ id: string, categoryName: string, categoryCode: number, relevance?: number | null }> | null, info?:
    | { categoriesProcessed: boolean }
    | Record<PropertyKey, never>
   | null };

type Categories_RestrictedAccessAudience_Fragment = { categories?: Array<{ id: string, categoryName: string, categoryCode: number, relevance?: number | null }> | null, info?:
    | { categoriesProcessed: boolean }
    | Record<PropertyKey, never>
   | null };

export type CategoriesFragment =
  | Categories_Audience_Fragment
  | Categories_RestrictedAccessAudience_Fragment
;

export type LookalikeInfoFieldsFragment = { requestedCount: number, matchedCount?: number | null, similarityPercentage: number, dateRange?: { from: any, to: any } | null };

type AdditionsFields_CustomerListAdditionsArrayInfo_Fragment = { matchedCount: number, date: any, requestedCount: number, totalCount: number };

type AdditionsFields_GlobalAdditionsArrayInfo_Fragment = { matchedCount: number, date: any, requestedCount: number, totalCount: number };

type AdditionsFields_PulseAdditionsArrayInfo_Fragment = { matchedCount: number, date: any, requestedCount: number, totalCount: number };

export type AdditionsFieldsFragment =
  | AdditionsFields_CustomerListAdditionsArrayInfo_Fragment
  | AdditionsFields_GlobalAdditionsArrayInfo_Fragment
  | AdditionsFields_PulseAdditionsArrayInfo_Fragment
;

export type GlobalInfoFieldsFragment = { lastSuccessfullyProcessedAt?: any | null, additions?: Array<{ matchedCount: number, date: any, requestedCount: number, totalCount: number }> | null };

export type PulseInfoFieldsFragment = { lastSuccessfullyProcessedAt?: any | null, subscriptionCount: number, subscriptionAmount: number, topicIds: Array<string>, lastProcessedDateRange?: { from: any, to: any } | null, items: Array<{ category: string, id: string, subCategory?: string | null, topic?: string | null }>, additions?: Array<{ matchedCount: number, date: any, requestedCount: number, totalCount: number }> | null };

export type CustomerListColumnMappingsFieldsFragment = { email?: number | null, emailField?: string | null, emailMd5?: number | null, emailMd5Field?: string | null, phone?: number | null, phoneField?: string | null, customFields?: Array<{ column: number, field: string, fieldType: CustomFieldType, originalField?: string | null }> | null };

export type CustomerListInfoFieldsFragment = { s3FileUri: string, additions?: Array<{ matchedCount: number, date: any, requestedCount: number, totalCount: number, mapping: { email?: number | null, emailField?: string | null, emailMd5?: number | null, emailMd5Field?: string | null, phone?: number | null, phoneField?: string | null, customFields?: Array<{ column: number, field: string, fieldType: CustomFieldType, originalField?: string | null }> | null } }> | null, processingAdditionInfo?: { mapping: { email?: number | null, emailField?: string | null, emailMd5?: number | null, emailMd5Field?: string | null, phone?: number | null, phoneField?: string | null, customFields?: Array<{ column: number, field: string, fieldType: CustomFieldType, originalField?: string | null }> | null } } | null };

export type AudienceOverviewQueryVariables = Exact<{
  audienceId: Scalars['ID']['input'];
}>;


export type AudienceOverviewQuery = { audience?: { id: string, name: string, deepLink?: string | null, condition: AudienceCondition, createdAt: any, peopleCount?: number | null, processingStatus?: AudienceProcessingStatus | null, verifyEmails?: boolean | null, audienceOnlyAccess: boolean, segmentsCount: number, lookalikesCount: number, quotaInfo?: { currentCount?: number | null, limit?: number | null, period?: AudienceQuotaPeriod | null } | null, baseAudience?:
      | { id: string, name: string, condition: AudienceCondition, parentAudience?:
          | { id: string, name: string, condition: AudienceCondition, createdAt: any }
          | { id: string, name?: string | null, condition?: AudienceCondition | null, createdAt?: any | null }
         | null }
      | { id: string, name?: string | null, condition?: AudienceCondition | null, parentAudience?:
          | { id: string, name: string, condition: AudienceCondition, createdAt: any }
          | { id: string, name?: string | null, condition?: AudienceCondition | null, createdAt?: any | null }
         | null }
     | null, userRoles?: Array<{ id: string, user: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null } }> | null, organization:
      | { __typename: 'Organization', imageUrl?: string | null, paidSubscription?: boolean | null, defaultS3OutputObjectKeyTemplate?: string | null, name?: string | null, id: string, hiddenPeopleFields: Array<string>, businessDataEnabled?: boolean | null, matchbackEnabled?: boolean | null, organizationType: OrganizationType, disableEmailValidationOwn?: boolean | null, disableEmailValidationFinal?: boolean | null, userRoles?: Array<{ id: string, user?: { id: string } | null } | null> | null, parentOrganization?:
          | { imageUrl?: string | null, id: string, name?: string | null, userRoles?: Array<{ id: string, user?: { id: string } | null } | null> | null, parentOrganization?:
              | { imageUrl?: string | null, id: string, name?: string | null, userRoles?: Array<{ id: string, user?: { id: string } | null } | null> | null }
              | { id: string, name?: string | null }
             | null }
          | { id: string, name?: string | null }
         | null }
      | { __typename: 'RestrictedAccessOrganization', name?: string | null, id: string, imageUrl?: string | null, hiddenPeopleFields?: Array<string> | null, businessDataEnabled?: boolean | null, matchbackEnabled?: boolean | null, organizationType?: OrganizationType | null }
    , pixelSettings?: { pixelId: string, hostAndPath: string, pixelDisabledAt?: any | null, pixelEnabled: boolean, pixelStatus: AudiencePixelStatus, pixelReachedQuotaAt?: any | null, quotaEnabled: boolean, pixelMatchingCadence: PixelMatchingCadence, quota: { limit?: number | null, period?: AudienceQuotaPeriod | null }, location?: { address?: string | null, city: string, state: string } | null, codeSnippets?: { head: string, body: string } | null, billing: { dayOfMonth: number } } | null, parentAudience?:
      | { peopleCount?: number | null, id: string, name: string, createdAt: any, condition: AudienceCondition, pixelSettings?: { pixelMatchingCadence: PixelMatchingCadence } | null, info?:
          | { s3FileUri: string, additions?: Array<{ matchedCount: number, date: any, requestedCount: number, totalCount: number, mapping: { email?: number | null, emailField?: string | null, emailMd5?: number | null, emailMd5Field?: string | null, phone?: number | null, phoneField?: string | null, customFields?: Array<{ column: number, field: string, fieldType: CustomFieldType, originalField?: string | null }> | null } }> | null, processingAdditionInfo?: { mapping: { email?: number | null, emailField?: string | null, emailMd5?: number | null, emailMd5Field?: string | null, phone?: number | null, phoneField?: string | null, customFields?: Array<{ column: number, field: string, fieldType: CustomFieldType, originalField?: string | null }> | null } } | null }
          | { lastSuccessfullyProcessedAt?: any | null, additions?: Array<{ matchedCount: number, date: any, requestedCount: number, totalCount: number }> | null }
          | { requestedCount: number, matchedCount?: number | null, similarityPercentage: number, dateRange?: { from: any, to: any } | null }
          | { categoriesProcessed: boolean }
          | { lastSuccessfullyProcessedAt?: any | null, subscriptionCount: number, subscriptionAmount: number, topicIds: Array<string>, lastProcessedDateRange?: { from: any, to: any } | null, items: Array<{ category: string, id: string, subCategory?: string | null, topic?: string | null }>, additions?: Array<{ matchedCount: number, date: any, requestedCount: number, totalCount: number }> | null }
          | Record<PropertyKey, never>
         | null, categories?: Array<{ id: string, categoryName: string, categoryCode: number, relevance?: number | null }> | null, filters?: Array<{ compoundFilter?: { operator: LogicalOperator, filters: Array<{ compoundFilter?: { operator: LogicalOperator, filters: Array<{ stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { negate?: boolean | null, excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null, in?: { field: GeoField, values: Array<string> } | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> } | null, stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { negate?: boolean | null, excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null, in?: { field: GeoField, values: Array<string> } | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> } | null, stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { negate?: boolean | null, excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null, in?: { field: GeoField, values: Array<string> } | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> | null }
      | { id: string, name?: string | null, createdAt?: any | null, condition?: AudienceCondition | null, info?:
          | { s3FileUri: string, additions?: Array<{ matchedCount: number, date: any, requestedCount: number, totalCount: number, mapping: { email?: number | null, emailField?: string | null, emailMd5?: number | null, emailMd5Field?: string | null, phone?: number | null, phoneField?: string | null, customFields?: Array<{ column: number, field: string, fieldType: CustomFieldType, originalField?: string | null }> | null } }> | null, processingAdditionInfo?: { mapping: { email?: number | null, emailField?: string | null, emailMd5?: number | null, emailMd5Field?: string | null, phone?: number | null, phoneField?: string | null, customFields?: Array<{ column: number, field: string, fieldType: CustomFieldType, originalField?: string | null }> | null } } | null }
          | { lastSuccessfullyProcessedAt?: any | null, additions?: Array<{ matchedCount: number, date: any, requestedCount: number, totalCount: number }> | null }
          | { requestedCount: number, matchedCount?: number | null, similarityPercentage: number, dateRange?: { from: any, to: any } | null }
          | { categoriesProcessed: boolean }
          | { lastSuccessfullyProcessedAt?: any | null, subscriptionCount: number, subscriptionAmount: number, topicIds: Array<string>, lastProcessedDateRange?: { from: any, to: any } | null, items: Array<{ category: string, id: string, subCategory?: string | null, topic?: string | null }>, additions?: Array<{ matchedCount: number, date: any, requestedCount: number, totalCount: number }> | null }
          | Record<PropertyKey, never>
         | null, categories?: Array<{ id: string, categoryName: string, categoryCode: number, relevance?: number | null }> | null, filters?: Array<{ compoundFilter?: { operator: LogicalOperator, filters: Array<{ compoundFilter?: { operator: LogicalOperator, filters: Array<{ stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { negate?: boolean | null, excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null, in?: { field: GeoField, values: Array<string> } | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> } | null, stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { negate?: boolean | null, excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null, in?: { field: GeoField, values: Array<string> } | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> } | null, stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { negate?: boolean | null, excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null, in?: { field: GeoField, values: Array<string> } | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> | null }
     | null, segments: Array<{ id: string, name: string, condition: AudienceCondition, peopleCount?: number | null, organizationId: string, creator:
        | { id: string, imageUrl?: string | null, firstName?: string | null, lastName?: string | null }
        | { id: string, imageUrl?: string | null, firstName?: string | null, lastName?: string | null }
      , organization:
        | { id: string, name?: string | null }
        | { id: string, name?: string | null }
       }>, info?:
      | { s3FileUri: string, additions?: Array<{ matchedCount: number, date: any, requestedCount: number, totalCount: number, mapping: { email?: number | null, emailField?: string | null, emailMd5?: number | null, emailMd5Field?: string | null, phone?: number | null, phoneField?: string | null, customFields?: Array<{ column: number, field: string, fieldType: CustomFieldType, originalField?: string | null }> | null } }> | null, processingAdditionInfo?: { mapping: { email?: number | null, emailField?: string | null, emailMd5?: number | null, emailMd5Field?: string | null, phone?: number | null, phoneField?: string | null, customFields?: Array<{ column: number, field: string, fieldType: CustomFieldType, originalField?: string | null }> | null } } | null }
      | { lastSuccessfullyProcessedAt?: any | null, additions?: Array<{ matchedCount: number, date: any, requestedCount: number, totalCount: number }> | null }
      | { requestedCount: number, matchedCount?: number | null, similarityPercentage: number, dateRange?: { from: any, to: any } | null }
      | { categoriesProcessed: boolean }
      | { lastSuccessfullyProcessedAt?: any | null, subscriptionCount: number, subscriptionAmount: number, topicIds: Array<string>, lastProcessedDateRange?: { from: any, to: any } | null, items: Array<{ category: string, id: string, subCategory?: string | null, topic?: string | null }>, additions?: Array<{ matchedCount: number, date: any, requestedCount: number, totalCount: number }> | null }
      | Record<PropertyKey, never>
     | null, customFields: Array<{ name: string, fieldType: CustomFieldType }>, processingResultInfo?: { invalidEntries: Array<{ value: string, fieldType: CustomFieldType, columnName: string, rowNumber: number }> } | null, filters?: Array<{ compoundFilter?: { operator: LogicalOperator, filters: Array<{ compoundFilter?: { operator: LogicalOperator, filters: Array<{ stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { negate?: boolean | null, excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null, in?: { field: GeoField, values: Array<string> } | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> } | null, stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { negate?: boolean | null, excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null, in?: { field: GeoField, values: Array<string> } | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> } | null, stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { negate?: boolean | null, excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null, in?: { field: GeoField, values: Array<string> } | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> | null, categories?: Array<{ id: string, categoryName: string, categoryCode: number, relevance?: number | null }> | null } | null };

export type AudiencePeoplePageQueryVariables = Exact<{
  pageNumber: Scalars['Int']['input'];
  audienceId: Scalars['ID']['input'];
  pageItemsCount: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<InputMaybe<PersonFilterInput>> | InputMaybe<PersonFilterInput>>;
  sort?: InputMaybe<Array<InputMaybe<SortFieldInput>> | InputMaybe<SortFieldInput>>;
  matchbackComparisons?: InputMaybe<MatchbackComparisonsFilterInput>;
  customBooleanFieldsFields: Array<Scalars['String']['input']> | Scalars['String']['input'];
  customDateFieldsFields: Array<Scalars['String']['input']> | Scalars['String']['input'];
  customIntegerFieldsFields: Array<Scalars['String']['input']> | Scalars['String']['input'];
  customStringFieldsFields: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AudiencePeoplePageQuery = { audience?: { peoplePage?: { totalCount: number, nodes: Array<{ address?: string | null, adultsInHousehold?: number | null, age?: number | null, behaviors?: Array<string | null> | null, bebacks?: number | null, childrenAgeRanges?: Array<string | null> | null, childrenBetweenAges0_3?: number | null, childrenBetweenAges10_12?: number | null, childrenBetweenAges13_18?: number | null, childrenBetweenAges4_6?: number | null, childrenBetweenAges7_9?: number | null, childrenInHousehold?: number | null, city?: string | null, creditRange?: string | null, dwellingType?: string | null, education?: string | null, email?: string | null, emailVerificationDate?: any | null, ethnicGroup?: string | null, firstName?: string | null, dnc?: boolean | null, dma?: number | null, optIn?: boolean | null, optInDate?: any | null, optInIp?: string | null, optInUrl?: string | null, gender?: string | null, generation?: string | null, homeHeatType?: string | null, homeOwner?: string | null, homePrice?: number | null, homePurchasedYearsAgo?: number | null, homeValue?: number | null, householdIncome?: string | null, householdNetWorth?: string | null, id: string, incomeLevels?: string | null, interests?: Array<string | null> | null, isMultilingual?: boolean | null, isPoliticalContributor?: boolean | null, isPrimaryResidence?: boolean | null, language?: string | null, lastName?: string | null, maid?: string | null, maidOs?: MaidOs | null, maritalStatus?: string | null, mortgageAge?: number | null, mortgageAmount?: number | null, mortgageLoanType?: string | null, mortgageRefinanceAge?: number | null, mortgageRefinanceAmount?: number | null, mortgageRefinanceType?: string | null, netWorth?: string | null, newCreditOfferedHousehold?: string | null, numberOfVehiclesInHousehold?: number | null, occupationDetail?: string | null, ownsAmexCard?: boolean | null, ownsBankCard?: boolean | null, ownsCreditCard?: boolean | null, ownsInvestment?: boolean | null, ownsPremiumAmexCard?: boolean | null, ownsPremiumCard?: boolean | null, ownsStocksAndBonds?: boolean | null, peopleInHousehold?: number | null, personality?: string | null, phone?: string | null, politicalParty?: string | null, premiumIncomeHousehold?: string | null, pixelLastHitDate?: any | null, pixelFirstHitDate?: any | null, religion?: string | null, state?: string | null, urbanicity?: string | null, veteransInHousehold?: number | null, zip?: string | null, companyName?: string | null, companyRevenue?: string | null, department?: string | null, jobTitle?: string | null, primaryIndustry?: string | null, seniorityLevel?: string | null, companyCity?: string | null, companyDomain?: string | null, companyEmployeeCount?: string | null, companySic?: Array<string | null> | null, companyState?: string | null, businessEmail?: string | null, zip4?: string | null, dpbc?: number | null, dpv?: number | null, carrierRoute?: string | null, fipsStateCode?: number | null, fipsCountyCode?: number | null, countyName?: string | null, customBooleanFields?: Array<boolean | null> | null, customDateFields?: Array<any | null> | null, customIntegerFields?: Array<number | null> | null, customStringFields?: Array<string | null> | null, beeswaxIds?: Array<string> | null, ipAddresses?: Array<string> | null, hemsMd5?: Array<string> | null, hemsSha1?: Array<string> | null, hemsSha256?: Array<string> | null, hemsMd5Uppercase?: Array<string> | null, hemsSha1Uppercase?: Array<string> | null, hemsSha256Uppercase?: Array<string> | null, matchbackComparisonsCount?: number | null, pixelLastIpLocation?: { countryName?: string | null, countryCode?: string | null, regionName?: string | null, postalCode?: string | null, city?: string | null } | null, social?: { facebook?: string | null, linkedIn?: string | null, twitter?: string | null } | null, maids?: Array<{ maid: string, os: MaidOs }> | null, matchbackComparisons?: Array<{ id: string, dateRanges?: Array<{ from: any, to: any }> | null, audience:
            | { __typename: 'Audience', id: string, name: string, condition: AudienceCondition, deletedAt?: any | null }
            | { __typename: 'RestrictedAccessAudience', id: string, name?: string | null, condition?: AudienceCondition | null, deletedAt?: any | null }
           }> | null }> } | null } | null };

export type AudiencePeopleCountsQueryVariables = Exact<{
  field: FilterStringField;
  audienceId: Scalars['ID']['input'];
  filters?: InputMaybe<Array<InputMaybe<PersonFilterInput>> | InputMaybe<PersonFilterInput>>;
  takeIntoAccountSameFieldFilters?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AudiencePeopleCountsQuery = { audience?: { peopleCounts?: Array<{ count: number, key: string } | null> | null } | null };

export type AudiencePeopleNumberHistogramQueryVariables = Exact<{
  field: FilterNumberField;
  audienceId: Scalars['ID']['input'];
  interval?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
  max?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<InputMaybe<PersonFilterInput>> | InputMaybe<PersonFilterInput>>;
  takeIntoAccountSameFieldFilters?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AudiencePeopleNumberHistogramQuery = { audience?: { peopleNumberHistogram?: Array<{ count: number, key: string } | null> | null } | null };

export type AudienceS3PathQueryVariables = Exact<{
  audienceId: Scalars['ID']['input'];
}>;


export type AudienceS3PathQuery = { audience?: { s3IntegrationTestPath: string } | null };

export type AudiencesPageQueryVariables = Exact<{
  pageNumber: Scalars['Int']['input'];
  pageItemsCount: Scalars['Int']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Array<AudienceCondition> | AudienceCondition>;
  pixelStatus?: InputMaybe<AudiencePixelStatus>;
  filters?: InputMaybe<Array<AudienceFilterInput> | AudienceFilterInput>;
}>;


export type AudiencesPageQuery = { audiencesPage: { totalCount: number, nodes: Array<{ id: string, name: string, condition: AudienceCondition, createdAt: any, peopleCount?: number | null, organizationId: string, processingStatus?: AudienceProcessingStatus | null, creator:
        | { id: string, firstName?: string | null, lastName?: string | null, imageUrl?: string | null }
        | { id: string, firstName?: string | null, lastName?: string | null, imageUrl?: string | null }
      , organization:
        | { id: string, name?: string | null }
        | { id: string, name?: string | null }
      , pixelSettings?: { pixelEnabled: boolean, pixelStatus: AudiencePixelStatus, quotaEnabled: boolean } | null, parentAudience?:
        | { id: string, createdAt: any, condition: AudienceCondition }
        | { id: string, createdAt?: any | null, condition?: AudienceCondition | null }
       | null, quotaInfo?: { currentCount?: number | null, limit?: number | null } | null }>, pageInfo: { hasNextPage: boolean } } };

export type AvailableGlobalPeopleCountQueryVariables = Exact<{
  filters: Array<InputMaybe<PersonFilterInput>> | InputMaybe<PersonFilterInput>;
  addingToGlobalAudienceId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AvailableGlobalPeopleCountQuery = { peopleSnapshot?: { totalCount: number } | null };

export type BeeswaxCreateSegmentMutationVariables = Exact<{
  input: BeeswaxCreateSegmentInput;
}>;


export type BeeswaxCreateSegmentMutation = { beeswaxCreateSegment: { id: string, name?: string | null } };

export type BeeswaxGetSegmentQueryVariables = Exact<{
  input: BeeswaxGetSegmentInput;
}>;


export type BeeswaxGetSegmentQuery = { beeswaxGetSegment?: { id: string, name?: string | null } | null };

export type BeeswaxListSegmentsQueryVariables = Exact<{
  input: BeeswaxListSegmentsInput;
}>;


export type BeeswaxListSegmentsQuery = { beeswaxListSegments: { hasNextPage: boolean, nextCursor?: string | null, items: Array<{ id: string, name?: string | null }> } };

export type AdminConfirmPendingAudiencePulseMutationVariables = Exact<{
  confirmPendingAudiencePulseParams: ConfirmPendingAudiencePulseInput;
}>;


export type AdminConfirmPendingAudiencePulseMutation = { adminConfirmPendingAudiencePulse?: { id: string } | null };

export type ConversationMessagesQueryVariables = Exact<{
  conversationId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConversationMessagesQuery = { conversationMessages: { agentSessionId: string, title: string, nodes: Array<{ id: string, body?: string | null, block?: any | null, a2ui?: any | null, a2uiSubmission?: any | null, mutationConfirmation?: any | null, role: ConversationRole, citations?: Array<{ title: string, url?: string | null, text?: string | null, start?: number | null, end?: number | null }> | null, sources?: Array<{ title: string, url: string }> | null, pdfReports?: Array<{ relativePath: string }> | null }>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type CreateAudienceGlobalMutationVariables = Exact<{
  audienceGlobalParams: AudienceGlobalInput;
}>;


export type CreateAudienceGlobalMutation = { createAudienceGlobal?: { id: string, name: string } | null };

export type CreateAudiencePixelMutationVariables = Exact<{
  audiencePixelParams: AudiencePixelInput;
}>;


export type CreateAudiencePixelMutation = { createAudiencePixel?: { id: string, name: string } | null };

export type CreateAudiencePulseMutationVariables = Exact<{
  audiencePulseParams: AudiencePulseInput;
}>;


export type CreateAudiencePulseMutation = { createAudiencePulse?: { name: string, id: string } | null };

export type CreateAudienceSegmentMutationVariables = Exact<{
  audienceSegmentParams: AudienceSegmentInput;
}>;


export type CreateAudienceSegmentMutation = { createAudienceSegment?: { id: string, name: string } | null };

export type CreateConversationMutationVariables = Exact<{
  title: Scalars['String']['input'];
}>;


export type CreateConversationMutation = { createConversation: { id: string, title: string } };

export type CreateAudienceIntegrationMutationVariables = Exact<{
  integrationParams: AudienceIntegrationInput;
}>;


export type CreateAudienceIntegrationMutation = { createAudienceIntegration?: { id: string, configuration:
      | { emails: Array<string> }
      | { activationType: string, historicalDataSync: boolean, activationStatus: ActivationConnectionStatus, parameters: Array<{ key: string, value?: string | null }> }
      | { buzzKey: string, email: string, segmentKey?: string | null, hemSalt?: string | null }
      | { name: string, description?: string | null, advertiserId?: string | null, partnerId?: string | null, audienceOwnerType?: DisplayVideo360AudienceOwnerType | null, historicalDataSync: boolean, daysToKeep: number, googleUserAccountId?: string | null, dv360Status: DisplayVideo360CustomerMatchConnectionStatus }
      | { name: string, description?: string | null, adAccountId: string, accessToken?: string | null, customAudienceId?: string | null, historicalDataSync: boolean, daysToKeep: number }
      | { name: string, description?: string | null, customerId: string, managerCustomerId?: string | null, userListId?: string | null, lastOperationId?: string | null, historicalDataSync: boolean, daysToKeep: number, status: GoogleCustomerMatchConnectionStatus, googleUserAccountId?: string | null }
      | { privateIntegrationToken?: string | null, locationId: string, tags: Array<string> }
      | { segmentName?: string | null, cpm: number, description?: string | null }
      | { apiKey?: string | null, audienceId: string, tag?: string | null, daysToKeep: number, historicalDataSync: boolean }
      | { destinationS3Bucket?: string | null, outputObjectKeyTemplates?: Array<string> | null, iamRoles?: Array<string> | null, ownership: S3AudienceIntegrationBucketOwnership }
      | { checkIfExistingCustomer: boolean, redshiftHost?: string | null, redshiftPort?: number | null, redshiftUser?: string | null, redshiftPassword?: string | null, redshiftDatabase?: string | null, emailAttributeName?: string | null, customEntries: any, endpoint: string, events: { existingCustomer?: string | null, nonExistingCustomer?: string | null, static?: string | null }, parameterNames: { phone: string, email: string, hashedPhone: string, hashedEmail: string } }
      | Record<PropertyKey, never>
     } | null };

export type CreateAudienceLookalikeMutationVariables = Exact<{
  audienceLookalikeParams: AudienceLookalikeInput;
}>;


export type CreateAudienceLookalikeMutation = { createAudienceLookalike?: { id: string, name: string } | null };

export type CreateOrganizationMutationVariables = Exact<{
  input?: InputMaybe<CreateOrganizationInput>;
}>;


export type CreateOrganizationMutation = { createOrganization?: { id: string } | null };

export type CreateSubscriptionMutationVariables = Exact<{
  subscriptionParams: SubscriptionInput;
}>;


export type CreateSubscriptionMutation = { createSubscription?: boolean | null };

export type AudiencesCountQueryVariables = Exact<{
  dateRange?: InputMaybe<DateOperatorsInput>;
  dateRangePast?: InputMaybe<DateOperatorsInput>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AudiencesCountQuery = { actualAudiencesCount?: { customerList: number, global: number, pixel: number, lookalike: number, pulse: number } | null, pastAudiencesCount?: { customerList: number, global: number, lookalike: number, pixel: number, pulse: number } | null };

export type EntitiesCountQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type EntitiesCountQuery = { entitiesCount?: { audiences: number, organizations: number, users: number } | null };

export type DeleteAudienceIntegrationMutationVariables = Exact<{
  deleteAudienceIntegrationId: Scalars['ID']['input'];
}>;


export type DeleteAudienceIntegrationMutation = { deleteAudienceIntegration?: boolean | null };

export type DeleteAudienceMutationVariables = Exact<{
  audienceId: Scalars['ID']['input'];
}>;


export type DeleteAudienceMutation = { deleteAudience?: boolean | null };

export type DiscardFailedAudienceCustomerListLoadMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DiscardFailedAudienceCustomerListLoadMutation = { discardFailedAudienceCustomerListLoad?: { id: string, processingStatus?: AudienceProcessingStatus | null } | null };

export type GenerateReportDownloadUrlMutationVariables = Exact<{
  relativePath: Scalars['String']['input'];
}>;


export type GenerateReportDownloadUrlMutation = { generateReportDownloadUrl: string };

export type GetConversationsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetConversationsQuery = { conversations: { totalCount: number, nodes: Array<{ id: string, title: string, lastUserMessageAt?: any | null }>, pageInfo: { endCursor?: string | null, hasNextPage: boolean } } };

export type PeopleSnapshotQueryVariables = Exact<{
  filters: Array<InputMaybe<PersonFilterInput>> | InputMaybe<PersonFilterInput>;
  parentAudienceId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PeopleSnapshotQuery = { peopleSnapshot?: { totalCount: number, geoResults?: Array<{ count: number, postalCodes: Array<string | null> } | null> | null, people: Array<{ id: string, firstName?: string | null, city?: string | null } | null>, postalCodeCounts?: Array<{ count: number, postalCode: string } | null> | null } | null };

export type GoogleAuthorizeMutationVariables = Exact<{
  input: GoogleAuthorizeInput;
}>;


export type GoogleAuthorizeMutation = { googleAuthorize: { accessToken: string, accountId: string, scopes: Array<string>, expiryDate: any } };

export type GoogleGenerateAccessTokenMutationVariables = Exact<{
  input: GoogleAccessTokenInput;
}>;


export type GoogleGenerateAccessTokenMutation = { googleGenerateAccessToken: { accessToken: string, expiryDate: any } };

export type GoogleTokenMutationVariables = Exact<{
  input: GoogleTokenInput;
}>;


export type GoogleTokenMutation = { googleToken?: { accessToken?: string | null, refreshToken?: string | null, tokenType?: string | null } | null };

export type IntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type IntegrationsQuery = { integrations: Array<{ description: string, imageUrl: string, integrationType: AudienceIntegrationType }> };

export type SendInviteMutationVariables = Exact<{
  inviteParams?: InputMaybe<InviteInput>;
}>;


export type SendInviteMutation = { createInvite?: { id: string, email: string } | null };

export type DeclineInviteMutationVariables = Exact<{
  declineInviteId: Scalars['ID']['input'];
}>;


export type DeclineInviteMutation = { declineInvite?: { status: string, organizationId?: string | null } | null };

export type AcceptInviteMutationVariables = Exact<{
  acceptInviteId: Scalars['ID']['input'];
}>;


export type AcceptInviteMutation = { acceptInvite?: { organizationId?: string | null, status: string } | null };

export type InvoicesQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type InvoicesQuery = { invoices?: Array<{ totalAmount?: string | null, currency?: string | null, paidDate?: any | null, taxAmount?: string | null, productName?: string | null, productInterval?: number | null, productIntervalUnit?: ProductIntervalUnit | null, publicUrl?: string | null, payments?: Array<{ paymentMethod?: { maskedCardNumber?: string | null, cardBrand?: string | null } | null } | null> | null }> | null };

export type LookalikesPageQueryVariables = Exact<{
  pageNumber: Scalars['Int']['input'];
  pageItemsCount: Scalars['Int']['input'];
  audienceId: Scalars['ID']['input'];
}>;


export type LookalikesPageQuery = { audience?: { lookalikesPage: { totalCount: number, nodes: Array<{ id: string, name: string, condition: AudienceCondition, peopleCount?: number | null, organizationId: string, creator:
          | { id: string, imageUrl?: string | null, firstName?: string | null, lastName?: string | null }
          | { id: string, imageUrl?: string | null, firstName?: string | null, lastName?: string | null }
        , organization:
          | { id: string, name?: string | null }
          | { id: string, name?: string | null }
        , parentAudience?:
          | { id: string, condition: AudienceCondition }
          | { id: string, condition?: AudienceCondition | null }
         | null }> } } | null };

export type MailchimpListAudiencesQueryVariables = Exact<{
  input: MailchimpListAudiencesInput;
}>;


export type MailchimpListAudiencesQuery = { mailchimpListAudiences: Array<{ id: string, name?: string | null }> };

export type CreateAudienceMatchbackMutationVariables = Exact<{
  params: AudienceMatchbackInput;
}>;


export type CreateAudienceMatchbackMutation = { createAudienceMatchback?: { id: string, name: string, processingStatus?: AudienceProcessingStatus | null, createdAt: any } | null };

export type MatchbackAudienceAdditionsQueryVariables = Exact<{
  audienceId: Scalars['ID']['input'];
}>;


export type MatchbackAudienceAdditionsQuery = { audience?: { id: string, condition: AudienceCondition, peopleCount?: number | null, info?:
      | { additions?: Array<{ matchedCount: number, date: any, requestedCount: number, totalCount: number }> | null }
      | { additions?: Array<{ matchedCount: number, date: any, requestedCount: number, totalCount: number }> | null }
      | { additions?: Array<{ matchedCount: number, date: any, requestedCount: number, totalCount: number }> | null }
      | Record<PropertyKey, never>
     | null } | null };

export type MatchbackStatusQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MatchbackStatusQuery = { audience?: { id: string, processingStatus?: AudienceProcessingStatus | null } | null };

export type MatchbackOverviewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MatchbackOverviewQuery = { audience?: { id: string, name: string, createdAt: any, peopleCount?: number | null, processingStatus?: AudienceProcessingStatus | null, deepLink?: string | null, baseAudience?:
      | { id: string, name: string }
      | { id: string, name?: string | null }
     | null, organization:
      | { id: string, name?: string | null }
      | { id: string, name?: string | null }
    , info?:
      | { comparisons?: Array<{ id: string, audience:
            | { __typename: 'Audience', peopleCount?: number | null, id: string, name: string, condition: AudienceCondition, deletedAt?: any | null }
            | { __typename: 'RestrictedAccessAudience', id: string, name?: string | null, condition?: AudienceCondition | null, deletedAt?: any | null }
          , dateRanges?: Array<{ from: any, to: any }> | null }> | null }
      | Record<PropertyKey, never>
     | null, matchbackAttribution?: { combinations: Array<{ count: number, comparisons: Array<{ id: string, audience:
            | { __typename: 'Audience', id: string, name: string }
            | { __typename: 'RestrictedAccessAudience', id: string, name?: string | null }
           }> }>, other?: { combinationCount: number, count: number } | null } | null } | null };

export type MatchbacksPageQueryVariables = Exact<{
  audienceId: Scalars['ID']['input'];
  pageNumber: Scalars['Int']['input'];
  pageItemsCount: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}>;


export type MatchbacksPageQuery = { audience?: { id: string, matchbacksAsBasePage: { totalCount: number, nodes: Array<{ id: string, name: string, createdAt: any, peopleCount?: number | null, processingStatus?: AudienceProcessingStatus | null, info?:
          | { comparisons?: Array<{ audience:
                | { __typename: 'Audience', peopleCount?: number | null, id: string, name: string, deletedAt?: any | null }
                | { __typename: 'RestrictedAccessAudience', id: string, name?: string | null, deletedAt?: any | null }
               }> | null }
          | Record<PropertyKey, never>
         | null }> } } | null };

export type DisableEmailValidationFieldsFragment = { disableEmailValidationOwn?: boolean | null, disableEmailValidationFinal?: boolean | null };

export type OrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationQuery = { organization?: { addressLine1?: string | null, state?: string | null, id: string, name?: string | null, deepLink?: string | null, country?: string | null, city?: string | null, phone?: string | null, paidSubscription?: boolean | null, subscriptionOverride?: boolean | null, pixelDomain?: string | null, businessDataEnabled?: boolean | null, customerListEnabled?: boolean | null, globalSearchEnabled?: boolean | null, globalSearchLimit?: number | null, lookalikeEnabled?: boolean | null, lookalikeSearchLimit?: number | null, pulseEnabled?: boolean | null, matchbackEnabled?: boolean | null, zip?: string | null, hiddenPeopleFields: Array<string>, pixelMatchingCadence?: PixelMatchingCadence | null, defaultS3OutputObjectKeyTemplate?: string | null, imageUrl?: string | null, audiencesCount?: number | null, organizationType: OrganizationType, disableEmailValidationOwn?: boolean | null, disableEmailValidationFinal?: boolean | null, userRoles?: Array<{ id: string, user?: { id: string } | null } | null> | null, parentOrganization?:
      | { organizationType: OrganizationType, id: string, name?: string | null, disableEmailValidationFinal?: boolean | null, userRoles?: Array<{ id: string, user?: { id: string } | null } | null> | null, parentOrganization?:
          | { organizationType: OrganizationType, id: string, userRoles?: Array<{ id: string, user?: { id: string } | null } | null> | null }
          | { id: string }
         | null }
      | { id: string, name?: string | null }
     | null } | null };

export type ValidateOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type ValidateOrganizationQuery = { organization?: { id: string } | null };

export type EditOrganizationMutationVariables = Exact<{
  input?: InputMaybe<UpdateOrganizationInput>;
}>;


export type EditOrganizationMutation = { updateOrganization?: { id: string } | null };

export type AdminUpdateOrganizationMutationVariables = Exact<{
  input?: InputMaybe<AdminUpdateOrganizationInput>;
}>;


export type AdminUpdateOrganizationMutation = { adminUpdateOrganization?: { id: string } | null };

export type InvitesOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type InvitesOrganizationQuery = { organization?: { id: string, pendingInvites?: Array<{ id: string, email: string, user?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null } | null, assignedRole: { id: string, name: string, organization?: { id: string, name?: string | null } | null } } | null> | null } | null };

export type DeleteSentInviteMutationVariables = Exact<{
  deleteInviteId: Scalars['ID']['input'];
}>;


export type DeleteSentInviteMutation = { deleteInvite?: { status: string } | null };

export type UserFieldsFragment = { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null };

export type UserRoleFieldsFragment = { id: string, name: string, organization?: { id: string, name?: string | null } | null };

export type MembersOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type MembersOrganizationQuery = { organization?: { id: string, userRoles?: Array<{ id: string, user?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null } | null, assignedRole: { id: string, name: string, organization?: { id: string, name?: string | null } | null } } | null> | null } | null };

export type RemoveMemberMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type RemoveMemberMutation = { removeMember?: boolean | null };

export type UpdateUserRoleMutationVariables = Exact<{
  input: UpdateUserRoleInput;
}>;


export type UpdateUserRoleMutation = { updateUserRole: { id: string, assignedRole: { id: string, name: string, organization?: { id: string, name?: string | null } | null } } };

export type OrganizationNameImageQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationNameImageQuery = { organization?: { name?: string | null, imageUrl?: string | null } | null };

export type OrganizationsPageQueryVariables = Exact<{
  pageNumber: Scalars['Int']['input'];
  pageItemsCount: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  organizationType?: InputMaybe<OrganizationType>;
  ancestorOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  includeAncestor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OrganizationsPageQuery = { organizationsPage: { totalCount: number, nodes: Array<{ addressLine1?: string | null, audiencesCount?: number | null, addressLine2?: string | null, city?: string | null, country?: string | null, createdAt?: any | null, subscriptionOverride?: boolean | null, id: string, imageUrl?: string | null, legalName?: string | null, name?: string | null, pixelMatchingCadence?: PixelMatchingCadence | null, paidSubscription?: boolean | null, businessDataEnabled?: boolean | null, pulseEnabled?: boolean | null, globalSearchEnabled?: boolean | null, customerListEnabled?: boolean | null, phone?: string | null, state?: string | null, updatedAt?: any | null, hiddenPeopleFields: Array<string>, lookalikeEnabled?: boolean | null, matchbackEnabled?: boolean | null, zip?: string | null, organizationType: OrganizationType, disableEmailValidationOwn?: boolean | null, disableEmailValidationFinal?: boolean | null, userRoles?: Array<{ id: string, user?: { id: string } | null } | null> | null }>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type ListOrganizationRolesQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type ListOrganizationRolesQuery = { listOrganizationRoles: Array<{ id: string, name: string, organization?: { id: string, name?: string | null } | null }> };

export type PeopleCountsQueryVariables = Exact<{
  field: FilterStringField;
  filters?: InputMaybe<Array<InputMaybe<PersonFilterInput>> | InputMaybe<PersonFilterInput>>;
  takeIntoAccountSameFieldFilters?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PeopleCountsQuery = { peopleCounts?: Array<{ key: string, count: number } | null> | null };

export type PeopleFieldsCountsQueryVariables = Exact<{
  field?: InputMaybe<FilterStringField>;
  customField?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  filters?: InputMaybe<Array<InputMaybe<PersonFilterInput>> | InputMaybe<PersonFilterInput>>;
  takeIntoAccountSameFieldFilters?: InputMaybe<Scalars['Boolean']['input']>;
  parentAudienceId?: InputMaybe<Scalars['ID']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type PeopleFieldsCountsQuery = { peopleFieldCounts: { totalCount?: number | null, nodes: Array<{ count: number, key: string }>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type PeopleFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type PeopleFieldsQuery = { peopleFields?: Array<{ category: FieldCategory, filterField: FilterField, title: string, type: FieldType, configuration?: { fieldAudienceTypes?: Array<AudienceCondition> | null, numberFilterConfiguration?: { from?: number | null, to?: number | null } | null, stringFilterConfiguration?: { condition?: LogicalOperator | null, onlyExistence?: boolean | null, isExtendedStringFilter?: boolean | null } | null } | null } | null> | null };

export type JourneyQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  personId: Scalars['ID']['input'];
  audienceId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<JourneyFilterInput> | JourneyFilterInput>;
}>;


export type JourneyQuery = { audience?: { personJourney?: { nodes: Array<{ date: any, id: string, url: string, ip: string, utmCampaign?: string | null, tealiumVisitorId?: string | null, gaSessionId?: string | null, utmMedium?: string | null, utmSource?: string | null, os?: { name?: string | null, version?: string | null } | null, ipLocation?: { countryName?: string | null, countryCode?: string | null, regionName?: string | null, postalCode?: string | null, city?: string | null } | null, browser?: { name?: string | null, version?: string | null } | null }>, pageInfo: { endCursor?: string | null, hasNextPage: boolean } } | null } | null };

export type PersonJourneyGroupsQueryVariables = Exact<{
  audienceId: Scalars['ID']['input'];
  personId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  groupBy: JourneyGroupByInput;
}>;


export type PersonJourneyGroupsQuery = { person?: { journeyGroups?: { totalCount?: number | null, nodes: Array<{ count: number, key: string }>, pageInfo: { hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null };

export type PeopleNumberHistogramQueryVariables = Exact<{
  field: FilterNumberField;
  interval?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
  max?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<InputMaybe<PersonFilterInput>> | InputMaybe<PersonFilterInput>>;
  takeIntoAccountSameFieldFilters?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PeopleNumberHistogramQuery = { peopleNumberHistogram?: Array<{ count: number, key: string } | null> | null };

export type PersonQueryVariables = Exact<{
  audienceId: Scalars['ID']['input'];
  personId: Scalars['ID']['input'];
}>;


export type PersonQuery = { person?: { id: string, email?: string | null, gender?: string | null, firstName?: string | null, lastName?: string | null, address?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null };

export type PeopleDateHistogramQueryVariables = Exact<{
  field: FilterDateField;
  audienceId: Scalars['ID']['input'];
  min?: InputMaybe<Scalars['Date']['input']>;
  max?: InputMaybe<Scalars['Date']['input']>;
  interval: DateIntervalInput;
}>;


export type PeopleDateHistogramQuery = { audience?: { peopleDateHistogram?: Array<{ key: string, count: number } | null> | null } | null };

export type PixelMatchCountsQueryVariables = Exact<{
  dateRange?: InputMaybe<DateOperatorsInput>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PixelMatchCountsQuery = { pixelMatchCounts?: { matchCount: number, lowestTraffic?: { count: number, audience:
        | { id: string }
        | { id: string }
       } | null, highestTraffic?: { count: number, audience:
        | { id: string }
        | { id: string }
       } | null } | null };

export type PixelStatusCountQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PixelStatusCountQuery = { pixelStatusCount?: { nearQuotaReached: number, quotaReached: number, withoutRecentMatches: number } | null };

export type PixelMatchDateHistogramQueryVariables = Exact<{
  min: Scalars['Date']['input'];
  max: Scalars['Date']['input'];
  interval: DateIntervalInput;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PixelMatchDateHistogramQuery = { pixelMatchDateHistogram?: Array<{ count: number, key: string }> | null };

export type AudiencePixelSettingsQueryVariables = Exact<{
  audienceId: Scalars['ID']['input'];
}>;


export type AudiencePixelSettingsQuery = { audience?: { id: string, name: string, createdAt: any, pixelSettings?: { hostAndPath: string, pixelEnabled: boolean, pixelStatus: AudiencePixelStatus, location?: { address?: string | null, city: string, state: string } | null, codeSnippets?: { head: string, body: string } | null, quota: { enabled?: boolean | null, limit?: number | null }, billing: { dayOfMonth: number } } | null } | null };

export type ProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductsQuery = { products?: Array<{ id: string, name?: string | null, description?: string | null, priceInCents?: number | null, intervalUnit?: ProductIntervalUnit | null, interval?: number | null, expirationInterval?: number | null, handle?: string | null, budgetPerPeriod?: number | null, productFamily?: { name?: string | null } | null, publicSignupPages?: Array<{ enabled?: boolean | null, url?: string | null }> | null, components?: Array<{ id: string, unitName?: string | null, unitPrice?: string | null } | null> | null }> | null };

export type PromptPersonFilterQueryVariables = Exact<{
  promptPersonFilterParams: PromptPersonFilterInput;
}>;


export type PromptPersonFilterQuery = { promptPersonFilter?: { sessionId?: string | null, filters: Array<{ compoundFilter?: { operator: LogicalOperator, filters: Array<{ compoundFilter?: { operator: LogicalOperator, filters: Array<{ stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { negate?: boolean | null, excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null, in?: { field: GeoField, values: Array<string> } | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> } | null, stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { negate?: boolean | null, excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null, in?: { field: GeoField, values: Array<string> } | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> } | null, stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { negate?: boolean | null, excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null, in?: { field: GeoField, values: Array<string> } | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> } | null };

export type PulseNodesQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  parentPaths?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}>;


export type PulseNodesQuery = { pulseNodes: { totalCount: number, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, nodes: Array<{ id: string, name: string, signalCount: number, paths: Array<string> }> } };

export type PulseNodesSignalCountQueryVariables = Exact<{ [key: string]: never; }>;


export type PulseNodesSignalCountQuery = { pulseNodesSignalCount: number };

export type RemoveAudienceMemberMutationVariables = Exact<{
  audienceId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type RemoveAudienceMemberMutation = { removeAudienceMember?: boolean | null };

export type ResendInviteMutationVariables = Exact<{
  resendInviteId: Scalars['ID']['input'];
}>;


export type ResendInviteMutation = { resendInvite?: { id: string } | null };

export type SegmentsPageQueryVariables = Exact<{
  pageNumber: Scalars['Int']['input'];
  pageItemsCount: Scalars['Int']['input'];
  audienceId: Scalars['ID']['input'];
}>;


export type SegmentsPageQuery = { audience?: { segmentsPage: { totalCount: number, nodes: Array<{ id: string, name: string, condition: AudienceCondition, peopleCount?: number | null, organizationId: string, creator:
          | { id: string, imageUrl?: string | null, firstName?: string | null, lastName?: string | null }
          | { id: string, imageUrl?: string | null, firstName?: string | null, lastName?: string | null }
        , organization:
          | { id: string, name?: string | null }
          | { id: string, name?: string | null }
        , parentAudience?:
          | { id: string, condition: AudienceCondition }
          | { id: string, condition?: AudienceCondition | null }
         | null }> } } | null };

export type SendSupportEmailMutationVariables = Exact<{
  message: Scalars['String']['input'];
}>;


export type SendSupportEmailMutation = { sendSupportEmail?: boolean | null };

export type SubscriptionInfoFragment = { id: string, currency?: string | null, totalRevenueInCents?: number | null, currentPeriodEndsAt?: any | null, cancelAtEndOfPeriod?: string | null, creditBalanceInCents?: number | null, currentPeriodUsageInfo: { currentPeriodUsageInCents: number, audienceIdCount: number, resolveIdCount: number }, product?: { id: string, intervalUnit?: ProductIntervalUnit | null, interval?: number | null, expirationInterval?: number | null, priceInCents?: number | null, name?: string | null, budgetPerPeriod?: number | null } | null, creditCard?: { cardType?: string | null, maskedCardNumber?: string | null, expirationMonth?: number | null, expirationYear?: number | null } | null };

export type SubscriptionInfoQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type SubscriptionInfoQuery = { subscriptionInfo?: { id: string, currency?: string | null, totalRevenueInCents?: number | null, currentPeriodEndsAt?: any | null, cancelAtEndOfPeriod?: string | null, creditBalanceInCents?: number | null, currentPeriodUsageInfo: { currentPeriodUsageInCents: number, audienceIdCount: number, resolveIdCount: number }, product?: { id: string, intervalUnit?: ProductIntervalUnit | null, interval?: number | null, expirationInterval?: number | null, priceInCents?: number | null, name?: string | null, budgetPerPeriod?: number | null } | null, creditCard?: { cardType?: string | null, maskedCardNumber?: string | null, expirationMonth?: number | null, expirationYear?: number | null } | null } | null };

export type TouchConversationAfterUserMessageMutationVariables = Exact<{
  conversationId: Scalars['ID']['input'];
}>;


export type TouchConversationAfterUserMessageMutation = { touchConversationAfterUserMessage: boolean };

export type UpdateAudienceMutationVariables = Exact<{
  audienceUpdateParams: AudienceUpdateInput;
}>;


export type UpdateAudienceMutation = { updateAudience?: { id: string, name: string } | null };

export type UpdateAudienceCategoriesMutationVariables = Exact<{
  audienceId: Scalars['ID']['input'];
  categoryCodes: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type UpdateAudienceCategoriesMutation = { updateAudienceCategories: boolean };

export type UpdateAudienceIntegrationMutationVariables = Exact<{
  integrationParams: AudienceIntegrationUpdateInput;
}>;


export type UpdateAudienceIntegrationMutation = { updateAudienceIntegration?: { id: string } | null };

export type UpdateAudiencePixelSettingsMutationVariables = Exact<{
  audiencePixelSettingsParams: AudiencePixelSettingsUpdateInput;
}>;


export type UpdateAudiencePixelSettingsMutation = { updatePixelAudienceSettings?: { id: string } | null };

export type UpdateAudiencePulseMutationVariables = Exact<{
  audiencePulseParams: UpdateAudiencePulseInput;
}>;


export type UpdateAudiencePulseMutation = { updateAudiencePulse?: { id: string } | null };

export type UpdateConversationMutationVariables = Exact<{
  updateConversationInput: UpdateConversationInput;
}>;


export type UpdateConversationMutation = { updateConversation: { id: string, title: string } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { me?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null, scopes?: Array<Scope> | null, whiteLabelImageUrl?: string | null, organizations?: Array<{ id: string, name?: string | null, legalName?: string | null, organizationType: OrganizationType, imageUrl?: string | null, subscriptionOverride?: boolean | null, paidSubscription?: boolean | null, audiencesCount?: number | null, businessDataEnabled?: boolean | null, pulseEnabled?: boolean | null, globalSearchEnabled?: boolean | null, customerListEnabled?: boolean | null, lookalikeEnabled?: boolean | null, matchbackEnabled?: boolean | null, phone?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, hiddenPeopleFields: Array<string>, state?: string | null, country?: string | null, zip?: string | null }> | null, invites?: Array<{ id: string, email: string, organizationId?: string | null, createdByUserId: string, status: string, createdAt: any, updatedAt: any, acceptedAt?: any | null, declinedAt?: any | null, deletedAt?: any | null, inviter?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null } | null, user?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null } | null, organization?: { id: string, name?: string | null, imageUrl?: string | null } | null }> | null, userRoles?: Array<{ id: string, hiddenPeopleFields?: Array<string> | null, organizationId?: string | null, assignedRole: { id: string, name: string, permissions: Array<Permission>, childOrgExtraPermissions?: Array<Permission> | null, hiddenPeopleFields?: Array<string> | null } }> | null } | null };

export type UpdateMeMutationVariables = Exact<{
  user?: InputMaybe<UpdateUserInput>;
}>;


export type UpdateMeMutation = { updateMe?: { id: string, firstName?: string | null, lastName?: string | null } | null };

export const ActivationAudienceIntegrationConfigurationFragmentDoc = gql`
    fragment ActivationAudienceIntegrationConfiguration on ActivationAudienceIntegrationConfiguration {
  activationType
  parameters {
    key
    value
  }
  historicalDataSync
  activationPeopleColumns: peopleColumns
  activationStatus: status
}
    `;
export const AdfAudienceIntegrationConfigurationFragmentDoc = gql`
    fragment ADFAudienceIntegrationConfiguration on ADFAudienceIntegrationConfiguration {
  emails
}
    `;
export const S3AudienceIntegrationConfigurationFragmentDoc = gql`
    fragment S3AudienceIntegrationConfiguration on S3AudienceIntegrationConfiguration {
  secretAccessKey
  region
  ownership
  iamRoles
  destinationS3Bucket
  outputObjectKeyTemplates
  accessKeyId
  exportType
  fileFormat
  peopleColumns
}
    `;
export const ZapierAudienceIntegrationConfigurationFragmentDoc = gql`
    fragment ZapierAudienceIntegrationConfiguration on ZapierAudienceIntegrationConfiguration {
  connectionTimestamp
  historicalDataSync
  status
}
    `;
export const FacebookAudienceIntegrationConfigurationFragmentDoc = gql`
    fragment FacebookAudienceIntegrationConfiguration on FacebookCustomAudienceAudienceIntegrationConfiguration {
  name
  description
  adAccountId
  accessToken
  customAudienceId
  historicalDataSync
  daysToKeep
}
    `;
export const GoogleAdsAudienceIntegrationConfigurationFragmentDoc = gql`
    fragment GoogleAdsAudienceIntegrationConfiguration on GoogleCustomerMatchAudienceIntegrationConfiguration {
  name
  description
  customerId
  managerCustomerId
  userListId
  lastOperationId
  historicalDataSync
  daysToKeep
  googleAdsStatus: status
  googleUserAccountId
}
    `;
export const HighLevelIntegrationConfigurationFragmentDoc = gql`
    fragment HighLevelIntegrationConfiguration on HighLevelAudienceIntegrationConfiguration {
  privateIntegrationToken
  locationId
  tags
}
    `;
export const TealiumIntegrationConfigurationFragmentDoc = gql`
    fragment TealiumIntegrationConfiguration on TealiumAudienceIntegrationConfiguration {
  checkIfExistingCustomer
  redshiftHost
  redshiftPort
  redshiftUser
  redshiftPassword
  redshiftDatabase
  emailAttributeName
  events {
    existingCustomer
    nonExistingCustomer
    static
  }
  parameterNames {
    phone
    email
    hashedPhone
    hashedEmail
  }
  customEntries
  endpoint
}
    `;
export const MailchimpAudienceIntegrationConfigurationFragmentDoc = gql`
    fragment MailchimpAudienceIntegrationConfiguration on MailchimpAudienceIntegrationConfiguration {
  apiKey
  audienceId
  tag
  daysToKeep
  historicalDataSync
}
    `;
export const BeeswaxAudienceIntegrationConfigurationFragmentDoc = gql`
    fragment BeeswaxAudienceIntegrationConfiguration on BeeswaxAudienceIntegrationConfiguration {
  buzzKey
  email
  segmentKey
  hemSalt
}
    `;
export const MadhiveAudienceIntegrationConfigurationFragmentDoc = gql`
    fragment MadhiveAudienceIntegrationConfiguration on MadhiveAudienceIntegrationConfiguration {
  segmentName
  cpm
  description
}
    `;
export const DisplayVideo360AudienceIntegrationConfigurationFragmentDoc = gql`
    fragment DisplayVideo360AudienceIntegrationConfiguration on DisplayVideo360CustomerMatchAudienceIntegrationConfiguration {
  name
  description
  advertiserId
  partnerId
  audienceOwnerType
  historicalDataSync
  daysToKeep
  dv360Status: status
  googleUserAccountId
}
    `;
export const BasicFilterFieldsFragmentDoc = gql`
    fragment BasicFilterFields on PersonFilter {
  stringFilter {
    field
    customField
    negate
    operator {
      in
      eq
      exists
    }
  }
  extendedStringFilter {
    field
    negate
    operator {
      contains
      eq
      startsWith
    }
  }
  numberFilter {
    field
    customField
    operator {
      between {
        from
        to
      }
      eq
      gt
      lt
      gte
      lte
      exists
    }
  }
  booleanFilter {
    field
    customField
    operator {
      eq
      exists
    }
  }
  geoFilter {
    negate
    operator {
      distance {
        distance
        location {
          latitude
          longitude
        }
        unit
      }
      polygon {
        latitude
        longitude
      }
      in {
        field
        values
      }
    }
    place {
      address
      postalCode
    }
    excludedZipCodes
  }
  dateFilter {
    field
    customField
    operator {
      exists
      between {
        from
        to
      }
      gt
      lt
      gte
      lte
    }
  }
}
    `;
export const FilterFieldsFragmentDoc = gql`
    fragment FilterFields on BaseAudience {
  filters {
    ...BasicFilterFields
    compoundFilter {
      filters {
        ...BasicFilterFields
        compoundFilter {
          filters {
            ...BasicFilterFields
          }
          operator
        }
      }
      operator
    }
  }
}
    ${BasicFilterFieldsFragmentDoc}`;
export const CategoriesFragmentDoc = gql`
    fragment Categories on BaseAudience {
  categories {
    id
    categoryName
    categoryCode
    relevance
  }
  info {
    ... on AudiencePixelInfo {
      categoriesProcessed
    }
  }
}
    `;
export const LookalikeInfoFieldsFragmentDoc = gql`
    fragment LookalikeInfoFields on AudienceLookalikeInfo {
  requestedCount
  matchedCount
  similarityPercentage
  dateRange {
    from
    to
  }
}
    `;
export const AdditionsFieldsFragmentDoc = gql`
    fragment AdditionsFields on BaseAdditionsArrayInfo {
  matchedCount
  date
  requestedCount
  totalCount
}
    `;
export const GlobalInfoFieldsFragmentDoc = gql`
    fragment GlobalInfoFields on AudienceGlobalInfo {
  lastSuccessfullyProcessedAt
  additions {
    ...AdditionsFields
  }
}
    ${AdditionsFieldsFragmentDoc}`;
export const PulseInfoFieldsFragmentDoc = gql`
    fragment PulseInfoFields on AudiencePulseInfo {
  lastProcessedDateRange {
    from
    to
  }
  lastSuccessfullyProcessedAt
  subscriptionCount
  subscriptionAmount
  items {
    category
    id
    subCategory
    topic
  }
  topicIds
  additions {
    ...AdditionsFields
  }
}
    ${AdditionsFieldsFragmentDoc}`;
export const CustomerListColumnMappingsFieldsFragmentDoc = gql`
    fragment CustomerListColumnMappingsFields on AudienceCustomerListColumnMappings {
  email
  emailField
  emailMd5
  emailMd5Field
  phone
  phoneField
  customFields {
    column
    field
    fieldType
    originalField
  }
}
    `;
export const CustomerListInfoFieldsFragmentDoc = gql`
    fragment CustomerListInfoFields on AudienceCustomerListInfo {
  s3FileUri
  additions {
    ...AdditionsFields
    mapping {
      ...CustomerListColumnMappingsFields
    }
  }
  processingAdditionInfo {
    mapping {
      ...CustomerListColumnMappingsFields
    }
  }
}
    ${AdditionsFieldsFragmentDoc}
${CustomerListColumnMappingsFieldsFragmentDoc}`;
export const DisableEmailValidationFieldsFragmentDoc = gql`
    fragment DisableEmailValidationFields on Organization {
  disableEmailValidationOwn: disableEmailValidation(retrieveFinalValue: false)
  disableEmailValidationFinal: disableEmailValidation(retrieveFinalValue: true)
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  id
  firstName
  lastName
  email
  phone
  imageUrl
}
    `;
export const UserRoleFieldsFragmentDoc = gql`
    fragment UserRoleFields on Role {
  id
  name
  organization {
    id
    name
  }
}
    `;
export const SubscriptionInfoFragmentDoc = gql`
    fragment SubscriptionInfo on SubscriptionInfo {
  id
  currency
  totalRevenueInCents
  currentPeriodEndsAt
  cancelAtEndOfPeriod
  creditBalanceInCents
  currentPeriodUsageInfo {
    currentPeriodUsageInCents
    audienceIdCount
    resolveIdCount
  }
  product {
    id
    intervalUnit
    interval
    expirationInterval
    priceInCents
    name
    budgetPerPeriod
  }
  creditCard {
    cardType
    maskedCardNumber
    expirationMonth
    expirationYear
  }
}
    `;
export const ConversationReferenceAutocompleteDocument = gql`
    query ConversationReferenceAutocomplete($searchQuery: String!, $first: Int!, $filter: ConversationReferenceFilterInput) {
  conversationReferenceAutocomplete(
    searchQuery: $searchQuery
    first: $first
    filter: $filter
  ) {
    nodes {
      name
      deepLink
      type
      audienceCondition
    }
  }
}
    `;

/**
 * __useConversationReferenceAutocompleteQuery__
 *
 * To run a query within a React component, call `useConversationReferenceAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationReferenceAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationReferenceAutocompleteQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useConversationReferenceAutocompleteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ConversationReferenceAutocompleteQuery, ConversationReferenceAutocompleteQueryVariables> & ({ variables: ConversationReferenceAutocompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConversationReferenceAutocompleteQuery, ConversationReferenceAutocompleteQueryVariables>(ConversationReferenceAutocompleteDocument, options);
      }
export function useConversationReferenceAutocompleteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConversationReferenceAutocompleteQuery, ConversationReferenceAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConversationReferenceAutocompleteQuery, ConversationReferenceAutocompleteQueryVariables>(ConversationReferenceAutocompleteDocument, options);
        }
// @ts-ignore
export function useConversationReferenceAutocompleteSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ConversationReferenceAutocompleteQuery, ConversationReferenceAutocompleteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConversationReferenceAutocompleteQuery, ConversationReferenceAutocompleteQueryVariables>;
export function useConversationReferenceAutocompleteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConversationReferenceAutocompleteQuery, ConversationReferenceAutocompleteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConversationReferenceAutocompleteQuery | undefined, ConversationReferenceAutocompleteQueryVariables>;
export function useConversationReferenceAutocompleteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConversationReferenceAutocompleteQuery, ConversationReferenceAutocompleteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConversationReferenceAutocompleteQuery, ConversationReferenceAutocompleteQueryVariables>(ConversationReferenceAutocompleteDocument, options);
        }
export type ConversationReferenceAutocompleteQueryHookResult = ReturnType<typeof useConversationReferenceAutocompleteQuery>;
export type ConversationReferenceAutocompleteLazyQueryHookResult = ReturnType<typeof useConversationReferenceAutocompleteLazyQuery>;
export type ConversationReferenceAutocompleteSuspenseQueryHookResult = ReturnType<typeof useConversationReferenceAutocompleteSuspenseQuery>;
export type ConversationReferenceAutocompleteQueryResult = ApolloReactHooks.QueryResult<ConversationReferenceAutocompleteQuery, ConversationReferenceAutocompleteQueryVariables>;
export const CreateAudienceCustomerListDocument = gql`
    mutation CreateAudienceCustomerList($audienceCustomerListParams: AudienceCustomerListInput!) {
  createAudienceCustomerList(
    audienceCustomerListParams: $audienceCustomerListParams
  ) {
    id
    name
  }
}
    `;
export type CreateAudienceCustomerListMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateAudienceCustomerListMutation, CreateAudienceCustomerListMutationVariables>;

/**
 * __useCreateAudienceCustomerListMutation__
 *
 * To run a mutation, you first call `useCreateAudienceCustomerListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAudienceCustomerListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAudienceCustomerListMutation, { data, loading, error }] = useCreateAudienceCustomerListMutation({
 *   variables: {
 *      audienceCustomerListParams: // value for 'audienceCustomerListParams'
 *   },
 * });
 */
export function useCreateAudienceCustomerListMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAudienceCustomerListMutation, CreateAudienceCustomerListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAudienceCustomerListMutation, CreateAudienceCustomerListMutationVariables>(CreateAudienceCustomerListDocument, options);
      }
export type CreateAudienceCustomerListMutationHookResult = ReturnType<typeof useCreateAudienceCustomerListMutation>;
export type CreateAudienceCustomerListMutationResult = ApolloReactHooks.MutationResult<CreateAudienceCustomerListMutation>;
export type CreateAudienceCustomerListMutationOptions = Apollo.MutationOptions<CreateAudienceCustomerListMutation, CreateAudienceCustomerListMutationVariables>;
export const ActivationSpecsDocument = gql`
    query ActivationSpecs {
  activationSpecs {
    activationType
    specVersion
    displayName
    category
    beta
    catalogId
    fieldDefs {
      key
      label
      kind
      secret
      required
      options
      pattern
      placeholder
      defaultValue
    }
    allowedAudienceConditions
    configurableColumns
    defaultPeopleColumns
  }
}
    `;

/**
 * __useActivationSpecsQuery__
 *
 * To run a query within a React component, call `useActivationSpecsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivationSpecsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivationSpecsQuery({
 *   variables: {
 *   },
 * });
 */
export function useActivationSpecsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActivationSpecsQuery, ActivationSpecsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActivationSpecsQuery, ActivationSpecsQueryVariables>(ActivationSpecsDocument, options);
      }
export function useActivationSpecsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActivationSpecsQuery, ActivationSpecsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActivationSpecsQuery, ActivationSpecsQueryVariables>(ActivationSpecsDocument, options);
        }
// @ts-ignore
export function useActivationSpecsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ActivationSpecsQuery, ActivationSpecsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ActivationSpecsQuery, ActivationSpecsQueryVariables>;
export function useActivationSpecsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ActivationSpecsQuery, ActivationSpecsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ActivationSpecsQuery | undefined, ActivationSpecsQueryVariables>;
export function useActivationSpecsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ActivationSpecsQuery, ActivationSpecsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ActivationSpecsQuery, ActivationSpecsQueryVariables>(ActivationSpecsDocument, options);
        }
export type ActivationSpecsQueryHookResult = ReturnType<typeof useActivationSpecsQuery>;
export type ActivationSpecsLazyQueryHookResult = ReturnType<typeof useActivationSpecsLazyQuery>;
export type ActivationSpecsSuspenseQueryHookResult = ReturnType<typeof useActivationSpecsSuspenseQuery>;
export type ActivationSpecsQueryResult = ApolloReactHooks.QueryResult<ActivationSpecsQuery, ActivationSpecsQueryVariables>;
export const ActivitySummaryPageDocument = gql`
    query ActivitySummaryPage($pageNumber: Int!, $pageItemsCount: Int!, $dateRange: DateOperatorsInput!, $organizationId: ID, $activityLevel: ActivityLevel) {
  activitySummaryPage(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    dateRange: $dateRange
    organizationId: $organizationId
    activityLevel: $activityLevel
  ) {
    totalCount
    nodes {
      actedByUserType
      actionType
      actor {
        id
        imageUrl
        firstName
        lastName
      }
      audience {
        id
        name
      }
      createdAt
      entityId
      entityType
      field
      newValue
      oldValue
      organization {
        id
        name
        imageUrl
      }
      user {
        id
        firstName
        lastName
        imageUrl
      }
    }
  }
}
    `;

/**
 * __useActivitySummaryPageQuery__
 *
 * To run a query within a React component, call `useActivitySummaryPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivitySummaryPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivitySummaryPageQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      dateRange: // value for 'dateRange'
 *      organizationId: // value for 'organizationId'
 *      activityLevel: // value for 'activityLevel'
 *   },
 * });
 */
export function useActivitySummaryPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ActivitySummaryPageQuery, ActivitySummaryPageQueryVariables> & ({ variables: ActivitySummaryPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActivitySummaryPageQuery, ActivitySummaryPageQueryVariables>(ActivitySummaryPageDocument, options);
      }
export function useActivitySummaryPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActivitySummaryPageQuery, ActivitySummaryPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActivitySummaryPageQuery, ActivitySummaryPageQueryVariables>(ActivitySummaryPageDocument, options);
        }
// @ts-ignore
export function useActivitySummaryPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ActivitySummaryPageQuery, ActivitySummaryPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ActivitySummaryPageQuery, ActivitySummaryPageQueryVariables>;
export function useActivitySummaryPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ActivitySummaryPageQuery, ActivitySummaryPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ActivitySummaryPageQuery | undefined, ActivitySummaryPageQueryVariables>;
export function useActivitySummaryPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ActivitySummaryPageQuery, ActivitySummaryPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ActivitySummaryPageQuery, ActivitySummaryPageQueryVariables>(ActivitySummaryPageDocument, options);
        }
export type ActivitySummaryPageQueryHookResult = ReturnType<typeof useActivitySummaryPageQuery>;
export type ActivitySummaryPageLazyQueryHookResult = ReturnType<typeof useActivitySummaryPageLazyQuery>;
export type ActivitySummaryPageSuspenseQueryHookResult = ReturnType<typeof useActivitySummaryPageSuspenseQuery>;
export type ActivitySummaryPageQueryResult = ApolloReactHooks.QueryResult<ActivitySummaryPageQuery, ActivitySummaryPageQueryVariables>;
export const AddPeopleAudienceCustomerListDocument = gql`
    mutation AddPeopleAudienceCustomerList($addPeopleAudienceCustomerListParams: AddPeopleAudienceCustomerListInput!) {
  addPeopleAudienceCustomerList(
    addPeopleAudienceCustomerListParams: $addPeopleAudienceCustomerListParams
  ) {
    id
    name
  }
}
    `;
export type AddPeopleAudienceCustomerListMutationFn = ApolloReactHooks.useMutation.MutationFunction<AddPeopleAudienceCustomerListMutation, AddPeopleAudienceCustomerListMutationVariables>;

/**
 * __useAddPeopleAudienceCustomerListMutation__
 *
 * To run a mutation, you first call `useAddPeopleAudienceCustomerListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPeopleAudienceCustomerListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPeopleAudienceCustomerListMutation, { data, loading, error }] = useAddPeopleAudienceCustomerListMutation({
 *   variables: {
 *      addPeopleAudienceCustomerListParams: // value for 'addPeopleAudienceCustomerListParams'
 *   },
 * });
 */
export function useAddPeopleAudienceCustomerListMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddPeopleAudienceCustomerListMutation, AddPeopleAudienceCustomerListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddPeopleAudienceCustomerListMutation, AddPeopleAudienceCustomerListMutationVariables>(AddPeopleAudienceCustomerListDocument, options);
      }
export type AddPeopleAudienceCustomerListMutationHookResult = ReturnType<typeof useAddPeopleAudienceCustomerListMutation>;
export type AddPeopleAudienceCustomerListMutationResult = ApolloReactHooks.MutationResult<AddPeopleAudienceCustomerListMutation>;
export type AddPeopleAudienceCustomerListMutationOptions = Apollo.MutationOptions<AddPeopleAudienceCustomerListMutation, AddPeopleAudienceCustomerListMutationVariables>;
export const AddAudienceVisitsDocument = gql`
    mutation AddAudienceVisits($addPeopleAudienceGlobalParams: AddPeopleAudienceGlobalInput!) {
  addPeopleAudienceGlobal(
    addPeopleAudienceGlobalParams: $addPeopleAudienceGlobalParams
  ) {
    id
  }
}
    `;
export type AddAudienceVisitsMutationFn = ApolloReactHooks.useMutation.MutationFunction<AddAudienceVisitsMutation, AddAudienceVisitsMutationVariables>;

/**
 * __useAddAudienceVisitsMutation__
 *
 * To run a mutation, you first call `useAddAudienceVisitsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAudienceVisitsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAudienceVisitsMutation, { data, loading, error }] = useAddAudienceVisitsMutation({
 *   variables: {
 *      addPeopleAudienceGlobalParams: // value for 'addPeopleAudienceGlobalParams'
 *   },
 * });
 */
export function useAddAudienceVisitsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddAudienceVisitsMutation, AddAudienceVisitsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddAudienceVisitsMutation, AddAudienceVisitsMutationVariables>(AddAudienceVisitsDocument, options);
      }
export type AddAudienceVisitsMutationHookResult = ReturnType<typeof useAddAudienceVisitsMutation>;
export type AddAudienceVisitsMutationResult = ApolloReactHooks.MutationResult<AddAudienceVisitsMutation>;
export type AddAudienceVisitsMutationOptions = Apollo.MutationOptions<AddAudienceVisitsMutation, AddAudienceVisitsMutationVariables>;
export const AgentSecureInputKeyDocument = gql`
    query AgentSecureInputKey {
  appConfiguration {
    agentSecureInputKey {
      kid
      publicKeyPem
    }
  }
}
    `;

/**
 * __useAgentSecureInputKeyQuery__
 *
 * To run a query within a React component, call `useAgentSecureInputKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentSecureInputKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentSecureInputKeyQuery({
 *   variables: {
 *   },
 * });
 */
export function useAgentSecureInputKeyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AgentSecureInputKeyQuery, AgentSecureInputKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AgentSecureInputKeyQuery, AgentSecureInputKeyQueryVariables>(AgentSecureInputKeyDocument, options);
      }
export function useAgentSecureInputKeyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AgentSecureInputKeyQuery, AgentSecureInputKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AgentSecureInputKeyQuery, AgentSecureInputKeyQueryVariables>(AgentSecureInputKeyDocument, options);
        }
// @ts-ignore
export function useAgentSecureInputKeySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AgentSecureInputKeyQuery, AgentSecureInputKeyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AgentSecureInputKeyQuery, AgentSecureInputKeyQueryVariables>;
export function useAgentSecureInputKeySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AgentSecureInputKeyQuery, AgentSecureInputKeyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AgentSecureInputKeyQuery | undefined, AgentSecureInputKeyQueryVariables>;
export function useAgentSecureInputKeySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AgentSecureInputKeyQuery, AgentSecureInputKeyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AgentSecureInputKeyQuery, AgentSecureInputKeyQueryVariables>(AgentSecureInputKeyDocument, options);
        }
export type AgentSecureInputKeyQueryHookResult = ReturnType<typeof useAgentSecureInputKeyQuery>;
export type AgentSecureInputKeyLazyQueryHookResult = ReturnType<typeof useAgentSecureInputKeyLazyQuery>;
export type AgentSecureInputKeySuspenseQueryHookResult = ReturnType<typeof useAgentSecureInputKeySuspenseQuery>;
export type AgentSecureInputKeyQueryResult = ApolloReactHooks.QueryResult<AgentSecureInputKeyQuery, AgentSecureInputKeyQueryVariables>;
export const AiCreditsUsageDocument = gql`
    query AiCreditsUsage {
  aiCreditsUsage {
    enabled
    usage
    limit
    percentage
    periodStart
    periodEnd
  }
}
    `;

/**
 * __useAiCreditsUsageQuery__
 *
 * To run a query within a React component, call `useAiCreditsUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiCreditsUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiCreditsUsageQuery({
 *   variables: {
 *   },
 * });
 */
export function useAiCreditsUsageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AiCreditsUsageQuery, AiCreditsUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiCreditsUsageQuery, AiCreditsUsageQueryVariables>(AiCreditsUsageDocument, options);
      }
export function useAiCreditsUsageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiCreditsUsageQuery, AiCreditsUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiCreditsUsageQuery, AiCreditsUsageQueryVariables>(AiCreditsUsageDocument, options);
        }
// @ts-ignore
export function useAiCreditsUsageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiCreditsUsageQuery, AiCreditsUsageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiCreditsUsageQuery, AiCreditsUsageQueryVariables>;
export function useAiCreditsUsageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiCreditsUsageQuery, AiCreditsUsageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AiCreditsUsageQuery | undefined, AiCreditsUsageQueryVariables>;
export function useAiCreditsUsageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AiCreditsUsageQuery, AiCreditsUsageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AiCreditsUsageQuery, AiCreditsUsageQueryVariables>(AiCreditsUsageDocument, options);
        }
export type AiCreditsUsageQueryHookResult = ReturnType<typeof useAiCreditsUsageQuery>;
export type AiCreditsUsageLazyQueryHookResult = ReturnType<typeof useAiCreditsUsageLazyQuery>;
export type AiCreditsUsageSuspenseQueryHookResult = ReturnType<typeof useAiCreditsUsageSuspenseQuery>;
export type AiCreditsUsageQueryResult = ApolloReactHooks.QueryResult<AiCreditsUsageQuery, AiCreditsUsageQueryVariables>;
export const AppConfigurationDocument = gql`
    query AppConfiguration {
  appConfiguration {
    pulseDateRange {
      from
      to
    }
    pulseSubscriptionAmount
  }
}
    `;

/**
 * __useAppConfigurationQuery__
 *
 * To run a query within a React component, call `useAppConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppConfigurationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AppConfigurationQuery, AppConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AppConfigurationQuery, AppConfigurationQueryVariables>(AppConfigurationDocument, options);
      }
export function useAppConfigurationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AppConfigurationQuery, AppConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AppConfigurationQuery, AppConfigurationQueryVariables>(AppConfigurationDocument, options);
        }
// @ts-ignore
export function useAppConfigurationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AppConfigurationQuery, AppConfigurationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AppConfigurationQuery, AppConfigurationQueryVariables>;
export function useAppConfigurationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AppConfigurationQuery, AppConfigurationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AppConfigurationQuery | undefined, AppConfigurationQueryVariables>;
export function useAppConfigurationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AppConfigurationQuery, AppConfigurationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AppConfigurationQuery, AppConfigurationQueryVariables>(AppConfigurationDocument, options);
        }
export type AppConfigurationQueryHookResult = ReturnType<typeof useAppConfigurationQuery>;
export type AppConfigurationLazyQueryHookResult = ReturnType<typeof useAppConfigurationLazyQuery>;
export type AppConfigurationSuspenseQueryHookResult = ReturnType<typeof useAppConfigurationSuspenseQuery>;
export type AppConfigurationQueryResult = ApolloReactHooks.QueryResult<AppConfigurationQuery, AppConfigurationQueryVariables>;
export const AttributionSourceCountsQueryDocument = gql`
    query AttributionSourceCountsQuery($audienceId: ID!, $utmGroup: UTMGroup!, $filters: [PersonFilterInput!], $count: Int) {
  audience(id: $audienceId) {
    attributionSourceCounts(utmGroup: $utmGroup, filters: $filters, count: $count) {
      attributions {
        count
        source
      }
    }
  }
}
    `;

/**
 * __useAttributionSourceCountsQueryQuery__
 *
 * To run a query within a React component, call `useAttributionSourceCountsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionSourceCountsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionSourceCountsQueryQuery({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *      utmGroup: // value for 'utmGroup'
 *      filters: // value for 'filters'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useAttributionSourceCountsQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AttributionSourceCountsQueryQuery, AttributionSourceCountsQueryQueryVariables> & ({ variables: AttributionSourceCountsQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AttributionSourceCountsQueryQuery, AttributionSourceCountsQueryQueryVariables>(AttributionSourceCountsQueryDocument, options);
      }
export function useAttributionSourceCountsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AttributionSourceCountsQueryQuery, AttributionSourceCountsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AttributionSourceCountsQueryQuery, AttributionSourceCountsQueryQueryVariables>(AttributionSourceCountsQueryDocument, options);
        }
// @ts-ignore
export function useAttributionSourceCountsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AttributionSourceCountsQueryQuery, AttributionSourceCountsQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AttributionSourceCountsQueryQuery, AttributionSourceCountsQueryQueryVariables>;
export function useAttributionSourceCountsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AttributionSourceCountsQueryQuery, AttributionSourceCountsQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AttributionSourceCountsQueryQuery | undefined, AttributionSourceCountsQueryQueryVariables>;
export function useAttributionSourceCountsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AttributionSourceCountsQueryQuery, AttributionSourceCountsQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AttributionSourceCountsQueryQuery, AttributionSourceCountsQueryQueryVariables>(AttributionSourceCountsQueryDocument, options);
        }
export type AttributionSourceCountsQueryQueryHookResult = ReturnType<typeof useAttributionSourceCountsQueryQuery>;
export type AttributionSourceCountsQueryLazyQueryHookResult = ReturnType<typeof useAttributionSourceCountsQueryLazyQuery>;
export type AttributionSourceCountsQuerySuspenseQueryHookResult = ReturnType<typeof useAttributionSourceCountsQuerySuspenseQuery>;
export type AttributionSourceCountsQueryQueryResult = ApolloReactHooks.QueryResult<AttributionSourceCountsQueryQuery, AttributionSourceCountsQueryQueryVariables>;
export const AudienceIntegrationDocument = gql`
    query AudienceIntegration($audienceIntegrationId: ID!) {
  audienceIntegration(id: $audienceIntegrationId) {
    configuration {
      ...ActivationAudienceIntegrationConfiguration
      ...ADFAudienceIntegrationConfiguration
      ...S3AudienceIntegrationConfiguration
      ...ZapierAudienceIntegrationConfiguration
      ...FacebookAudienceIntegrationConfiguration
      ...GoogleAdsAudienceIntegrationConfiguration
      ...HighLevelIntegrationConfiguration
      ...MailchimpAudienceIntegrationConfiguration
      ...TealiumIntegrationConfiguration
      ...BeeswaxAudienceIntegrationConfiguration
      ...MadhiveAudienceIntegrationConfiguration
      ...DisplayVideo360AudienceIntegrationConfiguration
    }
    id
    integrationType
    name
    creator {
      firstName
      lastName
    }
    lastSuccessfulRunAt
    lastRunSucceeded
    lastRunAt
    lastRunHasWarnings
    lastRunResult
    supportsTemplate
  }
}
    ${ActivationAudienceIntegrationConfigurationFragmentDoc}
${AdfAudienceIntegrationConfigurationFragmentDoc}
${S3AudienceIntegrationConfigurationFragmentDoc}
${ZapierAudienceIntegrationConfigurationFragmentDoc}
${FacebookAudienceIntegrationConfigurationFragmentDoc}
${GoogleAdsAudienceIntegrationConfigurationFragmentDoc}
${HighLevelIntegrationConfigurationFragmentDoc}
${MailchimpAudienceIntegrationConfigurationFragmentDoc}
${TealiumIntegrationConfigurationFragmentDoc}
${BeeswaxAudienceIntegrationConfigurationFragmentDoc}
${MadhiveAudienceIntegrationConfigurationFragmentDoc}
${DisplayVideo360AudienceIntegrationConfigurationFragmentDoc}`;

/**
 * __useAudienceIntegrationQuery__
 *
 * To run a query within a React component, call `useAudienceIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceIntegrationQuery({
 *   variables: {
 *      audienceIntegrationId: // value for 'audienceIntegrationId'
 *   },
 * });
 */
export function useAudienceIntegrationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AudienceIntegrationQuery, AudienceIntegrationQueryVariables> & ({ variables: AudienceIntegrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AudienceIntegrationQuery, AudienceIntegrationQueryVariables>(AudienceIntegrationDocument, options);
      }
export function useAudienceIntegrationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AudienceIntegrationQuery, AudienceIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AudienceIntegrationQuery, AudienceIntegrationQueryVariables>(AudienceIntegrationDocument, options);
        }
// @ts-ignore
export function useAudienceIntegrationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AudienceIntegrationQuery, AudienceIntegrationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AudienceIntegrationQuery, AudienceIntegrationQueryVariables>;
export function useAudienceIntegrationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AudienceIntegrationQuery, AudienceIntegrationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AudienceIntegrationQuery | undefined, AudienceIntegrationQueryVariables>;
export function useAudienceIntegrationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AudienceIntegrationQuery, AudienceIntegrationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AudienceIntegrationQuery, AudienceIntegrationQueryVariables>(AudienceIntegrationDocument, options);
        }
export type AudienceIntegrationQueryHookResult = ReturnType<typeof useAudienceIntegrationQuery>;
export type AudienceIntegrationLazyQueryHookResult = ReturnType<typeof useAudienceIntegrationLazyQuery>;
export type AudienceIntegrationSuspenseQueryHookResult = ReturnType<typeof useAudienceIntegrationSuspenseQuery>;
export type AudienceIntegrationQueryResult = ApolloReactHooks.QueryResult<AudienceIntegrationQuery, AudienceIntegrationQueryVariables>;
export const AudienceIntegrationTemplatesPageDocument = gql`
    query AudienceIntegrationTemplatesPage($audienceId: ID!, $integrationType: AudienceIntegrationType, $pageNumber: Int!, $pageItemsCount: Int!, $searchQuery: String) {
  audienceIntegrationTemplatesPage(
    audienceId: $audienceId
    integrationType: $integrationType
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    searchQuery: $searchQuery
  ) {
    nodes {
      id
      name
      integrationType
      cascadeToChildOrgs
      includeSegments
      automaticallyCreateActivations
      configuration {
        ...ActivationAudienceIntegrationConfiguration
        ...ADFAudienceIntegrationConfiguration
        ...S3AudienceIntegrationConfiguration
        ...ZapierAudienceIntegrationConfiguration
        ...FacebookAudienceIntegrationConfiguration
        ...GoogleAdsAudienceIntegrationConfiguration
        ...HighLevelIntegrationConfiguration
        ...MailchimpAudienceIntegrationConfiguration
        ...TealiumIntegrationConfiguration
        ...BeeswaxAudienceIntegrationConfiguration
        ...MadhiveAudienceIntegrationConfiguration
        ...DisplayVideo360AudienceIntegrationConfiguration
      }
    }
    totalCount
  }
}
    ${ActivationAudienceIntegrationConfigurationFragmentDoc}
${AdfAudienceIntegrationConfigurationFragmentDoc}
${S3AudienceIntegrationConfigurationFragmentDoc}
${ZapierAudienceIntegrationConfigurationFragmentDoc}
${FacebookAudienceIntegrationConfigurationFragmentDoc}
${GoogleAdsAudienceIntegrationConfigurationFragmentDoc}
${HighLevelIntegrationConfigurationFragmentDoc}
${MailchimpAudienceIntegrationConfigurationFragmentDoc}
${TealiumIntegrationConfigurationFragmentDoc}
${BeeswaxAudienceIntegrationConfigurationFragmentDoc}
${MadhiveAudienceIntegrationConfigurationFragmentDoc}
${DisplayVideo360AudienceIntegrationConfigurationFragmentDoc}`;

/**
 * __useAudienceIntegrationTemplatesPageQuery__
 *
 * To run a query within a React component, call `useAudienceIntegrationTemplatesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceIntegrationTemplatesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceIntegrationTemplatesPageQuery({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *      integrationType: // value for 'integrationType'
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useAudienceIntegrationTemplatesPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AudienceIntegrationTemplatesPageQuery, AudienceIntegrationTemplatesPageQueryVariables> & ({ variables: AudienceIntegrationTemplatesPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AudienceIntegrationTemplatesPageQuery, AudienceIntegrationTemplatesPageQueryVariables>(AudienceIntegrationTemplatesPageDocument, options);
      }
export function useAudienceIntegrationTemplatesPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AudienceIntegrationTemplatesPageQuery, AudienceIntegrationTemplatesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AudienceIntegrationTemplatesPageQuery, AudienceIntegrationTemplatesPageQueryVariables>(AudienceIntegrationTemplatesPageDocument, options);
        }
// @ts-ignore
export function useAudienceIntegrationTemplatesPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AudienceIntegrationTemplatesPageQuery, AudienceIntegrationTemplatesPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AudienceIntegrationTemplatesPageQuery, AudienceIntegrationTemplatesPageQueryVariables>;
export function useAudienceIntegrationTemplatesPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AudienceIntegrationTemplatesPageQuery, AudienceIntegrationTemplatesPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AudienceIntegrationTemplatesPageQuery | undefined, AudienceIntegrationTemplatesPageQueryVariables>;
export function useAudienceIntegrationTemplatesPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AudienceIntegrationTemplatesPageQuery, AudienceIntegrationTemplatesPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AudienceIntegrationTemplatesPageQuery, AudienceIntegrationTemplatesPageQueryVariables>(AudienceIntegrationTemplatesPageDocument, options);
        }
export type AudienceIntegrationTemplatesPageQueryHookResult = ReturnType<typeof useAudienceIntegrationTemplatesPageQuery>;
export type AudienceIntegrationTemplatesPageLazyQueryHookResult = ReturnType<typeof useAudienceIntegrationTemplatesPageLazyQuery>;
export type AudienceIntegrationTemplatesPageSuspenseQueryHookResult = ReturnType<typeof useAudienceIntegrationTemplatesPageSuspenseQuery>;
export type AudienceIntegrationTemplatesPageQueryResult = ApolloReactHooks.QueryResult<AudienceIntegrationTemplatesPageQuery, AudienceIntegrationTemplatesPageQueryVariables>;
export const CreateAudienceIntegrationTemplateDocument = gql`
    mutation CreateAudienceIntegrationTemplate($templateParams: AudienceIntegrationTemplateInput!) {
  createAudienceIntegrationTemplate(templateParams: $templateParams) {
    id
    name
    integrationType
    cascadeToChildOrgs
    includeSegments
    automaticallyCreateActivations
  }
}
    `;
export type CreateAudienceIntegrationTemplateMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateAudienceIntegrationTemplateMutation, CreateAudienceIntegrationTemplateMutationVariables>;

/**
 * __useCreateAudienceIntegrationTemplateMutation__
 *
 * To run a mutation, you first call `useCreateAudienceIntegrationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAudienceIntegrationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAudienceIntegrationTemplateMutation, { data, loading, error }] = useCreateAudienceIntegrationTemplateMutation({
 *   variables: {
 *      templateParams: // value for 'templateParams'
 *   },
 * });
 */
export function useCreateAudienceIntegrationTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAudienceIntegrationTemplateMutation, CreateAudienceIntegrationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAudienceIntegrationTemplateMutation, CreateAudienceIntegrationTemplateMutationVariables>(CreateAudienceIntegrationTemplateDocument, options);
      }
export type CreateAudienceIntegrationTemplateMutationHookResult = ReturnType<typeof useCreateAudienceIntegrationTemplateMutation>;
export type CreateAudienceIntegrationTemplateMutationResult = ApolloReactHooks.MutationResult<CreateAudienceIntegrationTemplateMutation>;
export type CreateAudienceIntegrationTemplateMutationOptions = Apollo.MutationOptions<CreateAudienceIntegrationTemplateMutation, CreateAudienceIntegrationTemplateMutationVariables>;
export const OrganizationAudienceIntegrationTemplatesPageDocument = gql`
    query OrganizationAudienceIntegrationTemplatesPage($organizationId: ID!, $integrationType: AudienceIntegrationType, $pageNumber: Int!, $pageItemsCount: Int!, $searchQuery: String) {
  organizationAudienceIntegrationTemplatesPage(
    organizationId: $organizationId
    integrationType: $integrationType
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    searchQuery: $searchQuery
  ) {
    nodes {
      id
      name
      integrationType
      cascadeToChildOrgs
      includeSegments
      automaticallyCreateActivations
      createdAt
      organization {
        id
        name
      }
      inheritedFromOrganization {
        id
        name
      }
    }
    totalCount
  }
}
    `;

/**
 * __useOrganizationAudienceIntegrationTemplatesPageQuery__
 *
 * To run a query within a React component, call `useOrganizationAudienceIntegrationTemplatesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationAudienceIntegrationTemplatesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationAudienceIntegrationTemplatesPageQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      integrationType: // value for 'integrationType'
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useOrganizationAudienceIntegrationTemplatesPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationAudienceIntegrationTemplatesPageQuery, OrganizationAudienceIntegrationTemplatesPageQueryVariables> & ({ variables: OrganizationAudienceIntegrationTemplatesPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationAudienceIntegrationTemplatesPageQuery, OrganizationAudienceIntegrationTemplatesPageQueryVariables>(OrganizationAudienceIntegrationTemplatesPageDocument, options);
      }
export function useOrganizationAudienceIntegrationTemplatesPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationAudienceIntegrationTemplatesPageQuery, OrganizationAudienceIntegrationTemplatesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationAudienceIntegrationTemplatesPageQuery, OrganizationAudienceIntegrationTemplatesPageQueryVariables>(OrganizationAudienceIntegrationTemplatesPageDocument, options);
        }
// @ts-ignore
export function useOrganizationAudienceIntegrationTemplatesPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationAudienceIntegrationTemplatesPageQuery, OrganizationAudienceIntegrationTemplatesPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationAudienceIntegrationTemplatesPageQuery, OrganizationAudienceIntegrationTemplatesPageQueryVariables>;
export function useOrganizationAudienceIntegrationTemplatesPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationAudienceIntegrationTemplatesPageQuery, OrganizationAudienceIntegrationTemplatesPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationAudienceIntegrationTemplatesPageQuery | undefined, OrganizationAudienceIntegrationTemplatesPageQueryVariables>;
export function useOrganizationAudienceIntegrationTemplatesPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationAudienceIntegrationTemplatesPageQuery, OrganizationAudienceIntegrationTemplatesPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationAudienceIntegrationTemplatesPageQuery, OrganizationAudienceIntegrationTemplatesPageQueryVariables>(OrganizationAudienceIntegrationTemplatesPageDocument, options);
        }
export type OrganizationAudienceIntegrationTemplatesPageQueryHookResult = ReturnType<typeof useOrganizationAudienceIntegrationTemplatesPageQuery>;
export type OrganizationAudienceIntegrationTemplatesPageLazyQueryHookResult = ReturnType<typeof useOrganizationAudienceIntegrationTemplatesPageLazyQuery>;
export type OrganizationAudienceIntegrationTemplatesPageSuspenseQueryHookResult = ReturnType<typeof useOrganizationAudienceIntegrationTemplatesPageSuspenseQuery>;
export type OrganizationAudienceIntegrationTemplatesPageQueryResult = ApolloReactHooks.QueryResult<OrganizationAudienceIntegrationTemplatesPageQuery, OrganizationAudienceIntegrationTemplatesPageQueryVariables>;
export const OrganizationAudienceIntegrationTemplateDocument = gql`
    query OrganizationAudienceIntegrationTemplate($organizationId: ID!, $id: ID!) {
  audienceIntegrationTemplate(organizationId: $organizationId, id: $id) {
    id
    name
    integrationType
    cascadeToChildOrgs
    includeSegments
    automaticallyCreateActivations
    createdAt
    organization {
      id
      name
    }
    inheritedFromOrganization {
      id
      name
    }
    configuration {
      ...ActivationAudienceIntegrationConfiguration
      ...ADFAudienceIntegrationConfiguration
      ...S3AudienceIntegrationConfiguration
      ...ZapierAudienceIntegrationConfiguration
      ...FacebookAudienceIntegrationConfiguration
      ...GoogleAdsAudienceIntegrationConfiguration
      ...HighLevelIntegrationConfiguration
      ...MailchimpAudienceIntegrationConfiguration
      ...TealiumIntegrationConfiguration
      ...BeeswaxAudienceIntegrationConfiguration
      ...MadhiveAudienceIntegrationConfiguration
      ...DisplayVideo360AudienceIntegrationConfiguration
    }
  }
}
    ${ActivationAudienceIntegrationConfigurationFragmentDoc}
${AdfAudienceIntegrationConfigurationFragmentDoc}
${S3AudienceIntegrationConfigurationFragmentDoc}
${ZapierAudienceIntegrationConfigurationFragmentDoc}
${FacebookAudienceIntegrationConfigurationFragmentDoc}
${GoogleAdsAudienceIntegrationConfigurationFragmentDoc}
${HighLevelIntegrationConfigurationFragmentDoc}
${MailchimpAudienceIntegrationConfigurationFragmentDoc}
${TealiumIntegrationConfigurationFragmentDoc}
${BeeswaxAudienceIntegrationConfigurationFragmentDoc}
${MadhiveAudienceIntegrationConfigurationFragmentDoc}
${DisplayVideo360AudienceIntegrationConfigurationFragmentDoc}`;

/**
 * __useOrganizationAudienceIntegrationTemplateQuery__
 *
 * To run a query within a React component, call `useOrganizationAudienceIntegrationTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationAudienceIntegrationTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationAudienceIntegrationTemplateQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationAudienceIntegrationTemplateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationAudienceIntegrationTemplateQuery, OrganizationAudienceIntegrationTemplateQueryVariables> & ({ variables: OrganizationAudienceIntegrationTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationAudienceIntegrationTemplateQuery, OrganizationAudienceIntegrationTemplateQueryVariables>(OrganizationAudienceIntegrationTemplateDocument, options);
      }
export function useOrganizationAudienceIntegrationTemplateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationAudienceIntegrationTemplateQuery, OrganizationAudienceIntegrationTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationAudienceIntegrationTemplateQuery, OrganizationAudienceIntegrationTemplateQueryVariables>(OrganizationAudienceIntegrationTemplateDocument, options);
        }
// @ts-ignore
export function useOrganizationAudienceIntegrationTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationAudienceIntegrationTemplateQuery, OrganizationAudienceIntegrationTemplateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationAudienceIntegrationTemplateQuery, OrganizationAudienceIntegrationTemplateQueryVariables>;
export function useOrganizationAudienceIntegrationTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationAudienceIntegrationTemplateQuery, OrganizationAudienceIntegrationTemplateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationAudienceIntegrationTemplateQuery | undefined, OrganizationAudienceIntegrationTemplateQueryVariables>;
export function useOrganizationAudienceIntegrationTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationAudienceIntegrationTemplateQuery, OrganizationAudienceIntegrationTemplateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationAudienceIntegrationTemplateQuery, OrganizationAudienceIntegrationTemplateQueryVariables>(OrganizationAudienceIntegrationTemplateDocument, options);
        }
export type OrganizationAudienceIntegrationTemplateQueryHookResult = ReturnType<typeof useOrganizationAudienceIntegrationTemplateQuery>;
export type OrganizationAudienceIntegrationTemplateLazyQueryHookResult = ReturnType<typeof useOrganizationAudienceIntegrationTemplateLazyQuery>;
export type OrganizationAudienceIntegrationTemplateSuspenseQueryHookResult = ReturnType<typeof useOrganizationAudienceIntegrationTemplateSuspenseQuery>;
export type OrganizationAudienceIntegrationTemplateQueryResult = ApolloReactHooks.QueryResult<OrganizationAudienceIntegrationTemplateQuery, OrganizationAudienceIntegrationTemplateQueryVariables>;
export const DeleteAudienceIntegrationTemplateDocument = gql`
    mutation DeleteAudienceIntegrationTemplate($id: ID!) {
  deleteAudienceIntegrationTemplate(id: $id)
}
    `;
export type DeleteAudienceIntegrationTemplateMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteAudienceIntegrationTemplateMutation, DeleteAudienceIntegrationTemplateMutationVariables>;

/**
 * __useDeleteAudienceIntegrationTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteAudienceIntegrationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAudienceIntegrationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAudienceIntegrationTemplateMutation, { data, loading, error }] = useDeleteAudienceIntegrationTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAudienceIntegrationTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAudienceIntegrationTemplateMutation, DeleteAudienceIntegrationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAudienceIntegrationTemplateMutation, DeleteAudienceIntegrationTemplateMutationVariables>(DeleteAudienceIntegrationTemplateDocument, options);
      }
export type DeleteAudienceIntegrationTemplateMutationHookResult = ReturnType<typeof useDeleteAudienceIntegrationTemplateMutation>;
export type DeleteAudienceIntegrationTemplateMutationResult = ApolloReactHooks.MutationResult<DeleteAudienceIntegrationTemplateMutation>;
export type DeleteAudienceIntegrationTemplateMutationOptions = Apollo.MutationOptions<DeleteAudienceIntegrationTemplateMutation, DeleteAudienceIntegrationTemplateMutationVariables>;
export const UpdateAudienceIntegrationTemplateDocument = gql`
    mutation UpdateAudienceIntegrationTemplate($templateParams: AudienceIntegrationTemplateUpdateInput!) {
  updateAudienceIntegrationTemplate(templateParams: $templateParams) {
    id
    name
    integrationType
    cascadeToChildOrgs
    includeSegments
    automaticallyCreateActivations
  }
}
    `;
export type UpdateAudienceIntegrationTemplateMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateAudienceIntegrationTemplateMutation, UpdateAudienceIntegrationTemplateMutationVariables>;

/**
 * __useUpdateAudienceIntegrationTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateAudienceIntegrationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAudienceIntegrationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAudienceIntegrationTemplateMutation, { data, loading, error }] = useUpdateAudienceIntegrationTemplateMutation({
 *   variables: {
 *      templateParams: // value for 'templateParams'
 *   },
 * });
 */
export function useUpdateAudienceIntegrationTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAudienceIntegrationTemplateMutation, UpdateAudienceIntegrationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAudienceIntegrationTemplateMutation, UpdateAudienceIntegrationTemplateMutationVariables>(UpdateAudienceIntegrationTemplateDocument, options);
      }
export type UpdateAudienceIntegrationTemplateMutationHookResult = ReturnType<typeof useUpdateAudienceIntegrationTemplateMutation>;
export type UpdateAudienceIntegrationTemplateMutationResult = ApolloReactHooks.MutationResult<UpdateAudienceIntegrationTemplateMutation>;
export type UpdateAudienceIntegrationTemplateMutationOptions = Apollo.MutationOptions<UpdateAudienceIntegrationTemplateMutation, UpdateAudienceIntegrationTemplateMutationVariables>;
export const TestAudienceIntegrationDocument = gql`
    mutation TestAudienceIntegration($integrationParams: AudienceIntegrationTestInput!) {
  testAudienceIntegration(integrationParams: $integrationParams) {
    success
    message
    hasWarnings
  }
}
    `;
export type TestAudienceIntegrationMutationFn = ApolloReactHooks.useMutation.MutationFunction<TestAudienceIntegrationMutation, TestAudienceIntegrationMutationVariables>;

/**
 * __useTestAudienceIntegrationMutation__
 *
 * To run a mutation, you first call `useTestAudienceIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestAudienceIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testAudienceIntegrationMutation, { data, loading, error }] = useTestAudienceIntegrationMutation({
 *   variables: {
 *      integrationParams: // value for 'integrationParams'
 *   },
 * });
 */
export function useTestAudienceIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TestAudienceIntegrationMutation, TestAudienceIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TestAudienceIntegrationMutation, TestAudienceIntegrationMutationVariables>(TestAudienceIntegrationDocument, options);
      }
export type TestAudienceIntegrationMutationHookResult = ReturnType<typeof useTestAudienceIntegrationMutation>;
export type TestAudienceIntegrationMutationResult = ApolloReactHooks.MutationResult<TestAudienceIntegrationMutation>;
export type TestAudienceIntegrationMutationOptions = Apollo.MutationOptions<TestAudienceIntegrationMutation, TestAudienceIntegrationMutationVariables>;
export const AudienceIntegrationsDocument = gql`
    query AudienceIntegrations($audienceId: ID!, $pageNumber: Int!, $pageItemsCount: Int!, $searchQuery: String) {
  audience(id: $audienceId) {
    integrationsPage(
      pageNumber: $pageNumber
      pageItemsCount: $pageItemsCount
      searchQuery: $searchQuery
    ) {
      nodes {
        id
        name
        integrationType
        lastSuccessfulRunAt
        lastRunSucceeded
        lastRunAt
        configuration {
          ... on ActivationAudienceIntegrationConfiguration {
            activationType
          }
        }
      }
      totalCount
    }
  }
}
    `;

/**
 * __useAudienceIntegrationsQuery__
 *
 * To run a query within a React component, call `useAudienceIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceIntegrationsQuery({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useAudienceIntegrationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AudienceIntegrationsQuery, AudienceIntegrationsQueryVariables> & ({ variables: AudienceIntegrationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AudienceIntegrationsQuery, AudienceIntegrationsQueryVariables>(AudienceIntegrationsDocument, options);
      }
export function useAudienceIntegrationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AudienceIntegrationsQuery, AudienceIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AudienceIntegrationsQuery, AudienceIntegrationsQueryVariables>(AudienceIntegrationsDocument, options);
        }
// @ts-ignore
export function useAudienceIntegrationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AudienceIntegrationsQuery, AudienceIntegrationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AudienceIntegrationsQuery, AudienceIntegrationsQueryVariables>;
export function useAudienceIntegrationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AudienceIntegrationsQuery, AudienceIntegrationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AudienceIntegrationsQuery | undefined, AudienceIntegrationsQueryVariables>;
export function useAudienceIntegrationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AudienceIntegrationsQuery, AudienceIntegrationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AudienceIntegrationsQuery, AudienceIntegrationsQueryVariables>(AudienceIntegrationsDocument, options);
        }
export type AudienceIntegrationsQueryHookResult = ReturnType<typeof useAudienceIntegrationsQuery>;
export type AudienceIntegrationsLazyQueryHookResult = ReturnType<typeof useAudienceIntegrationsLazyQuery>;
export type AudienceIntegrationsSuspenseQueryHookResult = ReturnType<typeof useAudienceIntegrationsSuspenseQuery>;
export type AudienceIntegrationsQueryResult = ApolloReactHooks.QueryResult<AudienceIntegrationsQuery, AudienceIntegrationsQueryVariables>;
export const InvitesAudienceDocument = gql`
    query InvitesAudience($audienceId: ID!) {
  audience(id: $audienceId) {
    id
    pendingInvites {
      id
      email
      user {
        id
        firstName
        lastName
        email
        phone
        imageUrl
      }
    }
  }
}
    `;

/**
 * __useInvitesAudienceQuery__
 *
 * To run a query within a React component, call `useInvitesAudienceQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitesAudienceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitesAudienceQuery({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *   },
 * });
 */
export function useInvitesAudienceQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InvitesAudienceQuery, InvitesAudienceQueryVariables> & ({ variables: InvitesAudienceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InvitesAudienceQuery, InvitesAudienceQueryVariables>(InvitesAudienceDocument, options);
      }
export function useInvitesAudienceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InvitesAudienceQuery, InvitesAudienceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InvitesAudienceQuery, InvitesAudienceQueryVariables>(InvitesAudienceDocument, options);
        }
// @ts-ignore
export function useInvitesAudienceSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InvitesAudienceQuery, InvitesAudienceQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InvitesAudienceQuery, InvitesAudienceQueryVariables>;
export function useInvitesAudienceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InvitesAudienceQuery, InvitesAudienceQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InvitesAudienceQuery | undefined, InvitesAudienceQueryVariables>;
export function useInvitesAudienceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InvitesAudienceQuery, InvitesAudienceQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InvitesAudienceQuery, InvitesAudienceQueryVariables>(InvitesAudienceDocument, options);
        }
export type InvitesAudienceQueryHookResult = ReturnType<typeof useInvitesAudienceQuery>;
export type InvitesAudienceLazyQueryHookResult = ReturnType<typeof useInvitesAudienceLazyQuery>;
export type InvitesAudienceSuspenseQueryHookResult = ReturnType<typeof useInvitesAudienceSuspenseQuery>;
export type InvitesAudienceQueryResult = ApolloReactHooks.QueryResult<InvitesAudienceQuery, InvitesAudienceQueryVariables>;
export const JourneyTopPathsDocument = gql`
    query JourneyTopPaths($audienceId: ID!, $count: Int!, $filters: [PersonFilterInput!]) {
  audience(id: $audienceId) {
    journeyTopPaths(count: $count, filters: $filters) {
      count
      paths {
        count
        pathPrefix
      }
    }
  }
}
    `;

/**
 * __useJourneyTopPathsQuery__
 *
 * To run a query within a React component, call `useJourneyTopPathsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJourneyTopPathsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJourneyTopPathsQuery({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *      count: // value for 'count'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useJourneyTopPathsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<JourneyTopPathsQuery, JourneyTopPathsQueryVariables> & ({ variables: JourneyTopPathsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<JourneyTopPathsQuery, JourneyTopPathsQueryVariables>(JourneyTopPathsDocument, options);
      }
export function useJourneyTopPathsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<JourneyTopPathsQuery, JourneyTopPathsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<JourneyTopPathsQuery, JourneyTopPathsQueryVariables>(JourneyTopPathsDocument, options);
        }
// @ts-ignore
export function useJourneyTopPathsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<JourneyTopPathsQuery, JourneyTopPathsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<JourneyTopPathsQuery, JourneyTopPathsQueryVariables>;
export function useJourneyTopPathsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<JourneyTopPathsQuery, JourneyTopPathsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<JourneyTopPathsQuery | undefined, JourneyTopPathsQueryVariables>;
export function useJourneyTopPathsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<JourneyTopPathsQuery, JourneyTopPathsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<JourneyTopPathsQuery, JourneyTopPathsQueryVariables>(JourneyTopPathsDocument, options);
        }
export type JourneyTopPathsQueryHookResult = ReturnType<typeof useJourneyTopPathsQuery>;
export type JourneyTopPathsLazyQueryHookResult = ReturnType<typeof useJourneyTopPathsLazyQuery>;
export type JourneyTopPathsSuspenseQueryHookResult = ReturnType<typeof useJourneyTopPathsSuspenseQuery>;
export type JourneyTopPathsQueryResult = ApolloReactHooks.QueryResult<JourneyTopPathsQuery, JourneyTopPathsQueryVariables>;
export const AudienceJourneyTopUrlsDocument = gql`
    query AudienceJourneyTopUrls($audienceId: ID!, $count: Int!, $filters: [PersonFilterInput!]) {
  audience(id: $audienceId) {
    journeyTopUrls(count: $count, filters: $filters)
  }
}
    `;

/**
 * __useAudienceJourneyTopUrlsQuery__
 *
 * To run a query within a React component, call `useAudienceJourneyTopUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceJourneyTopUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceJourneyTopUrlsQuery({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *      count: // value for 'count'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAudienceJourneyTopUrlsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AudienceJourneyTopUrlsQuery, AudienceJourneyTopUrlsQueryVariables> & ({ variables: AudienceJourneyTopUrlsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AudienceJourneyTopUrlsQuery, AudienceJourneyTopUrlsQueryVariables>(AudienceJourneyTopUrlsDocument, options);
      }
export function useAudienceJourneyTopUrlsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AudienceJourneyTopUrlsQuery, AudienceJourneyTopUrlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AudienceJourneyTopUrlsQuery, AudienceJourneyTopUrlsQueryVariables>(AudienceJourneyTopUrlsDocument, options);
        }
// @ts-ignore
export function useAudienceJourneyTopUrlsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AudienceJourneyTopUrlsQuery, AudienceJourneyTopUrlsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AudienceJourneyTopUrlsQuery, AudienceJourneyTopUrlsQueryVariables>;
export function useAudienceJourneyTopUrlsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AudienceJourneyTopUrlsQuery, AudienceJourneyTopUrlsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AudienceJourneyTopUrlsQuery | undefined, AudienceJourneyTopUrlsQueryVariables>;
export function useAudienceJourneyTopUrlsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AudienceJourneyTopUrlsQuery, AudienceJourneyTopUrlsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AudienceJourneyTopUrlsQuery, AudienceJourneyTopUrlsQueryVariables>(AudienceJourneyTopUrlsDocument, options);
        }
export type AudienceJourneyTopUrlsQueryHookResult = ReturnType<typeof useAudienceJourneyTopUrlsQuery>;
export type AudienceJourneyTopUrlsLazyQueryHookResult = ReturnType<typeof useAudienceJourneyTopUrlsLazyQuery>;
export type AudienceJourneyTopUrlsSuspenseQueryHookResult = ReturnType<typeof useAudienceJourneyTopUrlsSuspenseQuery>;
export type AudienceJourneyTopUrlsQueryResult = ApolloReactHooks.QueryResult<AudienceJourneyTopUrlsQuery, AudienceJourneyTopUrlsQueryVariables>;
export const AudienceLookalikeCountDocument = gql`
    query AudienceLookalikeCount($audienceLookalikeCountParams: AudienceLookalikeCountInput!) {
  audienceLookalikeCount(
    audienceLookalikeCountParams: $audienceLookalikeCountParams
  )
}
    `;

/**
 * __useAudienceLookalikeCountQuery__
 *
 * To run a query within a React component, call `useAudienceLookalikeCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceLookalikeCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceLookalikeCountQuery({
 *   variables: {
 *      audienceLookalikeCountParams: // value for 'audienceLookalikeCountParams'
 *   },
 * });
 */
export function useAudienceLookalikeCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AudienceLookalikeCountQuery, AudienceLookalikeCountQueryVariables> & ({ variables: AudienceLookalikeCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AudienceLookalikeCountQuery, AudienceLookalikeCountQueryVariables>(AudienceLookalikeCountDocument, options);
      }
export function useAudienceLookalikeCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AudienceLookalikeCountQuery, AudienceLookalikeCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AudienceLookalikeCountQuery, AudienceLookalikeCountQueryVariables>(AudienceLookalikeCountDocument, options);
        }
// @ts-ignore
export function useAudienceLookalikeCountSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AudienceLookalikeCountQuery, AudienceLookalikeCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AudienceLookalikeCountQuery, AudienceLookalikeCountQueryVariables>;
export function useAudienceLookalikeCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AudienceLookalikeCountQuery, AudienceLookalikeCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AudienceLookalikeCountQuery | undefined, AudienceLookalikeCountQueryVariables>;
export function useAudienceLookalikeCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AudienceLookalikeCountQuery, AudienceLookalikeCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AudienceLookalikeCountQuery, AudienceLookalikeCountQueryVariables>(AudienceLookalikeCountDocument, options);
        }
export type AudienceLookalikeCountQueryHookResult = ReturnType<typeof useAudienceLookalikeCountQuery>;
export type AudienceLookalikeCountLazyQueryHookResult = ReturnType<typeof useAudienceLookalikeCountLazyQuery>;
export type AudienceLookalikeCountSuspenseQueryHookResult = ReturnType<typeof useAudienceLookalikeCountSuspenseQuery>;
export type AudienceLookalikeCountQueryResult = ApolloReactHooks.QueryResult<AudienceLookalikeCountQuery, AudienceLookalikeCountQueryVariables>;
export const AudienceOverviewDocument = gql`
    query AudienceOverview($audienceId: ID!) {
  audience(id: $audienceId) {
    id
    name
    deepLink
    condition
    createdAt
    peopleCount
    processingStatus
    verifyEmails
    audienceOnlyAccess
    quotaInfo {
      currentCount
      limit
      period
    }
    baseAudience {
      id
      name
      condition
      parentAudience {
        id
        name
        condition
        createdAt
      }
    }
    userRoles {
      id
      user {
        id
        firstName
        lastName
        email
        phone
        imageUrl
      }
    }
    organization {
      name
      id
      imageUrl
      hiddenPeopleFields
      businessDataEnabled
      matchbackEnabled
      organizationType
      __typename
      ... on Organization {
        imageUrl
        ...DisableEmailValidationFields
        userRoles {
          id
          user {
            id
          }
        }
        paidSubscription
        defaultS3OutputObjectKeyTemplate
        parentOrganization {
          id
          name
          ... on Organization {
            imageUrl
            userRoles {
              id
              user {
                id
              }
            }
            parentOrganization {
              id
              name
              ... on Organization {
                imageUrl
                userRoles {
                  id
                  user {
                    id
                  }
                }
              }
            }
          }
        }
      }
    }
    pixelSettings {
      pixelId
      hostAndPath
      pixelDisabledAt
      pixelEnabled
      pixelStatus
      pixelReachedQuotaAt
      quotaEnabled
      pixelMatchingCadence
      quota {
        limit
        period
      }
      location {
        address
        city
        state
      }
      codeSnippets {
        head
        body
      }
      billing {
        dayOfMonth
      }
    }
    parentAudience {
      id
      name
      createdAt
      condition
      ... on Audience {
        peopleCount
        pixelSettings {
          pixelMatchingCadence
        }
      }
      ...Categories
      ...FilterFields
      info {
        ... on AudiencePulseInfo {
          ...PulseInfoFields
        }
        ... on AudienceGlobalInfo {
          ...GlobalInfoFields
        }
        ... on AudienceLookalikeInfo {
          ...LookalikeInfoFields
        }
        ... on AudienceCustomerListInfo {
          ...CustomerListInfoFields
        }
      }
    }
    ...FilterFields
    segmentsCount
    lookalikesCount
    segments {
      id
      name
      creator {
        id
        imageUrl
        firstName
        lastName
      }
      organization {
        id
        name
      }
      condition
      peopleCount
      organizationId
    }
    ...Categories
    info {
      ... on AudienceLookalikeInfo {
        ...LookalikeInfoFields
      }
      ... on AudiencePulseInfo {
        ...PulseInfoFields
      }
      ... on AudienceGlobalInfo {
        ...GlobalInfoFields
      }
      ... on AudienceCustomerListInfo {
        ...CustomerListInfoFields
      }
    }
    customFields {
      name
      fieldType
    }
    processingResultInfo {
      ... on CustomerListInvalidImportData {
        invalidEntries {
          value
          fieldType
          columnName
          rowNumber
        }
      }
    }
  }
}
    ${DisableEmailValidationFieldsFragmentDoc}
${CategoriesFragmentDoc}
${FilterFieldsFragmentDoc}
${PulseInfoFieldsFragmentDoc}
${GlobalInfoFieldsFragmentDoc}
${LookalikeInfoFieldsFragmentDoc}
${CustomerListInfoFieldsFragmentDoc}`;

/**
 * __useAudienceOverviewQuery__
 *
 * To run a query within a React component, call `useAudienceOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceOverviewQuery({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *   },
 * });
 */
export function useAudienceOverviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AudienceOverviewQuery, AudienceOverviewQueryVariables> & ({ variables: AudienceOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AudienceOverviewQuery, AudienceOverviewQueryVariables>(AudienceOverviewDocument, options);
      }
export function useAudienceOverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AudienceOverviewQuery, AudienceOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AudienceOverviewQuery, AudienceOverviewQueryVariables>(AudienceOverviewDocument, options);
        }
// @ts-ignore
export function useAudienceOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AudienceOverviewQuery, AudienceOverviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AudienceOverviewQuery, AudienceOverviewQueryVariables>;
export function useAudienceOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AudienceOverviewQuery, AudienceOverviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AudienceOverviewQuery | undefined, AudienceOverviewQueryVariables>;
export function useAudienceOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AudienceOverviewQuery, AudienceOverviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AudienceOverviewQuery, AudienceOverviewQueryVariables>(AudienceOverviewDocument, options);
        }
export type AudienceOverviewQueryHookResult = ReturnType<typeof useAudienceOverviewQuery>;
export type AudienceOverviewLazyQueryHookResult = ReturnType<typeof useAudienceOverviewLazyQuery>;
export type AudienceOverviewSuspenseQueryHookResult = ReturnType<typeof useAudienceOverviewSuspenseQuery>;
export type AudienceOverviewQueryResult = ApolloReactHooks.QueryResult<AudienceOverviewQuery, AudienceOverviewQueryVariables>;
export const AudiencePeoplePageDocument = gql`
    query AudiencePeoplePage($pageNumber: Int!, $audienceId: ID!, $pageItemsCount: Int!, $searchQuery: String, $filters: [PersonFilterInput], $sort: [SortFieldInput], $matchbackComparisons: MatchbackComparisonsFilterInput, $customBooleanFieldsFields: [String!]!, $customDateFieldsFields: [String!]!, $customIntegerFieldsFields: [String!]!, $customStringFieldsFields: [String!]!) {
  audience(id: $audienceId) {
    peoplePage(
      pageNumber: $pageNumber
      pageItemsCount: $pageItemsCount
      searchQuery: $searchQuery
      filters: $filters
      sort: $sort
      matchbackComparisons: $matchbackComparisons
    ) {
      totalCount
      nodes {
        address
        adultsInHousehold
        age
        behaviors
        bebacks
        childrenAgeRanges
        childrenBetweenAges0_3
        childrenBetweenAges10_12
        childrenBetweenAges13_18
        childrenBetweenAges4_6
        childrenBetweenAges7_9
        childrenInHousehold
        city
        creditRange
        dwellingType
        education
        email
        emailVerificationDate
        pixelLastIpLocation {
          countryName
          countryCode
          regionName
          postalCode
          city
        }
        ethnicGroup
        firstName
        dnc
        dma
        optIn
        optInDate
        optInIp
        optInUrl
        gender
        generation
        homeHeatType
        homeOwner
        homePrice
        homePurchasedYearsAgo
        homeValue
        householdIncome
        householdNetWorth
        id
        incomeLevels
        interests
        isMultilingual
        isPoliticalContributor
        isPrimaryResidence
        language
        lastName
        maid
        maidOs
        maritalStatus
        mortgageAge
        mortgageAmount
        mortgageLoanType
        mortgageRefinanceAge
        mortgageRefinanceAmount
        mortgageRefinanceType
        netWorth
        newCreditOfferedHousehold
        numberOfVehiclesInHousehold
        occupationDetail
        ownsAmexCard
        ownsBankCard
        ownsCreditCard
        ownsInvestment
        ownsPremiumAmexCard
        ownsPremiumCard
        ownsStocksAndBonds
        peopleInHousehold
        personality
        phone
        politicalParty
        premiumIncomeHousehold
        pixelLastHitDate
        pixelFirstHitDate
        religion
        social {
          facebook
          linkedIn
          twitter
        }
        state
        urbanicity
        veteransInHousehold
        zip
        companyName
        companyRevenue
        department
        jobTitle
        primaryIndustry
        seniorityLevel
        companyCity
        companyDomain
        companyEmployeeCount
        companySic
        companyState
        businessEmail
        zip4
        zip
        dpbc
        dpv
        carrierRoute
        fipsStateCode
        fipsCountyCode
        countyName
        customBooleanFields(fields: $customBooleanFieldsFields)
        customDateFields(fields: $customDateFieldsFields)
        customIntegerFields(fields: $customIntegerFieldsFields)
        customStringFields(fields: $customStringFieldsFields)
        beeswaxIds
        ipAddresses
        maids {
          maid
          os
        }
        hemsMd5
        hemsSha1
        hemsSha256
        hemsMd5Uppercase
        hemsSha1Uppercase
        hemsSha256Uppercase
        matchbackComparisonsCount
        matchbackComparisons {
          id
          dateRanges {
            from
            to
          }
          audience {
            id
            name
            condition
            deletedAt
            __typename
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAudiencePeoplePageQuery__
 *
 * To run a query within a React component, call `useAudiencePeoplePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudiencePeoplePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudiencePeoplePageQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      audienceId: // value for 'audienceId'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      searchQuery: // value for 'searchQuery'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      matchbackComparisons: // value for 'matchbackComparisons'
 *      customBooleanFieldsFields: // value for 'customBooleanFieldsFields'
 *      customDateFieldsFields: // value for 'customDateFieldsFields'
 *      customIntegerFieldsFields: // value for 'customIntegerFieldsFields'
 *      customStringFieldsFields: // value for 'customStringFieldsFields'
 *   },
 * });
 */
export function useAudiencePeoplePageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AudiencePeoplePageQuery, AudiencePeoplePageQueryVariables> & ({ variables: AudiencePeoplePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AudiencePeoplePageQuery, AudiencePeoplePageQueryVariables>(AudiencePeoplePageDocument, options);
      }
export function useAudiencePeoplePageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AudiencePeoplePageQuery, AudiencePeoplePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AudiencePeoplePageQuery, AudiencePeoplePageQueryVariables>(AudiencePeoplePageDocument, options);
        }
// @ts-ignore
export function useAudiencePeoplePageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AudiencePeoplePageQuery, AudiencePeoplePageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AudiencePeoplePageQuery, AudiencePeoplePageQueryVariables>;
export function useAudiencePeoplePageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AudiencePeoplePageQuery, AudiencePeoplePageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AudiencePeoplePageQuery | undefined, AudiencePeoplePageQueryVariables>;
export function useAudiencePeoplePageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AudiencePeoplePageQuery, AudiencePeoplePageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AudiencePeoplePageQuery, AudiencePeoplePageQueryVariables>(AudiencePeoplePageDocument, options);
        }
export type AudiencePeoplePageQueryHookResult = ReturnType<typeof useAudiencePeoplePageQuery>;
export type AudiencePeoplePageLazyQueryHookResult = ReturnType<typeof useAudiencePeoplePageLazyQuery>;
export type AudiencePeoplePageSuspenseQueryHookResult = ReturnType<typeof useAudiencePeoplePageSuspenseQuery>;
export type AudiencePeoplePageQueryResult = ApolloReactHooks.QueryResult<AudiencePeoplePageQuery, AudiencePeoplePageQueryVariables>;
export const AudiencePeopleCountsDocument = gql`
    query AudiencePeopleCounts($field: FilterStringField!, $audienceId: ID!, $filters: [PersonFilterInput], $takeIntoAccountSameFieldFilters: Boolean) {
  audience(id: $audienceId) {
    peopleCounts(
      field: $field
      filters: $filters
      takeIntoAccountSameFieldFilters: $takeIntoAccountSameFieldFilters
    ) {
      count
      key
    }
  }
}
    `;

/**
 * __useAudiencePeopleCountsQuery__
 *
 * To run a query within a React component, call `useAudiencePeopleCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudiencePeopleCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudiencePeopleCountsQuery({
 *   variables: {
 *      field: // value for 'field'
 *      audienceId: // value for 'audienceId'
 *      filters: // value for 'filters'
 *      takeIntoAccountSameFieldFilters: // value for 'takeIntoAccountSameFieldFilters'
 *   },
 * });
 */
export function useAudiencePeopleCountsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AudiencePeopleCountsQuery, AudiencePeopleCountsQueryVariables> & ({ variables: AudiencePeopleCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AudiencePeopleCountsQuery, AudiencePeopleCountsQueryVariables>(AudiencePeopleCountsDocument, options);
      }
export function useAudiencePeopleCountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AudiencePeopleCountsQuery, AudiencePeopleCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AudiencePeopleCountsQuery, AudiencePeopleCountsQueryVariables>(AudiencePeopleCountsDocument, options);
        }
// @ts-ignore
export function useAudiencePeopleCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AudiencePeopleCountsQuery, AudiencePeopleCountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AudiencePeopleCountsQuery, AudiencePeopleCountsQueryVariables>;
export function useAudiencePeopleCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AudiencePeopleCountsQuery, AudiencePeopleCountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AudiencePeopleCountsQuery | undefined, AudiencePeopleCountsQueryVariables>;
export function useAudiencePeopleCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AudiencePeopleCountsQuery, AudiencePeopleCountsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AudiencePeopleCountsQuery, AudiencePeopleCountsQueryVariables>(AudiencePeopleCountsDocument, options);
        }
export type AudiencePeopleCountsQueryHookResult = ReturnType<typeof useAudiencePeopleCountsQuery>;
export type AudiencePeopleCountsLazyQueryHookResult = ReturnType<typeof useAudiencePeopleCountsLazyQuery>;
export type AudiencePeopleCountsSuspenseQueryHookResult = ReturnType<typeof useAudiencePeopleCountsSuspenseQuery>;
export type AudiencePeopleCountsQueryResult = ApolloReactHooks.QueryResult<AudiencePeopleCountsQuery, AudiencePeopleCountsQueryVariables>;
export const AudiencePeopleNumberHistogramDocument = gql`
    query AudiencePeopleNumberHistogram($field: FilterNumberField!, $audienceId: ID!, $interval: Int, $min: Int, $max: Int, $filters: [PersonFilterInput], $takeIntoAccountSameFieldFilters: Boolean) {
  audience(id: $audienceId) {
    peopleNumberHistogram(
      field: $field
      interval: $interval
      min: $min
      max: $max
      filters: $filters
      takeIntoAccountSameFieldFilters: $takeIntoAccountSameFieldFilters
    ) {
      count
      key
    }
  }
}
    `;

/**
 * __useAudiencePeopleNumberHistogramQuery__
 *
 * To run a query within a React component, call `useAudiencePeopleNumberHistogramQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudiencePeopleNumberHistogramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudiencePeopleNumberHistogramQuery({
 *   variables: {
 *      field: // value for 'field'
 *      audienceId: // value for 'audienceId'
 *      interval: // value for 'interval'
 *      min: // value for 'min'
 *      max: // value for 'max'
 *      filters: // value for 'filters'
 *      takeIntoAccountSameFieldFilters: // value for 'takeIntoAccountSameFieldFilters'
 *   },
 * });
 */
export function useAudiencePeopleNumberHistogramQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AudiencePeopleNumberHistogramQuery, AudiencePeopleNumberHistogramQueryVariables> & ({ variables: AudiencePeopleNumberHistogramQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AudiencePeopleNumberHistogramQuery, AudiencePeopleNumberHistogramQueryVariables>(AudiencePeopleNumberHistogramDocument, options);
      }
export function useAudiencePeopleNumberHistogramLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AudiencePeopleNumberHistogramQuery, AudiencePeopleNumberHistogramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AudiencePeopleNumberHistogramQuery, AudiencePeopleNumberHistogramQueryVariables>(AudiencePeopleNumberHistogramDocument, options);
        }
// @ts-ignore
export function useAudiencePeopleNumberHistogramSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AudiencePeopleNumberHistogramQuery, AudiencePeopleNumberHistogramQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AudiencePeopleNumberHistogramQuery, AudiencePeopleNumberHistogramQueryVariables>;
export function useAudiencePeopleNumberHistogramSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AudiencePeopleNumberHistogramQuery, AudiencePeopleNumberHistogramQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AudiencePeopleNumberHistogramQuery | undefined, AudiencePeopleNumberHistogramQueryVariables>;
export function useAudiencePeopleNumberHistogramSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AudiencePeopleNumberHistogramQuery, AudiencePeopleNumberHistogramQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AudiencePeopleNumberHistogramQuery, AudiencePeopleNumberHistogramQueryVariables>(AudiencePeopleNumberHistogramDocument, options);
        }
export type AudiencePeopleNumberHistogramQueryHookResult = ReturnType<typeof useAudiencePeopleNumberHistogramQuery>;
export type AudiencePeopleNumberHistogramLazyQueryHookResult = ReturnType<typeof useAudiencePeopleNumberHistogramLazyQuery>;
export type AudiencePeopleNumberHistogramSuspenseQueryHookResult = ReturnType<typeof useAudiencePeopleNumberHistogramSuspenseQuery>;
export type AudiencePeopleNumberHistogramQueryResult = ApolloReactHooks.QueryResult<AudiencePeopleNumberHistogramQuery, AudiencePeopleNumberHistogramQueryVariables>;
export const AudienceS3PathDocument = gql`
    query AudienceS3Path($audienceId: ID!) {
  audience(id: $audienceId) {
    s3IntegrationTestPath
  }
}
    `;

/**
 * __useAudienceS3PathQuery__
 *
 * To run a query within a React component, call `useAudienceS3PathQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceS3PathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceS3PathQuery({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *   },
 * });
 */
export function useAudienceS3PathQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AudienceS3PathQuery, AudienceS3PathQueryVariables> & ({ variables: AudienceS3PathQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AudienceS3PathQuery, AudienceS3PathQueryVariables>(AudienceS3PathDocument, options);
      }
export function useAudienceS3PathLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AudienceS3PathQuery, AudienceS3PathQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AudienceS3PathQuery, AudienceS3PathQueryVariables>(AudienceS3PathDocument, options);
        }
// @ts-ignore
export function useAudienceS3PathSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AudienceS3PathQuery, AudienceS3PathQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AudienceS3PathQuery, AudienceS3PathQueryVariables>;
export function useAudienceS3PathSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AudienceS3PathQuery, AudienceS3PathQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AudienceS3PathQuery | undefined, AudienceS3PathQueryVariables>;
export function useAudienceS3PathSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AudienceS3PathQuery, AudienceS3PathQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AudienceS3PathQuery, AudienceS3PathQueryVariables>(AudienceS3PathDocument, options);
        }
export type AudienceS3PathQueryHookResult = ReturnType<typeof useAudienceS3PathQuery>;
export type AudienceS3PathLazyQueryHookResult = ReturnType<typeof useAudienceS3PathLazyQuery>;
export type AudienceS3PathSuspenseQueryHookResult = ReturnType<typeof useAudienceS3PathSuspenseQuery>;
export type AudienceS3PathQueryResult = ApolloReactHooks.QueryResult<AudienceS3PathQuery, AudienceS3PathQueryVariables>;
export const AudiencesPageDocument = gql`
    query AudiencesPage($pageNumber: Int!, $pageItemsCount: Int!, $organizationId: ID, $searchQuery: String, $conditions: [AudienceCondition!], $pixelStatus: AudiencePixelStatus, $filters: [AudienceFilterInput!]) {
  audiencesPage(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    organizationId: $organizationId
    searchQuery: $searchQuery
    conditions: $conditions
    pixelStatus: $pixelStatus
    filters: $filters
  ) {
    nodes {
      id
      name
      condition
      createdAt
      peopleCount
      organizationId
      creator {
        id
        firstName
        lastName
        imageUrl
      }
      organization {
        id
        name
      }
      pixelSettings {
        pixelEnabled
        pixelStatus
        quotaEnabled
      }
      processingStatus
      parentAudience {
        id
        createdAt
        condition
      }
      quotaInfo {
        currentCount
        limit
      }
    }
    totalCount
    pageInfo {
      hasNextPage
    }
  }
}
    `;

/**
 * __useAudiencesPageQuery__
 *
 * To run a query within a React component, call `useAudiencesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudiencesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudiencesPageQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      organizationId: // value for 'organizationId'
 *      searchQuery: // value for 'searchQuery'
 *      conditions: // value for 'conditions'
 *      pixelStatus: // value for 'pixelStatus'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAudiencesPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AudiencesPageQuery, AudiencesPageQueryVariables> & ({ variables: AudiencesPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AudiencesPageQuery, AudiencesPageQueryVariables>(AudiencesPageDocument, options);
      }
export function useAudiencesPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AudiencesPageQuery, AudiencesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AudiencesPageQuery, AudiencesPageQueryVariables>(AudiencesPageDocument, options);
        }
// @ts-ignore
export function useAudiencesPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AudiencesPageQuery, AudiencesPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AudiencesPageQuery, AudiencesPageQueryVariables>;
export function useAudiencesPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AudiencesPageQuery, AudiencesPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AudiencesPageQuery | undefined, AudiencesPageQueryVariables>;
export function useAudiencesPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AudiencesPageQuery, AudiencesPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AudiencesPageQuery, AudiencesPageQueryVariables>(AudiencesPageDocument, options);
        }
export type AudiencesPageQueryHookResult = ReturnType<typeof useAudiencesPageQuery>;
export type AudiencesPageLazyQueryHookResult = ReturnType<typeof useAudiencesPageLazyQuery>;
export type AudiencesPageSuspenseQueryHookResult = ReturnType<typeof useAudiencesPageSuspenseQuery>;
export type AudiencesPageQueryResult = ApolloReactHooks.QueryResult<AudiencesPageQuery, AudiencesPageQueryVariables>;
export const AvailableGlobalPeopleCountDocument = gql`
    query AvailableGlobalPeopleCount($filters: [PersonFilterInput]!, $addingToGlobalAudienceId: ID) {
  peopleSnapshot(
    filters: $filters
    addingToGlobalAudienceId: $addingToGlobalAudienceId
  ) {
    totalCount
  }
}
    `;

/**
 * __useAvailableGlobalPeopleCountQuery__
 *
 * To run a query within a React component, call `useAvailableGlobalPeopleCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableGlobalPeopleCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableGlobalPeopleCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      addingToGlobalAudienceId: // value for 'addingToGlobalAudienceId'
 *   },
 * });
 */
export function useAvailableGlobalPeopleCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AvailableGlobalPeopleCountQuery, AvailableGlobalPeopleCountQueryVariables> & ({ variables: AvailableGlobalPeopleCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AvailableGlobalPeopleCountQuery, AvailableGlobalPeopleCountQueryVariables>(AvailableGlobalPeopleCountDocument, options);
      }
export function useAvailableGlobalPeopleCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AvailableGlobalPeopleCountQuery, AvailableGlobalPeopleCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AvailableGlobalPeopleCountQuery, AvailableGlobalPeopleCountQueryVariables>(AvailableGlobalPeopleCountDocument, options);
        }
// @ts-ignore
export function useAvailableGlobalPeopleCountSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AvailableGlobalPeopleCountQuery, AvailableGlobalPeopleCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AvailableGlobalPeopleCountQuery, AvailableGlobalPeopleCountQueryVariables>;
export function useAvailableGlobalPeopleCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AvailableGlobalPeopleCountQuery, AvailableGlobalPeopleCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AvailableGlobalPeopleCountQuery | undefined, AvailableGlobalPeopleCountQueryVariables>;
export function useAvailableGlobalPeopleCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AvailableGlobalPeopleCountQuery, AvailableGlobalPeopleCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AvailableGlobalPeopleCountQuery, AvailableGlobalPeopleCountQueryVariables>(AvailableGlobalPeopleCountDocument, options);
        }
export type AvailableGlobalPeopleCountQueryHookResult = ReturnType<typeof useAvailableGlobalPeopleCountQuery>;
export type AvailableGlobalPeopleCountLazyQueryHookResult = ReturnType<typeof useAvailableGlobalPeopleCountLazyQuery>;
export type AvailableGlobalPeopleCountSuspenseQueryHookResult = ReturnType<typeof useAvailableGlobalPeopleCountSuspenseQuery>;
export type AvailableGlobalPeopleCountQueryResult = ApolloReactHooks.QueryResult<AvailableGlobalPeopleCountQuery, AvailableGlobalPeopleCountQueryVariables>;
export const BeeswaxCreateSegmentDocument = gql`
    mutation BeeswaxCreateSegment($input: BeeswaxCreateSegmentInput!) {
  beeswaxCreateSegment(input: $input) {
    id
    name
  }
}
    `;
export type BeeswaxCreateSegmentMutationFn = ApolloReactHooks.useMutation.MutationFunction<BeeswaxCreateSegmentMutation, BeeswaxCreateSegmentMutationVariables>;

/**
 * __useBeeswaxCreateSegmentMutation__
 *
 * To run a mutation, you first call `useBeeswaxCreateSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBeeswaxCreateSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [beeswaxCreateSegmentMutation, { data, loading, error }] = useBeeswaxCreateSegmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBeeswaxCreateSegmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BeeswaxCreateSegmentMutation, BeeswaxCreateSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BeeswaxCreateSegmentMutation, BeeswaxCreateSegmentMutationVariables>(BeeswaxCreateSegmentDocument, options);
      }
export type BeeswaxCreateSegmentMutationHookResult = ReturnType<typeof useBeeswaxCreateSegmentMutation>;
export type BeeswaxCreateSegmentMutationResult = ApolloReactHooks.MutationResult<BeeswaxCreateSegmentMutation>;
export type BeeswaxCreateSegmentMutationOptions = Apollo.MutationOptions<BeeswaxCreateSegmentMutation, BeeswaxCreateSegmentMutationVariables>;
export const BeeswaxGetSegmentDocument = gql`
    query BeeswaxGetSegment($input: BeeswaxGetSegmentInput!) {
  beeswaxGetSegment(input: $input) {
    id
    name
  }
}
    `;

/**
 * __useBeeswaxGetSegmentQuery__
 *
 * To run a query within a React component, call `useBeeswaxGetSegmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useBeeswaxGetSegmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBeeswaxGetSegmentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBeeswaxGetSegmentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BeeswaxGetSegmentQuery, BeeswaxGetSegmentQueryVariables> & ({ variables: BeeswaxGetSegmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BeeswaxGetSegmentQuery, BeeswaxGetSegmentQueryVariables>(BeeswaxGetSegmentDocument, options);
      }
export function useBeeswaxGetSegmentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BeeswaxGetSegmentQuery, BeeswaxGetSegmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BeeswaxGetSegmentQuery, BeeswaxGetSegmentQueryVariables>(BeeswaxGetSegmentDocument, options);
        }
// @ts-ignore
export function useBeeswaxGetSegmentSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BeeswaxGetSegmentQuery, BeeswaxGetSegmentQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BeeswaxGetSegmentQuery, BeeswaxGetSegmentQueryVariables>;
export function useBeeswaxGetSegmentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BeeswaxGetSegmentQuery, BeeswaxGetSegmentQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BeeswaxGetSegmentQuery | undefined, BeeswaxGetSegmentQueryVariables>;
export function useBeeswaxGetSegmentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BeeswaxGetSegmentQuery, BeeswaxGetSegmentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BeeswaxGetSegmentQuery, BeeswaxGetSegmentQueryVariables>(BeeswaxGetSegmentDocument, options);
        }
export type BeeswaxGetSegmentQueryHookResult = ReturnType<typeof useBeeswaxGetSegmentQuery>;
export type BeeswaxGetSegmentLazyQueryHookResult = ReturnType<typeof useBeeswaxGetSegmentLazyQuery>;
export type BeeswaxGetSegmentSuspenseQueryHookResult = ReturnType<typeof useBeeswaxGetSegmentSuspenseQuery>;
export type BeeswaxGetSegmentQueryResult = ApolloReactHooks.QueryResult<BeeswaxGetSegmentQuery, BeeswaxGetSegmentQueryVariables>;
export const BeeswaxListSegmentsDocument = gql`
    query BeeswaxListSegments($input: BeeswaxListSegmentsInput!) {
  beeswaxListSegments(input: $input) {
    items {
      id
      name
    }
    hasNextPage
    nextCursor
  }
}
    `;

/**
 * __useBeeswaxListSegmentsQuery__
 *
 * To run a query within a React component, call `useBeeswaxListSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBeeswaxListSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBeeswaxListSegmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBeeswaxListSegmentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BeeswaxListSegmentsQuery, BeeswaxListSegmentsQueryVariables> & ({ variables: BeeswaxListSegmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BeeswaxListSegmentsQuery, BeeswaxListSegmentsQueryVariables>(BeeswaxListSegmentsDocument, options);
      }
export function useBeeswaxListSegmentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BeeswaxListSegmentsQuery, BeeswaxListSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BeeswaxListSegmentsQuery, BeeswaxListSegmentsQueryVariables>(BeeswaxListSegmentsDocument, options);
        }
// @ts-ignore
export function useBeeswaxListSegmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BeeswaxListSegmentsQuery, BeeswaxListSegmentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BeeswaxListSegmentsQuery, BeeswaxListSegmentsQueryVariables>;
export function useBeeswaxListSegmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BeeswaxListSegmentsQuery, BeeswaxListSegmentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BeeswaxListSegmentsQuery | undefined, BeeswaxListSegmentsQueryVariables>;
export function useBeeswaxListSegmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BeeswaxListSegmentsQuery, BeeswaxListSegmentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BeeswaxListSegmentsQuery, BeeswaxListSegmentsQueryVariables>(BeeswaxListSegmentsDocument, options);
        }
export type BeeswaxListSegmentsQueryHookResult = ReturnType<typeof useBeeswaxListSegmentsQuery>;
export type BeeswaxListSegmentsLazyQueryHookResult = ReturnType<typeof useBeeswaxListSegmentsLazyQuery>;
export type BeeswaxListSegmentsSuspenseQueryHookResult = ReturnType<typeof useBeeswaxListSegmentsSuspenseQuery>;
export type BeeswaxListSegmentsQueryResult = ApolloReactHooks.QueryResult<BeeswaxListSegmentsQuery, BeeswaxListSegmentsQueryVariables>;
export const AdminConfirmPendingAudiencePulseDocument = gql`
    mutation AdminConfirmPendingAudiencePulse($confirmPendingAudiencePulseParams: ConfirmPendingAudiencePulseInput!) {
  adminConfirmPendingAudiencePulse(
    confirmPendingAudiencePulseParams: $confirmPendingAudiencePulseParams
  ) {
    id
  }
}
    `;
export type AdminConfirmPendingAudiencePulseMutationFn = ApolloReactHooks.useMutation.MutationFunction<AdminConfirmPendingAudiencePulseMutation, AdminConfirmPendingAudiencePulseMutationVariables>;

/**
 * __useAdminConfirmPendingAudiencePulseMutation__
 *
 * To run a mutation, you first call `useAdminConfirmPendingAudiencePulseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminConfirmPendingAudiencePulseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminConfirmPendingAudiencePulseMutation, { data, loading, error }] = useAdminConfirmPendingAudiencePulseMutation({
 *   variables: {
 *      confirmPendingAudiencePulseParams: // value for 'confirmPendingAudiencePulseParams'
 *   },
 * });
 */
export function useAdminConfirmPendingAudiencePulseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminConfirmPendingAudiencePulseMutation, AdminConfirmPendingAudiencePulseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminConfirmPendingAudiencePulseMutation, AdminConfirmPendingAudiencePulseMutationVariables>(AdminConfirmPendingAudiencePulseDocument, options);
      }
export type AdminConfirmPendingAudiencePulseMutationHookResult = ReturnType<typeof useAdminConfirmPendingAudiencePulseMutation>;
export type AdminConfirmPendingAudiencePulseMutationResult = ApolloReactHooks.MutationResult<AdminConfirmPendingAudiencePulseMutation>;
export type AdminConfirmPendingAudiencePulseMutationOptions = Apollo.MutationOptions<AdminConfirmPendingAudiencePulseMutation, AdminConfirmPendingAudiencePulseMutationVariables>;
export const ConversationMessagesDocument = gql`
    query ConversationMessages($conversationId: ID!, $first: Int!, $after: String) {
  conversationMessages(
    conversationId: $conversationId
    first: $first
    after: $after
  ) {
    nodes {
      id
      body
      block
      a2ui
      a2uiSubmission
      mutationConfirmation
      role
      citations {
        title
        url
        text
        start
        end
      }
      sources {
        title
        url
      }
      pdfReports {
        relativePath
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    agentSessionId
    title
  }
}
    `;

/**
 * __useConversationMessagesQuery__
 *
 * To run a query within a React component, call `useConversationMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationMessagesQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useConversationMessagesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ConversationMessagesQuery, ConversationMessagesQueryVariables> & ({ variables: ConversationMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConversationMessagesQuery, ConversationMessagesQueryVariables>(ConversationMessagesDocument, options);
      }
export function useConversationMessagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConversationMessagesQuery, ConversationMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConversationMessagesQuery, ConversationMessagesQueryVariables>(ConversationMessagesDocument, options);
        }
// @ts-ignore
export function useConversationMessagesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ConversationMessagesQuery, ConversationMessagesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConversationMessagesQuery, ConversationMessagesQueryVariables>;
export function useConversationMessagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConversationMessagesQuery, ConversationMessagesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConversationMessagesQuery | undefined, ConversationMessagesQueryVariables>;
export function useConversationMessagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConversationMessagesQuery, ConversationMessagesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConversationMessagesQuery, ConversationMessagesQueryVariables>(ConversationMessagesDocument, options);
        }
export type ConversationMessagesQueryHookResult = ReturnType<typeof useConversationMessagesQuery>;
export type ConversationMessagesLazyQueryHookResult = ReturnType<typeof useConversationMessagesLazyQuery>;
export type ConversationMessagesSuspenseQueryHookResult = ReturnType<typeof useConversationMessagesSuspenseQuery>;
export type ConversationMessagesQueryResult = ApolloReactHooks.QueryResult<ConversationMessagesQuery, ConversationMessagesQueryVariables>;
export const CreateAudienceGlobalDocument = gql`
    mutation createAudienceGlobal($audienceGlobalParams: AudienceGlobalInput!) {
  createAudienceGlobal(audienceGlobalParams: $audienceGlobalParams) {
    id
    name
  }
}
    `;
export type CreateAudienceGlobalMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateAudienceGlobalMutation, CreateAudienceGlobalMutationVariables>;

/**
 * __useCreateAudienceGlobalMutation__
 *
 * To run a mutation, you first call `useCreateAudienceGlobalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAudienceGlobalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAudienceGlobalMutation, { data, loading, error }] = useCreateAudienceGlobalMutation({
 *   variables: {
 *      audienceGlobalParams: // value for 'audienceGlobalParams'
 *   },
 * });
 */
export function useCreateAudienceGlobalMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAudienceGlobalMutation, CreateAudienceGlobalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAudienceGlobalMutation, CreateAudienceGlobalMutationVariables>(CreateAudienceGlobalDocument, options);
      }
export type CreateAudienceGlobalMutationHookResult = ReturnType<typeof useCreateAudienceGlobalMutation>;
export type CreateAudienceGlobalMutationResult = ApolloReactHooks.MutationResult<CreateAudienceGlobalMutation>;
export type CreateAudienceGlobalMutationOptions = Apollo.MutationOptions<CreateAudienceGlobalMutation, CreateAudienceGlobalMutationVariables>;
export const CreateAudiencePixelDocument = gql`
    mutation createAudiencePixel($audiencePixelParams: AudiencePixelInput!) {
  createAudiencePixel(audiencePixelParams: $audiencePixelParams) {
    id
    name
  }
}
    `;
export type CreateAudiencePixelMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateAudiencePixelMutation, CreateAudiencePixelMutationVariables>;

/**
 * __useCreateAudiencePixelMutation__
 *
 * To run a mutation, you first call `useCreateAudiencePixelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAudiencePixelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAudiencePixelMutation, { data, loading, error }] = useCreateAudiencePixelMutation({
 *   variables: {
 *      audiencePixelParams: // value for 'audiencePixelParams'
 *   },
 * });
 */
export function useCreateAudiencePixelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAudiencePixelMutation, CreateAudiencePixelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAudiencePixelMutation, CreateAudiencePixelMutationVariables>(CreateAudiencePixelDocument, options);
      }
export type CreateAudiencePixelMutationHookResult = ReturnType<typeof useCreateAudiencePixelMutation>;
export type CreateAudiencePixelMutationResult = ApolloReactHooks.MutationResult<CreateAudiencePixelMutation>;
export type CreateAudiencePixelMutationOptions = Apollo.MutationOptions<CreateAudiencePixelMutation, CreateAudiencePixelMutationVariables>;
export const CreateAudiencePulseDocument = gql`
    mutation CreateAudiencePulse($audiencePulseParams: AudiencePulseInput!) {
  createAudiencePulse(audiencePulseParams: $audiencePulseParams) {
    name
    id
  }
}
    `;
export type CreateAudiencePulseMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateAudiencePulseMutation, CreateAudiencePulseMutationVariables>;

/**
 * __useCreateAudiencePulseMutation__
 *
 * To run a mutation, you first call `useCreateAudiencePulseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAudiencePulseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAudiencePulseMutation, { data, loading, error }] = useCreateAudiencePulseMutation({
 *   variables: {
 *      audiencePulseParams: // value for 'audiencePulseParams'
 *   },
 * });
 */
export function useCreateAudiencePulseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAudiencePulseMutation, CreateAudiencePulseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAudiencePulseMutation, CreateAudiencePulseMutationVariables>(CreateAudiencePulseDocument, options);
      }
export type CreateAudiencePulseMutationHookResult = ReturnType<typeof useCreateAudiencePulseMutation>;
export type CreateAudiencePulseMutationResult = ApolloReactHooks.MutationResult<CreateAudiencePulseMutation>;
export type CreateAudiencePulseMutationOptions = Apollo.MutationOptions<CreateAudiencePulseMutation, CreateAudiencePulseMutationVariables>;
export const CreateAudienceSegmentDocument = gql`
    mutation createAudienceSegment($audienceSegmentParams: AudienceSegmentInput!) {
  createAudienceSegment(audienceSegmentParams: $audienceSegmentParams) {
    id
    name
  }
}
    `;
export type CreateAudienceSegmentMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateAudienceSegmentMutation, CreateAudienceSegmentMutationVariables>;

/**
 * __useCreateAudienceSegmentMutation__
 *
 * To run a mutation, you first call `useCreateAudienceSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAudienceSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAudienceSegmentMutation, { data, loading, error }] = useCreateAudienceSegmentMutation({
 *   variables: {
 *      audienceSegmentParams: // value for 'audienceSegmentParams'
 *   },
 * });
 */
export function useCreateAudienceSegmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAudienceSegmentMutation, CreateAudienceSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAudienceSegmentMutation, CreateAudienceSegmentMutationVariables>(CreateAudienceSegmentDocument, options);
      }
export type CreateAudienceSegmentMutationHookResult = ReturnType<typeof useCreateAudienceSegmentMutation>;
export type CreateAudienceSegmentMutationResult = ApolloReactHooks.MutationResult<CreateAudienceSegmentMutation>;
export type CreateAudienceSegmentMutationOptions = Apollo.MutationOptions<CreateAudienceSegmentMutation, CreateAudienceSegmentMutationVariables>;
export const CreateConversationDocument = gql`
    mutation CreateConversation($title: String!) {
  createConversation(title: $title) {
    id
    title
  }
}
    `;
export type CreateConversationMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateConversationMutation, CreateConversationMutationVariables>;

/**
 * __useCreateConversationMutation__
 *
 * To run a mutation, you first call `useCreateConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConversationMutation, { data, loading, error }] = useCreateConversationMutation({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateConversationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateConversationMutation, CreateConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateConversationMutation, CreateConversationMutationVariables>(CreateConversationDocument, options);
      }
export type CreateConversationMutationHookResult = ReturnType<typeof useCreateConversationMutation>;
export type CreateConversationMutationResult = ApolloReactHooks.MutationResult<CreateConversationMutation>;
export type CreateConversationMutationOptions = Apollo.MutationOptions<CreateConversationMutation, CreateConversationMutationVariables>;
export const CreateAudienceIntegrationDocument = gql`
    mutation CreateAudienceIntegration($integrationParams: AudienceIntegrationInput!) {
  createAudienceIntegration(integrationParams: $integrationParams) {
    configuration {
      ... on ActivationAudienceIntegrationConfiguration {
        activationType
        parameters {
          key
          value
        }
        historicalDataSync
        activationStatus: status
      }
      ... on S3AudienceIntegrationConfiguration {
        destinationS3Bucket
        outputObjectKeyTemplates
        iamRoles
        ownership
      }
      ... on ADFAudienceIntegrationConfiguration {
        emails
      }
      ... on MailchimpAudienceIntegrationConfiguration {
        apiKey
        audienceId
        tag
        daysToKeep
        historicalDataSync
      }
      ... on FacebookCustomAudienceAudienceIntegrationConfiguration {
        name
        description
        adAccountId
        accessToken
        customAudienceId
        historicalDataSync
        daysToKeep
      }
      ... on GoogleCustomerMatchAudienceIntegrationConfiguration {
        name
        description
        customerId
        managerCustomerId
        userListId
        lastOperationId
        historicalDataSync
        daysToKeep
        status
        googleUserAccountId
      }
      ... on HighLevelAudienceIntegrationConfiguration {
        privateIntegrationToken
        locationId
        tags
      }
      ... on TealiumAudienceIntegrationConfiguration {
        checkIfExistingCustomer
        redshiftHost
        redshiftPort
        redshiftUser
        redshiftPassword
        redshiftDatabase
        emailAttributeName
        events {
          existingCustomer
          nonExistingCustomer
          static
        }
        parameterNames {
          phone
          email
          hashedPhone
          hashedEmail
        }
        customEntries
        endpoint
      }
      ... on BeeswaxAudienceIntegrationConfiguration {
        buzzKey
        email
        segmentKey
        hemSalt
      }
      ... on MadhiveAudienceIntegrationConfiguration {
        segmentName
        cpm
        description
      }
      ... on DisplayVideo360CustomerMatchAudienceIntegrationConfiguration {
        name
        description
        advertiserId
        partnerId
        audienceOwnerType
        historicalDataSync
        daysToKeep
        dv360Status: status
        googleUserAccountId
      }
    }
    id
  }
}
    `;
export type CreateAudienceIntegrationMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateAudienceIntegrationMutation, CreateAudienceIntegrationMutationVariables>;

/**
 * __useCreateAudienceIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateAudienceIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAudienceIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAudienceIntegrationMutation, { data, loading, error }] = useCreateAudienceIntegrationMutation({
 *   variables: {
 *      integrationParams: // value for 'integrationParams'
 *   },
 * });
 */
export function useCreateAudienceIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAudienceIntegrationMutation, CreateAudienceIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAudienceIntegrationMutation, CreateAudienceIntegrationMutationVariables>(CreateAudienceIntegrationDocument, options);
      }
export type CreateAudienceIntegrationMutationHookResult = ReturnType<typeof useCreateAudienceIntegrationMutation>;
export type CreateAudienceIntegrationMutationResult = ApolloReactHooks.MutationResult<CreateAudienceIntegrationMutation>;
export type CreateAudienceIntegrationMutationOptions = Apollo.MutationOptions<CreateAudienceIntegrationMutation, CreateAudienceIntegrationMutationVariables>;
export const CreateAudienceLookalikeDocument = gql`
    mutation CreateAudienceLookalike($audienceLookalikeParams: AudienceLookalikeInput!) {
  createAudienceLookalike(audienceLookalikeParams: $audienceLookalikeParams) {
    id
    name
  }
}
    `;
export type CreateAudienceLookalikeMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateAudienceLookalikeMutation, CreateAudienceLookalikeMutationVariables>;

/**
 * __useCreateAudienceLookalikeMutation__
 *
 * To run a mutation, you first call `useCreateAudienceLookalikeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAudienceLookalikeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAudienceLookalikeMutation, { data, loading, error }] = useCreateAudienceLookalikeMutation({
 *   variables: {
 *      audienceLookalikeParams: // value for 'audienceLookalikeParams'
 *   },
 * });
 */
export function useCreateAudienceLookalikeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAudienceLookalikeMutation, CreateAudienceLookalikeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAudienceLookalikeMutation, CreateAudienceLookalikeMutationVariables>(CreateAudienceLookalikeDocument, options);
      }
export type CreateAudienceLookalikeMutationHookResult = ReturnType<typeof useCreateAudienceLookalikeMutation>;
export type CreateAudienceLookalikeMutationResult = ApolloReactHooks.MutationResult<CreateAudienceLookalikeMutation>;
export type CreateAudienceLookalikeMutationOptions = Apollo.MutationOptions<CreateAudienceLookalikeMutation, CreateAudienceLookalikeMutationVariables>;
export const CreateOrganizationDocument = gql`
    mutation CreateOrganization($input: CreateOrganizationInput) {
  createOrganization(input: $input) {
    id
  }
}
    `;
export type CreateOrganizationMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateOrganizationMutation, CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = ApolloReactHooks.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.MutationOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const CreateSubscriptionDocument = gql`
    mutation CreateSubscription($subscriptionParams: SubscriptionInput!) {
  createSubscription(subscriptionParams: $subscriptionParams)
}
    `;
export type CreateSubscriptionMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;

/**
 * __useCreateSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionMutation, { data, loading, error }] = useCreateSubscriptionMutation({
 *   variables: {
 *      subscriptionParams: // value for 'subscriptionParams'
 *   },
 * });
 */
export function useCreateSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>(CreateSubscriptionDocument, options);
      }
export type CreateSubscriptionMutationHookResult = ReturnType<typeof useCreateSubscriptionMutation>;
export type CreateSubscriptionMutationResult = ApolloReactHooks.MutationResult<CreateSubscriptionMutation>;
export type CreateSubscriptionMutationOptions = Apollo.MutationOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;
export const AudiencesCountDocument = gql`
    query AudiencesCount($dateRange: DateOperatorsInput, $dateRangePast: DateOperatorsInput, $organizationId: ID) {
  actualAudiencesCount: audiencesCount(
    dateRange: $dateRange
    organizationId: $organizationId
  ) {
    customerList
    global
    pixel
    lookalike
    pulse
  }
  pastAudiencesCount: audiencesCount(
    dateRange: $dateRangePast
    organizationId: $organizationId
  ) {
    customerList
    global
    lookalike
    pixel
    pulse
  }
}
    `;

/**
 * __useAudiencesCountQuery__
 *
 * To run a query within a React component, call `useAudiencesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudiencesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudiencesCountQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      dateRangePast: // value for 'dateRangePast'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAudiencesCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AudiencesCountQuery, AudiencesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AudiencesCountQuery, AudiencesCountQueryVariables>(AudiencesCountDocument, options);
      }
export function useAudiencesCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AudiencesCountQuery, AudiencesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AudiencesCountQuery, AudiencesCountQueryVariables>(AudiencesCountDocument, options);
        }
// @ts-ignore
export function useAudiencesCountSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AudiencesCountQuery, AudiencesCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AudiencesCountQuery, AudiencesCountQueryVariables>;
export function useAudiencesCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AudiencesCountQuery, AudiencesCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AudiencesCountQuery | undefined, AudiencesCountQueryVariables>;
export function useAudiencesCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AudiencesCountQuery, AudiencesCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AudiencesCountQuery, AudiencesCountQueryVariables>(AudiencesCountDocument, options);
        }
export type AudiencesCountQueryHookResult = ReturnType<typeof useAudiencesCountQuery>;
export type AudiencesCountLazyQueryHookResult = ReturnType<typeof useAudiencesCountLazyQuery>;
export type AudiencesCountSuspenseQueryHookResult = ReturnType<typeof useAudiencesCountSuspenseQuery>;
export type AudiencesCountQueryResult = ApolloReactHooks.QueryResult<AudiencesCountQuery, AudiencesCountQueryVariables>;
export const EntitiesCountDocument = gql`
    query EntitiesCount($organizationId: ID) {
  entitiesCount(organizationId: $organizationId) {
    audiences
    organizations
    users
  }
}
    `;

/**
 * __useEntitiesCountQuery__
 *
 * To run a query within a React component, call `useEntitiesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitiesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitiesCountQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useEntitiesCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EntitiesCountQuery, EntitiesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntitiesCountQuery, EntitiesCountQueryVariables>(EntitiesCountDocument, options);
      }
export function useEntitiesCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntitiesCountQuery, EntitiesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntitiesCountQuery, EntitiesCountQueryVariables>(EntitiesCountDocument, options);
        }
// @ts-ignore
export function useEntitiesCountSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntitiesCountQuery, EntitiesCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntitiesCountQuery, EntitiesCountQueryVariables>;
export function useEntitiesCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntitiesCountQuery, EntitiesCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntitiesCountQuery | undefined, EntitiesCountQueryVariables>;
export function useEntitiesCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntitiesCountQuery, EntitiesCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntitiesCountQuery, EntitiesCountQueryVariables>(EntitiesCountDocument, options);
        }
export type EntitiesCountQueryHookResult = ReturnType<typeof useEntitiesCountQuery>;
export type EntitiesCountLazyQueryHookResult = ReturnType<typeof useEntitiesCountLazyQuery>;
export type EntitiesCountSuspenseQueryHookResult = ReturnType<typeof useEntitiesCountSuspenseQuery>;
export type EntitiesCountQueryResult = ApolloReactHooks.QueryResult<EntitiesCountQuery, EntitiesCountQueryVariables>;
export const DeleteAudienceIntegrationDocument = gql`
    mutation DeleteAudienceIntegration($deleteAudienceIntegrationId: ID!) {
  deleteAudienceIntegration(id: $deleteAudienceIntegrationId)
}
    `;
export type DeleteAudienceIntegrationMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteAudienceIntegrationMutation, DeleteAudienceIntegrationMutationVariables>;

/**
 * __useDeleteAudienceIntegrationMutation__
 *
 * To run a mutation, you first call `useDeleteAudienceIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAudienceIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAudienceIntegrationMutation, { data, loading, error }] = useDeleteAudienceIntegrationMutation({
 *   variables: {
 *      deleteAudienceIntegrationId: // value for 'deleteAudienceIntegrationId'
 *   },
 * });
 */
export function useDeleteAudienceIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAudienceIntegrationMutation, DeleteAudienceIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAudienceIntegrationMutation, DeleteAudienceIntegrationMutationVariables>(DeleteAudienceIntegrationDocument, options);
      }
export type DeleteAudienceIntegrationMutationHookResult = ReturnType<typeof useDeleteAudienceIntegrationMutation>;
export type DeleteAudienceIntegrationMutationResult = ApolloReactHooks.MutationResult<DeleteAudienceIntegrationMutation>;
export type DeleteAudienceIntegrationMutationOptions = Apollo.MutationOptions<DeleteAudienceIntegrationMutation, DeleteAudienceIntegrationMutationVariables>;
export const DeleteAudienceDocument = gql`
    mutation DeleteAudience($audienceId: ID!) {
  deleteAudience(audienceId: $audienceId)
}
    `;
export type DeleteAudienceMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteAudienceMutation, DeleteAudienceMutationVariables>;

/**
 * __useDeleteAudienceMutation__
 *
 * To run a mutation, you first call `useDeleteAudienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAudienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAudienceMutation, { data, loading, error }] = useDeleteAudienceMutation({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *   },
 * });
 */
export function useDeleteAudienceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAudienceMutation, DeleteAudienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAudienceMutation, DeleteAudienceMutationVariables>(DeleteAudienceDocument, options);
      }
export type DeleteAudienceMutationHookResult = ReturnType<typeof useDeleteAudienceMutation>;
export type DeleteAudienceMutationResult = ApolloReactHooks.MutationResult<DeleteAudienceMutation>;
export type DeleteAudienceMutationOptions = Apollo.MutationOptions<DeleteAudienceMutation, DeleteAudienceMutationVariables>;
export const DiscardFailedAudienceCustomerListLoadDocument = gql`
    mutation DiscardFailedAudienceCustomerListLoad($id: ID!) {
  discardFailedAudienceCustomerListLoad(id: $id) {
    id
    processingStatus
  }
}
    `;
export type DiscardFailedAudienceCustomerListLoadMutationFn = ApolloReactHooks.useMutation.MutationFunction<DiscardFailedAudienceCustomerListLoadMutation, DiscardFailedAudienceCustomerListLoadMutationVariables>;

/**
 * __useDiscardFailedAudienceCustomerListLoadMutation__
 *
 * To run a mutation, you first call `useDiscardFailedAudienceCustomerListLoadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscardFailedAudienceCustomerListLoadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discardFailedAudienceCustomerListLoadMutation, { data, loading, error }] = useDiscardFailedAudienceCustomerListLoadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDiscardFailedAudienceCustomerListLoadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DiscardFailedAudienceCustomerListLoadMutation, DiscardFailedAudienceCustomerListLoadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DiscardFailedAudienceCustomerListLoadMutation, DiscardFailedAudienceCustomerListLoadMutationVariables>(DiscardFailedAudienceCustomerListLoadDocument, options);
      }
export type DiscardFailedAudienceCustomerListLoadMutationHookResult = ReturnType<typeof useDiscardFailedAudienceCustomerListLoadMutation>;
export type DiscardFailedAudienceCustomerListLoadMutationResult = ApolloReactHooks.MutationResult<DiscardFailedAudienceCustomerListLoadMutation>;
export type DiscardFailedAudienceCustomerListLoadMutationOptions = Apollo.MutationOptions<DiscardFailedAudienceCustomerListLoadMutation, DiscardFailedAudienceCustomerListLoadMutationVariables>;
export const GenerateReportDownloadUrlDocument = gql`
    mutation GenerateReportDownloadUrl($relativePath: String!) {
  generateReportDownloadUrl(relativePath: $relativePath)
}
    `;
export type GenerateReportDownloadUrlMutationFn = ApolloReactHooks.useMutation.MutationFunction<GenerateReportDownloadUrlMutation, GenerateReportDownloadUrlMutationVariables>;

/**
 * __useGenerateReportDownloadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateReportDownloadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateReportDownloadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateReportDownloadUrlMutation, { data, loading, error }] = useGenerateReportDownloadUrlMutation({
 *   variables: {
 *      relativePath: // value for 'relativePath'
 *   },
 * });
 */
export function useGenerateReportDownloadUrlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateReportDownloadUrlMutation, GenerateReportDownloadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GenerateReportDownloadUrlMutation, GenerateReportDownloadUrlMutationVariables>(GenerateReportDownloadUrlDocument, options);
      }
export type GenerateReportDownloadUrlMutationHookResult = ReturnType<typeof useGenerateReportDownloadUrlMutation>;
export type GenerateReportDownloadUrlMutationResult = ApolloReactHooks.MutationResult<GenerateReportDownloadUrlMutation>;
export type GenerateReportDownloadUrlMutationOptions = Apollo.MutationOptions<GenerateReportDownloadUrlMutation, GenerateReportDownloadUrlMutationVariables>;
export const GetConversationsDocument = gql`
    query GetConversations($first: Int!, $after: String, $searchQuery: String) {
  conversations(first: $first, after: $after, searchQuery: $searchQuery) {
    totalCount
    nodes {
      id
      title
      lastUserMessageAt
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetConversationsQuery__
 *
 * To run a query within a React component, call `useGetConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useGetConversationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetConversationsQuery, GetConversationsQueryVariables> & ({ variables: GetConversationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetConversationsQuery, GetConversationsQueryVariables>(GetConversationsDocument, options);
      }
export function useGetConversationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetConversationsQuery, GetConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetConversationsQuery, GetConversationsQueryVariables>(GetConversationsDocument, options);
        }
// @ts-ignore
export function useGetConversationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetConversationsQuery, GetConversationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetConversationsQuery, GetConversationsQueryVariables>;
export function useGetConversationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetConversationsQuery, GetConversationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetConversationsQuery | undefined, GetConversationsQueryVariables>;
export function useGetConversationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetConversationsQuery, GetConversationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetConversationsQuery, GetConversationsQueryVariables>(GetConversationsDocument, options);
        }
export type GetConversationsQueryHookResult = ReturnType<typeof useGetConversationsQuery>;
export type GetConversationsLazyQueryHookResult = ReturnType<typeof useGetConversationsLazyQuery>;
export type GetConversationsSuspenseQueryHookResult = ReturnType<typeof useGetConversationsSuspenseQuery>;
export type GetConversationsQueryResult = ApolloReactHooks.QueryResult<GetConversationsQuery, GetConversationsQueryVariables>;
export const PeopleSnapshotDocument = gql`
    query PeopleSnapshot($filters: [PersonFilterInput]!, $parentAudienceId: ID) {
  peopleSnapshot(filters: $filters, parentAudienceId: $parentAudienceId) {
    geoResults {
      count
      postalCodes
    }
    people {
      id
      firstName
      city
    }
    postalCodeCounts {
      count
      postalCode
    }
    totalCount
  }
}
    `;

/**
 * __usePeopleSnapshotQuery__
 *
 * To run a query within a React component, call `usePeopleSnapshotQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleSnapshotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleSnapshotQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      parentAudienceId: // value for 'parentAudienceId'
 *   },
 * });
 */
export function usePeopleSnapshotQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PeopleSnapshotQuery, PeopleSnapshotQueryVariables> & ({ variables: PeopleSnapshotQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PeopleSnapshotQuery, PeopleSnapshotQueryVariables>(PeopleSnapshotDocument, options);
      }
export function usePeopleSnapshotLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PeopleSnapshotQuery, PeopleSnapshotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PeopleSnapshotQuery, PeopleSnapshotQueryVariables>(PeopleSnapshotDocument, options);
        }
// @ts-ignore
export function usePeopleSnapshotSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PeopleSnapshotQuery, PeopleSnapshotQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PeopleSnapshotQuery, PeopleSnapshotQueryVariables>;
export function usePeopleSnapshotSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PeopleSnapshotQuery, PeopleSnapshotQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PeopleSnapshotQuery | undefined, PeopleSnapshotQueryVariables>;
export function usePeopleSnapshotSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PeopleSnapshotQuery, PeopleSnapshotQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PeopleSnapshotQuery, PeopleSnapshotQueryVariables>(PeopleSnapshotDocument, options);
        }
export type PeopleSnapshotQueryHookResult = ReturnType<typeof usePeopleSnapshotQuery>;
export type PeopleSnapshotLazyQueryHookResult = ReturnType<typeof usePeopleSnapshotLazyQuery>;
export type PeopleSnapshotSuspenseQueryHookResult = ReturnType<typeof usePeopleSnapshotSuspenseQuery>;
export type PeopleSnapshotQueryResult = ApolloReactHooks.QueryResult<PeopleSnapshotQuery, PeopleSnapshotQueryVariables>;
export const GoogleAuthorizeDocument = gql`
    mutation GoogleAuthorize($input: GoogleAuthorizeInput!) {
  googleAuthorize(input: $input) {
    accessToken
    accountId
    scopes
    expiryDate
  }
}
    `;
export type GoogleAuthorizeMutationFn = ApolloReactHooks.useMutation.MutationFunction<GoogleAuthorizeMutation, GoogleAuthorizeMutationVariables>;

/**
 * __useGoogleAuthorizeMutation__
 *
 * To run a mutation, you first call `useGoogleAuthorizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGoogleAuthorizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [googleAuthorizeMutation, { data, loading, error }] = useGoogleAuthorizeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGoogleAuthorizeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GoogleAuthorizeMutation, GoogleAuthorizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GoogleAuthorizeMutation, GoogleAuthorizeMutationVariables>(GoogleAuthorizeDocument, options);
      }
export type GoogleAuthorizeMutationHookResult = ReturnType<typeof useGoogleAuthorizeMutation>;
export type GoogleAuthorizeMutationResult = ApolloReactHooks.MutationResult<GoogleAuthorizeMutation>;
export type GoogleAuthorizeMutationOptions = Apollo.MutationOptions<GoogleAuthorizeMutation, GoogleAuthorizeMutationVariables>;
export const GoogleGenerateAccessTokenDocument = gql`
    mutation GoogleGenerateAccessToken($input: GoogleAccessTokenInput!) {
  googleGenerateAccessToken(input: $input) {
    accessToken
    expiryDate
  }
}
    `;
export type GoogleGenerateAccessTokenMutationFn = ApolloReactHooks.useMutation.MutationFunction<GoogleGenerateAccessTokenMutation, GoogleGenerateAccessTokenMutationVariables>;

/**
 * __useGoogleGenerateAccessTokenMutation__
 *
 * To run a mutation, you first call `useGoogleGenerateAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGoogleGenerateAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [googleGenerateAccessTokenMutation, { data, loading, error }] = useGoogleGenerateAccessTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGoogleGenerateAccessTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GoogleGenerateAccessTokenMutation, GoogleGenerateAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GoogleGenerateAccessTokenMutation, GoogleGenerateAccessTokenMutationVariables>(GoogleGenerateAccessTokenDocument, options);
      }
export type GoogleGenerateAccessTokenMutationHookResult = ReturnType<typeof useGoogleGenerateAccessTokenMutation>;
export type GoogleGenerateAccessTokenMutationResult = ApolloReactHooks.MutationResult<GoogleGenerateAccessTokenMutation>;
export type GoogleGenerateAccessTokenMutationOptions = Apollo.MutationOptions<GoogleGenerateAccessTokenMutation, GoogleGenerateAccessTokenMutationVariables>;
export const GoogleTokenDocument = gql`
    mutation GoogleToken($input: GoogleTokenInput!) {
  googleToken(input: $input) {
    accessToken
    refreshToken
    tokenType
  }
}
    `;
export type GoogleTokenMutationFn = ApolloReactHooks.useMutation.MutationFunction<GoogleTokenMutation, GoogleTokenMutationVariables>;

/**
 * __useGoogleTokenMutation__
 *
 * To run a mutation, you first call `useGoogleTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGoogleTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [googleTokenMutation, { data, loading, error }] = useGoogleTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGoogleTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GoogleTokenMutation, GoogleTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GoogleTokenMutation, GoogleTokenMutationVariables>(GoogleTokenDocument, options);
      }
export type GoogleTokenMutationHookResult = ReturnType<typeof useGoogleTokenMutation>;
export type GoogleTokenMutationResult = ApolloReactHooks.MutationResult<GoogleTokenMutation>;
export type GoogleTokenMutationOptions = Apollo.MutationOptions<GoogleTokenMutation, GoogleTokenMutationVariables>;
export const IntegrationsDocument = gql`
    query Integrations {
  integrations {
    description
    imageUrl
    integrationType
  }
}
    `;

/**
 * __useIntegrationsQuery__
 *
 * To run a query within a React component, call `useIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntegrationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IntegrationsQuery, IntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IntegrationsQuery, IntegrationsQueryVariables>(IntegrationsDocument, options);
      }
export function useIntegrationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IntegrationsQuery, IntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IntegrationsQuery, IntegrationsQueryVariables>(IntegrationsDocument, options);
        }
// @ts-ignore
export function useIntegrationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<IntegrationsQuery, IntegrationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<IntegrationsQuery, IntegrationsQueryVariables>;
export function useIntegrationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IntegrationsQuery, IntegrationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<IntegrationsQuery | undefined, IntegrationsQueryVariables>;
export function useIntegrationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IntegrationsQuery, IntegrationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IntegrationsQuery, IntegrationsQueryVariables>(IntegrationsDocument, options);
        }
export type IntegrationsQueryHookResult = ReturnType<typeof useIntegrationsQuery>;
export type IntegrationsLazyQueryHookResult = ReturnType<typeof useIntegrationsLazyQuery>;
export type IntegrationsSuspenseQueryHookResult = ReturnType<typeof useIntegrationsSuspenseQuery>;
export type IntegrationsQueryResult = ApolloReactHooks.QueryResult<IntegrationsQuery, IntegrationsQueryVariables>;
export const SendInviteDocument = gql`
    mutation SendInvite($inviteParams: InviteInput) {
  createInvite(inviteParams: $inviteParams) {
    id
    email
  }
}
    `;
export type SendInviteMutationFn = ApolloReactHooks.useMutation.MutationFunction<SendInviteMutation, SendInviteMutationVariables>;

/**
 * __useSendInviteMutation__
 *
 * To run a mutation, you first call `useSendInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInviteMutation, { data, loading, error }] = useSendInviteMutation({
 *   variables: {
 *      inviteParams: // value for 'inviteParams'
 *   },
 * });
 */
export function useSendInviteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendInviteMutation, SendInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendInviteMutation, SendInviteMutationVariables>(SendInviteDocument, options);
      }
export type SendInviteMutationHookResult = ReturnType<typeof useSendInviteMutation>;
export type SendInviteMutationResult = ApolloReactHooks.MutationResult<SendInviteMutation>;
export type SendInviteMutationOptions = Apollo.MutationOptions<SendInviteMutation, SendInviteMutationVariables>;
export const DeclineInviteDocument = gql`
    mutation DeclineInvite($declineInviteId: ID!) {
  declineInvite(id: $declineInviteId) {
    status
    organizationId
  }
}
    `;
export type DeclineInviteMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeclineInviteMutation, DeclineInviteMutationVariables>;

/**
 * __useDeclineInviteMutation__
 *
 * To run a mutation, you first call `useDeclineInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineInviteMutation, { data, loading, error }] = useDeclineInviteMutation({
 *   variables: {
 *      declineInviteId: // value for 'declineInviteId'
 *   },
 * });
 */
export function useDeclineInviteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeclineInviteMutation, DeclineInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeclineInviteMutation, DeclineInviteMutationVariables>(DeclineInviteDocument, options);
      }
export type DeclineInviteMutationHookResult = ReturnType<typeof useDeclineInviteMutation>;
export type DeclineInviteMutationResult = ApolloReactHooks.MutationResult<DeclineInviteMutation>;
export type DeclineInviteMutationOptions = Apollo.MutationOptions<DeclineInviteMutation, DeclineInviteMutationVariables>;
export const AcceptInviteDocument = gql`
    mutation AcceptInvite($acceptInviteId: ID!) {
  acceptInvite(id: $acceptInviteId) {
    organizationId
    status
  }
}
    `;
export type AcceptInviteMutationFn = ApolloReactHooks.useMutation.MutationFunction<AcceptInviteMutation, AcceptInviteMutationVariables>;

/**
 * __useAcceptInviteMutation__
 *
 * To run a mutation, you first call `useAcceptInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInviteMutation, { data, loading, error }] = useAcceptInviteMutation({
 *   variables: {
 *      acceptInviteId: // value for 'acceptInviteId'
 *   },
 * });
 */
export function useAcceptInviteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptInviteMutation, AcceptInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcceptInviteMutation, AcceptInviteMutationVariables>(AcceptInviteDocument, options);
      }
export type AcceptInviteMutationHookResult = ReturnType<typeof useAcceptInviteMutation>;
export type AcceptInviteMutationResult = ApolloReactHooks.MutationResult<AcceptInviteMutation>;
export type AcceptInviteMutationOptions = Apollo.MutationOptions<AcceptInviteMutation, AcceptInviteMutationVariables>;
export const InvoicesDocument = gql`
    query Invoices($organizationId: ID!) {
  invoices(organizationId: $organizationId) {
    totalAmount
    currency
    paidDate
    taxAmount
    productName
    productInterval
    productIntervalUnit
    publicUrl
    payments {
      paymentMethod {
        maskedCardNumber
        cardBrand
      }
    }
  }
}
    `;

/**
 * __useInvoicesQuery__
 *
 * To run a query within a React component, call `useInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useInvoicesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InvoicesQuery, InvoicesQueryVariables> & ({ variables: InvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
      }
export function useInvoicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
        }
// @ts-ignore
export function useInvoicesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InvoicesQuery, InvoicesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InvoicesQuery, InvoicesQueryVariables>;
export function useInvoicesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InvoicesQuery, InvoicesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InvoicesQuery | undefined, InvoicesQueryVariables>;
export function useInvoicesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
        }
export type InvoicesQueryHookResult = ReturnType<typeof useInvoicesQuery>;
export type InvoicesLazyQueryHookResult = ReturnType<typeof useInvoicesLazyQuery>;
export type InvoicesSuspenseQueryHookResult = ReturnType<typeof useInvoicesSuspenseQuery>;
export type InvoicesQueryResult = ApolloReactHooks.QueryResult<InvoicesQuery, InvoicesQueryVariables>;
export const LookalikesPageDocument = gql`
    query LookalikesPage($pageNumber: Int!, $pageItemsCount: Int!, $audienceId: ID!) {
  audience(id: $audienceId) {
    lookalikesPage(pageNumber: $pageNumber, pageItemsCount: $pageItemsCount) {
      totalCount
      nodes {
        id
        name
        creator {
          id
          imageUrl
          firstName
          lastName
        }
        organization {
          id
          name
        }
        condition
        peopleCount
        organizationId
        parentAudience {
          id
          condition
        }
      }
    }
  }
}
    `;

/**
 * __useLookalikesPageQuery__
 *
 * To run a query within a React component, call `useLookalikesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useLookalikesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLookalikesPageQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      audienceId: // value for 'audienceId'
 *   },
 * });
 */
export function useLookalikesPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LookalikesPageQuery, LookalikesPageQueryVariables> & ({ variables: LookalikesPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LookalikesPageQuery, LookalikesPageQueryVariables>(LookalikesPageDocument, options);
      }
export function useLookalikesPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LookalikesPageQuery, LookalikesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LookalikesPageQuery, LookalikesPageQueryVariables>(LookalikesPageDocument, options);
        }
// @ts-ignore
export function useLookalikesPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LookalikesPageQuery, LookalikesPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LookalikesPageQuery, LookalikesPageQueryVariables>;
export function useLookalikesPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LookalikesPageQuery, LookalikesPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LookalikesPageQuery | undefined, LookalikesPageQueryVariables>;
export function useLookalikesPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LookalikesPageQuery, LookalikesPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LookalikesPageQuery, LookalikesPageQueryVariables>(LookalikesPageDocument, options);
        }
export type LookalikesPageQueryHookResult = ReturnType<typeof useLookalikesPageQuery>;
export type LookalikesPageLazyQueryHookResult = ReturnType<typeof useLookalikesPageLazyQuery>;
export type LookalikesPageSuspenseQueryHookResult = ReturnType<typeof useLookalikesPageSuspenseQuery>;
export type LookalikesPageQueryResult = ApolloReactHooks.QueryResult<LookalikesPageQuery, LookalikesPageQueryVariables>;
export const MailchimpListAudiencesDocument = gql`
    query MailchimpListAudiences($input: MailchimpListAudiencesInput!) {
  mailchimpListAudiences(input: $input) {
    id
    name
  }
}
    `;

/**
 * __useMailchimpListAudiencesQuery__
 *
 * To run a query within a React component, call `useMailchimpListAudiencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailchimpListAudiencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailchimpListAudiencesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMailchimpListAudiencesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MailchimpListAudiencesQuery, MailchimpListAudiencesQueryVariables> & ({ variables: MailchimpListAudiencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MailchimpListAudiencesQuery, MailchimpListAudiencesQueryVariables>(MailchimpListAudiencesDocument, options);
      }
export function useMailchimpListAudiencesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MailchimpListAudiencesQuery, MailchimpListAudiencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MailchimpListAudiencesQuery, MailchimpListAudiencesQueryVariables>(MailchimpListAudiencesDocument, options);
        }
// @ts-ignore
export function useMailchimpListAudiencesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MailchimpListAudiencesQuery, MailchimpListAudiencesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MailchimpListAudiencesQuery, MailchimpListAudiencesQueryVariables>;
export function useMailchimpListAudiencesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MailchimpListAudiencesQuery, MailchimpListAudiencesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MailchimpListAudiencesQuery | undefined, MailchimpListAudiencesQueryVariables>;
export function useMailchimpListAudiencesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MailchimpListAudiencesQuery, MailchimpListAudiencesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MailchimpListAudiencesQuery, MailchimpListAudiencesQueryVariables>(MailchimpListAudiencesDocument, options);
        }
export type MailchimpListAudiencesQueryHookResult = ReturnType<typeof useMailchimpListAudiencesQuery>;
export type MailchimpListAudiencesLazyQueryHookResult = ReturnType<typeof useMailchimpListAudiencesLazyQuery>;
export type MailchimpListAudiencesSuspenseQueryHookResult = ReturnType<typeof useMailchimpListAudiencesSuspenseQuery>;
export type MailchimpListAudiencesQueryResult = ApolloReactHooks.QueryResult<MailchimpListAudiencesQuery, MailchimpListAudiencesQueryVariables>;
export const CreateAudienceMatchbackDocument = gql`
    mutation CreateAudienceMatchback($params: AudienceMatchbackInput!) {
  createAudienceMatchback(audienceMatchbackParams: $params) {
    id
    name
    processingStatus
    createdAt
  }
}
    `;
export type CreateAudienceMatchbackMutationFn = ApolloReactHooks.useMutation.MutationFunction<CreateAudienceMatchbackMutation, CreateAudienceMatchbackMutationVariables>;

/**
 * __useCreateAudienceMatchbackMutation__
 *
 * To run a mutation, you first call `useCreateAudienceMatchbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAudienceMatchbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAudienceMatchbackMutation, { data, loading, error }] = useCreateAudienceMatchbackMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreateAudienceMatchbackMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAudienceMatchbackMutation, CreateAudienceMatchbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAudienceMatchbackMutation, CreateAudienceMatchbackMutationVariables>(CreateAudienceMatchbackDocument, options);
      }
export type CreateAudienceMatchbackMutationHookResult = ReturnType<typeof useCreateAudienceMatchbackMutation>;
export type CreateAudienceMatchbackMutationResult = ApolloReactHooks.MutationResult<CreateAudienceMatchbackMutation>;
export type CreateAudienceMatchbackMutationOptions = Apollo.MutationOptions<CreateAudienceMatchbackMutation, CreateAudienceMatchbackMutationVariables>;
export const MatchbackAudienceAdditionsDocument = gql`
    query MatchbackAudienceAdditions($audienceId: ID!) {
  audience(id: $audienceId) {
    id
    condition
    peopleCount
    info {
      ... on AudienceCustomerListInfo {
        additions {
          ...AdditionsFields
        }
      }
      ... on AudienceGlobalInfo {
        additions {
          ...AdditionsFields
        }
      }
      ... on AudiencePulseInfo {
        additions {
          ...AdditionsFields
        }
      }
    }
  }
}
    ${AdditionsFieldsFragmentDoc}`;

/**
 * __useMatchbackAudienceAdditionsQuery__
 *
 * To run a query within a React component, call `useMatchbackAudienceAdditionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchbackAudienceAdditionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchbackAudienceAdditionsQuery({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *   },
 * });
 */
export function useMatchbackAudienceAdditionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MatchbackAudienceAdditionsQuery, MatchbackAudienceAdditionsQueryVariables> & ({ variables: MatchbackAudienceAdditionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MatchbackAudienceAdditionsQuery, MatchbackAudienceAdditionsQueryVariables>(MatchbackAudienceAdditionsDocument, options);
      }
export function useMatchbackAudienceAdditionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MatchbackAudienceAdditionsQuery, MatchbackAudienceAdditionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MatchbackAudienceAdditionsQuery, MatchbackAudienceAdditionsQueryVariables>(MatchbackAudienceAdditionsDocument, options);
        }
// @ts-ignore
export function useMatchbackAudienceAdditionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MatchbackAudienceAdditionsQuery, MatchbackAudienceAdditionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MatchbackAudienceAdditionsQuery, MatchbackAudienceAdditionsQueryVariables>;
export function useMatchbackAudienceAdditionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MatchbackAudienceAdditionsQuery, MatchbackAudienceAdditionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MatchbackAudienceAdditionsQuery | undefined, MatchbackAudienceAdditionsQueryVariables>;
export function useMatchbackAudienceAdditionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MatchbackAudienceAdditionsQuery, MatchbackAudienceAdditionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MatchbackAudienceAdditionsQuery, MatchbackAudienceAdditionsQueryVariables>(MatchbackAudienceAdditionsDocument, options);
        }
export type MatchbackAudienceAdditionsQueryHookResult = ReturnType<typeof useMatchbackAudienceAdditionsQuery>;
export type MatchbackAudienceAdditionsLazyQueryHookResult = ReturnType<typeof useMatchbackAudienceAdditionsLazyQuery>;
export type MatchbackAudienceAdditionsSuspenseQueryHookResult = ReturnType<typeof useMatchbackAudienceAdditionsSuspenseQuery>;
export type MatchbackAudienceAdditionsQueryResult = ApolloReactHooks.QueryResult<MatchbackAudienceAdditionsQuery, MatchbackAudienceAdditionsQueryVariables>;
export const MatchbackStatusDocument = gql`
    query MatchbackStatus($id: ID!) {
  audience(id: $id) {
    id
    processingStatus
  }
}
    `;

/**
 * __useMatchbackStatusQuery__
 *
 * To run a query within a React component, call `useMatchbackStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchbackStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchbackStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMatchbackStatusQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MatchbackStatusQuery, MatchbackStatusQueryVariables> & ({ variables: MatchbackStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MatchbackStatusQuery, MatchbackStatusQueryVariables>(MatchbackStatusDocument, options);
      }
export function useMatchbackStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MatchbackStatusQuery, MatchbackStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MatchbackStatusQuery, MatchbackStatusQueryVariables>(MatchbackStatusDocument, options);
        }
// @ts-ignore
export function useMatchbackStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MatchbackStatusQuery, MatchbackStatusQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MatchbackStatusQuery, MatchbackStatusQueryVariables>;
export function useMatchbackStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MatchbackStatusQuery, MatchbackStatusQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MatchbackStatusQuery | undefined, MatchbackStatusQueryVariables>;
export function useMatchbackStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MatchbackStatusQuery, MatchbackStatusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MatchbackStatusQuery, MatchbackStatusQueryVariables>(MatchbackStatusDocument, options);
        }
export type MatchbackStatusQueryHookResult = ReturnType<typeof useMatchbackStatusQuery>;
export type MatchbackStatusLazyQueryHookResult = ReturnType<typeof useMatchbackStatusLazyQuery>;
export type MatchbackStatusSuspenseQueryHookResult = ReturnType<typeof useMatchbackStatusSuspenseQuery>;
export type MatchbackStatusQueryResult = ApolloReactHooks.QueryResult<MatchbackStatusQuery, MatchbackStatusQueryVariables>;
export const MatchbackOverviewDocument = gql`
    query MatchbackOverview($id: ID!) {
  audience(id: $id) {
    id
    name
    createdAt
    peopleCount
    processingStatus
    deepLink
    baseAudience {
      id
      name
    }
    organization {
      id
      name
    }
    info {
      ... on AudienceMatchbackInfo {
        comparisons {
          id
          audience {
            __typename
            id
            name
            condition
            deletedAt
            ... on Audience {
              peopleCount
            }
          }
          dateRanges {
            from
            to
          }
        }
      }
    }
    matchbackAttribution(maxCombinations: 20) {
      combinations {
        count
        comparisons {
          id
          audience {
            __typename
            id
            name
          }
        }
      }
      other {
        combinationCount
        count
      }
    }
  }
}
    `;

/**
 * __useMatchbackOverviewQuery__
 *
 * To run a query within a React component, call `useMatchbackOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchbackOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchbackOverviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMatchbackOverviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MatchbackOverviewQuery, MatchbackOverviewQueryVariables> & ({ variables: MatchbackOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MatchbackOverviewQuery, MatchbackOverviewQueryVariables>(MatchbackOverviewDocument, options);
      }
export function useMatchbackOverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MatchbackOverviewQuery, MatchbackOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MatchbackOverviewQuery, MatchbackOverviewQueryVariables>(MatchbackOverviewDocument, options);
        }
// @ts-ignore
export function useMatchbackOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MatchbackOverviewQuery, MatchbackOverviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MatchbackOverviewQuery, MatchbackOverviewQueryVariables>;
export function useMatchbackOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MatchbackOverviewQuery, MatchbackOverviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MatchbackOverviewQuery | undefined, MatchbackOverviewQueryVariables>;
export function useMatchbackOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MatchbackOverviewQuery, MatchbackOverviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MatchbackOverviewQuery, MatchbackOverviewQueryVariables>(MatchbackOverviewDocument, options);
        }
export type MatchbackOverviewQueryHookResult = ReturnType<typeof useMatchbackOverviewQuery>;
export type MatchbackOverviewLazyQueryHookResult = ReturnType<typeof useMatchbackOverviewLazyQuery>;
export type MatchbackOverviewSuspenseQueryHookResult = ReturnType<typeof useMatchbackOverviewSuspenseQuery>;
export type MatchbackOverviewQueryResult = ApolloReactHooks.QueryResult<MatchbackOverviewQuery, MatchbackOverviewQueryVariables>;
export const MatchbacksPageDocument = gql`
    query MatchbacksPage($audienceId: ID!, $pageNumber: Int!, $pageItemsCount: Int!, $searchQuery: String) {
  audience(id: $audienceId) {
    id
    matchbacksAsBasePage(
      pageNumber: $pageNumber
      pageItemsCount: $pageItemsCount
      searchQuery: $searchQuery
    ) {
      totalCount
      nodes {
        id
        name
        createdAt
        peopleCount
        processingStatus
        info {
          ... on AudienceMatchbackInfo {
            comparisons {
              audience {
                __typename
                id
                name
                deletedAt
                ... on Audience {
                  peopleCount
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMatchbacksPageQuery__
 *
 * To run a query within a React component, call `useMatchbacksPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchbacksPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchbacksPageQuery({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useMatchbacksPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MatchbacksPageQuery, MatchbacksPageQueryVariables> & ({ variables: MatchbacksPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MatchbacksPageQuery, MatchbacksPageQueryVariables>(MatchbacksPageDocument, options);
      }
export function useMatchbacksPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MatchbacksPageQuery, MatchbacksPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MatchbacksPageQuery, MatchbacksPageQueryVariables>(MatchbacksPageDocument, options);
        }
// @ts-ignore
export function useMatchbacksPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MatchbacksPageQuery, MatchbacksPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MatchbacksPageQuery, MatchbacksPageQueryVariables>;
export function useMatchbacksPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MatchbacksPageQuery, MatchbacksPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MatchbacksPageQuery | undefined, MatchbacksPageQueryVariables>;
export function useMatchbacksPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MatchbacksPageQuery, MatchbacksPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MatchbacksPageQuery, MatchbacksPageQueryVariables>(MatchbacksPageDocument, options);
        }
export type MatchbacksPageQueryHookResult = ReturnType<typeof useMatchbacksPageQuery>;
export type MatchbacksPageLazyQueryHookResult = ReturnType<typeof useMatchbacksPageLazyQuery>;
export type MatchbacksPageSuspenseQueryHookResult = ReturnType<typeof useMatchbacksPageSuspenseQuery>;
export type MatchbacksPageQueryResult = ApolloReactHooks.QueryResult<MatchbacksPageQuery, MatchbacksPageQueryVariables>;
export const OrganizationDocument = gql`
    query Organization($organizationId: ID!) {
  organization(id: $organizationId) {
    addressLine1
    state
    id
    name
    deepLink
    country
    city
    phone
    paidSubscription
    subscriptionOverride
    pixelDomain
    businessDataEnabled
    customerListEnabled
    ...DisableEmailValidationFields
    globalSearchEnabled
    globalSearchLimit
    lookalikeEnabled
    lookalikeSearchLimit
    pulseEnabled
    matchbackEnabled
    zip
    hiddenPeopleFields
    pixelMatchingCadence
    defaultS3OutputObjectKeyTemplate
    userRoles {
      id
      user {
        id
      }
    }
    imageUrl
    audiencesCount
    organizationType
    parentOrganization {
      id
      name
      ... on Organization {
        organizationType
        disableEmailValidationFinal: disableEmailValidation(retrieveFinalValue: true)
        userRoles {
          id
          user {
            id
          }
        }
        parentOrganization {
          id
          ... on Organization {
            organizationType
            userRoles {
              id
              user {
                id
              }
            }
          }
        }
      }
    }
  }
}
    ${DisableEmailValidationFieldsFragmentDoc}`;

/**
 * __useOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationQuery, OrganizationQueryVariables> & ({ variables: OrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
      }
export function useOrganizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
        }
// @ts-ignore
export function useOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationQuery, OrganizationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationQuery, OrganizationQueryVariables>;
export function useOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationQuery, OrganizationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationQuery | undefined, OrganizationQueryVariables>;
export function useOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
        }
export type OrganizationQueryHookResult = ReturnType<typeof useOrganizationQuery>;
export type OrganizationLazyQueryHookResult = ReturnType<typeof useOrganizationLazyQuery>;
export type OrganizationSuspenseQueryHookResult = ReturnType<typeof useOrganizationSuspenseQuery>;
export type OrganizationQueryResult = ApolloReactHooks.QueryResult<OrganizationQuery, OrganizationQueryVariables>;
export const ValidateOrganizationDocument = gql`
    query ValidateOrganization($organizationId: ID!) {
  organization(id: $organizationId) {
    id
  }
}
    `;

/**
 * __useValidateOrganizationQuery__
 *
 * To run a query within a React component, call `useValidateOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useValidateOrganizationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ValidateOrganizationQuery, ValidateOrganizationQueryVariables> & ({ variables: ValidateOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ValidateOrganizationQuery, ValidateOrganizationQueryVariables>(ValidateOrganizationDocument, options);
      }
export function useValidateOrganizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ValidateOrganizationQuery, ValidateOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ValidateOrganizationQuery, ValidateOrganizationQueryVariables>(ValidateOrganizationDocument, options);
        }
// @ts-ignore
export function useValidateOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ValidateOrganizationQuery, ValidateOrganizationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ValidateOrganizationQuery, ValidateOrganizationQueryVariables>;
export function useValidateOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ValidateOrganizationQuery, ValidateOrganizationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ValidateOrganizationQuery | undefined, ValidateOrganizationQueryVariables>;
export function useValidateOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ValidateOrganizationQuery, ValidateOrganizationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ValidateOrganizationQuery, ValidateOrganizationQueryVariables>(ValidateOrganizationDocument, options);
        }
export type ValidateOrganizationQueryHookResult = ReturnType<typeof useValidateOrganizationQuery>;
export type ValidateOrganizationLazyQueryHookResult = ReturnType<typeof useValidateOrganizationLazyQuery>;
export type ValidateOrganizationSuspenseQueryHookResult = ReturnType<typeof useValidateOrganizationSuspenseQuery>;
export type ValidateOrganizationQueryResult = ApolloReactHooks.QueryResult<ValidateOrganizationQuery, ValidateOrganizationQueryVariables>;
export const EditOrganizationDocument = gql`
    mutation EditOrganization($input: UpdateOrganizationInput) {
  updateOrganization(input: $input) {
    id
  }
}
    `;
export type EditOrganizationMutationFn = ApolloReactHooks.useMutation.MutationFunction<EditOrganizationMutation, EditOrganizationMutationVariables>;

/**
 * __useEditOrganizationMutation__
 *
 * To run a mutation, you first call `useEditOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editOrganizationMutation, { data, loading, error }] = useEditOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditOrganizationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditOrganizationMutation, EditOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EditOrganizationMutation, EditOrganizationMutationVariables>(EditOrganizationDocument, options);
      }
export type EditOrganizationMutationHookResult = ReturnType<typeof useEditOrganizationMutation>;
export type EditOrganizationMutationResult = ApolloReactHooks.MutationResult<EditOrganizationMutation>;
export type EditOrganizationMutationOptions = Apollo.MutationOptions<EditOrganizationMutation, EditOrganizationMutationVariables>;
export const AdminUpdateOrganizationDocument = gql`
    mutation AdminUpdateOrganization($input: AdminUpdateOrganizationInput) {
  adminUpdateOrganization(input: $input) {
    id
  }
}
    `;
export type AdminUpdateOrganizationMutationFn = ApolloReactHooks.useMutation.MutationFunction<AdminUpdateOrganizationMutation, AdminUpdateOrganizationMutationVariables>;

/**
 * __useAdminUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useAdminUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateOrganizationMutation, { data, loading, error }] = useAdminUpdateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateOrganizationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminUpdateOrganizationMutation, AdminUpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminUpdateOrganizationMutation, AdminUpdateOrganizationMutationVariables>(AdminUpdateOrganizationDocument, options);
      }
export type AdminUpdateOrganizationMutationHookResult = ReturnType<typeof useAdminUpdateOrganizationMutation>;
export type AdminUpdateOrganizationMutationResult = ApolloReactHooks.MutationResult<AdminUpdateOrganizationMutation>;
export type AdminUpdateOrganizationMutationOptions = Apollo.MutationOptions<AdminUpdateOrganizationMutation, AdminUpdateOrganizationMutationVariables>;
export const InvitesOrganizationDocument = gql`
    query InvitesOrganization($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    pendingInvites {
      id
      email
      user {
        ...UserFields
      }
      assignedRole {
        ...UserRoleFields
      }
    }
  }
}
    ${UserFieldsFragmentDoc}
${UserRoleFieldsFragmentDoc}`;

/**
 * __useInvitesOrganizationQuery__
 *
 * To run a query within a React component, call `useInvitesOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitesOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitesOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useInvitesOrganizationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InvitesOrganizationQuery, InvitesOrganizationQueryVariables> & ({ variables: InvitesOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InvitesOrganizationQuery, InvitesOrganizationQueryVariables>(InvitesOrganizationDocument, options);
      }
export function useInvitesOrganizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InvitesOrganizationQuery, InvitesOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InvitesOrganizationQuery, InvitesOrganizationQueryVariables>(InvitesOrganizationDocument, options);
        }
// @ts-ignore
export function useInvitesOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InvitesOrganizationQuery, InvitesOrganizationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InvitesOrganizationQuery, InvitesOrganizationQueryVariables>;
export function useInvitesOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InvitesOrganizationQuery, InvitesOrganizationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InvitesOrganizationQuery | undefined, InvitesOrganizationQueryVariables>;
export function useInvitesOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InvitesOrganizationQuery, InvitesOrganizationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InvitesOrganizationQuery, InvitesOrganizationQueryVariables>(InvitesOrganizationDocument, options);
        }
export type InvitesOrganizationQueryHookResult = ReturnType<typeof useInvitesOrganizationQuery>;
export type InvitesOrganizationLazyQueryHookResult = ReturnType<typeof useInvitesOrganizationLazyQuery>;
export type InvitesOrganizationSuspenseQueryHookResult = ReturnType<typeof useInvitesOrganizationSuspenseQuery>;
export type InvitesOrganizationQueryResult = ApolloReactHooks.QueryResult<InvitesOrganizationQuery, InvitesOrganizationQueryVariables>;
export const DeleteSentInviteDocument = gql`
    mutation DeleteSentInvite($deleteInviteId: ID!) {
  deleteInvite(id: $deleteInviteId) {
    status
  }
}
    `;
export type DeleteSentInviteMutationFn = ApolloReactHooks.useMutation.MutationFunction<DeleteSentInviteMutation, DeleteSentInviteMutationVariables>;

/**
 * __useDeleteSentInviteMutation__
 *
 * To run a mutation, you first call `useDeleteSentInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSentInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSentInviteMutation, { data, loading, error }] = useDeleteSentInviteMutation({
 *   variables: {
 *      deleteInviteId: // value for 'deleteInviteId'
 *   },
 * });
 */
export function useDeleteSentInviteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteSentInviteMutation, DeleteSentInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteSentInviteMutation, DeleteSentInviteMutationVariables>(DeleteSentInviteDocument, options);
      }
export type DeleteSentInviteMutationHookResult = ReturnType<typeof useDeleteSentInviteMutation>;
export type DeleteSentInviteMutationResult = ApolloReactHooks.MutationResult<DeleteSentInviteMutation>;
export type DeleteSentInviteMutationOptions = Apollo.MutationOptions<DeleteSentInviteMutation, DeleteSentInviteMutationVariables>;
export const MembersOrganizationDocument = gql`
    query MembersOrganization($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    userRoles {
      id
      user {
        ...UserFields
      }
      assignedRole {
        ...UserRoleFields
      }
    }
  }
}
    ${UserFieldsFragmentDoc}
${UserRoleFieldsFragmentDoc}`;

/**
 * __useMembersOrganizationQuery__
 *
 * To run a query within a React component, call `useMembersOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembersOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembersOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useMembersOrganizationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MembersOrganizationQuery, MembersOrganizationQueryVariables> & ({ variables: MembersOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MembersOrganizationQuery, MembersOrganizationQueryVariables>(MembersOrganizationDocument, options);
      }
export function useMembersOrganizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MembersOrganizationQuery, MembersOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MembersOrganizationQuery, MembersOrganizationQueryVariables>(MembersOrganizationDocument, options);
        }
// @ts-ignore
export function useMembersOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MembersOrganizationQuery, MembersOrganizationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MembersOrganizationQuery, MembersOrganizationQueryVariables>;
export function useMembersOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MembersOrganizationQuery, MembersOrganizationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MembersOrganizationQuery | undefined, MembersOrganizationQueryVariables>;
export function useMembersOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MembersOrganizationQuery, MembersOrganizationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MembersOrganizationQuery, MembersOrganizationQueryVariables>(MembersOrganizationDocument, options);
        }
export type MembersOrganizationQueryHookResult = ReturnType<typeof useMembersOrganizationQuery>;
export type MembersOrganizationLazyQueryHookResult = ReturnType<typeof useMembersOrganizationLazyQuery>;
export type MembersOrganizationSuspenseQueryHookResult = ReturnType<typeof useMembersOrganizationSuspenseQuery>;
export type MembersOrganizationQueryResult = ApolloReactHooks.QueryResult<MembersOrganizationQuery, MembersOrganizationQueryVariables>;
export const RemoveMemberDocument = gql`
    mutation RemoveMember($organizationId: ID!, $userId: ID!) {
  removeMember(id: $organizationId, userId: $userId)
}
    `;
export type RemoveMemberMutationFn = ApolloReactHooks.useMutation.MutationFunction<RemoveMemberMutation, RemoveMemberMutationVariables>;

/**
 * __useRemoveMemberMutation__
 *
 * To run a mutation, you first call `useRemoveMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMemberMutation, { data, loading, error }] = useRemoveMemberMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveMemberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveMemberMutation, RemoveMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveMemberMutation, RemoveMemberMutationVariables>(RemoveMemberDocument, options);
      }
export type RemoveMemberMutationHookResult = ReturnType<typeof useRemoveMemberMutation>;
export type RemoveMemberMutationResult = ApolloReactHooks.MutationResult<RemoveMemberMutation>;
export type RemoveMemberMutationOptions = Apollo.MutationOptions<RemoveMemberMutation, RemoveMemberMutationVariables>;
export const UpdateUserRoleDocument = gql`
    mutation UpdateUserRole($input: UpdateUserRoleInput!) {
  updateUserRole(input: $input) {
    id
    assignedRole {
      ...UserRoleFields
    }
  }
}
    ${UserRoleFieldsFragmentDoc}`;
export type UpdateUserRoleMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;

/**
 * __useUpdateUserRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRoleMutation, { data, loading, error }] = useUpdateUserRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>(UpdateUserRoleDocument, options);
      }
export type UpdateUserRoleMutationHookResult = ReturnType<typeof useUpdateUserRoleMutation>;
export type UpdateUserRoleMutationResult = ApolloReactHooks.MutationResult<UpdateUserRoleMutation>;
export type UpdateUserRoleMutationOptions = Apollo.MutationOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;
export const OrganizationNameImageDocument = gql`
    query OrganizationNameImage($organizationId: ID!) {
  organization(id: $organizationId) {
    name
    imageUrl
  }
}
    `;

/**
 * __useOrganizationNameImageQuery__
 *
 * To run a query within a React component, call `useOrganizationNameImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationNameImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationNameImageQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationNameImageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationNameImageQuery, OrganizationNameImageQueryVariables> & ({ variables: OrganizationNameImageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationNameImageQuery, OrganizationNameImageQueryVariables>(OrganizationNameImageDocument, options);
      }
export function useOrganizationNameImageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationNameImageQuery, OrganizationNameImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationNameImageQuery, OrganizationNameImageQueryVariables>(OrganizationNameImageDocument, options);
        }
// @ts-ignore
export function useOrganizationNameImageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationNameImageQuery, OrganizationNameImageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationNameImageQuery, OrganizationNameImageQueryVariables>;
export function useOrganizationNameImageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationNameImageQuery, OrganizationNameImageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationNameImageQuery | undefined, OrganizationNameImageQueryVariables>;
export function useOrganizationNameImageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationNameImageQuery, OrganizationNameImageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationNameImageQuery, OrganizationNameImageQueryVariables>(OrganizationNameImageDocument, options);
        }
export type OrganizationNameImageQueryHookResult = ReturnType<typeof useOrganizationNameImageQuery>;
export type OrganizationNameImageLazyQueryHookResult = ReturnType<typeof useOrganizationNameImageLazyQuery>;
export type OrganizationNameImageSuspenseQueryHookResult = ReturnType<typeof useOrganizationNameImageSuspenseQuery>;
export type OrganizationNameImageQueryResult = ApolloReactHooks.QueryResult<OrganizationNameImageQuery, OrganizationNameImageQueryVariables>;
export const OrganizationsPageDocument = gql`
    query OrganizationsPage($pageNumber: Int!, $pageItemsCount: Int!, $searchQuery: String, $organizationType: OrganizationType, $ancestorOrganizationId: ID, $includeAncestor: Boolean) {
  organizationsPage(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    searchQuery: $searchQuery
    organizationType: $organizationType
    ancestorOrganizationId: $ancestorOrganizationId
    includeAncestor: $includeAncestor
  ) {
    nodes {
      addressLine1
      audiencesCount
      addressLine2
      city
      country
      createdAt
      subscriptionOverride
      id
      imageUrl
      legalName
      name
      pixelMatchingCadence
      paidSubscription
      businessDataEnabled
      ...DisableEmailValidationFields
      pulseEnabled
      globalSearchEnabled
      customerListEnabled
      phone
      state
      updatedAt
      hiddenPeopleFields
      lookalikeEnabled
      matchbackEnabled
      zip
      userRoles {
        id
        user {
          id
        }
      }
      organizationType
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${DisableEmailValidationFieldsFragmentDoc}`;

/**
 * __useOrganizationsPageQuery__
 *
 * To run a query within a React component, call `useOrganizationsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationsPageQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      searchQuery: // value for 'searchQuery'
 *      organizationType: // value for 'organizationType'
 *      ancestorOrganizationId: // value for 'ancestorOrganizationId'
 *      includeAncestor: // value for 'includeAncestor'
 *   },
 * });
 */
export function useOrganizationsPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationsPageQuery, OrganizationsPageQueryVariables> & ({ variables: OrganizationsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationsPageQuery, OrganizationsPageQueryVariables>(OrganizationsPageDocument, options);
      }
export function useOrganizationsPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationsPageQuery, OrganizationsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationsPageQuery, OrganizationsPageQueryVariables>(OrganizationsPageDocument, options);
        }
// @ts-ignore
export function useOrganizationsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationsPageQuery, OrganizationsPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationsPageQuery, OrganizationsPageQueryVariables>;
export function useOrganizationsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationsPageQuery, OrganizationsPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationsPageQuery | undefined, OrganizationsPageQueryVariables>;
export function useOrganizationsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationsPageQuery, OrganizationsPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationsPageQuery, OrganizationsPageQueryVariables>(OrganizationsPageDocument, options);
        }
export type OrganizationsPageQueryHookResult = ReturnType<typeof useOrganizationsPageQuery>;
export type OrganizationsPageLazyQueryHookResult = ReturnType<typeof useOrganizationsPageLazyQuery>;
export type OrganizationsPageSuspenseQueryHookResult = ReturnType<typeof useOrganizationsPageSuspenseQuery>;
export type OrganizationsPageQueryResult = ApolloReactHooks.QueryResult<OrganizationsPageQuery, OrganizationsPageQueryVariables>;
export const ListOrganizationRolesDocument = gql`
    query ListOrganizationRoles($organizationId: ID!) {
  listOrganizationRoles(id: $organizationId) {
    id
    name
    organization {
      id
      name
    }
  }
}
    `;

/**
 * __useListOrganizationRolesQuery__
 *
 * To run a query within a React component, call `useListOrganizationRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOrganizationRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOrganizationRolesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useListOrganizationRolesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ListOrganizationRolesQuery, ListOrganizationRolesQueryVariables> & ({ variables: ListOrganizationRolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListOrganizationRolesQuery, ListOrganizationRolesQueryVariables>(ListOrganizationRolesDocument, options);
      }
export function useListOrganizationRolesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListOrganizationRolesQuery, ListOrganizationRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListOrganizationRolesQuery, ListOrganizationRolesQueryVariables>(ListOrganizationRolesDocument, options);
        }
// @ts-ignore
export function useListOrganizationRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ListOrganizationRolesQuery, ListOrganizationRolesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ListOrganizationRolesQuery, ListOrganizationRolesQueryVariables>;
export function useListOrganizationRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ListOrganizationRolesQuery, ListOrganizationRolesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ListOrganizationRolesQuery | undefined, ListOrganizationRolesQueryVariables>;
export function useListOrganizationRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ListOrganizationRolesQuery, ListOrganizationRolesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ListOrganizationRolesQuery, ListOrganizationRolesQueryVariables>(ListOrganizationRolesDocument, options);
        }
export type ListOrganizationRolesQueryHookResult = ReturnType<typeof useListOrganizationRolesQuery>;
export type ListOrganizationRolesLazyQueryHookResult = ReturnType<typeof useListOrganizationRolesLazyQuery>;
export type ListOrganizationRolesSuspenseQueryHookResult = ReturnType<typeof useListOrganizationRolesSuspenseQuery>;
export type ListOrganizationRolesQueryResult = ApolloReactHooks.QueryResult<ListOrganizationRolesQuery, ListOrganizationRolesQueryVariables>;
export const PeopleCountsDocument = gql`
    query PeopleCounts($field: FilterStringField!, $filters: [PersonFilterInput], $takeIntoAccountSameFieldFilters: Boolean) {
  peopleCounts(
    field: $field
    filters: $filters
    takeIntoAccountSameFieldFilters: $takeIntoAccountSameFieldFilters
  ) {
    key
    count
  }
}
    `;

/**
 * __usePeopleCountsQuery__
 *
 * To run a query within a React component, call `usePeopleCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleCountsQuery({
 *   variables: {
 *      field: // value for 'field'
 *      filters: // value for 'filters'
 *      takeIntoAccountSameFieldFilters: // value for 'takeIntoAccountSameFieldFilters'
 *   },
 * });
 */
export function usePeopleCountsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PeopleCountsQuery, PeopleCountsQueryVariables> & ({ variables: PeopleCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PeopleCountsQuery, PeopleCountsQueryVariables>(PeopleCountsDocument, options);
      }
export function usePeopleCountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PeopleCountsQuery, PeopleCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PeopleCountsQuery, PeopleCountsQueryVariables>(PeopleCountsDocument, options);
        }
// @ts-ignore
export function usePeopleCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PeopleCountsQuery, PeopleCountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PeopleCountsQuery, PeopleCountsQueryVariables>;
export function usePeopleCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PeopleCountsQuery, PeopleCountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PeopleCountsQuery | undefined, PeopleCountsQueryVariables>;
export function usePeopleCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PeopleCountsQuery, PeopleCountsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PeopleCountsQuery, PeopleCountsQueryVariables>(PeopleCountsDocument, options);
        }
export type PeopleCountsQueryHookResult = ReturnType<typeof usePeopleCountsQuery>;
export type PeopleCountsLazyQueryHookResult = ReturnType<typeof usePeopleCountsLazyQuery>;
export type PeopleCountsSuspenseQueryHookResult = ReturnType<typeof usePeopleCountsSuspenseQuery>;
export type PeopleCountsQueryResult = ApolloReactHooks.QueryResult<PeopleCountsQuery, PeopleCountsQueryVariables>;
export const PeopleFieldsCountsDocument = gql`
    query PeopleFieldsCounts($field: FilterStringField, $customField: String, $first: Int!, $filters: [PersonFilterInput], $takeIntoAccountSameFieldFilters: Boolean, $parentAudienceId: ID, $searchQuery: String, $after: String) {
  peopleFieldCounts(
    field: $field
    customField: $customField
    first: $first
    filters: $filters
    takeIntoAccountSameFieldFilters: $takeIntoAccountSameFieldFilters
    parentAudienceId: $parentAudienceId
    searchQuery: $searchQuery
    after: $after
  ) {
    nodes {
      count
      key
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __usePeopleFieldsCountsQuery__
 *
 * To run a query within a React component, call `usePeopleFieldsCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleFieldsCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleFieldsCountsQuery({
 *   variables: {
 *      field: // value for 'field'
 *      customField: // value for 'customField'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *      takeIntoAccountSameFieldFilters: // value for 'takeIntoAccountSameFieldFilters'
 *      parentAudienceId: // value for 'parentAudienceId'
 *      searchQuery: // value for 'searchQuery'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePeopleFieldsCountsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PeopleFieldsCountsQuery, PeopleFieldsCountsQueryVariables> & ({ variables: PeopleFieldsCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PeopleFieldsCountsQuery, PeopleFieldsCountsQueryVariables>(PeopleFieldsCountsDocument, options);
      }
export function usePeopleFieldsCountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PeopleFieldsCountsQuery, PeopleFieldsCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PeopleFieldsCountsQuery, PeopleFieldsCountsQueryVariables>(PeopleFieldsCountsDocument, options);
        }
// @ts-ignore
export function usePeopleFieldsCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PeopleFieldsCountsQuery, PeopleFieldsCountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PeopleFieldsCountsQuery, PeopleFieldsCountsQueryVariables>;
export function usePeopleFieldsCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PeopleFieldsCountsQuery, PeopleFieldsCountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PeopleFieldsCountsQuery | undefined, PeopleFieldsCountsQueryVariables>;
export function usePeopleFieldsCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PeopleFieldsCountsQuery, PeopleFieldsCountsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PeopleFieldsCountsQuery, PeopleFieldsCountsQueryVariables>(PeopleFieldsCountsDocument, options);
        }
export type PeopleFieldsCountsQueryHookResult = ReturnType<typeof usePeopleFieldsCountsQuery>;
export type PeopleFieldsCountsLazyQueryHookResult = ReturnType<typeof usePeopleFieldsCountsLazyQuery>;
export type PeopleFieldsCountsSuspenseQueryHookResult = ReturnType<typeof usePeopleFieldsCountsSuspenseQuery>;
export type PeopleFieldsCountsQueryResult = ApolloReactHooks.QueryResult<PeopleFieldsCountsQuery, PeopleFieldsCountsQueryVariables>;
export const PeopleFieldsDocument = gql`
    query PeopleFields {
  peopleFields {
    category
    filterField
    title
    type
    configuration {
      fieldAudienceTypes
      numberFilterConfiguration {
        from
        to
      }
      stringFilterConfiguration {
        condition
        onlyExistence
        isExtendedStringFilter
      }
    }
  }
}
    `;

/**
 * __usePeopleFieldsQuery__
 *
 * To run a query within a React component, call `usePeopleFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePeopleFieldsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PeopleFieldsQuery, PeopleFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PeopleFieldsQuery, PeopleFieldsQueryVariables>(PeopleFieldsDocument, options);
      }
export function usePeopleFieldsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PeopleFieldsQuery, PeopleFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PeopleFieldsQuery, PeopleFieldsQueryVariables>(PeopleFieldsDocument, options);
        }
// @ts-ignore
export function usePeopleFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PeopleFieldsQuery, PeopleFieldsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PeopleFieldsQuery, PeopleFieldsQueryVariables>;
export function usePeopleFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PeopleFieldsQuery, PeopleFieldsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PeopleFieldsQuery | undefined, PeopleFieldsQueryVariables>;
export function usePeopleFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PeopleFieldsQuery, PeopleFieldsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PeopleFieldsQuery, PeopleFieldsQueryVariables>(PeopleFieldsDocument, options);
        }
export type PeopleFieldsQueryHookResult = ReturnType<typeof usePeopleFieldsQuery>;
export type PeopleFieldsLazyQueryHookResult = ReturnType<typeof usePeopleFieldsLazyQuery>;
export type PeopleFieldsSuspenseQueryHookResult = ReturnType<typeof usePeopleFieldsSuspenseQuery>;
export type PeopleFieldsQueryResult = ApolloReactHooks.QueryResult<PeopleFieldsQuery, PeopleFieldsQueryVariables>;
export const JourneyDocument = gql`
    query Journey($first: Int!, $personId: ID!, $audienceId: ID!, $after: String, $filters: [JourneyFilterInput!]) {
  audience(id: $audienceId) {
    personJourney(
      personId: $personId
      first: $first
      after: $after
      filters: $filters
    ) {
      nodes {
        date
        id
        url
        ip
        os {
          name
          version
        }
        ipLocation {
          countryName
          countryCode
          regionName
          postalCode
          city
        }
        utmCampaign
        tealiumVisitorId
        gaSessionId
        utmMedium
        utmSource
        browser {
          name
          version
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    `;

/**
 * __useJourneyQuery__
 *
 * To run a query within a React component, call `useJourneyQuery` and pass it any options that fit your needs.
 * When your component renders, `useJourneyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJourneyQuery({
 *   variables: {
 *      first: // value for 'first'
 *      personId: // value for 'personId'
 *      audienceId: // value for 'audienceId'
 *      after: // value for 'after'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useJourneyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<JourneyQuery, JourneyQueryVariables> & ({ variables: JourneyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<JourneyQuery, JourneyQueryVariables>(JourneyDocument, options);
      }
export function useJourneyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<JourneyQuery, JourneyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<JourneyQuery, JourneyQueryVariables>(JourneyDocument, options);
        }
// @ts-ignore
export function useJourneySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<JourneyQuery, JourneyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<JourneyQuery, JourneyQueryVariables>;
export function useJourneySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<JourneyQuery, JourneyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<JourneyQuery | undefined, JourneyQueryVariables>;
export function useJourneySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<JourneyQuery, JourneyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<JourneyQuery, JourneyQueryVariables>(JourneyDocument, options);
        }
export type JourneyQueryHookResult = ReturnType<typeof useJourneyQuery>;
export type JourneyLazyQueryHookResult = ReturnType<typeof useJourneyLazyQuery>;
export type JourneySuspenseQueryHookResult = ReturnType<typeof useJourneySuspenseQuery>;
export type JourneyQueryResult = ApolloReactHooks.QueryResult<JourneyQuery, JourneyQueryVariables>;
export const PersonJourneyGroupsDocument = gql`
    query PersonJourneyGroups($audienceId: ID!, $personId: ID!, $first: Int!, $groupBy: JourneyGroupByInput!) {
  person(audienceId: $audienceId, personId: $personId) {
    journeyGroups(first: $first, groupBy: $groupBy) {
      nodes {
        count
        key
      }
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
}
    `;

/**
 * __usePersonJourneyGroupsQuery__
 *
 * To run a query within a React component, call `usePersonJourneyGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonJourneyGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonJourneyGroupsQuery({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *      personId: // value for 'personId'
 *      first: // value for 'first'
 *      groupBy: // value for 'groupBy'
 *   },
 * });
 */
export function usePersonJourneyGroupsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PersonJourneyGroupsQuery, PersonJourneyGroupsQueryVariables> & ({ variables: PersonJourneyGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PersonJourneyGroupsQuery, PersonJourneyGroupsQueryVariables>(PersonJourneyGroupsDocument, options);
      }
export function usePersonJourneyGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PersonJourneyGroupsQuery, PersonJourneyGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PersonJourneyGroupsQuery, PersonJourneyGroupsQueryVariables>(PersonJourneyGroupsDocument, options);
        }
// @ts-ignore
export function usePersonJourneyGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PersonJourneyGroupsQuery, PersonJourneyGroupsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PersonJourneyGroupsQuery, PersonJourneyGroupsQueryVariables>;
export function usePersonJourneyGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PersonJourneyGroupsQuery, PersonJourneyGroupsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PersonJourneyGroupsQuery | undefined, PersonJourneyGroupsQueryVariables>;
export function usePersonJourneyGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PersonJourneyGroupsQuery, PersonJourneyGroupsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PersonJourneyGroupsQuery, PersonJourneyGroupsQueryVariables>(PersonJourneyGroupsDocument, options);
        }
export type PersonJourneyGroupsQueryHookResult = ReturnType<typeof usePersonJourneyGroupsQuery>;
export type PersonJourneyGroupsLazyQueryHookResult = ReturnType<typeof usePersonJourneyGroupsLazyQuery>;
export type PersonJourneyGroupsSuspenseQueryHookResult = ReturnType<typeof usePersonJourneyGroupsSuspenseQuery>;
export type PersonJourneyGroupsQueryResult = ApolloReactHooks.QueryResult<PersonJourneyGroupsQuery, PersonJourneyGroupsQueryVariables>;
export const PeopleNumberHistogramDocument = gql`
    query PeopleNumberHistogram($field: FilterNumberField!, $interval: Int, $min: Int, $max: Int, $filters: [PersonFilterInput], $takeIntoAccountSameFieldFilters: Boolean) {
  peopleNumberHistogram(
    field: $field
    interval: $interval
    min: $min
    max: $max
    filters: $filters
    takeIntoAccountSameFieldFilters: $takeIntoAccountSameFieldFilters
  ) {
    count
    key
  }
}
    `;

/**
 * __usePeopleNumberHistogramQuery__
 *
 * To run a query within a React component, call `usePeopleNumberHistogramQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleNumberHistogramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleNumberHistogramQuery({
 *   variables: {
 *      field: // value for 'field'
 *      interval: // value for 'interval'
 *      min: // value for 'min'
 *      max: // value for 'max'
 *      filters: // value for 'filters'
 *      takeIntoAccountSameFieldFilters: // value for 'takeIntoAccountSameFieldFilters'
 *   },
 * });
 */
export function usePeopleNumberHistogramQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PeopleNumberHistogramQuery, PeopleNumberHistogramQueryVariables> & ({ variables: PeopleNumberHistogramQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PeopleNumberHistogramQuery, PeopleNumberHistogramQueryVariables>(PeopleNumberHistogramDocument, options);
      }
export function usePeopleNumberHistogramLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PeopleNumberHistogramQuery, PeopleNumberHistogramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PeopleNumberHistogramQuery, PeopleNumberHistogramQueryVariables>(PeopleNumberHistogramDocument, options);
        }
// @ts-ignore
export function usePeopleNumberHistogramSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PeopleNumberHistogramQuery, PeopleNumberHistogramQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PeopleNumberHistogramQuery, PeopleNumberHistogramQueryVariables>;
export function usePeopleNumberHistogramSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PeopleNumberHistogramQuery, PeopleNumberHistogramQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PeopleNumberHistogramQuery | undefined, PeopleNumberHistogramQueryVariables>;
export function usePeopleNumberHistogramSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PeopleNumberHistogramQuery, PeopleNumberHistogramQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PeopleNumberHistogramQuery, PeopleNumberHistogramQueryVariables>(PeopleNumberHistogramDocument, options);
        }
export type PeopleNumberHistogramQueryHookResult = ReturnType<typeof usePeopleNumberHistogramQuery>;
export type PeopleNumberHistogramLazyQueryHookResult = ReturnType<typeof usePeopleNumberHistogramLazyQuery>;
export type PeopleNumberHistogramSuspenseQueryHookResult = ReturnType<typeof usePeopleNumberHistogramSuspenseQuery>;
export type PeopleNumberHistogramQueryResult = ApolloReactHooks.QueryResult<PeopleNumberHistogramQuery, PeopleNumberHistogramQueryVariables>;
export const PersonDocument = gql`
    query Person($audienceId: ID!, $personId: ID!) {
  person(audienceId: $audienceId, personId: $personId) {
    id
    email
    gender
    firstName
    lastName
    address
    city
    state
    zip
  }
}
    `;

/**
 * __usePersonQuery__
 *
 * To run a query within a React component, call `usePersonQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonQuery({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function usePersonQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PersonQuery, PersonQueryVariables> & ({ variables: PersonQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PersonQuery, PersonQueryVariables>(PersonDocument, options);
      }
export function usePersonLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PersonQuery, PersonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PersonQuery, PersonQueryVariables>(PersonDocument, options);
        }
// @ts-ignore
export function usePersonSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PersonQuery, PersonQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PersonQuery, PersonQueryVariables>;
export function usePersonSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PersonQuery, PersonQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PersonQuery | undefined, PersonQueryVariables>;
export function usePersonSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PersonQuery, PersonQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PersonQuery, PersonQueryVariables>(PersonDocument, options);
        }
export type PersonQueryHookResult = ReturnType<typeof usePersonQuery>;
export type PersonLazyQueryHookResult = ReturnType<typeof usePersonLazyQuery>;
export type PersonSuspenseQueryHookResult = ReturnType<typeof usePersonSuspenseQuery>;
export type PersonQueryResult = ApolloReactHooks.QueryResult<PersonQuery, PersonQueryVariables>;
export const PeopleDateHistogramDocument = gql`
    query PeopleDateHistogram($field: FilterDateField!, $audienceId: ID!, $min: Date, $max: Date, $interval: DateIntervalInput!) {
  audience(id: $audienceId) {
    peopleDateHistogram(field: $field, min: $min, max: $max, interval: $interval) {
      key
      count
    }
  }
}
    `;

/**
 * __usePeopleDateHistogramQuery__
 *
 * To run a query within a React component, call `usePeopleDateHistogramQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleDateHistogramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleDateHistogramQuery({
 *   variables: {
 *      field: // value for 'field'
 *      audienceId: // value for 'audienceId'
 *      min: // value for 'min'
 *      max: // value for 'max'
 *      interval: // value for 'interval'
 *   },
 * });
 */
export function usePeopleDateHistogramQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PeopleDateHistogramQuery, PeopleDateHistogramQueryVariables> & ({ variables: PeopleDateHistogramQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PeopleDateHistogramQuery, PeopleDateHistogramQueryVariables>(PeopleDateHistogramDocument, options);
      }
export function usePeopleDateHistogramLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PeopleDateHistogramQuery, PeopleDateHistogramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PeopleDateHistogramQuery, PeopleDateHistogramQueryVariables>(PeopleDateHistogramDocument, options);
        }
// @ts-ignore
export function usePeopleDateHistogramSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PeopleDateHistogramQuery, PeopleDateHistogramQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PeopleDateHistogramQuery, PeopleDateHistogramQueryVariables>;
export function usePeopleDateHistogramSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PeopleDateHistogramQuery, PeopleDateHistogramQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PeopleDateHistogramQuery | undefined, PeopleDateHistogramQueryVariables>;
export function usePeopleDateHistogramSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PeopleDateHistogramQuery, PeopleDateHistogramQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PeopleDateHistogramQuery, PeopleDateHistogramQueryVariables>(PeopleDateHistogramDocument, options);
        }
export type PeopleDateHistogramQueryHookResult = ReturnType<typeof usePeopleDateHistogramQuery>;
export type PeopleDateHistogramLazyQueryHookResult = ReturnType<typeof usePeopleDateHistogramLazyQuery>;
export type PeopleDateHistogramSuspenseQueryHookResult = ReturnType<typeof usePeopleDateHistogramSuspenseQuery>;
export type PeopleDateHistogramQueryResult = ApolloReactHooks.QueryResult<PeopleDateHistogramQuery, PeopleDateHistogramQueryVariables>;
export const PixelMatchCountsDocument = gql`
    query PixelMatchCounts($dateRange: DateOperatorsInput, $organizationId: ID) {
  pixelMatchCounts(dateRange: $dateRange, organizationId: $organizationId) {
    matchCount
    lowestTraffic {
      audience {
        id
      }
      count
    }
    highestTraffic {
      audience {
        id
      }
      count
    }
  }
}
    `;

/**
 * __usePixelMatchCountsQuery__
 *
 * To run a query within a React component, call `usePixelMatchCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePixelMatchCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePixelMatchCountsQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function usePixelMatchCountsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PixelMatchCountsQuery, PixelMatchCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PixelMatchCountsQuery, PixelMatchCountsQueryVariables>(PixelMatchCountsDocument, options);
      }
export function usePixelMatchCountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PixelMatchCountsQuery, PixelMatchCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PixelMatchCountsQuery, PixelMatchCountsQueryVariables>(PixelMatchCountsDocument, options);
        }
// @ts-ignore
export function usePixelMatchCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PixelMatchCountsQuery, PixelMatchCountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PixelMatchCountsQuery, PixelMatchCountsQueryVariables>;
export function usePixelMatchCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PixelMatchCountsQuery, PixelMatchCountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PixelMatchCountsQuery | undefined, PixelMatchCountsQueryVariables>;
export function usePixelMatchCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PixelMatchCountsQuery, PixelMatchCountsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PixelMatchCountsQuery, PixelMatchCountsQueryVariables>(PixelMatchCountsDocument, options);
        }
export type PixelMatchCountsQueryHookResult = ReturnType<typeof usePixelMatchCountsQuery>;
export type PixelMatchCountsLazyQueryHookResult = ReturnType<typeof usePixelMatchCountsLazyQuery>;
export type PixelMatchCountsSuspenseQueryHookResult = ReturnType<typeof usePixelMatchCountsSuspenseQuery>;
export type PixelMatchCountsQueryResult = ApolloReactHooks.QueryResult<PixelMatchCountsQuery, PixelMatchCountsQueryVariables>;
export const PixelStatusCountDocument = gql`
    query PixelStatusCount($organizationId: ID) {
  pixelStatusCount(organizationId: $organizationId) {
    nearQuotaReached
    quotaReached
    withoutRecentMatches
  }
}
    `;

/**
 * __usePixelStatusCountQuery__
 *
 * To run a query within a React component, call `usePixelStatusCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePixelStatusCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePixelStatusCountQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function usePixelStatusCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PixelStatusCountQuery, PixelStatusCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PixelStatusCountQuery, PixelStatusCountQueryVariables>(PixelStatusCountDocument, options);
      }
export function usePixelStatusCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PixelStatusCountQuery, PixelStatusCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PixelStatusCountQuery, PixelStatusCountQueryVariables>(PixelStatusCountDocument, options);
        }
// @ts-ignore
export function usePixelStatusCountSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PixelStatusCountQuery, PixelStatusCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PixelStatusCountQuery, PixelStatusCountQueryVariables>;
export function usePixelStatusCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PixelStatusCountQuery, PixelStatusCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PixelStatusCountQuery | undefined, PixelStatusCountQueryVariables>;
export function usePixelStatusCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PixelStatusCountQuery, PixelStatusCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PixelStatusCountQuery, PixelStatusCountQueryVariables>(PixelStatusCountDocument, options);
        }
export type PixelStatusCountQueryHookResult = ReturnType<typeof usePixelStatusCountQuery>;
export type PixelStatusCountLazyQueryHookResult = ReturnType<typeof usePixelStatusCountLazyQuery>;
export type PixelStatusCountSuspenseQueryHookResult = ReturnType<typeof usePixelStatusCountSuspenseQuery>;
export type PixelStatusCountQueryResult = ApolloReactHooks.QueryResult<PixelStatusCountQuery, PixelStatusCountQueryVariables>;
export const PixelMatchDateHistogramDocument = gql`
    query PixelMatchDateHistogram($min: Date!, $max: Date!, $interval: DateIntervalInput!, $organizationId: ID) {
  pixelMatchDateHistogram(
    min: $min
    max: $max
    interval: $interval
    organizationId: $organizationId
  ) {
    count
    key
  }
}
    `;

/**
 * __usePixelMatchDateHistogramQuery__
 *
 * To run a query within a React component, call `usePixelMatchDateHistogramQuery` and pass it any options that fit your needs.
 * When your component renders, `usePixelMatchDateHistogramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePixelMatchDateHistogramQuery({
 *   variables: {
 *      min: // value for 'min'
 *      max: // value for 'max'
 *      interval: // value for 'interval'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function usePixelMatchDateHistogramQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PixelMatchDateHistogramQuery, PixelMatchDateHistogramQueryVariables> & ({ variables: PixelMatchDateHistogramQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PixelMatchDateHistogramQuery, PixelMatchDateHistogramQueryVariables>(PixelMatchDateHistogramDocument, options);
      }
export function usePixelMatchDateHistogramLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PixelMatchDateHistogramQuery, PixelMatchDateHistogramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PixelMatchDateHistogramQuery, PixelMatchDateHistogramQueryVariables>(PixelMatchDateHistogramDocument, options);
        }
// @ts-ignore
export function usePixelMatchDateHistogramSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PixelMatchDateHistogramQuery, PixelMatchDateHistogramQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PixelMatchDateHistogramQuery, PixelMatchDateHistogramQueryVariables>;
export function usePixelMatchDateHistogramSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PixelMatchDateHistogramQuery, PixelMatchDateHistogramQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PixelMatchDateHistogramQuery | undefined, PixelMatchDateHistogramQueryVariables>;
export function usePixelMatchDateHistogramSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PixelMatchDateHistogramQuery, PixelMatchDateHistogramQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PixelMatchDateHistogramQuery, PixelMatchDateHistogramQueryVariables>(PixelMatchDateHistogramDocument, options);
        }
export type PixelMatchDateHistogramQueryHookResult = ReturnType<typeof usePixelMatchDateHistogramQuery>;
export type PixelMatchDateHistogramLazyQueryHookResult = ReturnType<typeof usePixelMatchDateHistogramLazyQuery>;
export type PixelMatchDateHistogramSuspenseQueryHookResult = ReturnType<typeof usePixelMatchDateHistogramSuspenseQuery>;
export type PixelMatchDateHistogramQueryResult = ApolloReactHooks.QueryResult<PixelMatchDateHistogramQuery, PixelMatchDateHistogramQueryVariables>;
export const AudiencePixelSettingsDocument = gql`
    query AudiencePixelSettings($audienceId: ID!) {
  audience(id: $audienceId) {
    id
    pixelSettings {
      hostAndPath
      location {
        address
        city
        state
      }
      codeSnippets {
        head
        body
      }
      quota {
        enabled
        limit
      }
      billing {
        dayOfMonth
      }
      pixelEnabled
      pixelStatus
    }
    name
    createdAt
  }
}
    `;

/**
 * __useAudiencePixelSettingsQuery__
 *
 * To run a query within a React component, call `useAudiencePixelSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudiencePixelSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudiencePixelSettingsQuery({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *   },
 * });
 */
export function useAudiencePixelSettingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AudiencePixelSettingsQuery, AudiencePixelSettingsQueryVariables> & ({ variables: AudiencePixelSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AudiencePixelSettingsQuery, AudiencePixelSettingsQueryVariables>(AudiencePixelSettingsDocument, options);
      }
export function useAudiencePixelSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AudiencePixelSettingsQuery, AudiencePixelSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AudiencePixelSettingsQuery, AudiencePixelSettingsQueryVariables>(AudiencePixelSettingsDocument, options);
        }
// @ts-ignore
export function useAudiencePixelSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AudiencePixelSettingsQuery, AudiencePixelSettingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AudiencePixelSettingsQuery, AudiencePixelSettingsQueryVariables>;
export function useAudiencePixelSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AudiencePixelSettingsQuery, AudiencePixelSettingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AudiencePixelSettingsQuery | undefined, AudiencePixelSettingsQueryVariables>;
export function useAudiencePixelSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AudiencePixelSettingsQuery, AudiencePixelSettingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AudiencePixelSettingsQuery, AudiencePixelSettingsQueryVariables>(AudiencePixelSettingsDocument, options);
        }
export type AudiencePixelSettingsQueryHookResult = ReturnType<typeof useAudiencePixelSettingsQuery>;
export type AudiencePixelSettingsLazyQueryHookResult = ReturnType<typeof useAudiencePixelSettingsLazyQuery>;
export type AudiencePixelSettingsSuspenseQueryHookResult = ReturnType<typeof useAudiencePixelSettingsSuspenseQuery>;
export type AudiencePixelSettingsQueryResult = ApolloReactHooks.QueryResult<AudiencePixelSettingsQuery, AudiencePixelSettingsQueryVariables>;
export const ProductsDocument = gql`
    query Products {
  products {
    id
    name
    description
    priceInCents
    intervalUnit
    interval
    expirationInterval
    handle
    productFamily {
      name
    }
    publicSignupPages {
      enabled
      url
    }
    components {
      id
      unitName
      unitPrice
    }
    budgetPerPeriod
  }
}
    `;

/**
 * __useProductsQuery__
 *
 * To run a query within a React component, call `useProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
      }
export function useProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
        }
// @ts-ignore
export function useProductsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProductsQuery, ProductsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductsQuery, ProductsQueryVariables>;
export function useProductsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductsQuery, ProductsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductsQuery | undefined, ProductsQueryVariables>;
export function useProductsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
        }
export type ProductsQueryHookResult = ReturnType<typeof useProductsQuery>;
export type ProductsLazyQueryHookResult = ReturnType<typeof useProductsLazyQuery>;
export type ProductsSuspenseQueryHookResult = ReturnType<typeof useProductsSuspenseQuery>;
export type ProductsQueryResult = ApolloReactHooks.QueryResult<ProductsQuery, ProductsQueryVariables>;
export const PromptPersonFilterDocument = gql`
    query PromptPersonFilter($promptPersonFilterParams: PromptPersonFilterInput!) {
  promptPersonFilter(promptPersonFilterParams: $promptPersonFilterParams) {
    filters {
      ...BasicFilterFields
      compoundFilter {
        filters {
          ...BasicFilterFields
          compoundFilter {
            filters {
              ...BasicFilterFields
            }
            operator
          }
        }
        operator
      }
    }
    sessionId
  }
}
    ${BasicFilterFieldsFragmentDoc}`;

/**
 * __usePromptPersonFilterQuery__
 *
 * To run a query within a React component, call `usePromptPersonFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromptPersonFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromptPersonFilterQuery({
 *   variables: {
 *      promptPersonFilterParams: // value for 'promptPersonFilterParams'
 *   },
 * });
 */
export function usePromptPersonFilterQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PromptPersonFilterQuery, PromptPersonFilterQueryVariables> & ({ variables: PromptPersonFilterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PromptPersonFilterQuery, PromptPersonFilterQueryVariables>(PromptPersonFilterDocument, options);
      }
export function usePromptPersonFilterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PromptPersonFilterQuery, PromptPersonFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PromptPersonFilterQuery, PromptPersonFilterQueryVariables>(PromptPersonFilterDocument, options);
        }
// @ts-ignore
export function usePromptPersonFilterSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PromptPersonFilterQuery, PromptPersonFilterQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PromptPersonFilterQuery, PromptPersonFilterQueryVariables>;
export function usePromptPersonFilterSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PromptPersonFilterQuery, PromptPersonFilterQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PromptPersonFilterQuery | undefined, PromptPersonFilterQueryVariables>;
export function usePromptPersonFilterSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PromptPersonFilterQuery, PromptPersonFilterQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PromptPersonFilterQuery, PromptPersonFilterQueryVariables>(PromptPersonFilterDocument, options);
        }
export type PromptPersonFilterQueryHookResult = ReturnType<typeof usePromptPersonFilterQuery>;
export type PromptPersonFilterLazyQueryHookResult = ReturnType<typeof usePromptPersonFilterLazyQuery>;
export type PromptPersonFilterSuspenseQueryHookResult = ReturnType<typeof usePromptPersonFilterSuspenseQuery>;
export type PromptPersonFilterQueryResult = ApolloReactHooks.QueryResult<PromptPersonFilterQuery, PromptPersonFilterQueryVariables>;
export const PulseNodesDocument = gql`
    query PulseNodes($first: Int!, $after: String, $parentPaths: [String!], $searchQuery: String) {
  pulseNodes(
    first: $first
    after: $after
    parentPaths: $parentPaths
    searchQuery: $searchQuery
  ) {
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
    nodes {
      id
      name
      signalCount
      paths
    }
  }
}
    `;

/**
 * __usePulseNodesQuery__
 *
 * To run a query within a React component, call `usePulseNodesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePulseNodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePulseNodesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      parentPaths: // value for 'parentPaths'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function usePulseNodesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PulseNodesQuery, PulseNodesQueryVariables> & ({ variables: PulseNodesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PulseNodesQuery, PulseNodesQueryVariables>(PulseNodesDocument, options);
      }
export function usePulseNodesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PulseNodesQuery, PulseNodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PulseNodesQuery, PulseNodesQueryVariables>(PulseNodesDocument, options);
        }
// @ts-ignore
export function usePulseNodesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PulseNodesQuery, PulseNodesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PulseNodesQuery, PulseNodesQueryVariables>;
export function usePulseNodesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PulseNodesQuery, PulseNodesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PulseNodesQuery | undefined, PulseNodesQueryVariables>;
export function usePulseNodesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PulseNodesQuery, PulseNodesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PulseNodesQuery, PulseNodesQueryVariables>(PulseNodesDocument, options);
        }
export type PulseNodesQueryHookResult = ReturnType<typeof usePulseNodesQuery>;
export type PulseNodesLazyQueryHookResult = ReturnType<typeof usePulseNodesLazyQuery>;
export type PulseNodesSuspenseQueryHookResult = ReturnType<typeof usePulseNodesSuspenseQuery>;
export type PulseNodesQueryResult = ApolloReactHooks.QueryResult<PulseNodesQuery, PulseNodesQueryVariables>;
export const PulseNodesSignalCountDocument = gql`
    query PulseNodesSignalCount {
  pulseNodesSignalCount
}
    `;

/**
 * __usePulseNodesSignalCountQuery__
 *
 * To run a query within a React component, call `usePulseNodesSignalCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePulseNodesSignalCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePulseNodesSignalCountQuery({
 *   variables: {
 *   },
 * });
 */
export function usePulseNodesSignalCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PulseNodesSignalCountQuery, PulseNodesSignalCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PulseNodesSignalCountQuery, PulseNodesSignalCountQueryVariables>(PulseNodesSignalCountDocument, options);
      }
export function usePulseNodesSignalCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PulseNodesSignalCountQuery, PulseNodesSignalCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PulseNodesSignalCountQuery, PulseNodesSignalCountQueryVariables>(PulseNodesSignalCountDocument, options);
        }
// @ts-ignore
export function usePulseNodesSignalCountSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PulseNodesSignalCountQuery, PulseNodesSignalCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PulseNodesSignalCountQuery, PulseNodesSignalCountQueryVariables>;
export function usePulseNodesSignalCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PulseNodesSignalCountQuery, PulseNodesSignalCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PulseNodesSignalCountQuery | undefined, PulseNodesSignalCountQueryVariables>;
export function usePulseNodesSignalCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PulseNodesSignalCountQuery, PulseNodesSignalCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PulseNodesSignalCountQuery, PulseNodesSignalCountQueryVariables>(PulseNodesSignalCountDocument, options);
        }
export type PulseNodesSignalCountQueryHookResult = ReturnType<typeof usePulseNodesSignalCountQuery>;
export type PulseNodesSignalCountLazyQueryHookResult = ReturnType<typeof usePulseNodesSignalCountLazyQuery>;
export type PulseNodesSignalCountSuspenseQueryHookResult = ReturnType<typeof usePulseNodesSignalCountSuspenseQuery>;
export type PulseNodesSignalCountQueryResult = ApolloReactHooks.QueryResult<PulseNodesSignalCountQuery, PulseNodesSignalCountQueryVariables>;
export const RemoveAudienceMemberDocument = gql`
    mutation RemoveAudienceMember($audienceId: ID!, $userId: ID!) {
  removeAudienceMember(audienceId: $audienceId, userId: $userId)
}
    `;
export type RemoveAudienceMemberMutationFn = ApolloReactHooks.useMutation.MutationFunction<RemoveAudienceMemberMutation, RemoveAudienceMemberMutationVariables>;

/**
 * __useRemoveAudienceMemberMutation__
 *
 * To run a mutation, you first call `useRemoveAudienceMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAudienceMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAudienceMemberMutation, { data, loading, error }] = useRemoveAudienceMemberMutation({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveAudienceMemberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveAudienceMemberMutation, RemoveAudienceMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveAudienceMemberMutation, RemoveAudienceMemberMutationVariables>(RemoveAudienceMemberDocument, options);
      }
export type RemoveAudienceMemberMutationHookResult = ReturnType<typeof useRemoveAudienceMemberMutation>;
export type RemoveAudienceMemberMutationResult = ApolloReactHooks.MutationResult<RemoveAudienceMemberMutation>;
export type RemoveAudienceMemberMutationOptions = Apollo.MutationOptions<RemoveAudienceMemberMutation, RemoveAudienceMemberMutationVariables>;
export const ResendInviteDocument = gql`
    mutation ResendInvite($resendInviteId: ID!) {
  resendInvite(id: $resendInviteId) {
    id
  }
}
    `;
export type ResendInviteMutationFn = ApolloReactHooks.useMutation.MutationFunction<ResendInviteMutation, ResendInviteMutationVariables>;

/**
 * __useResendInviteMutation__
 *
 * To run a mutation, you first call `useResendInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInviteMutation, { data, loading, error }] = useResendInviteMutation({
 *   variables: {
 *      resendInviteId: // value for 'resendInviteId'
 *   },
 * });
 */
export function useResendInviteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResendInviteMutation, ResendInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResendInviteMutation, ResendInviteMutationVariables>(ResendInviteDocument, options);
      }
export type ResendInviteMutationHookResult = ReturnType<typeof useResendInviteMutation>;
export type ResendInviteMutationResult = ApolloReactHooks.MutationResult<ResendInviteMutation>;
export type ResendInviteMutationOptions = Apollo.MutationOptions<ResendInviteMutation, ResendInviteMutationVariables>;
export const SegmentsPageDocument = gql`
    query SegmentsPage($pageNumber: Int!, $pageItemsCount: Int!, $audienceId: ID!) {
  audience(id: $audienceId) {
    segmentsPage(pageNumber: $pageNumber, pageItemsCount: $pageItemsCount) {
      totalCount
      nodes {
        id
        name
        creator {
          id
          imageUrl
          firstName
          lastName
        }
        organization {
          id
          name
        }
        condition
        peopleCount
        organizationId
        parentAudience {
          id
          condition
        }
      }
    }
  }
}
    `;

/**
 * __useSegmentsPageQuery__
 *
 * To run a query within a React component, call `useSegmentsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentsPageQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      audienceId: // value for 'audienceId'
 *   },
 * });
 */
export function useSegmentsPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SegmentsPageQuery, SegmentsPageQueryVariables> & ({ variables: SegmentsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SegmentsPageQuery, SegmentsPageQueryVariables>(SegmentsPageDocument, options);
      }
export function useSegmentsPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SegmentsPageQuery, SegmentsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SegmentsPageQuery, SegmentsPageQueryVariables>(SegmentsPageDocument, options);
        }
// @ts-ignore
export function useSegmentsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SegmentsPageQuery, SegmentsPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SegmentsPageQuery, SegmentsPageQueryVariables>;
export function useSegmentsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SegmentsPageQuery, SegmentsPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SegmentsPageQuery | undefined, SegmentsPageQueryVariables>;
export function useSegmentsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SegmentsPageQuery, SegmentsPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SegmentsPageQuery, SegmentsPageQueryVariables>(SegmentsPageDocument, options);
        }
export type SegmentsPageQueryHookResult = ReturnType<typeof useSegmentsPageQuery>;
export type SegmentsPageLazyQueryHookResult = ReturnType<typeof useSegmentsPageLazyQuery>;
export type SegmentsPageSuspenseQueryHookResult = ReturnType<typeof useSegmentsPageSuspenseQuery>;
export type SegmentsPageQueryResult = ApolloReactHooks.QueryResult<SegmentsPageQuery, SegmentsPageQueryVariables>;
export const SendSupportEmailDocument = gql`
    mutation SendSupportEmail($message: String!) {
  sendSupportEmail(message: $message)
}
    `;
export type SendSupportEmailMutationFn = ApolloReactHooks.useMutation.MutationFunction<SendSupportEmailMutation, SendSupportEmailMutationVariables>;

/**
 * __useSendSupportEmailMutation__
 *
 * To run a mutation, you first call `useSendSupportEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSupportEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSupportEmailMutation, { data, loading, error }] = useSendSupportEmailMutation({
 *   variables: {
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSendSupportEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendSupportEmailMutation, SendSupportEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendSupportEmailMutation, SendSupportEmailMutationVariables>(SendSupportEmailDocument, options);
      }
export type SendSupportEmailMutationHookResult = ReturnType<typeof useSendSupportEmailMutation>;
export type SendSupportEmailMutationResult = ApolloReactHooks.MutationResult<SendSupportEmailMutation>;
export type SendSupportEmailMutationOptions = Apollo.MutationOptions<SendSupportEmailMutation, SendSupportEmailMutationVariables>;
export const SubscriptionInfoDocument = gql`
    query SubscriptionInfo($organizationId: ID!) {
  subscriptionInfo(organizationId: $organizationId) {
    ...SubscriptionInfo
  }
}
    ${SubscriptionInfoFragmentDoc}`;

/**
 * __useSubscriptionInfoQuery__
 *
 * To run a query within a React component, call `useSubscriptionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionInfoQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useSubscriptionInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SubscriptionInfoQuery, SubscriptionInfoQueryVariables> & ({ variables: SubscriptionInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubscriptionInfoQuery, SubscriptionInfoQueryVariables>(SubscriptionInfoDocument, options);
      }
export function useSubscriptionInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubscriptionInfoQuery, SubscriptionInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubscriptionInfoQuery, SubscriptionInfoQueryVariables>(SubscriptionInfoDocument, options);
        }
// @ts-ignore
export function useSubscriptionInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SubscriptionInfoQuery, SubscriptionInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SubscriptionInfoQuery, SubscriptionInfoQueryVariables>;
export function useSubscriptionInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SubscriptionInfoQuery, SubscriptionInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SubscriptionInfoQuery | undefined, SubscriptionInfoQueryVariables>;
export function useSubscriptionInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SubscriptionInfoQuery, SubscriptionInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SubscriptionInfoQuery, SubscriptionInfoQueryVariables>(SubscriptionInfoDocument, options);
        }
export type SubscriptionInfoQueryHookResult = ReturnType<typeof useSubscriptionInfoQuery>;
export type SubscriptionInfoLazyQueryHookResult = ReturnType<typeof useSubscriptionInfoLazyQuery>;
export type SubscriptionInfoSuspenseQueryHookResult = ReturnType<typeof useSubscriptionInfoSuspenseQuery>;
export type SubscriptionInfoQueryResult = ApolloReactHooks.QueryResult<SubscriptionInfoQuery, SubscriptionInfoQueryVariables>;
export const TouchConversationAfterUserMessageDocument = gql`
    mutation TouchConversationAfterUserMessage($conversationId: ID!) {
  touchConversationAfterUserMessage(conversationId: $conversationId)
}
    `;
export type TouchConversationAfterUserMessageMutationFn = ApolloReactHooks.useMutation.MutationFunction<TouchConversationAfterUserMessageMutation, TouchConversationAfterUserMessageMutationVariables>;

/**
 * __useTouchConversationAfterUserMessageMutation__
 *
 * To run a mutation, you first call `useTouchConversationAfterUserMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTouchConversationAfterUserMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [touchConversationAfterUserMessageMutation, { data, loading, error }] = useTouchConversationAfterUserMessageMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useTouchConversationAfterUserMessageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TouchConversationAfterUserMessageMutation, TouchConversationAfterUserMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TouchConversationAfterUserMessageMutation, TouchConversationAfterUserMessageMutationVariables>(TouchConversationAfterUserMessageDocument, options);
      }
export type TouchConversationAfterUserMessageMutationHookResult = ReturnType<typeof useTouchConversationAfterUserMessageMutation>;
export type TouchConversationAfterUserMessageMutationResult = ApolloReactHooks.MutationResult<TouchConversationAfterUserMessageMutation>;
export type TouchConversationAfterUserMessageMutationOptions = Apollo.MutationOptions<TouchConversationAfterUserMessageMutation, TouchConversationAfterUserMessageMutationVariables>;
export const UpdateAudienceDocument = gql`
    mutation updateAudience($audienceUpdateParams: AudienceUpdateInput!) {
  updateAudience(audienceUpdateParams: $audienceUpdateParams) {
    id
    name
  }
}
    `;
export type UpdateAudienceMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateAudienceMutation, UpdateAudienceMutationVariables>;

/**
 * __useUpdateAudienceMutation__
 *
 * To run a mutation, you first call `useUpdateAudienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAudienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAudienceMutation, { data, loading, error }] = useUpdateAudienceMutation({
 *   variables: {
 *      audienceUpdateParams: // value for 'audienceUpdateParams'
 *   },
 * });
 */
export function useUpdateAudienceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAudienceMutation, UpdateAudienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAudienceMutation, UpdateAudienceMutationVariables>(UpdateAudienceDocument, options);
      }
export type UpdateAudienceMutationHookResult = ReturnType<typeof useUpdateAudienceMutation>;
export type UpdateAudienceMutationResult = ApolloReactHooks.MutationResult<UpdateAudienceMutation>;
export type UpdateAudienceMutationOptions = Apollo.MutationOptions<UpdateAudienceMutation, UpdateAudienceMutationVariables>;
export const UpdateAudienceCategoriesDocument = gql`
    mutation UpdateAudienceCategories($audienceId: ID!, $categoryCodes: [Int!]!) {
  updateAudienceCategories(audienceId: $audienceId, categoryCodes: $categoryCodes)
}
    `;
export type UpdateAudienceCategoriesMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateAudienceCategoriesMutation, UpdateAudienceCategoriesMutationVariables>;

/**
 * __useUpdateAudienceCategoriesMutation__
 *
 * To run a mutation, you first call `useUpdateAudienceCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAudienceCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAudienceCategoriesMutation, { data, loading, error }] = useUpdateAudienceCategoriesMutation({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *      categoryCodes: // value for 'categoryCodes'
 *   },
 * });
 */
export function useUpdateAudienceCategoriesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAudienceCategoriesMutation, UpdateAudienceCategoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAudienceCategoriesMutation, UpdateAudienceCategoriesMutationVariables>(UpdateAudienceCategoriesDocument, options);
      }
export type UpdateAudienceCategoriesMutationHookResult = ReturnType<typeof useUpdateAudienceCategoriesMutation>;
export type UpdateAudienceCategoriesMutationResult = ApolloReactHooks.MutationResult<UpdateAudienceCategoriesMutation>;
export type UpdateAudienceCategoriesMutationOptions = Apollo.MutationOptions<UpdateAudienceCategoriesMutation, UpdateAudienceCategoriesMutationVariables>;
export const UpdateAudienceIntegrationDocument = gql`
    mutation UpdateAudienceIntegration($integrationParams: AudienceIntegrationUpdateInput!) {
  updateAudienceIntegration(integrationParams: $integrationParams) {
    id
  }
}
    `;
export type UpdateAudienceIntegrationMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateAudienceIntegrationMutation, UpdateAudienceIntegrationMutationVariables>;

/**
 * __useUpdateAudienceIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateAudienceIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAudienceIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAudienceIntegrationMutation, { data, loading, error }] = useUpdateAudienceIntegrationMutation({
 *   variables: {
 *      integrationParams: // value for 'integrationParams'
 *   },
 * });
 */
export function useUpdateAudienceIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAudienceIntegrationMutation, UpdateAudienceIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAudienceIntegrationMutation, UpdateAudienceIntegrationMutationVariables>(UpdateAudienceIntegrationDocument, options);
      }
export type UpdateAudienceIntegrationMutationHookResult = ReturnType<typeof useUpdateAudienceIntegrationMutation>;
export type UpdateAudienceIntegrationMutationResult = ApolloReactHooks.MutationResult<UpdateAudienceIntegrationMutation>;
export type UpdateAudienceIntegrationMutationOptions = Apollo.MutationOptions<UpdateAudienceIntegrationMutation, UpdateAudienceIntegrationMutationVariables>;
export const UpdateAudiencePixelSettingsDocument = gql`
    mutation updateAudiencePixelSettings($audiencePixelSettingsParams: AudiencePixelSettingsUpdateInput!) {
  updatePixelAudienceSettings(
    audiencePixelSettingsParams: $audiencePixelSettingsParams
  ) {
    id
  }
}
    `;
export type UpdateAudiencePixelSettingsMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateAudiencePixelSettingsMutation, UpdateAudiencePixelSettingsMutationVariables>;

/**
 * __useUpdateAudiencePixelSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateAudiencePixelSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAudiencePixelSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAudiencePixelSettingsMutation, { data, loading, error }] = useUpdateAudiencePixelSettingsMutation({
 *   variables: {
 *      audiencePixelSettingsParams: // value for 'audiencePixelSettingsParams'
 *   },
 * });
 */
export function useUpdateAudiencePixelSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAudiencePixelSettingsMutation, UpdateAudiencePixelSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAudiencePixelSettingsMutation, UpdateAudiencePixelSettingsMutationVariables>(UpdateAudiencePixelSettingsDocument, options);
      }
export type UpdateAudiencePixelSettingsMutationHookResult = ReturnType<typeof useUpdateAudiencePixelSettingsMutation>;
export type UpdateAudiencePixelSettingsMutationResult = ApolloReactHooks.MutationResult<UpdateAudiencePixelSettingsMutation>;
export type UpdateAudiencePixelSettingsMutationOptions = Apollo.MutationOptions<UpdateAudiencePixelSettingsMutation, UpdateAudiencePixelSettingsMutationVariables>;
export const UpdateAudiencePulseDocument = gql`
    mutation UpdateAudiencePulse($audiencePulseParams: UpdateAudiencePulseInput!) {
  updateAudiencePulse(audiencePulseParams: $audiencePulseParams) {
    id
  }
}
    `;
export type UpdateAudiencePulseMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateAudiencePulseMutation, UpdateAudiencePulseMutationVariables>;

/**
 * __useUpdateAudiencePulseMutation__
 *
 * To run a mutation, you first call `useUpdateAudiencePulseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAudiencePulseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAudiencePulseMutation, { data, loading, error }] = useUpdateAudiencePulseMutation({
 *   variables: {
 *      audiencePulseParams: // value for 'audiencePulseParams'
 *   },
 * });
 */
export function useUpdateAudiencePulseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAudiencePulseMutation, UpdateAudiencePulseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAudiencePulseMutation, UpdateAudiencePulseMutationVariables>(UpdateAudiencePulseDocument, options);
      }
export type UpdateAudiencePulseMutationHookResult = ReturnType<typeof useUpdateAudiencePulseMutation>;
export type UpdateAudiencePulseMutationResult = ApolloReactHooks.MutationResult<UpdateAudiencePulseMutation>;
export type UpdateAudiencePulseMutationOptions = Apollo.MutationOptions<UpdateAudiencePulseMutation, UpdateAudiencePulseMutationVariables>;
export const UpdateConversationDocument = gql`
    mutation UpdateConversation($updateConversationInput: UpdateConversationInput!) {
  updateConversation(updateConversationInput: $updateConversationInput) {
    id
    title
  }
}
    `;
export type UpdateConversationMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateConversationMutation, UpdateConversationMutationVariables>;

/**
 * __useUpdateConversationMutation__
 *
 * To run a mutation, you first call `useUpdateConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConversationMutation, { data, loading, error }] = useUpdateConversationMutation({
 *   variables: {
 *      updateConversationInput: // value for 'updateConversationInput'
 *   },
 * });
 */
export function useUpdateConversationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateConversationMutation, UpdateConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateConversationMutation, UpdateConversationMutationVariables>(UpdateConversationDocument, options);
      }
export type UpdateConversationMutationHookResult = ReturnType<typeof useUpdateConversationMutation>;
export type UpdateConversationMutationResult = ApolloReactHooks.MutationResult<UpdateConversationMutation>;
export type UpdateConversationMutationOptions = Apollo.MutationOptions<UpdateConversationMutation, UpdateConversationMutationVariables>;
export const MeDocument = gql`
    query Me {
  me {
    id
    firstName
    lastName
    email
    phone
    imageUrl
    scopes
    whiteLabelImageUrl
    organizations {
      id
      name
      legalName
      organizationType
      imageUrl
      subscriptionOverride
      paidSubscription
      audiencesCount
      businessDataEnabled
      pulseEnabled
      globalSearchEnabled
      customerListEnabled
      lookalikeEnabled
      matchbackEnabled
      phone
      addressLine1
      addressLine2
      city
      hiddenPeopleFields
      state
      country
      zip
    }
    invites {
      id
      email
      organizationId
      createdByUserId
      status
      createdAt
      updatedAt
      acceptedAt
      declinedAt
      deletedAt
      inviter {
        id
        firstName
        lastName
        email
        phone
        imageUrl
      }
      user {
        id
        firstName
        lastName
        email
        phone
        imageUrl
      }
      organization {
        id
        name
        imageUrl
      }
    }
    userRoles {
      id
      hiddenPeopleFields
      assignedRole {
        id
        name
        permissions
        childOrgExtraPermissions
        hiddenPeopleFields
      }
      organizationId
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
// @ts-ignore
export function useMeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MeQuery, MeQueryVariables>;
export function useMeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MeQuery | undefined, MeQueryVariables>;
export function useMeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = ApolloReactHooks.QueryResult<MeQuery, MeQueryVariables>;
export const UpdateMeDocument = gql`
    mutation UpdateMe($user: UpdateUserInput) {
  updateMe(user: $user) {
    id
    firstName
    lastName
  }
}
    `;
export type UpdateMeMutationFn = ApolloReactHooks.useMutation.MutationFunction<UpdateMeMutation, UpdateMeMutationVariables>;

/**
 * __useUpdateMeMutation__
 *
 * To run a mutation, you first call `useUpdateMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeMutation, { data, loading, error }] = useUpdateMeMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateMeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMeMutation, UpdateMeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateMeMutation, UpdateMeMutationVariables>(UpdateMeDocument, options);
      }
export type UpdateMeMutationHookResult = ReturnType<typeof useUpdateMeMutation>;
export type UpdateMeMutationResult = ApolloReactHooks.MutationResult<UpdateMeMutation>;
export type UpdateMeMutationOptions = Apollo.MutationOptions<UpdateMeMutation, UpdateMeMutationVariables>;